import { Modal } from 'bootstrap';
import { SharedService } from './../../services/sharedService/shared-service.service';
import { CommonPatternsService } from './../../common-patterns.service';
import { LoaderService } from 'src/app/loader.service';
import { error, event } from 'jquery';
import { AppComponent } from './../../app.component';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { AfterViewInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import {
  AbstractControl,
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ExcelService } from './../../services/excel.service';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { HeaderComponent } from './../../layouts/header/header.component';
import { EnableDisableDirective } from './../../Directives/enable-disable.directive';
import { ActivatedRoute, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { PaymentService } from '../../services/payment.service';
import { ReportsComponent } from './../../components/reports/reports.component'
import { PhoneFormatPipe } from "../../pipes/phone-format.pipe";
import * as moment from 'moment';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { Observable, startWith, Subject, takeUntil } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { LoggerService } from 'src/app/services/logger.service';
import { Store } from '@ngrx/store';
import { loadCorporateData, loadCorporateDataSuccess } from '../../state/actions/corporates.actions';
import { selectCorporateData, selectCorporateError, selectCorporateLoading } from 'src/app/state/selectors/corporates.selector';
import { loadCorporateSignupConfigData } from 'src/app/state/actions/corporateSignupConfig.actions';
import { selectCorporateSignupConfigData } from 'src/app/state/selectors/corporateSignupConfig.selector';
import { selectLanguageData } from 'src/app/state/selectors';
import * as ClipboardJS from 'clipboard';
import { from, of } from 'rxjs';
import { concatMap, switchMap, catchError, finalize } from 'rxjs/operators';
import { AnyARecord } from 'dns';

declare var $: any;
@Component({
  selector: 'app-edit-corporate',
  templateUrl: './edit-corporate.component.html',
  styleUrls: ['./edit-corporate.component.css'],
  providers: [DatePipe, HeaderComponent, EnableDisableDirective, PhoneFormatPipe],
  // encapsulation: ViewEncapsulation.None
})
export class EditCorporateComponent implements OnInit {
  @ViewChild(ReportsComponent) reportsComponent: ReportsComponent;
  @ViewChild(ConfirmationDialogComponent) confirmationDialog: ConfirmationDialogComponent;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  dtTrigger: Subject<any> = new Subject<any>();
  adminName: any;
  role: any;
  deleteTierName: any;
  tierName: any;
  tierDescription: any;
  tierStatus: any;
  tierEffectiveDate: any;
  tierTimeofService: any;
  tierMinTimeofService: any;
  tierMaxTimeofService: any;
  tierMembers: any[] = []
  // selectedTierName: any;
  selectedTierName: { [key: number]: string } = {};
  walletAmount: any;
  walletCarryForwordAmount: any;
  walletAllocation: any;
  walletIndustryCategory: any;
  walletIntialBalanceSetup: any;
  walletAdvsiorFeeStructure: any;
  walletCoveragePercentage: any;
  walletType: any;
  tierDetails: any;
  checkDeleteTier: boolean = false;
  checkMemeberTier: boolean = false;
  historyDetails: any[] = []
  serviceCount: any = 0;
  basicTiersCount: any = 1;
  AnnualCount: any = 0;
  adminData: any;
  lengthofstatus: any;
  defaultColor: any;
  applicationStatus: any;
  paidByCompany: Array<any> = [];
  allBrokers: Array<any> = [];
  allBrokers_: Array<any> = [];
  allBrokerscheck: boolean = false
  coveredByCompany: Array<any> = [];
  paidByEmployee: Array<any> = [];
  paidByCompanyDefault: Array<any> = [];
  coveredByCompanyDefault: Array<any> = [];
  paidByEmployeeDefault: Array<any> = [];
  bulkplans: Array<any> = [];
  bulkemployeecheck: Array<any> = [];
  payrolldeduction: Array<any> = [];
  countryList: any;
  subdomainName: any;
  payrolldedcutionname: any;
  payrollOptions: any;
  planselectedId: any;
  planRequestBody: any;
  selectedWalletConfig: any;
  plancheckCoverage: any = false;
  plancheck2Coverage: any = false;
  plancheck3Coverage: any = false;
  block1coverage: any = true;
  block2coverage: any = true;
  block3coverage: any = true;
  dateFormat = 'MM-DD-YYYY';

  employeeplancheck: any
  empCount: any;
  elementid: any;
  block2execid: any;
  defaultAmount: any;
  checkmark = false;
  executiveid: any;
  selectionTiers: any;
  plansNewBlock1: any;
  tierConfigCheck: any;
  walletConfigCheck: any;
  customSelected = false;
  upgradeplanscheck: any;
  showtierbasicplans = false;
  showtieradvplans = false;

  basicInfo = true;
  showsearchbox: boolean = true;
  isActive1: boolean = true;
  plansInfo = false;
  showTiersTable = false;
  corporateTiers: Array<any> = [];
  corporateTiersDeleteList: Array<any> = [];
  showTierConfig = false;
  showWalletConfig = false;

  showTierConfig1 = false;
  showWalletConfig1 = false;
  showTiersTable1 = false;
  showaddadmin = false;
  addadminform = true;
  wallettierInfo = false;
  wallettierInfoandtier = false;
  EmployeeInfo = false;
  datagraphInfo = false;
  showdeletebutton = false;
  showemptywalletConfig = false;

  uploadlogoafter = false;
  nowalletnotierInfo = false;
  upgradeplansselection = false;
  upgradeplansselectiontiers = false;
  employeeplanpurchase = false;
  employeeplanpurchasetiers = false;
  voidcheckuploadafter = false;
  showconfigurebutton = true;

  showvoidcheck = true;
  showimagelogo = true;
  willDownload = false;
  bankDetails = false;
  showstatus = false;
  walletData: any;
  tierWalletConfig: any;
  TierData: any;
  public postalvalue: any;
  public invalidpostalcodeprivince: boolean = false;
  public invalidpostalcodeprivincewaddell: boolean = false;
  statesInfo: any;
  plansres: any;
  planres2: any;
  plansBlock1: any;
  plansBlock1Tiers: any;
  packageIndex: any;
  imagedisplay: any;
  imagedisplayvoid: any;
  editindex: any;
  groupIndex: any;
  walletConfig: any;
  employeeplanpurchasetierscheck: any;
  upgradertierscheck: any;
  packageIndexblock2: any;
  groupIndexblock2: any;
  corporationclient: any;
  disabledColor: any;
  counter: any;
  selectedplansblock1: any;
  selectedplansblock2: any;
  selectedplansblock3: any;
  configureTierList: any;
  disallowedplans: any;
  disallowedplansTiers: any;
  voidcheckfile: any;
  uploadadminlogoimg: any;
  session: any;
  configprovinceres: any;
  configprovincereslist: any;
  enrollmentDates: any;
  provincialHealthcareUrl: any;
  provincialZipcodes: any;
  provincelistid: any;
  state_id: any;
  stateId: any;
  fusebillStateId: any;
  countryId: any;
  fusebillCountryId: any;
  statename: any;
  corporateId: any;
  corporateClientId: any;
  maxEmployeeCount: any;
  lengthofemployee: any;
  editadminfirstname: any;
  editadminlastname: any;
  editadminphone: any;
  editadminemail: any;
  editadminrole: any = '';
  editEmployeeId: any;
  selectedPlansTierBlock1: any;
  selectedplansforTier: Array<any> = [];
  dummyAdminData: Array<any> = [];
  tierinfonames: Array<any> = [];
  addedEmployeelist: Array<any> = [];
  tierslist: Array<any> = [];
  finalTiersforGraph: Array<any> = [];
  TierlistforGrapsh: Array<any> = [];
  planssummarymain: Array<any> = [];
  planssummaryopt: Array<any> = [];
  planssummary: Array<any> = [];
  plansresblack2: Array<any> = [];
  plansresblack2Tiers: Array<any> = [];
  plansresblack2final: Array<any> = [];
  plansresblack3: Array<any> = [];
  Newplansresblack3: Array<any> = [];
  planssummary2: Array<any> = [];
  plansNewBlock2: Array<any> = [];
  selectedCoverage: Array<any> = [];
  Newplansresblack3Tiers: Array<any> = [];
  plansNewBlock2Tiers: Array<any> = [];
  plansNewBlock3Tiers: Array<any> = [];
  plansresblack3Tiers: Array<any> = [];
  finalblock2res: Array<any> = [];
  excelempdata: Array<any> = [];
  tierconfig: Array<any> = [];
  EmployeeAddData: Array<any> = [];
  finalemployeekeys: Array<any> = [];
  tierarray: Array<any> = [];
  corpDetails: any = {};
  genericLink: string
  SubDomains: Array<any> = [];
  CorpName: any;
  streetAddress: any;
  streetAddress2: any;
  country: any = '';
  city: any;
  province: any = '';
  postalCode: any;
  policyStartDate: any;
  PolicyStartDate1:any;
  setupWallet: any;
  setUplevelofCoverage: any;
  noOfEmployees: any;
  paymentInfo: any;
  waitTime: any;
  useCreditCard: any;
  invoicePayment: any;
  padPayment: any;
  minDate: any;
  maxDate: any;

  aptSuite: any;

  filterarray: Array<any> = [];
  packagePlanLevelTiers: any = {};
  displayPackage: Array<boolean> = [];
  selectedPlansInfoTierArray: Array<any> = [];
  selectedPlansInfoTierArrayBlock2: Array<any> = [];
  selectedPlansInfoTierArrayBlock3: Array<any> = [];
  selectedTiers: Array<any> = [];
  TiersArray: Array<any> = [];
  selectedPackagePlansInfoTier: any = {};
  selectedPackagePlansInfoTierBlock2: any = {};
  selectedPackagePlansInfoTierBlock3: any = {};
  selectedPackagePlansInfoTiername: any = {};
  selectedPackagePlansInfoTiernameBlock2: any = {};
  selectedPackagePlansInfoTiernameBlock3: any = {};
  selectedPackagePlansInfoTier2: any = {};
  selectedPackagesassignedTiers: any = {};
  selectedPackagesassignedTiers2: any = {};
  selectedPackagesassignedTiers21: any = {};
  selectedPackagesavailableTiers: any = {};
  selectedPackagesavailableTiers2: any = {};
  selectedPackagesavailableTiers21: any = {};
  selectedPackagesavailableTiers3: any = {};
  selectedPackagesassignedTiers3: any = {};

  selectedPackagePlansInfoTier2Block2: any = {};
  selectedPackagePlansInfoTier3Block3: any = {};
  selectedPackagesassignedTiersBlock2: any = {};
  selectedPackagesassignedTiersBlock3: any = {};
  selectedPackagesassignedTiers2Block2: any = {};
  selectedPackagesassignedTiers2Block21: any = {};
  selectedPackagesassignedTiers3Block3: any = {};
  selectedPackagesassignedTiers3Block31: any = {};
  selectedPackagesavailableTiersBlock2: any = {};
  selectedPackagesavailableTiersBlock3: any = {};
  selectedPackagesavailableTiers2Block2: any = {};
  selectedPackagesavailableTiers2Block21: any = {};
  selectedPackagesavailableTiers3Block3: any = {};
  selectedPackagesavailableTiers3Block31: any = {};
  seelctedplanLevelTierMapping: Array<any> = [];
  seelctedplanLevelTierMapping2: Array<any> = [];

  showinput = true;
  showinput1 = false;

  showinputBlock2 = true;
  showinput1Block2 = false;
  showTierlist: boolean = false;
  showinputBlock3 = true;
  showinput1Block3 = false;
  seelctedplanLevelTierMappingBlock2: Array<any> = [];
  seelctedplanLevelTierMapping2Block2: Array<any> = [];

  seelctedplanLevelTierMappingBlock3: Array<any> = [];
  seelctedplanLevelTierMapping3Block3: Array<any> = [];
  walletsymbol: any;
  chart: any;
  chart1: any;
  isActive!: boolean;
  showemptytierconfig: any;
  annualincomeCheck = false;
  lengthofServiceCheck = false;
  tiersLevelCheck = false;
  public fieldArray: Array<any> = [];
  public newAttribute: any = {};
  public defaulttiers: Array<any> = [];
  public dynamicArray: Array<any> = [];
  public dynamicArrayService: Array<any> = [];
  public dynamicArrayAnnualIncome: Array<any> = [];
  dropdownList: Array<any> = [];
  selectedItems: Array<any> = [];
  dropdownSettings = {};
  public employeeList: Array<any> = [];
  public bulkemployeeList: Array<any> = [];
  public newDynamic: any = {};
  adminStatuslist: Array<any> = [];
  dropDownSelect = false;
  companyPaidCoveragePlanLevels: any
  addTierForm: FormGroup = new FormGroup({
    tierName: new FormControl(''),
    tierDescription: new FormControl(''),
    tierStatus: new FormControl(''),
    tierEffectiveDate: new FormControl(''),
    tierTimeOfService: new FormControl(''),
    mintierTimeOfService: new FormControl(''),
    maxtierTimeOfService: new FormControl(''),
    formLink: new FormControl(''),
  });

  deleteTierForm: FormGroup = new FormGroup({
    memberCheck: new FormControl(''),
  });

  addWalletForm: FormGroup = new FormGroup({


    walletAmount: new FormControl(''),
    carryForwordAmount: new FormControl(''),
    allocation: new FormControl(''),
    industryCategory: new FormControl(''),
    intialBalanceSetup: new FormControl(''),
    advsiorFee: new FormControl(''),
    coveragePerecentage: new FormControl(''),
    walletType: new FormControl(''),
  });
  clientregform: FormGroup = new FormGroup({
    brokerName: new FormControl(''),
    profile: new FormControl(''),
    authorizenetCustomerId: new FormControl(''),
    contactEmail: new FormControl(''),
    paymentPlatform: new FormControl(''),
    corporationName: new FormControl(''),
    PolicyStartDate: new FormControl(''),
    PolicyStartDate1: new FormControl(''),

    streetAddress: new FormControl(''),
    streetAddress2: new FormControl(''),
    apt_suite: new FormControl(),

    country: new FormControl(''),
    city: new FormControl(''),
    Province: new FormControl(''),
    multiSelectProviance: new FormControl(''),
    postalCode: new FormControl(''),
    waitingPeriod: new FormControl(''),
    waitingPeriodCustom: new FormControl(''),
    waitingPeriodinitialsignup: new FormControl(''),
    paymentInfo: new FormControl(''),
    bankCode: new FormControl(''),
    BankTransit: new FormControl(''),
    accounNum: new FormControl(''),
    voidcheck: new FormControl(''),
    corporatelogo: new FormControl(''),
    walletConfig: new FormControl(''),
    tierConfig: new FormControl(''),
    expectednoofEmployees: new FormControl(''),
    ShowEmployer: new FormControl(''),
    autoSelectEmp: new FormControl(''),
    showEmployeeListData: new FormControl(''),
  });

  bankingInfoForm: FormGroup = new FormGroup({

    bankCode: new FormControl(''),
    BankTransit: new FormControl(''),
    accounNum: new FormControl(''),
    voidcheck: new FormControl(''),
    bankindustryCategory: new FormControl(''),
    bankadvsiorFee: new FormControl(''),

  })

  addEmployeeformList: FormGroup = new FormGroup({
    employeeId: new FormControl(''),
    employeeFirstName: new FormControl(''),
    employeeLastName: new FormControl(''),
    employeeEmail: new FormControl(''),
    employeeOccupation: new FormControl(''),
    employeeDateofhire: new FormControl(''),
    employeeDateofbirth: new FormControl(''),
    employeeGender: new FormControl(''),
    employeeCountry: new FormControl(''),
    employeeResidence: new FormControl(''),
    employeefamilyStatus: new FormControl(''),
    employeePhoneno: new FormControl(''),
    employeeStreetAddress: new FormControl(''),
    employeeCity: new FormControl(''),
    employeeProvince: new FormControl(''),
    employeePostalCode: new FormControl(''),
    employeeTier: new FormControl(''),
    empployeeAnnualIncome: new FormControl(''),
  });

  addEmployeeformListwaddell: FormGroup = new FormGroup({
    employeeId: new FormControl(''),
    employeeFirstName: new FormControl(''),
    employeeLastName: new FormControl(''),
    employeeEmail: new FormControl(''),
    employeePhoneno: new FormControl(''),
    employeeStreetAddress: new FormControl(''),
    employeeCountry: new FormControl(''),
    employeeCity: new FormControl(''),
    employeeProvince: new FormControl(''),
    employeePostalCode: new FormControl(''),
  });

  @ViewChild('multiSelectDropdown') multiSelectDropdown: any;
  adminform: FormGroup = new FormGroup({
    adminfirstname: new FormControl(''),
    adminlastname: new FormControl(''),
    adminphone: new FormControl(''),
    adminemail: new FormControl(''),
    role: new FormControl(''),
    roleName: new FormControl(''),

  });
  payrolldeductionoption: FormGroup = new FormGroup({
    payrolloption: new FormControl(''),

  });

  //ganesh
  tax = 0.13;
  price = {
    'EAP 2.0': 5,
    'Mind & Body': 15,
    'Complete Wellness': 20
  }

  submitted = false;
  // submittedadmin = false;
  @ViewChild('lengthOfServicetrue')
  lengthOfServicetrue!: ElementRef<HTMLElement>;
  @ViewChild('lengthOfServicefalse')
  lengthOfServicefalse!: ElementRef<HTMLElement>;
  @ViewChild('annualIncometrue')
  annualIncometrue!: ElementRef<HTMLElement>;
  @ViewChild('annualIncomefalse')
  annualIncomefalse!: ElementRef<HTMLElement>;

  @ViewChild('nextpage')
  nextpage!: ElementRef<HTMLElement>;

  @ViewChild('nextpage')
  closemodel!: ElementRef<HTMLElement>;
  @ViewChild('upgradeplansfalse')
  upgradeplansfalse!: ElementRef<HTMLElement>;
  @ViewChild('upgradeplanstrue')
  upgradeplanstrue!: ElementRef<HTMLElement>;

  @ViewChild('upgradeplanstiersfalse')
  upgradeplanstiersfalse!: ElementRef<HTMLElement>;
  @ViewChild('upgradeplanstierstrue')
  upgradeplanstierstrue!: ElementRef<HTMLElement>;

  @ViewChild('employeepurchasefalse')
  employeepurchasefalse!: ElementRef<HTMLElement>;
  @ViewChild('employeepurchasetrue')
  employeepurchasetrue!: ElementRef<HTMLElement>;

  @ViewChild('employeepurchaseTiersfalse')
  employeepurchaseTiersfalse!: ElementRef<HTMLElement>;
  @ViewChild('employeepurchaseTierstrue')
  employeepurchaseTierstrue!: ElementRef<HTMLElement>;
  disabledelement: any;
  @ViewChild(HeaderComponent)
  headerComponent!: HeaderComponent;

  selectedOption: any;
  @ViewChild('myFileInput') myFileInput: ElementRef;

  @ViewChild('myFileInputwaddel') myFileInputwaddel: ElementRef;


  @ViewChild('form') form: ElementRef;
  accessCode: any;
  encRequestRes: any;
  order_no: any = 'qaz234567';
  testAmount: any = '10';
  selectedAddress: any = {
    name: 'testing',
    address: 'test address',
    city: 'test city',
    pincode: '23456',
    state: 'state test',
    phone: '1234567890'
  }
  firstName: any;
  showOtherField: boolean = false;
  groupContactsData: any;
  existingPlans: any;
  coreplantemplateValue: any = null;
  emailAlreadyexist: boolean = false;
  domainExisting: boolean = false;
  multiSelectProviance: any = [];
  multiSelectProviancenames: any = [];
  multiProviance: any;
  NoWaithingPeridos: boolean = false;
  threeMonths: boolean = false;
  SixMonths: boolean = false;
  multiSlectProviances: any;
  corporationName: any;
  ParentBrokerName: any;
  ParentBrokerId: any;
  corporateEmployeesInitialSignupWaittime: any;
  showmultiSlectProviances: any = [];
  requireEmployeeName: any;
  employeeWorkingProviance: any;
  postalCodeDisplay: any = "Postal Code";
  provianceDispaly: any = "Province";
  selectedCountry: string;
  isCountrySelected: boolean;
  block1Coveragecheck: any;
  balkPlans: any;
  headCountmiss: boolean = false;
  headCountmiss1: boolean = false;
  showHeadCount: { [key: string]: any } = {};
  getPlanCoverage: { [key: string]: any } = {};
  showEmployeeValue: any;
  showEmployeeValue1: any;
  hidementalplans: any = 222;
  hidewaddellplans: any = 222;
  showinputbox: any;
  showinputbox1: any;
  uploadEmployeeExcelData: Array<any> = [];
  employeedata: any = [];
  employeedata2: any = [];
  showEmployeelist: any = [];
  deletedId: Array<any> = [];  // employeedata: { label: string; key: string; mandatory: boolean; display: boolean; }[];
  addemployeefrom: boolean;
  editemployeefrom: boolean;
  editEmployeeindex: any;
  editEmployeefirstname: any;
  editEmployeelastname: any;
  editEmployeephone: any;
  editEmployeeemail: any;
  presentMail: any;
  editEmployeeDateofbirth: string;
  editEmployeeOccupation: any;
  editEmployeefamilyStatus: string;
  editemployeeCountry: any;
  editEmployeeResidenetIn: any;
  editEmployeeeAnnualIncome: any;
  UId: any;
  isBulk: boolean;
  editEmployeeDateofhire: string;
  editEmployeesex: any;
  showinputboxvalue: { [key: string]: boolean } = {}
  showinputboxvalue1: any = "12121";
  failedEmployeesList: any;
  isSubscribed: any;
  brokerProfileslist: Array<any> = [];
  brokerProfileslist1: any = {};
  filteredallBrokers: Array<any> = [];
  waddellExcelKeys: any[];
  editEmployeeStreeAddress: any;
  editEmployeeCity: any;
  editEmployeeProvicne: any;
  editEmployeeposatlCode: any;
  ExcelProvinceCode: any = '';
  showBrokerData: boolean = false;
  brokerProfileslistSearch: Array<any> = [];
  profileid: any;
  roeAgreementSigned: any;
  selectedPackages: any = [];
  checkboxCheck: { [key: string]: boolean } = {};
  plansCoveragecheckboxCheck: { [key: string]: boolean } = {};
  selectedSubGrpId: any = '';
  isCollapsed: { [key: string]: boolean } = {};
  isCollapsedTwo: { [key: string]: boolean } = {};
  isCollapsedThree: { [key: string]: boolean } = {};
  updatedBrokerId: any;
  public lang: any = {};
  selectedLanguage: string;
  languageData: any
  finalCompanyPaidCoverages: any = [];
  loading$: Observable<boolean>;
  error$: Observable<string | null>;
  corporateData$: Observable<any>;
  clientList: any = []
  corporateDetails: any = {}
  filteredEmployeeList: any = []
  corporateSignupConfigData$: Observable<any>;
  corporateSignupConfigData: any = {};
  languageData$: Observable<any>;
  private destroy$ = new Subject<void>();
  editPlanHeadCount: any = {};
  nonEditingBulkPlan: any = {}
  currentHeadCount: any;
  newHeadCount: any;
  effectiveDate: any;
  editBulkPlanModal: boolean = false;
  dateOptions: { value: string, text: string }[] = [];
  expandActivePlanExpiry: boolean = true;
  activateOldPlan: boolean = true;
  updateProvisioningDate: boolean = true;
  showActivateOldPlan: boolean = false;
  paymentMethodValue: any;
  crateTierid: any;
  gigterminationRes: any;
  continueWithExistingPlans: boolean;
  samePlansWithCorporate: boolean;
  showEditTier:boolean = false;
  isAddTier: boolean = false;
  showAddTier: boolean = false;
  wsaSelected:any={};
  initialBalanceSetupDisplay: any;
  carryForwardUnusedAmount: any;
  rolloverAllocationPeriodDisplay: any;
  paymentPlatform: any = 'Staxbill'; // AuthorizeNet
  paymentPlatformsList: any = ['Staxbill','AuthorizeNet'];
  contactEmail: any = '';

  constructor(private logger: LoggerService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    public app: AppComponent,
    public router: Router,
    public elementRef: ElementRef,
    private excelService: ExcelService,
    private datePipe: DatePipe,
    private toastrService: ToastrService,
    private ngZone: NgZone,
    private ref: ChangeDetectorRef,
    private PaymentService: PaymentService,
    private phoneNoFormat: PhoneFormatPipe,
    private _LoaderService: LoaderService,
    private commonPatternsService: CommonPatternsService,
    private SharedService: SharedService,
    private store: Store<{
      corporateData: [],
      corporateSignupConfigData: {},
      languageData: []
    }>
  ) {
    this.corporateData$ = store.select(selectCorporateData);
    this.loading$ = store.select(selectCorporateLoading);
    this.error$ = store.select(selectCorporateError);
    this.languageData$ = store.select(selectLanguageData);
    this.corporateSignupConfigData$ = store.select(selectCorporateSignupConfigData);
  }

  ngOnInit(): void {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Edit Corporate');
    },100)
    // this.headerComponent.headerDetails('login');
      
    // this.categoriesWithSubcategories = grouped;

// this.onWalletTypeSelected(event:Event);
    this.formConfig();
    this.formConfig1();
    this.getLanguageTokens()
    this.isSubscribed = false;
    this.selectedOption = '';
    this.accessCode = 'AVMM97HL24AS35MMSA';

    this.adminData = [];
    sessionStorage.setItem('adminData', '');

    let adminsstatus = [
      { id: 1, name: 'Enter Address', checked: false, color: 'red' },
      { id: 2, name: 'Select Policy Start Date', checked: false, color: 'red' },
      {
        id: 3,
        name: 'Add Additional Administrator',
        checked: false,
        color: 'red',
      },
      {
        id: 4,
        name: 'Enter Waiting Period For New Employees',
        checked: false,
        color: 'red',
      },
      { id: 5, name: 'Select Payment Method', checked: false, color: 'red' },
      { id: 6, name: 'Add/Update Company logo', checked: false, color: 'red' },
      {
        id: 7,
        name: 'Enable Wallet - Enabled or Disabled',
        checked: false,
        color: 'red',
      },
      {
        id: 8,
        name: 'Enter Tiered Benefits - Enabled or Disabled',
        checked: false,
        color: 'red',
      },
      { id: 9, name: 'Select Benefit Plans', checked: false, color: 'red' },
      {
        id: 10,
        name: 'Add Employees and (Assign tiers if Tiers Selected)',
        checked: false,
        color: 'red',
      },
      { id: 11, name: 'Review Setup', checked: false, color: 'red' },
      {
        id: 12,
        name: 'Send Invite to all employees',
        checked: false,
        color: 'red',
      },
    ];

    this.adminStatuslist = adminsstatus;

    this.adminName = sessionStorage.getItem('adminName');

    this.role = sessionStorage.getItem('role');

    this.walletsymbol = '$';
    this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');
    sessionStorage.setItem('corporateId', '');
    sessionStorage.setItem('corporateClientId', '');

    // console.log(this.adminData)
    this.dropdownSettings = {
      singleSelection: false,
      closeDropDownOnSelection: true,
      idField: 'id',
      textField: 'shortName',
      selectAllText: this.lang.Select_All,
      unSelectAllText: this.lang.Deselect_All,
      itemsShowLimit: 8,
      allowSearchFilter: true,
    };

    this.selectedItems = [
      { id: 114, name: 'All' },
      { id: 115, name: 'Employee' },
      { id: 116, name: 'Management' },
    ];

    // sessionStorage.setItem('corporateId', '74');
    this.defaultColor = 'black';
    this.addTierForm = this.formBuilder.group({
      tierName: ['', [Validators.required]],
      tierDescription: ['', [Validators.required]],
      tierStatus: ['', [Validators.required]],
      tierEffectiveDate: ['', [Validators.required]],
      tierTimeOfService: ['', [Validators.required]],
      mintierTimeOfService: [''],
      maxtierTimeOfService: [''],
      formLink: [''],
    })
    this.deleteTierForm = this.formBuilder.group({
      memberCheck: ['', [Validators.required]],

    })

    this.addWalletForm = this.formBuilder.group({
      walletAmount: ['', [Validators.required]],
      carryForwordAmount: ['', [Validators.required]],
      allocation: ['', [Validators.required]],
      industryCategory: [''],
      intialBalanceSetup: ['', [Validators.required]],
      advsiorFee: [''],
      coveragePerecentage: ['', [Validators.required]],
      walletType: ['', [Validators.required]],
    })
    this.bankingInfoForm = this.formBuilder.group({
      bankCode: ['', [Validators.required]],
      BankTransit: ['', [Validators.required]],
      accounNum: ['', [Validators.required]],
      bankindustryCategory: ['', [Validators.required]],
      bankadvsiorFee: ['', [Validators.required, Validators.min(0), Validators.max(15)]],
      voidcheck: ['']
    })

    this.clientregform = this.formBuilder.group({
      brokerName: [''],
      profile: [''],
      authorizenetCustomerId: [''],
      contactEmail: ['', [Validators.required, Validators.pattern(this.commonPatternsService.emailPattern)]],
      paymentPlatform: [''],
      corporationName: [
        '',
        [
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(255),
          Validators.pattern('^(?:<[^>]*$|[^<]*>$|^[^<>]*$)'),

        ],
      ],
      PolicyStartDate: [''],
      streetAddress: [''],
      streetAddress2: [''],
      apt_suite: [''],
      country: ['', [Validators.required]],
      city: ['', [Validators.required]],
      Province: ['', [Validators.required]],
      multiSelectProviance: ['', [Validators.required]],
      postalCode: ['', [Validators.required, Validators.compose([postalcodeValidator])]],
      waitingPeriod: [''],
      waitingPeriodCustom: [''],
      waitingPeriodinitialsignup: [''],
      paymentInfo: [''],
      bankCode: [''],
      BankTransit: [''],
      accounNum: [''],
      voidcheck: [''],
      corporatelogo: [''],
      walletConfig: [false, [Validators.required]],
      tierConfig: ['', [Validators.required]],
      expectednoofEmployees: [''],
      ShowEmployer: ['', [Validators.required]],
      autoSelectEmp: [false, [Validators.required]],
      showEmployeeListData: [false, [Validators.required]],
    });
    this.adminform = this.formBuilder.group({
      adminfirstname: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(200)
        ],
      ],
      adminlastname: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(200)
        ],
      ],
      adminphone: ["",
        Validators.compose([Validators.required, Validators.minLength(17), Validators.maxLength(17), Validators.pattern(/^[^A-Za-z@#$%&*{}'";:<>?]+$/)]),
      ],
      adminemail: [
        '',
        [
          Validators.required,
          Validators.pattern(this.commonPatternsService.emailPattern),
        ],
      ],
      role: ['', [Validators.required]],
      roleName: [''],
    });

    this.payrolldeductionoption = this.formBuilder.group({
      payrolloption: ['', [Validators.required]],
    });

    this.addEmployeeformList = this.formBuilder.group({
      employeeId: [''],
      employeeFirstName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      employeeLastName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      employeeEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(
            this.commonPatternsService.emailPattern
          ),

        ],
      ],

      employeeOccupation: ['', Validators.pattern('^(?!\\s)[A-Za-z0-9\\s]+$')],
      employeeDateofhire: [''],
      employeeDateofbirth: [''],
      employeeGender: [null],
      employeeCountry: [''],
      employeeResidence: [''],
      employeefamilyStatus: [''],

      employeePhoneno: ['', Validators.compose([Validators.minLength(17), Validators.maxLength(17), Validators.pattern(/^[^A-Za-z@#$%&*{}'";:<>?]+$/)])],
      employeeStreetAddress: [''],
      employeeCity: [''],
      employeeProvince: [''],
      employeePostalCode: [''],
      employeeTier: [''],
      empployeeAnnualIncome: ['']
    });

    this.addEmployeeformListwaddell = this.formBuilder.group({
      employeeId: [''],
      employeeFirstName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      employeeLastName: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
        ],
      ],
      employeeEmail: [
        '',
        [
          Validators.required,
          Validators.pattern(
            this.commonPatternsService.emailPattern
          ),

        ],
      ],
      employeePhoneno: ["",
        Validators.compose([Validators.required, Validators.minLength(17), Validators.maxLength(17), Validators.pattern(/^[^A-Za-z@#$%&*{}'";:<>?]+$/)]),
      ],
      employeeStreetAddress: ['', [Validators.required]],
      employeeCountry: ['', [Validators.required]],
      employeeCity: ['', [Validators.required]],
      employeeProvince: ['', [Validators.required]],
      employeePostalCode: ['', Validators.compose([Validators.required, postalcodeValidatorwaddell])],
    });



    // this.dynamicArray.push(
    //   { sno: '1', tierName: 'All', walletAmount: '$1000' },
    // );
    this.dynamicArray.forEach((element: any) => {
      let obj = {
        id: element.sno,
        tierName: this.capitalize(element.tierName),
      };
      this.tierinfonames.push(obj);
    });

    setTimeout(() => {
      // this.GetCorpDetails();
      // this.getServiceWorkerDetails();
    }, 1000);
    this.generateDateOptions();

    this.store.dispatch(loadCorporateData());
    this.corporateData$ = this.store.select(state => state.corporateData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.corporateData$.subscribe(data => {
      if (data) {
        console.log(data)
        if (data?.corporateData == undefined || Object.keys(data.corporateData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (this.clientList.length > 0) {
          return;
        }

        const role = sessionStorage.getItem('role');
        if (role == 'ADMINISTRATOR') {
          // this.clientList = decompress(data.corporateData)
          this.clientList = data.corporateData
        } else {
          this.clientList = data.corporateData.map(res => {
            return {
              ...res,
              formsLength: res.forms?.length || 0
            }
          })
        }
      } else {
        console.error('Observable returned undefined');
      }
    })
  }
  editForm(){
    this.gracePeriod;
    

  }

  public getLanguageTokens() {
    // let body = {
    //   "project": "Admin Portal",
    //   "url": "editCorporate"
    // }
    // this.http
    //   .post('https://languageengineapi.aitestpro.com/string/project-url-strings', body, {
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       console.log(response)
    //       this.lang = {};
    //       this.languageData = response.strings
    //       this.selectedLanguage = sessionStorage.getItem("language")
    //       for (let token of response.strings) {
    //         this.lang[token.key] = token[this.selectedLanguage];
    //       }

    //       this.dropdownSettings = {
    //         singleSelection: false,
    //         // closeDropDownOnSelection: true,
    //         idField: 'id',
    //         textField: 'shortName',
    //         selectAllText: this.lang.Select_All,
    //         unSelectAllText: this.lang.Deselect_All,
    //         itemsShowLimit: 4,
    //         allowSearchFilter: true,
    //       };

    //     })



    this.languageData$ = this.store.select(state => state.languageData).pipe(
      startWith([]),
      takeUntil(this.destroy$)
    );

    this.languageData$.subscribe(data => {
      if (data) {
        // console.log(data)
        if (data?.languageData == undefined || Object.keys(data.languageData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        // if(Object.keys(this.lang).length>0){
        //   return;
        // }
        setTimeout(() => {
          this.lang = {};
          this.languageData = data?.languageData
          this.selectedLanguage = sessionStorage.getItem("language")
          for (let token of data?.languageData) {
            this.lang[token.key] = token[this.selectedLanguage];
          }
          // console.log('this.lang',this.lang)

          this.dropdownSettings = {
            singleSelection: false,
            // closeDropDownOnSelection: true,
            idField: 'id',
            textField: 'shortName',
            selectAllText: this.lang.Select_All,
            unSelectAllText: this.lang.Deselect_All,
            itemsShowLimit: 8,
            allowSearchFilter: true,
          };
        }, 0)
      }
    })


  }
  toggleCollapsee(parentId: string): void {
    this.isCollapsed[parentId] = !this.isCollapsed[parentId];
  }
  toggleCollapseeTwo(parentId: string): void {
    this.isCollapsedTwo[parentId] = !this.isCollapsedTwo[parentId];
  }
  toggleCollapseeThree(parentId: string): void {
    this.isCollapsedThree[parentId] = !this.isCollapsedThree[parentId];
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
  copylink() {
    this.toastrService.success("link copied to Clipboard");
  }
  get emp() {
    // console.log(this.addEmployeeformList.controls)
    return this.addEmployeeformList.controls;
  }
  get empwaddell() {
    return this.addEmployeeformListwaddell.controls;
  }
  checkout() {
    let redirect_url = 'http%3A%2F%2Flocalhost%3A3008%2Fhandleresponse';
    let useremail = 'testemail@gmail.com';
    let request = `merchant_id=284414&order_id=${this.order_no}&currency=INR&amount=${this.testAmount}&redirect_url=${redirect_url}&cancel_url=${redirect_url}&language=EN&billing_name=${this.selectedAddress.name}&billing_address=${this.selectedAddress.address}&billing_city=${this.selectedAddress.city}&billing_state=MH&billing_zip=${this.selectedAddress.pincode}&billing_country=India&billing_tel=${this.selectedAddress.phone}&delivery_name=${this.selectedAddress.name}&delivery_address=${this.selectedAddress.address}&delivery_city=${this.selectedAddress.city}&delivery_state=${this.selectedAddress.state}&delivery_zip=${this.selectedAddress.pincode}&delivery_country=India&delivery_tel=${this.selectedAddress.phone}&billing_email=${useremail}`
    this.encRequestRes = request;
    setTimeout(() => {
      this.form.nativeElement.submit();
    }, 1000)

    // this.PaymentService.encryptdata(request).subscribe(
    //   data => {
    //   console.log('---------------------', data['response'])
    //   this.encRequestRes = data['response'];
    //       setTimeout(()=>{
    //           this.form.nativeElement.submit();
    //       },1000)
    //   }, error => {
    //   console.log(error)
    //   }
    //   );
  }
// onWalletTypeSelected(event: Event): void {
//   const selectedValue = (event.target as HTMLSelectElement).value;
//   console.log({ event }, selectedValue);

//   const selectedOption = this.tierWalletConfig.walletTypes.find(
//     (item: any) => item.value === selectedValue
//   );

//   if (selectedOption?.key === 'mywsa') {
//     console.log('mywsa selected!');
    
//     // ✅ Always show modal
//     setTimeout(() => {
//       ($('#wsadata') as any).modal('show');
//     }, 100);

//     // ✅ Optional: Reset and reassign the value so next same selection still triggers change
//     this.walletType = ''; // Unset temporarily
//     setTimeout(() => {
//       this.walletType = selectedValue; // Re-assign to allow same selection next time
//     }, 200);
//   }

//   this.closeEditTierdModel();
// }
onWalletTypeSelected(event: Event): void {
  const selectedValue = (event.target as HTMLSelectElement).value;
  const selectedOption = this.tierWalletConfig.walletTypes.find(
    (item: any) => item.value === selectedValue
  );

  this.walletType = selectedValue;
  console.log('walletType',this.walletType);

  if (selectedOption?.key === 'mywsa') {
    this.showWSAModal();
    if (this.wsaOptions) {
      this.wsaSelected = { ...this.wsaOptions }; // deep copy to avoid mutation issues
    }
    setTimeout(()=>{
       this.openEditWSA();

    },100
    )
  this.openEditWSA();


    // this.updateWSAForm(this.wsaOptions, 0);  
    //  this.openEditWSA();
     console.log({wsaSelected:this.wsaSelected})
  this.selectedGracePeriodKey=this.wsaSelected?.gracePeriod
  console.log('selectedGracePeriodKey',this.selectedGracePeriodKey)
  this.wsaReimbursementFreeze=this.wsaSelected?.reimbursementFreeze
  this.freezeStartDate=this.wsaSelected?.reimburseStartDate
  this.reimbursementFreezeReason=this.wsaSelected?.reimbursementFreeze
  this.allowCarryOver1=this.wsaSelected?.allowCarryOver
  this.maxCarryOverLimit=this.wsaSelected?.setMaxCarryOverLimit
  this.maxCarryOverAmount=this.wsaSelected?.maxCarryOverAmount
  // this.subCategorySelection=this.wsaSelected?.wsaCategories
  // this.categorySelection=this.wsaSelected?.wsaCategories
  

 console.log('categoriesWithSubcategories',this.categoriesWithSubcategories)
 console.log('wsaCategories',this.wsaSelected?.wsaCategories)
     console.log()
  }
  

  this.closeEditTierdModel(); // if you need to close another modal
}

forceOpenWSAModal(): void {
  this.showWSAModal();
}

private showWSAModal(): void {
  // This forces the Bootstrap modal to show
  const modalElement = document.getElementById('wsadata');
  if (modalElement) {
    const modal = new (window as any).bootstrap.Modal(modalElement, {
      backdrop: 'static'
    });
    modal.show();
  }
}



selectedGracePeriodKey1: string = '';
enableGracePeriod: boolean | null = null;
// wsaReimbursementFreeze:boolean|null = null;
// allowCarryOver1:boolean|null=null;
allowCarryOver1: string = 'Yes';


maxCarryOverLimit:any;

reimbursementFreezeReason: string = '';
// freezeStartDate: string = ''; 
  // TypeScript Component
gracePeriod:any;
maximumCarryOverLimitAmount:any;
allowCarryOver:any;

reimbursement:any;
reimbursementDate:any;
setMaximumCarryOverLimit:any;
wsaCategories?:any;
selectedCarryOverOption: string = '';
selectedCategories: string[] = [];
selectedSubCategories: { [categoryId: string]: Set<string> } = {};


allOptions: any[] = [];
categories: any[] = [];
subCategories: any[] = [];


selectedGracePeriodKey:string = ''; // Will hold the selected key (e.g., "30D")

onBack(){
  console.log('back');
}
  onSubmit(){
console.log('submit');
  }
  // filteredCategories:any;
  filteredCategories: any[] = [];
categoriesWithSubcategories: any[] = [];
categorySelection: { [categoryId: string]: boolean } = {};
// subCategorySelection: { [key: string]: boolean } = {};
subCategorySelection: { [categoryId: string]: { [subCategoryId: string]: boolean } } = {};


// Track selected categories
onCategoryChange(event: Event, categoryId: string): void {
  const isChecked = (event.target as HTMLInputElement).checked;
  this.categorySelection[categoryId] = isChecked;
   if(isChecked == false){
    this.subCategorySelection[categoryId] = {};

  }
}

// Track selected sub-categories
onSubCategoryChange(event: Event, subCategoryId: string, categoryId: string): void {
  const isChecked = (event.target as HTMLInputElement).checked;

  // Initialize if not yet set
  if (!this.subCategorySelection[categoryId]) {
    this.subCategorySelection[categoryId] = {};
  }

  this.subCategorySelection[categoryId][subCategoryId] = isChecked;
 
}


// Utility to check state
isCategorySelected(categoryId: string): boolean {
  return !!this.categorySelection[categoryId];
}

isSubCategorySelected(subCategoryId: string, categoryId: string): boolean {
  return !!(this.subCategorySelection[categoryId]?.[subCategoryId]);
}

// isCategorySelected(categoryId: number): boolean {
//   return this.selectedCategoryIds.has(categoryId);
// }

// onCategoryChange(event: any, categoryId: number): void {
//   if (event.target.checked) {
//     this.selectedCategoryIds.add(categoryId);
//   } else {
//     this.selectedCategoryIds.delete(categoryId);
//     this.selectedSubcategoryMap.delete(categoryId); // Also clear its subcategories
//   }
// }

// isSubCategorySelected(subId: number, categoryId: number): boolean {
//   return this.selectedSubcategoryMap.has(categoryId) && this.selectedSubcategoryMap.get(categoryId)!.has(subId);
// }

// onSubCategoryChange(event: any, subId: number, categoryId: number): void {
//   if (!this.selectedSubcategoryMap.has(categoryId)) {
//     this.selectedSubcategoryMap.set(categoryId, new Set());
//   }

//   const subSet = this.selectedSubcategoryMap.get(categoryId)!;

//   if (event.target.checked) {
//     subSet.add(subId);
//   } else {
//     subSet.delete(subId);
//     if (subSet.size === 0) {
//       this.selectedSubcategoryMap.delete(categoryId);
//     }
//   }
// }
validationMessage: string = '';
currentYear = new Date().getFullYear();

decemberStart = new Date(this.currentYear, 11, 1); // December 1
decemberEnd = new Date(this.currentYear, 11, 31); // December 31

bsConfig = {
  dateInputFormat: 'MM-DD-YYYY',
  showWeekNumbers: false,
  minDate: this.decemberStart,
  maxDate: this.decemberEnd
};
checkDateOfBirth(selectedDate: Date): void {
  console.log('Selected:', selectedDate);
  if (!selectedDate || isNaN(selectedDate.getTime())) {
    // this.validationMessage = 'Invalid date format.';
    return;
  }

  const inputMonth = selectedDate.getMonth(); // 11 = December
  const inputYear = selectedDate.getFullYear();

  if (inputYear !== this.currentYear || inputMonth !== 11) {
    this.validationMessage = `Please select a date in December ${this.currentYear}.`;
    return;
  }

  const afterDate = new Date(inputYear + 1, 0, 1); // Jan 1 next year

  const formattedPicked = this.formatDate1(selectedDate);
  const formattedAfter = this.formatDate1(afterDate);

  this.validationMessage = `Employees are eligible to make WSA claims for the current benefit year beyond ${formattedPicked}, but all approved eligible claims will not be reimbursed until after ${formattedAfter}.`;
}
onReimbursementFreezeChange(value: string): void {
  this.wsaReimbursementFreeze = value;

  if (value === 'No') {
    this.freezeStartDate = null;
    this.validationMessage = ''; // Clear message
  }
}



// checkDateOfBirth(event: any): void {
//   console.log(event.target.value);
//   this.freezeStartDate = event.target.value;
//   const inputDate = new Date(event.target.value);
//   console.log('inputDate',inputDate)
//   if (isNaN(inputDate.getTime())) {
//     this.validationMessage = 'Invalid date format.';
//     return;
//   }

//   const inputMonth = inputDate.getMonth(); // 11 = December
//   const inputYear = inputDate.getFullYear();
//   // console.log('inputMonth',inputMonth)
//   // console.log('inputYear',inputYear)
//   console.log('this.currentYear',this.currentYear)
//   if (inputYear != this.currentYear || inputMonth != 11) {
//     this.validationMessage = `Please select a date in December ${this.currentYear}.`;
//   } else {
//   const pickedDate = new Date(event.target.value);
//   console.log('pickedDate',pickedDate)


//   const afterDate = new Date(pickedDate);
//   afterDate.setFullYear(pickedDate.getFullYear() + 1);
//   afterDate.setMonth(0); // January
//   afterDate.setDate(1);  // 1st
//   console.log('afterDate',afterDate)

//   const formattedPicked = this.formatDate1(pickedDate);
//   const formattedAfter = this.formatDate1(afterDate);
//   console.log(formattedPicked,formattedAfter);

//   this.validationMessage = `Employees are eligible to make WSA claims for the current benefit year beyond ${formattedPicked}, but all approved eligible claims will not be reimbursed until after ${formattedAfter}`;
//   }
//   console.log('validationMessage',this.validationMessage)
  
// }
preventNumbers(event: KeyboardEvent): void {
  const char = event.key;
  if (/\d/.test(char)) {
    event.preventDefault();
  }
}




selectedCategoryData: any[] = [];
isEditMode: boolean = false;
editingItemIndex: number | null = null;

forceShowWSAModal(): void {
  console.log('Forcing modal open for myWSA');
  setTimeout(() => {
    ($('#wsadata') as any).modal('show');
  }, 100);
}


openEditWSA(){
    $('#wsadata').modal('hide');
    // this.allowCarryOver1='Yes';
      this.allowCarryOver1 = this.wsaSelected?.allowCarryOver ?? '';
      console.log('allowCarryOver1 (from wsaSelected):', this.allowCarryOver1);

  console.log('this.wsaSelected',this.wsaSelected)
  this.selectedGracePeriodKey = this.wsaSelected?.gracePeriod ?? '';
 
  this.wsaReimbursementFreeze = this.wsaSelected?.reimbursement ?? 'No';

  this.freezeStartDate = this.wsaSelected?.reimburseStartDate ?? '';
  
//  this.maxCarryOverLimit = this.wsaSelected?.setMaxCarryOverLimit ? 'Yes' : 'No';
//   this.maxCarryOverAmount = this.wsaSelected?.maximumCarryOverLimitAmount ?? null;

this.maxCarryOverLimit = this.wsaSelected?.setMaxCarryOverLimit === 'Yes' ? 'Yes' : 'No';

if (this.allowCarryOver1 === 'Yes' && this.maxCarryOverLimit === 'Yes') {
  this.maxCarryOverAmount = this.wsaSelected?.maximumCarryOverLimitAmount ?? null;
} else {
  this.maxCarryOverAmount = null;
}


console.log('reimbursementFreeze:', this.wsaSelected?.reimbursementFreeze);
console.log('maxCarryOverAmount:', this.wsaSelected?.maximumCarryOverLimitAmount);
console.log('wsaReimbursementFreeze model:', this.wsaReimbursementFreeze);
console.log('maxCarryOverAmount model:', this.maxCarryOverAmount);

  this.categorySelection = {};
  this.subCategorySelection = {};

 console.log('categoriesWithSubcategories',this.categoriesWithSubcategories)
 console.log('wsaCategories',this.wsaSelected?.wsaCategories)
 let selectedCategories = new Set();
 let selectedSubCategories = new Set();

 for(let i=0; i<this.categoriesWithSubcategories.length;i++){
  for(let j=0; j<this.categoriesWithSubcategories[i].subcategories.length; j++){
    if(this.wsaSelected?.wsaCategories.includes(this.categoriesWithSubcategories[i].subcategories[j].value)){
      let categoryId= this.categoriesWithSubcategories[i].subcategories[j].categoryId;
      let id= this.categoriesWithSubcategories[i].subcategories[j].id;
      selectedCategories.add(categoryId)
      selectedSubCategories.add(id)
      this.categorySelection[categoryId] = true
      if (!this.subCategorySelection[categoryId]) this.subCategorySelection[categoryId] = {};
      this.subCategorySelection[categoryId][id]=true
    }
  }
 }
 console.log('selectedCategories',selectedCategories);
 console.log('selectedSubCategories',selectedSubCategories);
 console.log('categorySelection',this.categorySelection)
 console.log('subCategorySelection',this.subCategorySelection)


  $('#wsadata').modal('show');
}

selectedCategoryIds: Set<number> = new Set();
selectedSubcategoryMap: Map<number, Set<number>> = new Map();



formInvalid(): boolean {
  if (!this.selectedGracePeriodKey) {
    // console.log('Grace Period not selected');
    return true;
  }

  if (!this.allowCarryOver1) {
    // console.log('Allow Carry Over not selected');
    return true;
  }

  if (this.wsaReimbursementFreeze === 'Yes' && !this.freezeStartDate) {
    // console.log('Freeze Start Date missing');
    return true;
  }

  if (!this.wsaReimbursementFreeze) {
    // console.log('Reimbursement Freeze not selected');
    return true;
  }

  if (this.allowCarryOver1 === 'Yes') {
    if (!this.maxCarryOverLimit) {
      // console.log('Max Carry Over Limit not selected');
      return true;
    }

    if (this.maxCarryOverLimit === 'Yes' && (this.maxCarryOverAmount == null)) {
      // console.log('Max Carry Over Amount missing or invalid');
      return true;
    }
  }

  let hasAtLeastOneSubcategory = false;

  for (const item of this.categoriesWithSubcategories) {
    const categoryId = item.category.id;
    const subcategories = item.subcategories;

    for (const sub of subcategories) {
      if (this.subCategorySelection[categoryId]?.[sub.id]) {
        hasAtLeastOneSubcategory = true;
        break;
      }
    }
  }

  if (!hasAtLeastOneSubcategory) {
    // console.log('No subcategories selected');
    return true;
  }

  return false;
}



submitSelectedData(): void {
  this.selectedCategoryData = [];

  for (const item of this.categoriesWithSubcategories) {
    const categoryId = item.category.id;

    if (this.categorySelection[categoryId]) {
      const selectedSubcategories = [];

      for (const sub of item.subcategories) {
        const isSelected = this.subCategorySelection[categoryId]?.[sub.id];

        if (isSelected) {
          if (sub.label === 'Add custom sub category') {
            if (item.customSubcategoryLabel?.trim()) {
              selectedSubcategories.push({
                label: item.customSubcategoryLabel,
                
                custom: true
              });
            }
          } else {

            selectedSubcategories.push({
              
              label: sub.label,
              custom: false
            });
          }
        }
      }

      this.selectedCategoryData.push({
        category: item.category.label,
        subCategories: selectedSubcategories
        // categories:this.selectedCategoryIds
      });
    }
  }
  const setMaxLimit = this.allowCarryOver1 === 'Yes' && this.maxCarryOverAmount != null && this.maxCarryOverAmount !== ''
  ? 'Yes'
  : 'No';

  const formValues = {
    gracePeriod: Number(this.selectedGracePeriodKey ?? 0) ?? 0,
    reimbursement: this.wsaReimbursementFreeze,
    reimburseStartDate: this.wsaReimbursementFreeze === 'Yes' ? this.freezeStartDate : null,
    allowCarryOver: this.allowCarryOver1,
  //    setMaxCarryOverLimit: this.allowCarryOver1 === 'Yes' && this.maxCarryOverLimit ? 'Yes' : 'No',
  // ...(this.allowCarryOver1 === 'Yes' && this.maxCarryOverLimit === 'Yes' && this.maxCarryOverAmount != null
  //   ? { maximumCarryOverLimitAmount: this.maxCarryOverAmount }
  //   : {}),

  setMaxCarryOverLimit: setMaxLimit,
  ...(setMaxLimit === 'Yes' ? { maximumCarryOverLimitAmount: this.maxCarryOverAmount } : {}),
  wsaCategories: this.selectedCategoryData.flatMap(item =>
    item.subCategories.map(sub => sub.label)
  )
};

  //   setMaxCarryOverLimit: this.allowCarryOver1 === 'Yes' && this.maxCarryOverLimit === true ? 'Yes' : 'No',
  // ...(this.allowCarryOver1 === 'Yes' && this.maxCarryOverLimit === true && this.maxCarryOverAmount != null
  //   ? { maximumCarryOverLimitAmount: this.maxCarryOverAmount }
  //   : {}),

   
    //  setMaxCarryOverLimit:this.maxCarryOverLimit ? 'Yes' : 'No',
    //  maximumCarryOverLimitAmount: this.maxCarryOverLimit === 'Yes' ? this.maxCarryOverAmount : null,

    // wsaCategories: this.selectedCategoryData.flatMap(item =>
    //   item.subCategories.map(sub => sub.label)
    // )
    // wsaCategories: this.selectedCategoryData.map(item => item.category) // Only sending category labels
    
  // };

  console.log('Final Submitted WSA Form:', formValues);
  this.wsaOptions = formValues;
  this.wsaSelected = formValues;
  this.wsaOptions = { ...formValues }; // Save for reuse
this.wsaSelected = { ...formValues };
console.log
console.log("Submitted:", this.wsaOptions);
sessionStorage.setItem('wsaOptions',JSON.stringify(this.wsaOptions))
// console.log("Re-opening WSA, selected:", this.wsaSelected);
// console.log('formValues', formValues);

  this.closeEditTierdModel();
  $('#wsadata').modal('hide');
}

wsaOptions: any = {};
wsaReimbursementFreeze: string = '';
freezeStartDate: string = '';

maxCarryOverAmount: string = '';

wsaDataList: any[] = []; // Replace `any` with your actual type if known

addCustomCategory(item: any): void {
  const label = item.customSubcategoryLabel?.trim();

  if (!label || label.length < 3) return;

  // Check if subcategory with same label already exists
  const exists = item.subcategories.some(
    (sub: any) => sub.label.toLowerCase() === label.toLowerCase()
  );

  if (!exists) {
    const newSubCategory = {
      id: 'custom-' + Date.now(), // generate unique ID
      label: label,
      categoryId: item.category.id
    };

    item.subcategories.push(newSubCategory);
  }

  // Clear input
  item.customSubcategoryLabel = '';
}
removeCustomSubCategory(item: any, sub: any): void {
  const index = item.subcategories.findIndex((s: any) => s.id === sub.id);
  if (index > -1) {
    item.subcategories.splice(index, 1);

    // Also remove it from selection map if checked
    const selection = this.subCategorySelection[item.category.id];
    if (selection && selection[sub.id]) {
      delete selection[sub.id];
    }
  }
}


get reimbursementFreezeMessage(): string | null {
  console.log('freezeStartDate',this.freezeStartDate)
  if (!this.freezeStartDate) return null;

  const pickedDate = new Date(this.freezeStartDate);
  console.log('pickedDate',pickedDate)
  const afterDate = new Date(pickedDate);
  afterDate.setFullYear(pickedDate.getFullYear() + 1);
  afterDate.setMonth(0); // January
  afterDate.setDate(1);  // 1st
  console.log('afterDate',afterDate)

  const formattedPicked = this.formatDate1(pickedDate);
  const formattedAfter = this.formatDate1(afterDate);
  console.log(formattedPicked,formattedAfter)

  return `Employees are eligible to make WSA claims for the current benefit year beyond ${formattedPicked}, but all approved eligible claims will not be reimbursed until after ${formattedAfter}`;
}

formatDate1(date: Date): string {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${month}/${day}/${year}`;
}


  formConfig1() {
    var endPoint = '/api/ap/admin/corporateTiersWallet/formConfig';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {

            this.tierWalletConfig = response.data 

            this.gracePeriod = this.tierWalletConfig.wsaOptions.gracePeriod
            this.maximumCarryOverLimitAmount=this.tierWalletConfig.wsaOptions.maximumCarryOverLimitAmount
            console.log('maximumCarryOverLimitAmount',this.maximumCarryOverLimitAmount)
            // this.allowCarryOver=this.tierWalletConfig.wsaOptions.allowCarryOver
            this.reimbursement=this.tierWalletConfig.wsaOptions.reimbursement
            console.log('Reimbursement:', this.reimbursement);
              this.allowCarryOver = this.tierWalletConfig.wsaOptions.allowCarryOver;
              this.allowCarryOver1 = this.allowCarryOver.default || '';
              console.log('AllowCarryOver:',this.allowCarryOver);


            this.reimbursementDate=this.tierWalletConfig.wsaOptions.reimbursementDate
            this.setMaximumCarryOverLimit=this.tierWalletConfig.setMaximumCarryOverLimit
            this.wsaCategories=response.data.wsaOptions.wsaCategories


            // this.filteredCategories = this.wsaCategories.options.filter((item: any) => item.type === 'category');
          console.log({wsaCategories:this.wsaCategories})
          const options = this.wsaCategories.options;
          console.log({options})
          const categories = options.filter((item: any) => item.type === 'category');
          console.log({categories})
          const subcategories = options.filter((item: any) => item.type === 'sub-category');
          console.log({subcategories})


          this.categoriesWithSubcategories = categories.map((category: any) => {
  const relatedSubcategories = subcategories
    .filter((sub: any) => sub.categoryId === category.id)
    .map((sub: any) => ({
      ...sub,
      selected: false 
    }));

  const hasCustomSubcategoryOption = relatedSubcategories.some(
    (sub: any) => sub.label === 'Add custom sub category'
  );

  return {
    category,
    subcategories: relatedSubcategories,
    showCustomInput: false,
    customSubcategoryLabel: '',
    hasCustomSubcategoryOption
  };
});
           console.log("Mapped categories:", this.categoriesWithSubcategories);
           
            
            console.log(response)
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });

          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }
  formConfig() {
    console.log("enter function");
    // var endPoint = '/api/ap/admin/corporateSignup/formConfig';
    // var accessToken = sessionStorage.getItem('accessToken');

    // this.http
    //   .get(environment.apiUrl + endPoint, {
    //     headers: {
    //       Authorization: 'Bearer ' + accessToken,
    //       'Content-Type': 'application/json',
    //     },
    //   })
    //   .subscribe(
    //     (response: any) => {
    //       if (response['status'] == 200) {
    //         console.log('hjjhj', response);

    //         this.companyPaidCoveragePlanLevels = response.data.companyPaidCoveragePlanLevels

    //         this.waddellExcelKeys = response.data.bulkPlanExcelKeys.waddell
    //         this.statesInfo = response.data.states;
    //         this.walletConfig = response.data.walletConfig;

    //         this.allBrokers = response.data.allBrokersUnique;
    //         this.allBrokers_ = response.data.allBrokers;


    //         this.payrolldeduction = response.data.payRolldeductionUI
    //         this.countryList = response.data.allCountrys;
    //         this.multiSlectProviances = response.data.countryList[0].countryStates;
    //         this.multiSlectProviances = this.multiSlectProviances.sort(
    //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //         );
    //         console.log("this.countryList  :", this.countryList);
    //         this.groupContactsData = response.data.groupContactRoles;


    //         this.configprovinceres = response.data.states.sort(
    //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
    //         );
    //         console.log('configaratoom', this.configprovinceres);


    //         this.enrollmentDates = response.data.planEnrollmentDatesFullMonth;
    //         console.log(this.enrollmentDates)

    //         // console.log(this.allBrokers)
    //         this.GetCorpDetails();
    //       } else {
    //         Swal.fire({ title: this.lang.Error??'Error', text: response.message });
    //       }
    //     },
    //     (error) => {
    //       if (
    //         error.status == 400 ||
    //         error.status == 401 ||
    //         error.status == 402 ||
    //         error.status == 403
    //       ) {
    //         Swal.fire({
    //           title: this.lang.Error??'Error',
    //           text: error.error.error.message,
    //           showDenyButton: false,
    //           showCancelButton: false,
    //           confirmButtonText: this.lang.Proceed,
    //         }).then((result) => {
    //           /* Read more about isConfirmed, isDenied below */
    //           if (result.isConfirmed) {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //           else {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //         });
    //       } else {
    //         // Swal.fire(error.error.error.message)
    //         Swal.fire({ title: this.lang.Error??'Error', text: error.error.error.message });
    //       }
    //       // this.toastrService.error("Invalid Credentials", 'Error!');
    //     }
    //   );

    this.store.dispatch(loadCorporateSignupConfigData());
    this.corporateSignupConfigData$ = this.store.select(state => state.corporateSignupConfigData).pipe(
      // startWith([]),
      // takeUntil(this.destroy$)
    );
    this.corporateSignupConfigData$.subscribe(data => {
      if (data) {
        console.log(data)
        if (data?.corporateSignupConfigData == undefined || Object.keys(data.corporateSignupConfigData).length <= 0) {
          console.log('No data to process', new Date().toISOString());
          return;
        }
        if (Object.keys(this.corporateSignupConfigData).length > 0) {
          return;
        }
        console.log('corporateSignupConfigData', this.corporateSignupConfigData)
        this.corporateSignupConfigData = { ...data.corporateSignupConfigData }

        this.companyPaidCoveragePlanLevels = this.corporateSignupConfigData.companyPaidCoveragePlanLevels
        this.waddellExcelKeys = this.corporateSignupConfigData.bulkPlanExcelKeys.waddell
        this.statesInfo = this.corporateSignupConfigData.states;
        this.walletConfig = this.corporateSignupConfigData.walletConfig;

        this.allBrokers = this.corporateSignupConfigData.allBrokersUnique;
        this.allBrokers_ = this.corporateSignupConfigData.allBrokers;
        this.payrolldeduction = this.corporateSignupConfigData.payRolldeductionUI
        this.countryList = this.corporateSignupConfigData.allCountrys;
        this.multiSlectProviances = this.corporateSignupConfigData.countryList[0].countryStates;
        this.multiSlectProviances = [...this.multiSlectProviances].sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
        console.log("this.countryList  :", this.countryList);
        this.groupContactsData = this.corporateSignupConfigData.groupContactRoles;

        this.configprovinceres = [...this.corporateSignupConfigData.states].sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );
        console.log('configaratoom', this.configprovinceres);

        this.enrollmentDates = this.corporateSignupConfigData.planEnrollmentDatesFullMonth;
        console.log(this.enrollmentDates)

        // console.log(this.allBrokers)
        this.GetCorpDetails();

      } else {
        console.error('Observable returned undefined');
      }
    })
  }

  isGenericLink() {
    if ((this.corpDetails.plans?.coveredByCompany?.length > 0 || this.corpDetails?.plans?.paidByEmployee?.length > 0 || this.corpDetails?.plans?.paidByCompany?.length > 0) && (this.genericLink)) {
      return true
    }
    return false
  }

  // getServiceWorkerDetails() {
  //   let CorpId = this.route.snapshot.params['id']
  //   var endPoint = '/api/ap/admin/corporate/' + CorpId + '/details';

  //   let prefetchurls = []

  //   let Data = [{
  //     url: environment.apiUrl + endPoint,
  //     // fetch options
  //     options: {

  //       mode: 'cors',
  //       headers: {

  //         Authorization: 'Bearer ' + sessionStorage.getItem('accessToken'),
  //         'Content-Type': 'application/json',
  //       }
  //     }
  //   }]
  //   prefetchurls = Data

  //   postServiceWorkerMessage(WorkerMessageType.Prefetch, prefetchurls).then((results: WorkerUrlPrefetchResult) => {


  //     let CorpId = this.route.snapshot.params['id']


  //     let response = results[0].response

  //     console.log(results[0].response.data)
  //     this.employeeList = response.data.employees;
  //     this.addedEmployeelist = response.data.employees;

  //     this.lengthofemployee = this.employeeList.length;
  //     this.bulkplans = response.data.bulkPlans;
  //     this.corpDetails = response.data;
  //     this.genericLink = response.data.genericLink

  //     this.SharedService.setCorporationName(response.data.corporationName)
  //     sessionStorage.setItem(
  //       'corporateClientId',
  //       response.data.corporateClientId
  //     );
  //     sessionStorage.setItem("corporationName", response.data.corporationName)
  //     sessionStorage.setItem('corporateId', CorpId);
  //     this.corpDetails = response.data;
  //     this.CorpName = response.data.corporationName;
  //     this.policyStartDate =
  //       this.datePipe.transform(
  //         response.data.policyStartDate,
  //         'MMM-dd-yyyy'
  //       ) || '';
  //     if (!this.enrollmentDates?.includes(this.policyStartDate)) {
  //       this.enrollmentDates.unshift(this.policyStartDate)
  //     }
  //     this.client['PolicyStartDate'].setValue(this.policyStartDate);
  //     this.client['PolicyStartDate'].updateValueAndValidity();

  //     this.domainExisting = response.data.domainExisting;
  //     this.streetAddress = response.data.streetAddressLine1;
  //     this.streetAddress2 = response.data.streetAddressLine2;
  //     this.aptSuite = response.data.apt;
  //     this.country = response.data.country;
  //     this.multiProviance = JSON.parse(response.data.corporteWorkingProvince).map(function (item) {
  //       return parseInt(item, 10);
  //     });
  //     this.multiSelectProviance = JSON.parse(response.data.corporteWorkingProvince)
  //     console.log('this.multiProviance', (this.multiProviance));

  //     setTimeout(() => {
  //       this.showmultiSlectProviances = [];
  //       this.multiSlectProviances.map((proviance) => {

  //         if (this.multiProviance?.includes(proviance.id)) {

  //           this.showmultiSlectProviances.push(proviance)
  //           this.multiSelectProviancenames.push(proviance)
  //           console.log("showmulti", this.showmultiSlectProviances)
  //         }

  //       });

  //       this.client['multiSelectProviance'].setValue(this.showmultiSlectProviances);
  //       console.log(this.client['multiSelectProviance'])

  //     }, 1000);

  //     console.log(this.multiSelectProviance, "muti")

  //     this.corporationName = response.data.corporationName;
  //     this.ParentBrokerName = response.data.parentName;
  //     setTimeout(() => {
  //       this.allBrokers.map((broker) => {
  //         if (broker.id == response.data.parentId) {
  //           this.ParentBrokerId = broker.id;
  //           console.log(this.ParentBrokerId);
  //         }
  //       });
  //     }, 1000);
  //     console.log('this.ParentBrokerId', this.ParentBrokerId);
  //     this.ParentBrokerId = this.ParentBrokerId ?? " ";
  //     this.city = response.data.city;
  //     this.corporateEmployeesInitialSignupWaittime = response.data.corporateEmployeesInitialSignupWaittime;
  //     this.clientregform.get('waitingPeriodinitialsignup').setValue(this.corporateEmployeesInitialSignupWaittime);
  //     this.postalCode = response.data.postalCode;
  //     this.waitTime = response.data.waitTime;
  //     if (this.waitTime == 0) {
  //       this.NoWaithingPeridos = true;
  //     }
  //     else if (this.waitTime == 3) {
  //       this.threeMonths = true;
  //     } else if (this.waitTime == 6) {
  //       this.SixMonths = true;
  //     }
  //     this.useCreditCard = response.data.useCreditCard;
  //     this.padPayment = response.data.padPayment;
  //     this.invoicePayment = response.data.invoicePayment;
  //     this.imagedisplay = response.data.logo;
  //     this.setupWallet = response.data.setupWallet;
  //     this.setUplevelofCoverage = response.data.setUplevelofCoverage;
  //     // this.adminData = response.data.groupAdmins;
  //     this.adminData = response.data.groupAdmins_new;
  //     this.requireEmployeeName = response.data.requireEmployeeName.toString();
  //     this.client['ShowEmployer'].setValue(this.requireEmployeeName);
  //     this.client['ShowEmployer'].updateValueAndValidity();
  //     this.client['autoSelectEmp'].setValue(response.data.cpPlanAutoSelection);
  //     this.client['autoSelectEmp'].updateValueAndValidity();
  //     this.paidByCompany = response.data.plans.paidByCompany;

  //     this.coveredByCompany = response.data.plans.coveredByCompany;

  //     this.paidByEmployee = response.data.plans.paidByEmployee;

  //     this.bulkplans = response.data.bulkPlans;
  //     this.noOfEmployees = response.data.expectedNumberofEmployess;

  //     // if (this.bulkplans.length > 0) {
  //     //   this.noOfEmployees = this.bulkplans[0].qunatity

  //     // }
  //     // else {
  //     //   this.noOfEmployees = response.data.expectedNumberofEmployess;

  //     // }

  //     this.bulkemployeecheck = response.data.employees
  //     this.employeeList = response.data.employees;
  //     this.addedEmployeelist = response.data.employees;
  //     this.lengthofemployee = this.employeeList.length;
  //     setTimeout(() => {
  //       this.countryList.forEach((element: any) => {

  //         if (element.name == this.country) {
  //           this.configprovincereslist = element.countryStates
  //         }
  //         this.configprovincereslist = this.configprovincereslist.sort(
  //           (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
  //         );
  //       })
  //     }, 1000);

  //     this.province = response.data.proviceShortName;

  //     const dom: HTMLElement = this.elementRef.nativeElement;
  //     if (this.useCreditCard == true) {
  //       const element: any = dom.querySelector('#creditpaymentInfo');
  //       if (element != null) element.click();
  //     } else if (this.padPayment == true) {
  //       const element: any = dom.querySelector('#padcreditpaymentInfo');
  //       if (element != null) element.click();
  //     } else {
  //       const element: any = dom.querySelector('#invoicepaymentInfo');
  //       if (element != null) element.click();
  //     }
  //     if (this.waitTime == 0) {
  //       // alert("Aa")
  //       const element: any = dom.querySelector('#nowaitingPeriod');//nowaitingPeriod
  //       if (element != null && element != undefined)
  //         if (element != null) element.click();
  //     } else if (this.waitTime == 3) {
  //       const element: any = dom.querySelector('#threemonths');
  //       if (element != null && element != undefined)
  //         if (element != null) element.click();
  //     } else if (this.waitTime == 6) {
  //       const element: any = dom.querySelector('#sixmonths');
  //       if (element != null && element != undefined)
  //         if (element != null) element.click();
  //     } else {
  //       const element: any = dom.querySelector('#customselection');
  //       if (element != null && element != undefined)
  //         if (element != null) element.click();
  //     }

  //     if (this.policyStartDate && this.policyStartDate.length > 0) {
  //       this.updateStatus(2);
  //     }
  //     if (this.province && this.province.length > 0) {
  //       this.updateStatus(1);
  //     }

  //     if (this.imagedisplay && this.imagedisplay.length > 0) {
  //       this.showimagelogo = false;
  //       this.uploadlogoafter = true;
  //     }

  //     if (this.adminData.length > 0) {
  //       for (let admin of this.adminData) {
  //         admin['firstName'] = admin['firstName'] ?? '';
  //         admin['lastName'] = admin['lastName'] ?? '';
  //         admin['phoneNum'] = admin['phoneNum'] ?? '';
  //         admin['email'] = admin['email'] ?? '';
  //         admin['role'] = admin['role'] ?? '';
  //         admin['roleName'] = admin['roleName'] ?? '';
  //       }
  //       console.log("'''''''''''''''''''''''''''''*********", this.adminData);
  //       sessionStorage.setItem('adminData', JSON.stringify(this.adminData));
  //       this.addadminform = false;
  //       this.showaddadmin = true;
  //       this.addadminform = false;
  //       // this.firstName=response.data.groupAdmins;


  //     }









  //   })
  // }
  ShowBrokerData() {
    this.allBrokerscheck = true
    this.getBrokerProfiles(this.ParentBrokerId)
  }

  async GetCorpDetails() {
    //here need to put return false

    // return false;

    let CorpId = this.route.snapshot.params['id']

    if (CorpId == '' || CorpId == undefined) {
      this.clientregform.reset();
    } else {
      var endPoint = '/api/ap/admin/v2/corporate/' + CorpId + '/details';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .get(environment.apiUrl + endPoint, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {

              this.showBrokerData = true

              this.crateTierid = response.data.defaultActiveTierId;
              this.paymentPlatform = response.data?.paymentPlatform ?? 'Staxbill';
              sessionStorage.setItem('createId', this.crateTierid);

              this.clientregform.get('authorizenetCustomerId').setValue(response.data?.authorizenetCustomerId ?? '0');
              this.clientregform.get('contactEmail').setValue(response.data?.contactEmail ?? '');
              this.contactEmail = response.data?.contactEmail??'';

              if (response.data?.defaultTier?.wallet == true) {
                this.walletIndustryCategory = response.data?.defaultTier?.walletConfig?.industryCategory
                this.walletAdvsiorFeeStructure = response.data?.defaultTier?.walletConfig?.advisorFeeStructure
              } else {
                this.walletIndustryCategory = response.data?.defaultTier?.walletConfig?.industryCategory
                this.walletAdvsiorFeeStructure = 0
              }
              this.bank['bankCode'].setValue(response.data?.myhsaBankingDetails?.bankCode ?? '')
              this.bank['BankTransit'].setValue(response.data?.myhsaBankingDetails?.branchCode ?? '')
              this.bank['accounNum'].setValue(response.data?.myhsaBankingDetails?.accountNumber ?? '')


              if (this.crateTierid == 0) {
                var corporateId = sessionStorage.getItem('corporateId')
                var endPoint = '/api/ap/admin/corporate/' + CorpId + '/tiers/default';

                this.http
                  .post(environment.apiUrl + endPoint, {}, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    },
                  })
                  .subscribe((response: any) => {
                    if (response['status'] == 200) {
                      // this.crateTierid = response.tierId
                      this.crateTierid = response.data
                      sessionStorage.setItem('createId', this.crateTierid);
                    }
                  });
              }

              // this.corporateDetails = {
              //   ...this.corporateDetails,
              //   id: response?.data?.corporateId,
              //   name: response?.data?.corporationName,
              //   email:response?.data?.groupAdmins[0]?.email,
              //   parent:response?.data?.parentName
              // }

              this.corpDetails = response.data;

              this.genericLink = response.data.genericLink
              this.roeAgreementSigned = response.data?.roeAgreementSigned
              this.brokerProfileslist = this.parseAllValuesInArray(response.data.profiles)
              // this.brokerProfileslist1 = this.brokerProfileslist[0]
              this.brokerProfileslist1 = this.brokerProfileslist.length > 0 ? this.brokerProfileslist[0] : [] // ts file

              this.profileid = this.brokerProfileslist[0]?.originalBrokerId
              this.updatedBrokerId = this.brokerProfileslist[0]?.originalBrokerId
              let existingBrokerCheck = true;
              this.allBrokers.forEach((element: any) => {
                console.log(response.data.profiles[0]?.primaryBrokerId)
                if (element.id == response.data.profiles[0]?.primaryBrokerId) {
                  console.log(element)
                  this.filteredallBrokers.push(element)
                  this.ParentBrokerId = element.id
                  existingBrokerCheck = false;
                }
              })

              // check with the parent Name
              this.allBrokers.forEach((element: any) => {
                if (element.id == response?.data?.parentId) {
                  this.filteredallBrokers.push(element)
                  this.ParentBrokerId = element.id
                  existingBrokerCheck = false;
                }
              })

              //check if brokerId exists in this.allBrokers_
              const oldBroker = this.allBrokers_.find(item => item.id == response.data.profiles[0]?.primaryBrokerId)
              if (oldBroker && existingBrokerCheck) {
                existingBrokerCheck = false;
                this.filteredallBrokers.push(oldBroker)
                this.ParentBrokerId = oldBroker.id
              }


              console.log(this.filteredallBrokers)

              this.SharedService.setCorporationName(response.data.corporationName)
              this.SharedService.setCorporateStatus(response.data.roeAgreementSigned ? "Completed" : "Incomplete")

              sessionStorage.setItem(
                'corporateClientId',
                response.data.corporateClientId
              );
              sessionStorage.setItem("corporationName", response.data.corporationName)
              sessionStorage.setItem('corporateId', CorpId);
              this.corpDetails = response.data;
              this.CorpName = response.data.corporationName;
              this.policyStartDate =
                this.datePipe.transform(
                  response.data.policyStartDate,
                  'MMM-dd-yyyy'
                ) || '';
              // if (!this.enrollmentDates?.includes(this.policyStartDate)) {
              //   this.enrollmentDates?.unshift(this.policyStartDate)
              // }
              let newEnrollmentDates = [...this.enrollmentDates];
              if (this.policyStartDate && !newEnrollmentDates.includes(this.policyStartDate)) {
                newEnrollmentDates.unshift(this.policyStartDate);
              }
              this.enrollmentDates = newEnrollmentDates;
              this.client['PolicyStartDate'].setValue(this.policyStartDate);
              this.client['PolicyStartDate'].updateValueAndValidity();

              this.domainExisting = response.data.domainExisting;
              this.streetAddress = response.data.streetAddressLine1;
              this.streetAddress2 = response.data.streetAddressLine2;
              this.aptSuite = response.data.apt;
              this.country = response.data.country;
              this.multiProviance = JSON.parse(response.data.corporteWorkingProvince).map(function (item) {
                return parseInt(item, 10);
              });
              this.multiSelectProviance = JSON.parse(response.data.corporteWorkingProvince)
              console.log('this.multiProviance', (this.multiProviance));

              setTimeout(() => {
                this.showmultiSlectProviances = [];
                this.multiSlectProviances.map((proviance) => {

                  if (this.multiProviance?.includes(proviance.id)) {

                    this.showmultiSlectProviances.push(proviance)
                    this.multiSelectProviancenames.push(proviance)
                    console.log("showmulti", this.showmultiSlectProviances)
                  }

                });

                this.client['multiSelectProviance'].setValue(this.showmultiSlectProviances);
                console.log(this.client['multiSelectProviance'])

              }, 1000);

              console.log(this.multiSelectProviance, "muti")

              this.corporationName = response.data.corporationName;
              this.ParentBrokerName = response.data.parentName;
              setTimeout(() => {
                this.allBrokers.map((broker) => {
                  if (broker.id == response.data.parentId) {
                    this.ParentBrokerId = broker.id;
                    console.log(this.ParentBrokerId);
                  }
                });
              }, 1000);
              console.log('this.ParentBrokerId', this.ParentBrokerId);
              this.ParentBrokerId = this.ParentBrokerId ?? " ";
              this.city = response.data.city;
              this.corporateEmployeesInitialSignupWaittime = response.data.corporateEmployeesInitialSignupWaittime;
              this.clientregform.get('waitingPeriodinitialsignup').setValue(this.corporateEmployeesInitialSignupWaittime);
              this.postalCode = response.data.postalCode;
              this.waitTime = response.data.waitTime;
              if (this.waitTime == 0) {
                this.NoWaithingPeridos = true;
              }
              else if (this.waitTime == 3) {
                this.threeMonths = true;
              } else if (this.waitTime == 6) {
                this.SixMonths = true;
              }

              this.paymentMethodValue = response.data.corporateParentCustomer.paymentMethod
              this.useCreditCard = response.data.useCreditCard;
              this.padPayment = response.data.padPayment;
              this.invoicePayment = response.data.invoicePayment;
              this.imagedisplay = response.data.logo;
              this.setupWallet = response.data.setupWallet;
              this.setUplevelofCoverage = response.data.setUplevelofCoverage;
              // this.adminData = response.data.groupAdmins;
              this.adminData = response.data.groupAdmins_new;
              this.requireEmployeeName = response.data.requireEmployeeName.toString();
              this.client['ShowEmployer'].setValue(this.requireEmployeeName);
              this.client['ShowEmployer'].updateValueAndValidity();
              this.client['autoSelectEmp'].setValue(response.data.cpPlanAutoSelection);
              this.client['autoSelectEmp'].updateValueAndValidity();

              // no tier
              if(response.data?.defaultActiveTierId != undefined 
                && response.data?.defaultActiveTierId != 0 
                && response.data?.setUplevelofCoverage == false){
                let tierId = response.data?.defaultActiveTierId;
                this.paidByCompany = response.data.plans?.paidByCompany?.filter((plan:any)=>plan.tierId == tierId) ?? [];
                this.coveredByCompany = response.data.plans?.coveredByCompany?.filter((plan:any)=>plan.tierId == tierId) ?? [];
                this.paidByEmployee = response.data.plans?.paidByEmployee?.filter((plan:any)=>plan.tierId == tierId) ?? [];

                this.paidByCompanyDefault = response.data.plans?.paidByCompany?.filter((plan:any)=>plan.tierId == tierId) ?? [];
                this.coveredByCompanyDefault = response.data.plans?.coveredByCompany?.filter((plan:any)=>plan.tierId == tierId) ?? [];  
                this.paidByEmployeeDefault = response.data.plans?.paidByEmployee?.filter((plan:any)=>plan.tierId == tierId) ?? [];
                this.bulkplans = response.data.plans?.bulkPlans?.filter((plan:any)=>plan.tierId == tierId) ?? [];
              }else{
                this.paidByCompany = response.data.plans?.paidByCompany ?? [];
                this.coveredByCompany = response.data.plans?.coveredByCompany ?? [];
                this.paidByEmployee = response.data.plans?.paidByEmployee ?? [];

                this.paidByCompanyDefault = response.data.plans?.paidByCompany ?? [];
                this.coveredByCompanyDefault = response.data.plans?.coveredByCompany ?? [];  
                this.paidByEmployeeDefault = response.data.plans?.paidByEmployee ?? [];
                this.bulkplans = response.data.corporateSelectedBulkPlans;
              }

              // this.bulkplans = response.data.bulkPlans;
              this.noOfEmployees = response.data.expectedNumberofEmployess;



              // if (this.bulkplans.length > 0) {
              //   this.noOfEmployees = this.bulkplans[0].qunatity

              // }
              // else {
              //   this.noOfEmployees = response.data.expectedNumberofEmployess;

              // }

              this.bulkemployeecheck = response.data.employees
              this.employeeList = response.data.employees;
              this.addedEmployeelist = response.data.employees;
              this.lengthofemployee = this.employeeList.length;
              setTimeout(() => {
                this.countryList.forEach((element: any) => {

                  if (element.name == this.country) {
                    this.configprovincereslist = element.countryStates
                  }
                  this.configprovincereslist = [...this.configprovincereslist].sort(
                    (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
                  );
                })
              }, 1000);



              this.province = response.data.proviceShortName;

              const dom: HTMLElement = this.elementRef.nativeElement;
              // alert(this.paymentMethodValue)
              if (this.paymentMethodValue == 'CREDIT_CARD') {
                const element: any = dom.querySelector('#creditpaymentInfo');
                if (element != null) element.click();
              } else if (this.paymentMethodValue == 'ACH') {
                const element: any = dom.querySelector('#padcreditpaymentInfo');
                if (element != null) element.click();
              } else {
                const element: any = dom.querySelector('#invoicepaymentInfo');
                if (element != null) element.click();
              }
              if (this.waitTime == 0) {
                // alert("Aa")
                const element: any = dom.querySelector('#nowaitingPeriod');//nowaitingPeriod
                if (element != null && element != undefined)
                  if (element != null) element.click();
              } else if (this.waitTime == 3) {
                const element: any = dom.querySelector('#threemonths');
                if (element != null && element != undefined)
                  if (element != null) element.click();
              } else if (this.waitTime == 6) {
                const element: any = dom.querySelector('#sixmonths');
                if (element != null && element != undefined)
                  if (element != null) element.click();
              } else {
                const element: any = dom.querySelector('#customselection');
                if (element != null && element != undefined)
                  if (element != null) element.click();
              }

              if (this.policyStartDate && this.policyStartDate.length > 0) {
                this.updateStatus(2);
              }
              if (this.province && this.province.length > 0) {
                this.updateStatus(1);
              }

              if (this.imagedisplay && this.imagedisplay.length > 0) {
                this.showimagelogo = false;
                this.uploadlogoafter = true;
              }

              if (this.adminData.length > 0) {
                for (let admin of this.adminData) {
                  admin['firstName'] = admin['firstName'] ?? '';
                  admin['lastName'] = admin['lastName'] ?? '';
                  admin['phoneNum'] = admin['phoneNum'] ?? '';
                  admin['email'] = admin['email'] ?? '';
                  admin['role'] = admin['role'] ?? '';
                  admin['roleName'] = admin['roleName'] ?? '';
                }
                console.log("'''''''''''''''''''''''''''''*********", this.adminData);
                sessionStorage.setItem('adminData', JSON.stringify(this.adminData));
                this.addadminform = false;
                this.showaddadmin = true;
                this.addadminform = false;
                // this.firstName=response.data.groupAdmins;


              }
            this.walletAmount=response.data?.defaultTier?.walletConfig?.walletAmount
            this.walletType=response.data?.defaultTier?.walletConfig?.walletType
             this.walletCarryForwordAmount=response.data?.defaultTier?.walletConfig?.carryForwardUnusedAmount
            this.walletCoveragePercentage=response.data?.defaultTier?.walletConfig?.coveragePercentage
            this.walletAllocation=response.data?.defaultTier?.walletConfig?.rolloverAllocationPeriod
            this.wsaOptions=response.data?.defaultTier?.walletConfig?.wsaOptions
            this.walletIntialBalanceSetup=response.data?.defaultTier?.walletConfig?.initialBalanceSetup
             




            
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang.Proceed,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
                else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    }
  }

  getBrokerProfiles(brokerId: any) {
    var brokerId = brokerId
    this.updatedBrokerId = brokerId;
    var endPoint = '/api/ap/broker/' + brokerId + '/profiles';
    var accessToken = sessionStorage.getItem('accessToken');

    this.http
      .get(environment.apiUrl + endPoint, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response['status'] == 200) {

          this.brokerProfileslistSearch = this.parseAllValuesInArray(response.data.profiles);
          // console.log(this.brokerProfileslist)

          this.profileid = this.brokerProfileslist1?.originalBrokerId;
          this.corporateDetails = { ...this.corporateDetails, parentName: this.brokerProfileslist[0]?.additionalData?.brokerFullDetails[0]?.name }
          console.log('this.corporateDetails parentname', this.corporateDetails)
        }
      });
  }
  parseAllValuesInArray(arr: any[]): any[] {
    return arr.map(obj => {
      const parsedObj: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          try {
            parsedObj[key] = JSON.parse(obj[key]);
          } catch (e) {
            parsedObj[key] = obj[key]; // If parsing fails, retain original value
          }
        }
      }
      return parsedObj;
    });
  }
  GetCorpDetails2(CorpId: any) {
    if (CorpId == '' || CorpId == undefined) {
      this.clientregform.reset();
    } else {
      var endPoint = '/api/ap/admin/corporate/' + CorpId + '/details';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .get(environment.apiUrl + endPoint, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              this.clientregform.get('authorizenetCustomerId').setValue(response.data?.authorizenetCustomerId ?? '0');
              this.clientregform.get('contactEmail').setValue(response.data?.contactEmail ?? '');
              this.contactEmail = response.data?.contactEmail??'';

              this.crateTierid = response.data?.defaultActiveTierId
              if (response.data?.defaultTier?.wallet == true) {
                this.walletIndustryCategory = response.data?.defaultTier?.walletConfig?.industryCategory
                this.walletAdvsiorFeeStructure = response.data?.defaultTier?.walletConfig?.advisorFeeStructure
              }
              this.bank['bankCode'].setValue(response.data?.myhsaBankingDetails?.bankCode ?? '')
              this.bank['BankTransit'].setValue(response.data?.myhsaBankingDetails?.branchCode ?? '')
              this.bank['accounNum'].setValue(response.data?.myhsaBankingDetails?.accountNumber ?? '')
              sessionStorage.setItem('createId', this.crateTierid);
              if (this.crateTierid == 0) {
                var corporateId = sessionStorage.getItem('corporateId')
                var endPoint = '/api/ap/admin/corporate/' + CorpId + '/tiers/default';

                this.http
                  .post(environment.apiUrl + endPoint, {}, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    },
                  })
                  .subscribe((response: any) => {
                    if (response['status'] == 200) {
                      // this.crateTierid = response.tierId
                      this.crateTierid = response.data
                      sessionStorage.setItem('createId', this.crateTierid);
                    }
                  });
              }
              if (response.data.corporateTiers.length == 0) {
                var CreateNewTiers = '/api/ap/admin/corporate/' + CorpId + '/tiers/default';

                this.http
                  .post(environment.apiUrl + CreateNewTiers, {}, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    },
                  })
                  .subscribe((response: any) => {
                    if (response.status == '200') {
                      // this.crateTierid = response.data.tierId
                      this.crateTierid = response.data
                      sessionStorage.setItem('createId', this.crateTierid);
                    } else {
                      Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
                    }
                  }, (error) => {
                    if (
                      error.status == 400 ||
                      error.status == 401 ||
                      error.status == 402 ||
                      error.status == 403
                    ) {
                      Swal.fire({
                        title: this.lang.Error ?? 'Error',
                        text: error.error.error.message,
                        showDenyButton: false,
                        showCancelButton: true,
                        confirmButtonText: this.lang.Proceed,
                      }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                          sessionStorage.clear();
                          this.router.navigate(['/login']);
                        }
                        else {
                          sessionStorage.clear();
                          this.router.navigate(['/login']);
                        }
                      });
                    } else {
                      // Swal.fire(error.error.error.message)
                      Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
                    }
                    // this.toastrService.error("Invalid Credentials", 'Error!');
                  });

              }
              else {
                this.crateTierid = response.data?.defaultTier
                  ? response.data.defaultTier.id
                  : response.data?.corporateTiers?.[0]?.id;
                sessionStorage.setItem('createId', this.crateTierid);
              }
              console.log(response);
              this.corporateDetails = {
                ...this.corporateDetails,
                formsLength: response?.data.formId > 0 ? 1 : 0,
                formId: response?.data.formId ?? 0
              }

              this.store.dispatch(loadCorporateDataSuccess({ corporateData: [...this.clientList, { ...this.corporateDetails }] }))
              this.bulkplans = response.data.bulkPlans;

              if (response.data.employees.length > 0) {

                // this.employeeList = response.data.employees;
                this.addedEmployeelist = response.data.employees;

                console.log(this.addedEmployeelist)

                this.lengthofemployee = this.employeeList.length;
              }
              if (this.clientregform.value.showEmployeeListData == true) {
                this.EmployeeInfo = true;
              }
              else {
                this.EmployeeInfo = false;
                this.datagraphInfo = true;
              }
              this.showTiersTable = false;
              // this.getExistingTiers()
              // if (this.clientregform.value.tierConfig == true) {

              //   this.showTiersTable = true;
              //   this.getExistingTiers()
              // }
              // else {
              //   if (this.clientregform.value.showEmployeeListData == true) {
              //     this.EmployeeInfo = true;
              //   }
              //   else {
              //     this.EmployeeInfo = false;
              //     this.datagraphInfo = true;
              //   }
              //   this.showTiersTable = false;
              // }

            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showCancelButton: false,
                showDenyButton: false,
                confirmButtonText: 'Proceed',
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                } else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    }
  }
  GetCorpDetails1(CorpId: any) {
    if (CorpId == '' || CorpId == undefined) {
      this.clientregform.reset();
    } else {
      var endPoint = '/api/ap/admin/v2/corporate/' + CorpId + '/details';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .get(environment.apiUrl + endPoint, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              console.log(response);

              this.clientregform.get('authorizenetCustomerId').setValue(response.data?.authorizenetCustomerId ?? '0');
              this.clientregform.get('contactEmail').setValue(response.data?.contactEmail ?? '');
              this.contactEmail = response.data?.contactEmail??'';

              if (response.data.employees.length > 0) {
                // this.employeeList = this.employeeList.concat(response.data.employees);
                // this.addedEmployeelist = this.addedEmployeelist.concat(response.data.employees);
                this.lengthofemployee = this.employeeList.length;
              }
              if (response.data?.defaultTier?.wallet == true) {
                this.walletIndustryCategory = response.data?.defaultTier?.walletConfig?.industryCategory
                this.walletAdvsiorFeeStructure = response.data?.defaultTier?.walletConfig?.advisorFeeStructure
              }
              this.bank['bankCode'].setValue(response.data?.myhsaBankingDetails?.bankCode ?? '')
              this.bank['BankTransit'].setValue(response.data?.myhsaBankingDetails?.branchCode ?? '')
              this.bank['accounNum'].setValue(response.data?.myhsaBankingDetails?.accountNumber ?? '')

              sessionStorage.setItem('createId', this.crateTierid);
              if (this.crateTierid == 0) {
                var corporateId = sessionStorage.getItem('corporateId')
                var endPoint = '/api/ap/admin/corporate/' + CorpId + '/tiers/default';

                this.http
                  .post(environment.apiUrl + endPoint, {}, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    },
                  })
                  .subscribe((response: any) => {
                    if (response['status'] == 200) {
                      // this.crateTierid = response.tierId
                      this.crateTierid = response.data
                      sessionStorage.setItem('createId', this.crateTierid);
                    }
                  });
              }
              // if (this.clientregform.value.showEmployeeListData == true) {
              //   this.EmployeeInfo = true;
              // }
              // else {
              //   this.EmployeeInfo = false;
              //   this.datagraphInfo = true;
              // }


              if (this.clientregform.value.tierConfig == true) {

                this.showTiersTable = true;
                this.getExistingTiers()
              }
              else {
                if (this.clientregform.value.showEmployeeListData == true) {
                  this.EmployeeInfo = true;
                }
                else {
                  this.EmployeeInfo = false;
                  this.datagraphInfo = true;
                }
                this.showTiersTable = false;
              }

              // this.bulkplans = response.data.bulkPlans;
              this.bulkplans = response.data.corporateSelectedBulkPlans;
              this.paidByCompany = response.data.plans?.paidByCompany ?? [];
              this.coveredByCompany = response.data.plans?.coveredByCompany ?? [];
              this.paidByEmployee = response.data.plans?.paidByEmployee ?? [];

            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          },
          (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang.Proceed,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
                else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          }
        );
    }
  }

  multiSelectProvianceItemSelect(event: any) {
    console.log(event);
    this.multiSelectProviance.push(event.id);
    this.multiSelectProviancenames.push(event)
    console.log(this.multiSelectProviancenames);
  }
  multiSelectProvianceSelectAll(event: any) {
    console.log(event);
    this.multiSelectProviance = [];
    this.multiSelectProviancenames = [];
    event.forEach((proviance: any) => {
      this.multiSelectProviance.push(proviance.id);
      this.multiSelectProviancenames.push({ "id": proviance.id, "shortName": proviance.shortName });
    });
    console.log(this.multiSelectProviancenames);
    this.closemultiSelectProvianceSelectDropdown();
  }

  closemultiSelectProvianceSelectDropdown() {
    if (this.multiSelectDropdown) {
      this.multiSelectDropdown.closeDropdown();
    }
  }
  multiSelectProvianceItemDeSelect(event: any) {
    console.log(event);
    let indexOf = this.multiSelectProviance.indexOf(event.id);
    this.multiSelectProviance.splice(indexOf, 1);
    this.multiSelectProviancenames.splice(indexOf, 1);
    console.log(this.multiSelectProviancenames);

  }
  multiSelectProvianceItemDeSelectAll(event: any) {
    console.log(event);
    this.multiSelectProviance = [];
    this.multiSelectProviancenames = [];
  }

  ShowCorpDetails(name: any) {
    console.log(name);

    this.clientregform.reset();
    this.CorpName = name;
    this.addadminform = true;
    this.showaddadmin = false;
    this.adminData = '';
  }
  editCorpDetails() {
    // alert("1")
    // $("#fieldsetattr").removeattr
    $('#fieldsetattr').attr('disabled', false);
  }
  onItemSelectTiers(tier: any, planLevel: any) {


    console.log(planLevel);
    console.log(tier.id);

    console.log(tier);

    this.showinput = true;
    this.showinput1 = false;
    // planLevel.tiers.push(tier)   ///check already exit tiers
    // planLevel.tiersidArray.push(tier.id)  //check already exist tierid
    if (planLevel.tiersidArray?.includes(tier.id)) {
      planLevel.coverage = '';  //default

      console.log('default');
    } else {
      console.log('second');
      planLevel.tiers.push(tier);
      planLevel.tiersidArray.push(tier.id);

      planLevel.tierid = tier.id;
      planLevel.tiername = this.capitalize(tier.name);
      planLevel.coverage = ''; //default
    }

    this.seelctedplanLevelTierMapping.push(planLevel);

    console.log(this.seelctedplanLevelTierMapping);

    //  1.disallowedplans

    // planLevel.disallowedPlanLevels

    //removing all in gold when selecting mind&body

    console.log(planLevel);
    this.unselectPlanLevelTier(
      planLevel.subGroupid,
      planLevel.parentid,
      tier.id,
      planLevel.packageindex,
      planLevel.groupindex,
      planLevel.subgroupindex
    );

    //removing mind & body when selecting all in gold
    if (planLevel.disallowedPlanLevels != null) {
      let disallowed_plans = planLevel.disallowedPlanLevels.split(','); //[1,14,24]
      const dom1: HTMLElement = this.elementRef.nativeElement;

      const disallowed_elements = dom1.querySelectorAll(
        '.plansscreen input.block1tiers'
      );

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        //id/subgroupid,packageid,parentid,tierid

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        // console.log('main', plandetailsobj);

        var currentpackageid = plandetailsobj[2];
        var currentparentid = plandetailsobj[3];
        var currentid = plandetailsobj[4];
        var currentpackagename = plandetailsobj[5];

        if (
          disallowed_plans?.includes(currentparentid) ||
          disallowed_plans?.includes(currentid)
        ) {
          let mappingtiers = this.seelctedplanLevelTierMapping;

          console.log(mappingtiers);

          for (let i = 0; i < mappingtiers.length; i++) {
            if (mappingtiers[i] && mappingtiers[i].subGroupid == currentid) {
              if (mappingtiers[i].tiersidArray?.includes(tier.id)) {
                console.log(this.seelctedplanLevelTierMapping[i].tiers);

                this.plansBlock1Tiers[
                  this.seelctedplanLevelTierMapping[i].packageindex
                ]['groups'][this.seelctedplanLevelTierMapping[i].groupindex][
                  'subGroups'
                ][this.seelctedplanLevelTierMapping[i].subgroupindex].checked =
                  false;
                this.plansBlock1Tiers[
                  this.seelctedplanLevelTierMapping[i].packageindex
                ]['groups'][this.seelctedplanLevelTierMapping[i].groupindex][
                  'subGroups'
                ][this.seelctedplanLevelTierMapping[i].subgroupindex].tiers =
                  [];
                console.log(
                  this.selectedPackagePlansInfoTier[currentpackagename]
                );

                console.log(currentid);
                console.log(currentparentid);

                console.log(this.selectedPackagePlansInfoTier);
                let arr = this.selectedPackagePlansInfoTier[currentpackagename];
                let subGroupIdindex;
                for (let i = 0; i < arr.length; i++) {
                  if (arr[i].subGroupid == currentid) {
                    subGroupIdindex = i;
                    break;
                  }
                }

                console.log(subGroupIdindex);

                if (subGroupIdindex > -1) {
                  console.log(subGroupIdindex);
                  this.selectedPackagePlansInfoTier[currentpackagename].splice(
                    subGroupIdindex,
                    1
                  );

                  console.log(this.selectedPackagesassignedTiers2);
                } else {
                  console.log('check1');
                }

                console.log(planLevel.packageId);
                console.log(planLevel.subGroupid);

                this.seelctedplanLevelTierMapping[i] = null;
                //1.remove this tierid from assignedTiers
                //2.Add this tierid to availbleTiers

                console.log(currentpackagename);

                console.log(currentpackageid);
                console.log(this.selectedPackagesassignedTiers2);

                // if(!this.selectedPackagesassignedTiers2[currentpackageid]){
                this.selectedPackagesassignedTiers2[currentpackageid][
                  currentid
                ] = this.selectedPackagesassignedTiers2[currentpackageid][
                  currentid
                ].filter((object) => {
                  console.log(object);
                  return object.id !== tier.id;
                });
                // }

                // let allselectedplans = this.selectedPackagesavailableTiers[currentpackagename]
              }
            }

            // sessionStorage.setItem('plansBlock1Tiers', JSON.stringify(this.plansBlock1Tiers));
          }
        }
      }
    }

    // planid,tierid,selectedplans
    // disallwoed plans --array---eachplan---selectedplans remove

    //  2.availbeltiers ,assigned tiers
    console.log(this.seelctedplanLevelTierMapping);
    console.log(this.selectedPackagePlansInfoTier);
    console.log(this.selectedPackagesassignedTiers2);

    this.seelctedplanLevelTierMapping =
      this.seelctedplanLevelTierMapping.filter((item: any) => item != null);

    console.log(this.seelctedplanLevelTierMapping);

    this.seelctedplanLevelTierMapping = [
      ...new Map(
        this.seelctedplanLevelTierMapping.map((item) => [
          item['subGroupName'],
          item,
        ])
      ).values(),
    ];

    this.seelctedplanLevelTierMapping2 = this.seelctedplanLevelTierMapping;

    if (!this.selectedPackagesavailableTiers[planLevel.packageId]) {
      this.selectedPackagesavailableTiers[planLevel.packageId] =
        this.configureTierList;
    }

    if (!this.selectedPackagesavailableTiers2[planLevel.packageId]) {
      this.selectedPackagesavailableTiers2[planLevel.packageId] = {};
      this.selectedPackagesavailableTiers2[planLevel.packageId][
        planLevel.subGroupid
      ] = this.configureTierList;
    } else {
      if (
        !this.selectedPackagesavailableTiers2[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesavailableTiers2[planLevel.packageId][
          planLevel.subGroupid
        ] = this.configureTierList;
      }
    }

    // console.log(this.selectedPackagesavailableTiers[planLevel.packageName]);
    if (!this.selectedPackagesassignedTiers[planLevel.packageId]) {
      this.selectedPackagesassignedTiers[planLevel.packageId] = [];
    }

    if (!this.selectedPackagesassignedTiers2[planLevel.packageId]) {
      this.selectedPackagesassignedTiers2[planLevel.packageId] = {};
      this.selectedPackagesassignedTiers2[planLevel.packageId][
        planLevel.subGroupid
      ] = [];
    } else {
      if (
        !this.selectedPackagesassignedTiers2[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesassignedTiers2[planLevel.packageId][
          planLevel.subGroupid
        ] = [];
      }
    }

    const exists =
      this.selectedPackagesassignedTiers[planLevel.packageId].findIndex(
        (item) => item.id === tier.id
      ) > -1;
    if (exists) {
      console.log('check');
    } else {
      this.selectedPackagesassignedTiers[planLevel.packageId].push(tier);

      let availablearray = this.selectedPackagesavailableTiers[
        planLevel.packageId
      ].filter((object) => {
        return object.id !== tier.id;
      });

      this.selectedPackagesavailableTiers[planLevel.packageId] = availablearray;
    }

    const exists2 =
      this.selectedPackagesassignedTiers2[planLevel.packageId][
        planLevel.subGroupid
      ].findIndex((item) => item.id === tier.id) > -1;
    if (exists2) {
      console.log('check2');
      let groups = Object.keys(
        this.selectedPackagesavailableTiers2[planLevel.packageId]
      );

      console.log(groups);

      for (let group of groups) {
        if (group == planLevel.subGroupid) {
          continue;
        }
        if (!this.selectedPackagesavailableTiers2[planLevel.packageId][group]) {
          console.log('assigningCOnfigTierlist');
          this.selectedPackagesavailableTiers2[planLevel.packageId][group] =
            this.configureTierList;

          console.log(this.configureTierList);
        } else {
          console.log('alrradyexist');
        }
        let availablearray2 = this.selectedPackagesavailableTiers2[
          planLevel.packageId
        ][group].filter((object) => {
          return object.id !== tier.id;
        });

        console.log(availablearray2);
        this.selectedPackagesavailableTiers2[planLevel.packageId][group] =
          availablearray2; //Here Close
      }
    } else {
      console.log('else check2');

      let assignedarry2 = [];
      assignedarry2 =
        this.selectedPackagesassignedTiers2[planLevel.packageId][
        planLevel.subGroupid
        ];
      assignedarry2.push(tier);

      this.selectedPackagesassignedTiers2[planLevel.packageId][
        planLevel.subGroupid
      ] = assignedarry2;
    }
    console.log(this.seelctedplanLevelTierMapping);
    console.log(this.selectedPackagesavailableTiers);
    console.log(this.selectedPackagesassignedTiers);

    console.log(this.seelctedplanLevelTierMapping2);
    console.log(this.selectedPackagesavailableTiers2);
    console.log(this.selectedPackagesassignedTiers2);

    // sessionStorage.setItem("seelctedplanLevelTierMapping",JSON.stringify(this.seelctedplanLevelTierMapping))
  }

  onItemSelectTiersBlock2(tier: any, planLevel: any) {
    // console.log(planLevel)

    // planLevel.tiers.push(tier)   ///check already exit tiers
    // planLevel.tiersidArray.push(tier.id)  //check already exist tierid


    this.showinputBlock2 = true;
    this.showinput1Block2 = false;

    console.log(this.seelctedplanLevelTierMappingBlock2);

    if (planLevel.tiersidArray?.includes(tier.id)) {
      planLevel.coverage = ''; //default
    } else {
      planLevel.tiers.push(tier);
      planLevel.tiersidArray.push(tier.id);

      planLevel.tierid = tier.id;
      planLevel.tiername = this.capitalize(tier.name);
      planLevel.coverage = ''; //default
    }

    this.seelctedplanLevelTierMappingBlock2.push(planLevel);

    console.log(this.seelctedplanLevelTierMappingBlock2);

    //  1.disallowedplans

    // planLevel.disallowedPlanLevels

    //removing all in gold when selecting mind&body


    console.log(planLevel);
    this.unselectPlanLevelTierBlock2(
      planLevel.subGroupid,
      planLevel.parentid,
      tier.id
    );

    //removing mind & body when selecting all in gold
    if (planLevel.disallowedPlanLevels != null) {
      let disallowed_plans = planLevel.disallowedPlanLevels.split(','); //[1,10,14]
      const dom1: HTMLElement = this.elementRef.nativeElement;

      const disallowed_elements = dom1.querySelectorAll(
        '.plansscreen input.block2tiers'
      );

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        //id/subgroupid,packageid,parentid,tierid

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        // console.log('main', plandetailsobj);

        var currentpackageid = plandetailsobj[2];
        var currentparentid = plandetailsobj[3];
        var currentid = plandetailsobj[4];
        var currentpackagename = plandetailsobj[5];

        if (
          disallowed_plans?.includes(currentparentid) ||
          disallowed_plans?.includes(currentid)
        ) {
          let mappingtiers = this.seelctedplanLevelTierMappingBlock2;

          for (let i = 0; i < mappingtiers.length; i++) {
            if (mappingtiers[i] && mappingtiers[i].subGroupid == currentid) {
              if (mappingtiers[i].tiersidArray?.includes(tier.id)) {
                // if (mappingtiers[i].tierid==tier.id) {
                //remove this plan from seelctedplanLevelTierMapping

                console.log(this.seelctedplanLevelTierMappingBlock2[i].tiers);

                //  const index = this.seelctedplanLevelTierMapping[i].tiers.findIndex((item) => item.id === tier.id);
                //  if (index !== -1) {
                //   this.seelctedplanLevelTierMapping[i].tiers.splice(index, 1);
                //    return this.seelctedplanLevelTierMapping[i].tiers;
                //  }

                this.plansresblack2Tiers[
                  this.seelctedplanLevelTierMappingBlock2[i].packageindex
                ]['groups'][
                  this.seelctedplanLevelTierMappingBlock2[i].groupindex
                ]['subGroups'][
                  this.seelctedplanLevelTierMappingBlock2[i].subgroupindex
                ].checked = false;
                this.plansresblack2Tiers[
                  this.seelctedplanLevelTierMappingBlock2[i].packageindex
                ]['groups'][
                  this.seelctedplanLevelTierMappingBlock2[i].groupindex
                ]['subGroups'][
                  this.seelctedplanLevelTierMappingBlock2[i].subgroupindex
                ].tiers = [];

                let arr =
                  this.selectedPackagePlansInfoTierBlock2[currentpackagename];
                let subGroupIdindex;
                for (let i = 0; i < arr.length; i++) {
                  if (arr[i].subGroupid == currentid) {
                    subGroupIdindex = i;
                    break;
                  }
                }

                console.log(subGroupIdindex);

                if (subGroupIdindex > -1) {
                  console.log(subGroupIdindex);
                  this.selectedPackagePlansInfoTierBlock2[
                    currentpackagename
                  ].splice(subGroupIdindex, 1);

                  console.log(this.selectedPackagePlansInfoTierBlock2);
                } else {
                  console.log('check1');
                }
                this.seelctedplanLevelTierMappingBlock2[i] = null;
                //1.remove this tierid from assignedTiers
                //2.Add this tierid to availbleTiers

                this.selectedPackagesavailableTiers2Block2[currentpackageid][
                  currentid
                ] = this.selectedPackagesavailableTiers2Block2[currentpackageid][
                  currentid
                ].filter((object) => {
                  console.log(object);
                  return object.id !== tier.id;
                });

                // console.log(
                //   this.selectedPackagesavailableTiersBlock2[currentpackagename]
                // );
                // this.selectedPackagesavailableTiersBlock2[
                //   currentpackagename
                // ].push(tier);

                // let allselectedplans = this.selectedPackagesavailableTiers[currentpackagename]
              }
            }
          }
        }
      }
    }

    // planid,tierid,selectedplans
    // disallwoed plans --array---eachplan---selectedplans remove

    //  2.availbeltiers ,assigned tiers
    console.log(this.seelctedplanLevelTierMappingBlock2);

    this.seelctedplanLevelTierMappingBlock2 =
      this.seelctedplanLevelTierMappingBlock2.filter(
        (item: any) => item != null
      );

    console.log(this.seelctedplanLevelTierMappingBlock2);

    this.seelctedplanLevelTierMappingBlock2 = [
      ...new Map(
        this.seelctedplanLevelTierMappingBlock2.map((item) => [
          item['subGroupName'],
          item,
        ])
      ).values(),
    ];

    this.seelctedplanLevelTierMapping2Block2 =
      this.seelctedplanLevelTierMappingBlock2;
    // console.log(this.seelctedplanLevelTierMapping);

    // for(let i=0;i<this.seelctedplanLevelTierMapping.length;i++){
    //   const dom: HTMLElement = this.elementRef.nativeElement;
    //   const element: any = dom.querySelector("#plancheck" + this.seelctedplanLevelTierMapping[i].subGroupid);

    //     element.click()
    // }

    // this.plansBlock1[planLevel.packageindex]['groups'][planLevel.groupindex][
    //   'subGroups'
    // ][planLevel.subgroupindex].checked = true;

    if (!this.selectedPackagesavailableTiersBlock2[planLevel.packageId]) {
      this.selectedPackagesavailableTiersBlock2[planLevel.packageId] =
        this.configureTierList;
    }
    if (!this.selectedPackagesavailableTiers2Block2[planLevel.packageId]) {
      this.selectedPackagesavailableTiers2Block2[planLevel.packageId] = {};
      this.selectedPackagesavailableTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
      ] = this.configureTierList;
    } else {
      if (
        !this.selectedPackagesavailableTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesavailableTiers2Block2[planLevel.packageId][
          planLevel.subGroupid
        ] = this.configureTierList;
      }
    }

    // console.log(this.selectedPackagesavailableTiers[planLevel.packageName]);
    if (!this.selectedPackagesassignedTiersBlock2[planLevel.packageId]) {
      this.selectedPackagesassignedTiersBlock2[planLevel.packageId] = [];
    }

    if (!this.selectedPackagesassignedTiers2Block2[planLevel.packageId]) {
      this.selectedPackagesassignedTiers2Block2[planLevel.packageId] = {};
      this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
      ] = [];
    } else {
      if (
        !this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
          planLevel.subGroupid
        ] = [];
      }
    }

    const exists =
      this.selectedPackagesassignedTiersBlock2[planLevel.packageId].findIndex(
        (item) => item.id === tier.id
      ) > -1;
    if (exists) {
      console.log('check');
    } else {
      // this.selectedPackagesassignedTiersBlock2[planLevel.packageId].push(tier);
      // let availablearray = this.selectedPackagesavailableTiersBlock2[
      //   planLevel.packageId
      // ].filter((object) => {
      //   return object.id !== tier.id;
      // });
      // this.selectedPackagesavailableTiersBlock2[planLevel.packageId] =
      //   availablearray;
    }

    const exists2 =
      this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
      ].findIndex((item) => item.id === tier.id) > -1;
    if (exists2) {
      console.log('check2');
      let groups = Object.keys(
        this.selectedPackagesavailableTiers2Block2[planLevel.packageId]
      );

      console.log(groups);

      for (let group of groups) {
        if (group == planLevel.subGroupid) {
          continue;
        }
        if (
          !this.selectedPackagesavailableTiers2Block2[planLevel.packageId][
          group
          ]
        ) {
          console.log('assigningCOnfigTierlist');
          this.selectedPackagesavailableTiers2Block2[planLevel.packageId][
            group
          ] = this.configureTierList;
        } else {
          console.log('alrradyexist');
        }
        let availablearray2 = this.selectedPackagesavailableTiers2Block2[
          planLevel.packageId
        ][group].filter((object) => {
          return object.id !== tier.id;
        });
        this.selectedPackagesavailableTiers2Block2[planLevel.packageId][group] =
          availablearray2;
      }
    } else {
      console.log('else check2');

      let assignedarry2block2 = [];
      assignedarry2block2 =
        this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
        ];
      assignedarry2block2.push(tier);

      this.selectedPackagesassignedTiers2Block2[planLevel.packageId][
        planLevel.subGroupid
      ] = assignedarry2block2;
    }
    console.log(this.seelctedplanLevelTierMappingBlock2);
    console.log(this.selectedPackagesavailableTiersBlock2);
    console.log(this.selectedPackagesassignedTiersBlock2);

    console.log(this.seelctedplanLevelTierMapping2Block2);
    console.log(this.selectedPackagesavailableTiers2Block2);
    console.log(this.selectedPackagesassignedTiers2Block2);

    // sessionStorage.setItem("seelctedplanLevelTierMapping",JSON.stringify(this.seelctedplanLevelTierMapping))
  }
  onItemSelectTiersBlock3(tier: any, planLevel: any) {
    console.log("123456789098765432345678", planLevel)

    // planLevel.tiers.push(tier)   ///check already exit tiers
    // planLevel.tiersidArray.push(tier.id)  //check already exist tierid

    this.showinputBlock3 = true;
    this.showinput1Block3 = false;

    if (planLevel.tiersidArray?.includes(tier.id)) {
      planLevel.coverage = ''; //default
    } else {
      planLevel.tiers.push(tier);
      planLevel.tiersidArray.push(tier.id);

      planLevel.tierid = tier.id;
      planLevel.tiername = this.capitalize(tier.name);
      planLevel.coverage = ''; //default
    }

    this.seelctedplanLevelTierMappingBlock3.push(planLevel);

    console.log(this.seelctedplanLevelTierMappingBlock3);

    //  1.disallowedplans

    // planLevel.disallowedPlanLevels

    //removing all in gold when selecting mind&body

    console.log(planLevel);
    this.unselectPlanLevelTierBlock3(
      planLevel.subGroupid,
      planLevel.parentid,
      tier.id
    );

    //removing mind & body when selecting all in gold
    if (planLevel.disallowedPlanLevels != null) {
      let disallowed_plans = planLevel.disallowedPlanLevels.split(','); //[1,10,14]
      const dom1: HTMLElement = this.elementRef.nativeElement;

      const disallowed_elements = dom1.querySelectorAll(
        '.plansscreen input.block3tiers'
      );

      for (let i = 0; i < disallowed_elements.length; i++) {
        let elem: any = disallowed_elements[i];
        //id/subgroupid,packageid,parentid,tierid

        if (!elem.attributes.data) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        // console.log('main', plandetailsobj);

        var currentpackageid = plandetailsobj[2];
        var currentparentid = plandetailsobj[3];
        var currentid = plandetailsobj[4];
        var currentpackagename = plandetailsobj[5];

        if (
          disallowed_plans?.includes(currentparentid) ||
          disallowed_plans?.includes(currentid)
        ) {
          let mappingtiers = this.seelctedplanLevelTierMappingBlock3;

          for (let i = 0; i < mappingtiers.length; i++) {
            if (mappingtiers[i] && mappingtiers[i].subGroupid == currentid) {
              if (mappingtiers[i].tiersidArray?.includes(tier.id)) {
                // if (mappingtiers[i].tierid==tier.id) {
                //remove this plan from seelctedplanLevelTierMapping

                console.log(this.seelctedplanLevelTierMappingBlock3[i].tiers);

                //  const index = this.seelctedplanLevelTierMapping[i].tiers.findIndex((item) => item.id === tier.id);
                //  if (index !== -1) {
                //   this.seelctedplanLevelTierMapping[i].tiers.splice(index, 1);
                //    return this.seelctedplanLevelTierMapping[i].tiers;
                //  }

                this.plansresblack3Tiers[
                  this.seelctedplanLevelTierMappingBlock3[i].packageindex
                ]['groups'][
                  this.seelctedplanLevelTierMappingBlock3[i].groupindex
                ]['subGroups'][
                  this.seelctedplanLevelTierMappingBlock3[i].subgroupindex
                ].checked = false;

                this.plansresblack3Tiers[
                  this.seelctedplanLevelTierMappingBlock3[i].packageindex
                ]['groups'][
                  this.seelctedplanLevelTierMappingBlock3[i].groupindex
                ]['subGroups'][
                  this.seelctedplanLevelTierMappingBlock3[i].subgroupindex
                ].tiers = [];
                let arr =
                  this.selectedPackagePlansInfoTierBlock3[currentpackagename];
                let subGroupIdindex;
                for (let i = 0; i < arr.length; i++) {
                  if (arr[i].subGroupid == currentid) {
                    subGroupIdindex = i;
                    break;
                  }
                }

                console.log(subGroupIdindex);

                if (subGroupIdindex > -1) {
                  console.log(subGroupIdindex);
                  this.selectedPackagePlansInfoTierBlock3[
                    currentpackagename
                  ].splice(subGroupIdindex, 1);

                  console.log(this.selectedPackagePlansInfoTierBlock3);
                } else {
                  console.log('check1');
                }

                this.seelctedplanLevelTierMappingBlock3[i] = null;
                //1.remove this tierid from assignedTiers
                //2.Add this tierid to availbleTiers


                this.selectedPackagesavailableTiers3Block3[currentpackageid][
                  currentid
                ] = this.selectedPackagesavailableTiers3Block3[currentpackageid][
                  currentid
                ].filter((object) => {
                  console.log(object);
                  return object.id !== tier.id;
                });

                console.log(
                  this.selectedPackagesavailableTiersBlock3[currentpackagename]
                );
                this.selectedPackagesavailableTiersBlock3[
                  currentpackagename
                ].push(tier);

                // let allselectedplans = this.selectedPackagesavailableTiers[currentpackagename]
              }
            }
          }
        }
      }
    }

    // planid,tierid,selectedplans
    // disallwoed plans --array---eachplan---selectedplans remove

    //  2.availbeltiers ,assigned tiers
    console.log(this.seelctedplanLevelTierMappingBlock3);

    this.seelctedplanLevelTierMappingBlock3 =
      this.seelctedplanLevelTierMappingBlock3.filter(
        (item: any) => item != null
      );

    console.log(this.seelctedplanLevelTierMappingBlock3);

    this.seelctedplanLevelTierMappingBlock3 = [
      ...new Map(
        this.seelctedplanLevelTierMappingBlock3.map((item) => [
          item['subGroupName'],
          item,
        ])
      ).values(),
    ];

    this.seelctedplanLevelTierMapping3Block3 =
      this.seelctedplanLevelTierMappingBlock3;

    if (!this.selectedPackagesavailableTiersBlock3[planLevel.packageId]) {
      this.selectedPackagesavailableTiersBlock3[planLevel.packageId] =
        this.configureTierList;
    }
    if (!this.selectedPackagesavailableTiers3Block3[planLevel.packageId]) {
      this.selectedPackagesavailableTiers3Block3[planLevel.packageId] = {};
      this.selectedPackagesavailableTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
      ] = this.configureTierList;
    } else {
      if (
        !this.selectedPackagesavailableTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesavailableTiers3Block3[planLevel.packageId][
          planLevel.subGroupid
        ] = this.configureTierList;
      }
    }

    // console.log(this.selectedPackagesavailableTiers[planLevel.packageName]);
    if (!this.selectedPackagesassignedTiersBlock3[planLevel.packageId]) {
      this.selectedPackagesassignedTiersBlock3[planLevel.packageId] = [];
    }
    if (!this.selectedPackagesassignedTiers3Block3[planLevel.packageId]) {
      this.selectedPackagesassignedTiers3Block3[planLevel.packageId] = {};
      this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
      ] = [];
    } else {
      if (
        !this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
        ]
      ) {
        this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
          planLevel.subGroupid
        ] = [];
      }
    }

    const exists =
      this.selectedPackagesassignedTiersBlock3[planLevel.packageId].findIndex(
        (item) => item.id === tier.id
      ) > -1;
    if (exists) {
      console.log('check');
    } else {
      // this.selectedPackagesassignedTiersBlock3[planLevel.packageId].push(tier);
      // let availablearray = this.selectedPackagesavailableTiersBlock3[
      //   planLevel.packageId
      // ].filter((object) => {
      //   return object.id !== tier.id;
      // });
      // this.selectedPackagesavailableTiersBlock3[planLevel.packageId] =
      //   availablearray;
    }

    const exists2 =
      this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
      ].findIndex((item) => item.id === tier.id) > -1;
    if (exists2) {
      console.log('check2');
      let groups = Object.keys(
        this.selectedPackagesavailableTiers3Block3[planLevel.packageId]
      );

      console.log(groups);

      for (let group of groups) {
        if (group == planLevel.subGroupid) {
          continue;
        }
        if (
          !this.selectedPackagesavailableTiers3Block3[planLevel.packageId][
          group
          ]
        ) {
          console.log('assigningCOnfigTierlist');
          this.selectedPackagesavailableTiers3Block3[planLevel.packageId][
            group
          ] = this.configureTierList;
        } else {
          console.log('alrradyexist');
        }
        let availablearray2 = this.selectedPackagesavailableTiers3Block3[
          planLevel.packageId
        ][group].filter((object) => {
          return object.id !== tier.id;
        });
        this.selectedPackagesavailableTiers3Block3[planLevel.packageId][group] =
          availablearray2;
      }
    } else {
      console.log('else check2');

      let assignedarry2block3 = [];
      assignedarry2block3 =
        this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
        ];
      assignedarry2block3.push(tier);

      this.selectedPackagesassignedTiers3Block3[planLevel.packageId][
        planLevel.subGroupid
      ] = assignedarry2block3;
    }
    console.log(this.seelctedplanLevelTierMappingBlock3);
    console.log(this.selectedPackagesavailableTiersBlock3);
    console.log(this.selectedPackagesassignedTiersBlock3);

    console.log(this.seelctedplanLevelTierMapping3Block3);
    console.log(this.selectedPackagesavailableTiers3Block3);
    console.log(this.selectedPackagesassignedTiers3Block3);

    // sessionStorage.setItem("seelctedplanLevelTierMapping",JSON.stringify(this.seelctedplanLevelTierMapping))
  }

  showSlectedPlansTiers() {
    console.log(this.seelctedplanLevelTierMapping);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements: any = dom.querySelectorAll('input.block1tiers');

    for (let element of elements) {
      // console.log(element);
      element.checked = false;
    }

    let slectedTierBlcok1 = [];
    for (let i = 0; i < this.seelctedplanLevelTierMapping.length; i++) {
      let selecplanLevel = this.seelctedplanLevelTierMapping[i];
      if (
        this.seelctedplanLevelTierMapping[i].subGroupName ==
        'Complete Executive Care' ||
        this.seelctedplanLevelTierMapping[i].subGroupName == 'Executive Health'
      ) {

        //default
        if (this.seelctedplanLevelTierMapping[i].coverage == '') {
          this.seelctedplanLevelTierMapping[i].coverage = '001';
        }
      }
      const dom: HTMLElement = this.elementRef.nativeElement;
      const element: any = dom.querySelector(
        '#plancheck' + selecplanLevel.subGroupid
      );

      element.checked = true;
      this.plansBlock1Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].checked = true;
      this.plansBlock1Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].tiers = selecplanLevel.tiers;

      let tiersarray = selecplanLevel.tiers;

      for (let j = 0; j < tiersarray.length; j++) {
        slectedTierBlcok1.push(tiersarray[j].name);
      }
    }
  }


  showSlectedPlansTiersBlock2() {
    console.log(this.seelctedplanLevelTierMappingBlock2);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements: any = dom.querySelectorAll('input.block2tiers');

    for (let element of elements) {
      // console.log(element);
      element.checked = false;
    }

    let slectedTierBlcok1 = [];
    for (let i = 0; i < this.seelctedplanLevelTierMappingBlock2.length; i++) {
      let selecplanLevel = this.seelctedplanLevelTierMappingBlock2[i];

      if (
        this.seelctedplanLevelTierMappingBlock2[i].subGroupName ==
        'Complete Executive Care' ||
        this.seelctedplanLevelTierMappingBlock2[i].subGroupName ==
        'Executive Health'
      ) {
        //default
        if (this.seelctedplanLevelTierMappingBlock2[i].coverage == '') {
          this.seelctedplanLevelTierMappingBlock2[i].coverage = '001';
        }
      }

      const dom: HTMLElement = this.elementRef.nativeElement;
      const element: any = dom.querySelector(
        '#plancheck2Upgrade' + selecplanLevel.subGroupid
      );

      element.checked = true;
      this.plansresblack2Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].checked = true;
      this.plansresblack2Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].tiers = selecplanLevel.tiers;

      let tiersarray = selecplanLevel.tiers;

      for (let j = 0; j < tiersarray.length; j++) {
        slectedTierBlcok1.push(tiersarray[j].name);
      }
    }
  }
  showSlectedPlansTiersBlock3() {
    console.log(this.seelctedplanLevelTierMappingBlock3);

    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements: any = dom.querySelectorAll('input.block3tiers');

    for (let element of elements) {
      console.log(element);
      element.checked = false;
    }

    let slectedTierBlcok1 = [];
    for (let i = 0; i < this.seelctedplanLevelTierMappingBlock3.length; i++) {
      let selecplanLevel = this.seelctedplanLevelTierMappingBlock3[i];
      if (
        this.seelctedplanLevelTierMappingBlock3[i].subGroupName ==
        'Complete Executive Care' ||
        this.seelctedplanLevelTierMappingBlock3[i].subGroupName ==
        'Executive Health'
      ) {
        //default
        if (this.seelctedplanLevelTierMappingBlock3[i].coverage == '') {
          this.seelctedplanLevelTierMappingBlock3[i].coverage = '001';
        }
      }
      const dom: HTMLElement = this.elementRef.nativeElement;
      const element: any = dom.querySelector(
        '#plancheck3Voluntry' + selecplanLevel.subGroupid
      );

      element.checked = true;
      this.plansresblack3Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].checked = true;
      this.plansresblack3Tiers[selecplanLevel.packageindex]['groups'][
        selecplanLevel.groupindex
      ]['subGroups'][selecplanLevel.subgroupindex].tiers = selecplanLevel.tiers;

      let tiersarray = selecplanLevel.tiers;

      for (let j = 0; j < tiersarray.length; j++) {
        slectedTierBlcok1.push(tiersarray[j].name);
      }
    }
  }
  onItemremoveTiers(tier: any, planLevel: any) {
    // 1.remove tier from selected list ui
    // 2.Remove from assigned tiers
    // 3.Add to Availabel Tiers
    // 4.Remove from Selected Plans

    console.log(tier);
    console.log(planLevel);

    // this.selectedPackagesassignedTiers[planLevel.packageId] =
    //   this.selectedPackagesassignedTiers[planLevel.packageId].filter(
    //     (object) => {
    //       return object.id !== tier.id;
    //     }
    //   );

    console.log(this.selectedPackagesassignedTiers2);
    console.log(this.selectedPackagesavailableTiers2);

    if (!this.selectedPackagesassignedTiers2[planLevel.packageId]) {
      this.selectedPackagesassignedTiers2[planLevel.packageId] =
        this.selectedPackagesassignedTiers2[planLevel.packageId].filter(
          (object) => {
            return object.id !== tier.id;
          }
        );
    }

    let groups = Object.keys(
      this.selectedPackagesavailableTiers2[planLevel.packageId]
    );

    console.log(groups);

    for (let group of groups) {
      console.log(group);
      console.log(planLevel.subGroupid);
      if (group == planLevel.subGroupid) {
        continue;
      }
      if (!this.selectedPackagesavailableTiers2[planLevel.packageId][group]) {
        this.selectedPackagesavailableTiers2[planLevel.packageId][group] = [];
        console.log('CheckingassigningCOnfigTierlist');
      } else {
        console.log('alrradyexist');
      }
      // console.log(this.selectedPackagesassignedTiers2)
      let available2 = [];
      available2 =
        this.selectedPackagesavailableTiers2[planLevel.packageId][group];

      available2.push(tier);
      this.selectedPackagesavailableTiers2[planLevel.packageId][group] =
        available2;
    }

    this.showinput = false;
    this.showinput1 = true;

    console.log(this.selectedPackagesavailableTiers2);

    this.selectedPackagesavailableTiers21 =
      this.selectedPackagesavailableTiers2;
    this.selectedPackagesassignedTiers21 = this.selectedPackagesassignedTiers2;

    let mappingtiers = this.seelctedplanLevelTierMapping;

    for (let i = 0; i < mappingtiers.length; i++) {
      console.log(mappingtiers[i].subGroupid);
      console.log(planLevel.subGroupid);
      if (
        mappingtiers[i] &&
        mappingtiers[i].subGroupid == planLevel.subGroupid
      ) {
        for (let j = 0; j < mappingtiers[i].tiers.length; j++) {
          if (mappingtiers[i].tiers[j].id == tier.id) {
            mappingtiers[i].tiers[j] = null;
            // console.log("checkhere")
          }

          if (mappingtiers[i].tiersidArray?.includes(tier.id)) {
            mappingtiers[i].tiersidArray.splice(i, 1);
          }
        }

        if (mappingtiers[i].tiers.length > 0) {
          mappingtiers[i].tiers = mappingtiers[i].tiers.filter(
            (item: any) => item != null
          );
        }
      }
    }

    this.seelctedplanLevelTierMapping = mappingtiers;

    this.seelctedplanLevelTierMapping =
      this.seelctedplanLevelTierMapping.filter((item: any) => item != null);

    console.log(this.seelctedplanLevelTierMapping);
  }

  checkhere() {
    setTimeout(() => {
      console.log(this.selectedPackagesavailableTiers21);
      console.log(this.selectedPackagesassignedTiers21);
    }, 1000);
  }
  onItemremoveTiersBlock2(tier: any, planLevel: any) {
    // 1.remove tier from seelcted list ui
    // 2.Remove from assigned tiers
    // 3.Add to Availabel Tiers
    // 4.Remove from Seelcted Plans

    if (!this.selectedPackagesassignedTiers2Block2[planLevel.packageId]) {
      this.selectedPackagesassignedTiers2Block2[planLevel.packageId] =
        this.selectedPackagesassignedTiers2Block2[planLevel.packageId].filter(
          (object) => {
            return object.id !== tier.id;
          }
        );
    }

    console.log(this.selectedPackagesassignedTiers2Block2);

    // this.selectedPackagesavailableTiersBlock2[planLevel.packageId].push(tier);

    let groups = Object.keys(
      this.selectedPackagesavailableTiers2Block2[planLevel.packageId]
    );

    console.log(groups);

    for (let group of groups) {
      console.log(group);
      console.log(planLevel.subGroupid);
      if (group == planLevel.subGroupid) {
        continue;
      }
      if (
        !this.selectedPackagesavailableTiers2Block2[planLevel.packageId][group]
      ) {
        this.selectedPackagesavailableTiers2Block2[planLevel.packageId][group] =
          [];
        console.log('CheckingassigningCOnfigTierlist');
      } else {
        console.log('alrradyexist');
      }
      // console.log(this.selectedPackagesassignedTiers2)
      let available2 = [];
      available2 =
        this.selectedPackagesavailableTiers2Block2[planLevel.packageId][group];

      available2.push(tier);
      this.selectedPackagesavailableTiers2Block2[planLevel.packageId][group] =
        available2;
    }

    this.showinputBlock2 = false;
    this.showinput1Block2 = true;

    console.log(this.selectedPackagesavailableTiers2Block2);

    this.selectedPackagesavailableTiers2Block21 =
      this.selectedPackagesavailableTiers2Block2;
    this.selectedPackagesassignedTiers2Block21 =
      this.selectedPackagesassignedTiers2Block2;

    let mappingtiers = this.seelctedplanLevelTierMappingBlock2;

    for (let i = 0; i < mappingtiers.length; i++) {
      console.log(mappingtiers[i].subGroupid);
      console.log(planLevel.subGroupid);
      if (
        mappingtiers[i] &&
        mappingtiers[i].subGroupid == planLevel.subGroupid
      ) {
        for (let j = 0; j < mappingtiers[i].tiers.length; j++) {
          if (mappingtiers[i].tiers[j].id == tier.id) {
            mappingtiers[i].tiers[j] = null;
            // console.log("checkhere")
          }
          if (mappingtiers[i].tiersidArray?.includes(tier.id)) {
            mappingtiers[i].tiersidArray.splice(i, 1);
          }
        }

        if (mappingtiers[i].tiers.length > 0) {
          mappingtiers[i].tiers = mappingtiers[i].tiers.filter(
            (item: any) => item != null
          );
        }
      }
    }

    this.seelctedplanLevelTierMappingBlock2 = mappingtiers;

    this.seelctedplanLevelTierMappingBlock2 =
      this.seelctedplanLevelTierMappingBlock2.filter(
        (item: any) => item != null
      );

    console.log(this.seelctedplanLevelTierMappingBlock2);
  }
  onItemremoveTiersBlock3(tier: any, planLevel: any) {
    // 1.remove tier from seelcted list ui
    // 2.Remove from assigned tiers
    // 3.Add to Availabel Tiers
    // 4.Remove from Seelcted Plans

    if (!this.selectedPackagesassignedTiers3Block3[planLevel.packageId]) {
      this.selectedPackagesassignedTiers3Block3[planLevel.packageId] =
        this.selectedPackagesassignedTiers3Block3[planLevel.packageId].filter(
          (object) => {
            return object.id !== tier.id;
          }
        );
    }

    console.log(this.selectedPackagesassignedTiers3Block3);

    // this.selectedPackagesavailableTiersBlock3[planLevel.packageId].push(tier);

    let groups = Object.keys(
      this.selectedPackagesavailableTiers3Block3[planLevel.packageId]
    );

    console.log(groups);

    for (let group of groups) {
      console.log(group);
      console.log(planLevel.subGroupid);
      if (group == planLevel.subGroupid) {
        continue;
      }
      if (
        !this.selectedPackagesavailableTiers3Block3[planLevel.packageId][group]
      ) {
        this.selectedPackagesavailableTiers3Block3[planLevel.packageId][group] =
          [];
        console.log('CheckingassigningCOnfigTierlist');
      } else {
        console.log('alrradyexist');
      }
      // console.log(this.selectedPackagesassignedTiers2)
      let available2 = [];
      available2 =
        this.selectedPackagesavailableTiers3Block3[planLevel.packageId][group];

      available2.push(tier);
      this.selectedPackagesavailableTiers3Block3[planLevel.packageId][group] =
        available2;
    }

    this.showinputBlock3 = false;
    this.showinput1Block3 = true;

    console.log(this.selectedPackagesavailableTiers3Block3);

    this.selectedPackagesavailableTiers3Block31 =
      this.selectedPackagesavailableTiers3Block3;
    this.selectedPackagesassignedTiers3Block31 =
      this.selectedPackagesassignedTiers3Block3;

    let mappingtiers = this.seelctedplanLevelTierMappingBlock3;

    for (let i = 0; i < mappingtiers.length; i++) {
      console.log(mappingtiers[i].subGroupid);
      console.log(planLevel.subGroupid);
      if (
        mappingtiers[i] &&
        mappingtiers[i].subGroupid == planLevel.subGroupid
      ) {
        for (let j = 0; j < mappingtiers[i].tiers.length; j++) {
          if (mappingtiers[i].tiers[j].id == tier.id) {
            mappingtiers[i].tiers[j] = null;
            // console.log("checkhere")
          }
          if (mappingtiers[i].tiersidArray?.includes(tier.id)) {
            mappingtiers[i].tiersidArray.splice(i, 1);
          }
        }

        if (mappingtiers[i].tiers.length > 0) {
          mappingtiers[i].tiers = mappingtiers[i].tiers.filter(
            (item: any) => item != null
          );
        }

        // if (mappingtiers[i].tiersidArray?.includes(tier.id)) {
        //   // if (mappingtiers[i].tierid==tier.id) {
        //   //remove this plan from seelctedplanLevelTierMapping
        //   this.seelctedplanLevelTierMapping[i] = null;
        // }
      }
    }

    this.seelctedplanLevelTierMappingBlock3 = mappingtiers;

    // console.log(this.seelctedplanLevelTierMapping);
    this.seelctedplanLevelTierMappingBlock3 =
      this.seelctedplanLevelTierMappingBlock3.filter(
        (item: any) => item != null
      );

    // console.log(this.selectedPackagesavailableTiers);
    // console.log(this.selectedPackagesassignedTiers);
  }
  onItemSelect(
    item: any,
    packageid: number,
    parentId: number,
    subgroupid: number,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    // console.log(item);
    // console.log(packageid);
    // console.log(parentId);
    // console.log(subgroupid);

    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex][
      'tiers'
    ].push(item);
    // Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex]['checked']=true;

    this.plansBlock1 = Mainplanres;
    // console.log(this.plansBlock1)

    sessionStorage.setItem('planResults', JSON.stringify(Mainplanres));
    // this.checkSelectedPlans()
  }

  onSelectAll(
    item: any,
    packageid: number,
    parentId: number,
    subgroupid: number,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex][
      'tiers'
    ] = item;
    Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex][
      'checked'
    ] = true;

    this.plansBlock1 = Mainplanres;

    sessionStorage.setItem('planResults', JSON.stringify(Mainplanres));
  }
  onItemDeSelect(
    item: any,
    packageid: number,
    parentId: number,
    subgroupid: number,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    let array =
      Mainplanres[packageindex]['groups'][groupindex]['subGroups'][
      subgroupindex
      ]['tiers'];

    array = array.filter(function (obj) {
      return obj.id !== item.id;
    });

    Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex][
      'tiers'
    ] = array;
    // Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex]['checked'] = true
    this.plansBlock1 = Mainplanres;

    sessionStorage.setItem('planResults', JSON.stringify(Mainplanres));

    // this.checkSelectedPlans()
  }
  onDeSelectAll(
    item: any,
    packageid: number,
    parentId: number,
    subgroupid: number,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex][
      'tiers'
    ] = [];
    // Mainplanres[packageindex]['groups'][groupindex]['subGroups'][subgroupindex]['checked']=true;

    this.plansBlock1 = Mainplanres;

    console.log(this.plansBlock1);

    sessionStorage.setItem('planResults', JSON.stringify(Mainplanres));

    // this.checkSelectedPlans()
  }

  checkSelectedPlans() {
    this.planssummary = JSON.parse(sessionStorage.getItem('planResults'));

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1')
    );

    if (this.planssummary) {
      // [{"packageid":"2","parentId":"14","subGroupId":"21","orderId":"18","packagename":"Mental Health & Wellness","groupname":"Wellness","subGrpname":"Mind & Body","tiers":[],"packageindex":1,"groupindex":0,"subgroupindex":2}]

      this.planssummary.forEach((plandetails: any, index: number) => {
        plandetails.groups.forEach((groups: any, index1: number) => {
          this.selectedplansblock1.forEach((subgroup: any, index3: number) => {
            var allAvailble =
              this.planssummary[index]['groups'][index1]['subGroups'];

            allAvailble.forEach((element1: any, index2: any) => {
              if (element1 != null) {
                if (element1.id == subgroup.subGroupId) {
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    const element: any = dom.querySelector(
                      '#plancheck' + element1.id
                    );

                    console.log(element);
                    element.click();
                  }, 100);
                }
              }
            });
          });
        });
      });
    }
  }

  closeModal(value: any) {
    value.active = false;
  }
  numberOnly(event: any): boolean {
    return true;//this.commonPatternsService.numberOnly(event);
  }

  get f() {
    return this.adminform.controls;
  }
  addadmin() {
    console.log(this.adminData);

    if (this.adminform.invalid) {
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = {
      firstName: this.capitalize(this.adminform.value.adminfirstname),
      lastName: this.capitalize(this.adminform.value.adminlastname),
      phoneNum: this.adminform.value.adminphone,
      email: this.adminform.value.adminemail,
      role: this.adminform.value.role,
      roleName: ''
    };
    obj['roleName'] = obj.role == 'CORPORATE_OTHERS' ? this.adminform.value.roleName : "";
    this.emailAlreadyexist = false;
    for (let admin of this.adminData) {
      if (admin['email'] == obj['email']) {
        Swal.fire({
          title: this.lang.Info,
          text: 'Email Already exist',
          showDenyButton: false,
          confirmButtonText: 'OK',
        }).then((res) => {
          if (res.isConfirmed) {
            this.emailAlreadyexist = true;
            return false;
          }
        });
        this.emailAlreadyexist = true;
        break;
      }
    }


    let CorpId = this.route.snapshot.params['id'];
    let endPoint = `/api/ap/admin/v2/corporate/${CorpId}/groupAdmin`;
    let accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            // Swal.f
            // Swal.fire({title:this.lang.Info,text:response.message||response.data.message});
            Swal.fire({ title: this.lang.Info, text: response.message || response.data.message }).then((result) => {
              if (result.isConfirmed) {
                this.clientregform.reset();
                this.GetCorpDetails();
                // this.getServiceWorkerDetails();

              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            })
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    $('#basicModal1').modal('hide');
    console.log(this.adminData);
    this.corporateDetails = { ...this.corporateDetails, email: this.adminData[0]?.email ?? this.adminform.value.adminemail }
    console.log('this.corporateDetails email', this.corporateDetails)
  }
  editadminSubmit() {
    if (this.adminform.invalid) {
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = {
      firstName: this.capitalize(this.adminform.value.adminfirstname),
      lastName: this.capitalize(this.adminform.value.adminlastname),
      phoneNum: this.adminform.value.adminphone,
      email: this.adminform.value.adminemail,
      role: this.adminform.value.role,
      roleName: ''
    };
    obj['roleName'] = obj.role == 'CORPORATE_OTHERS' ? this.adminform.value.roleName : "";
    // this.adminData[this.editindex] = obj;

    let adminIndex = this.adminData[this.editindex].groupAdminId;
    let CorpId = this.route.snapshot.params['id'];
    let endPoint = `/api/ap/admin/v2/corporate/${CorpId}/groupAdmin/${adminIndex}`;
    let accessToken = sessionStorage.getItem('accessToken');
    this.http
      .put(environment.apiUrl + endPoint, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        async (response: any) => {
          if (response['status'] == 200) {

            var endPoint = '/api/ap/admin/corporate/' + CorpId + '/details';
            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //   environment.apiUrl + endPoint
            // ]);

            this.GetCorpDetails();
            // this.getServiceWorkerDetails();
            Swal.fire({ title: this.lang.Info, text: response.message || response.data.message }).then((result) => {
              if (result.isConfirmed) {
                // this.adminform.reset();
                this.showOtherField = false;
                this.showaddadmin = true;
                this.addadminform = false;
                $('#basicModaledit').modal('hide');
                // this.clientregform.reset();
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            })
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
        }
      );


  }

  deleteadmin(index: any) {

    Swal.fire({
      title: this.lang.Alert,
      text: this.lang.Are_you_sure_you_want_to_delete_this_group_contact,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        var accessToken = sessionStorage.getItem('accessToken');
        let CorpId = this.route.snapshot.params['id'];
        let adminIndex = this.adminData[index].groupAdminId;
        let endpoint = `/api/ap/admin/v2/corporate/${CorpId}/groupAdmin/${adminIndex}`;


        this.http.delete(environment.apiUrl + endpoint, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        }).subscribe(async (responce: any) => {
          if (responce.status == 200) {
            let CorpId = this.route.snapshot.params['id']
            var endPoint = '/api/ap/admin/corporate/' + CorpId + '/details';

            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //   environment.apiUrl + endPoint
            // ]);

            Swal.fire({ title: this.lang.Info, text: responce.message }).then((result) => {
              if (result.isConfirmed) {
                this.clientregform.reset();
                this.GetCorpDetails();
                // this.getServiceWorkerDetails();


              }
            });

          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: responce.data.message || responce.message || responce.error.message });
          }
        }), (error) => {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.message || error.data.message || error.error.error });
        }
      }
    })

  }
  editadmin(admin: any, index: any) {
    // this.adminform.patchValue(admin);
    this.editindex = index;
    this.editadminfirstname = admin.firstName;
    this.editadminlastname = admin.lastName;
    this.editadminphone = admin.phoneNum;
    this.editadminemail = admin.email;
    this.editadminrole = admin.role;
    if (this.editadminrole == 'CORPORATE_OTHERS') {
      this.showOtherField = true;
      this.f['roleName'].setValue(admin.roleName.toLowerCase());
    }
    this.emailAlreadyexist = false;
    setTimeout(() => {
      this.f['adminfirstname'].setValue(admin.firstName);
      this.f['adminlastname'].setValue(admin.lastName);
    }, 100);
  }

  changeToFirstlatterUpperCase(controlName: any) {
    let value = this.f[controlName].value;
    value = this.f[controlName].value[0].toUpperCase() + this.f[controlName].value.slice(1).toLowerCase();
    this.f[controlName].setValue(value);
  }

  hidegrpadmindetails() {

    this.showOtherField = false;
    this.editadminfirstname = "";
    this.editadminlastname = "";
    this.editadminphone = "";
    this.editadminemail = "";
    this.editadminrole = "";
    this.adminform.reset();

  }
  uploadadminlogoclear(event1: any) {
    this.showimagelogo = true;
    this.uploadlogoafter = false;
    this.imagedisplay = '';
    this.uploadadminlogoimg = '';
    sessionStorage.setItem('adminlogo', '');
    this.client['corporatelogo'].reset();
    // this.client['corporatelogo'].setValidators([Validators.required]);

    // this.client['corporatelogo'].updateValueAndValidity();
  }

  onPaste(e: any) { e.preventDefault() }
  uploadadminlogo(event1: any) {
    console.log('test');
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.uploadadminlogoimg = event1.target.files[0];

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
    ];

    let error = false;

    let message = '';

    if (allowedMimes?.includes(this.uploadadminlogoimg.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadadminlogoimg.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showimagelogo = false;
          this.uploadlogoafter = true;
          this.imagedisplay = reader.result;
        };
        sessionStorage.setItem('adminlogo', this.uploadadminlogoimg);
      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        //  message = 'File size is too large,maximum file size is 5 MB'
        // alert(message);
        Swal.fire({ title: this.lang.Info, text: message });
        this.uploadadminlogoimg = "";
      }
    } else {
      error = true;

      message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
      // alert(message);
      Swal.fire({ title: this.lang.Info, text: message });
      this.uploadadminlogoimg = "";
    }
  }
  uploadadminlogo1(event1: any) {
    var fileExtension = '.' + event1.target.files[0].name.split('.').pop();

    // alert(event.target.files[0].name.replace(event.target.files[0].name,"void.pdf"))
    this.uploadadminlogoimg = event1.target.files[0];

    var allowedMimes = [
      'image/jpeg',
      'image/pjpeg',
      'image/png',
    ];

    let error = false;

    let message = '';

    if (allowedMimes?.includes(this.uploadadminlogoimg.type)) {
      const maxFileSize = 1024 * 1024 * (environment.fileSize ? +environment.fileSize : 5);

      if (this.uploadadminlogoimg.size <= maxFileSize) {
        //300KB

        error = false;
        var reader = new FileReader();
        reader.readAsDataURL(event1.target.files[0]);

        reader.onload = (_event) => {
          this.showimagelogo = false;
          this.imagedisplay = reader.result;
        };
        sessionStorage.setItem('adminlogo', this.uploadadminlogoimg);
      } else {
        error = true;
        message = `File size is too large,maximum file size is 5 MB`
        // message = this.lang.File_size_is_too_large_maximum_file_size_is_300kb;
        // alert(message);
        Swal.fire({ title: this.lang.Info, text: message });
        this.uploadadminlogoimg = "";
      }
    } else {
      error = true;

      message = this.lang.Invalid_file_type_Only_jpg_png_image_pdf_files_are_allowed;
      // alert(message);
      Swal.fire({ title: this.lang.Info, text: message });
      this.uploadadminlogoimg = "";
    }
    // var reader = new FileReader();
    // reader.readAsDataURL(event1.target.files[0]);

    // reader.onload = (_event) => {
    //   this.showimagelogo = false;
    //   this.imagedisplay = reader.result;
    // };
    // sessionStorage.setItem('adminlogo', this.uploadadminlogoimg);
  }

  coreplantemplate(e) {
    const dom: HTMLElement = this.elementRef.nativeElement;
    this.coreplantemplateValue = e.target.value;
    let summaryBlock1 = JSON.parse(sessionStorage.getItem('summaryBlock1') || '[]');

    for (let i = 0; i < summaryBlock1.length; i++) {
      const element: any = dom.querySelector(
        '#plancheck' + summaryBlock1[i].subGroupId
      );
      element.click();
    }

    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );

    this.plansBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );

    if (e.target.value == 'starter') {
      const element: any = dom.querySelector('#plancheck' + 19);
      element.click();
      this.defaultAmount = '1000';
      // this.plansNewBlock1.forEach((element:any,index:number) => {

      // if(element.id !=2 && element.id !=8){

      //   const element2: any = dom.querySelector(".collapsed")

      //   if(element2){

      //   }else{
      //      const element1: any = dom.querySelector("#plancheckcollapseone" +element.id)
      //       element1.click()
      //   }

      // }
      // else{

      //   const element2: any = dom.querySelector(".collapsed")

      //   if(element2){
      //     const element1: any = dom.querySelector("#plancheckcollapseone" +element.id)
      //     element1.click()
      //   }else{

      //   }
      // }
      // });
    } else if (e.target.value == 'standard') {
      const element: any = dom.querySelector('#plancheck' + 3);
      element.click();
      const element1: any = dom.querySelector('#plancheck' + 21);
      element1.click();
      this.defaultAmount = '300';
      // this.plansNewBlock1.forEach((element:any,index:number) => {
      //   if(element.id !=1 && element.id !=2 && element.id !=8){
      //      const element1: any = dom.querySelector("#plancheckcollapseone" +element.id)
      //         element1.click()
      //   }
      //   else{
      //     // if(element.id !=2){
      //     //   element.groups.forEach((groups:any,index:number) => {

      //     //     if(groups.id !=1){

      //     //     const element1: any = dom.querySelector("#plancheckcollapseone" +groups.id)
      //     //     element1.click()
      //     //     }

      //     //   });

      //     // }

      //   }

      //         });
    } else if (e.target.value == 'executive') {
      setTimeout(() => {
        const element: any = dom.querySelector('#plancheck' + 9);
        element.click();
      }, 10);

      const element1: any = dom.querySelector('#plancheck' + 18);
      element1.click();
      this.defaultAmount = '2500';
      // this.plansNewBlock1.forEach((element:any,index:number) => {
      //   if(element.id !=1 && element.id !=5 && element.id !=8){
      //      const element1: any = dom.querySelector("#plancheckcollapseone" +element.id)
      //         element1.click()
      //   }
      //   else{
      //     // if(element.id !=5){
      //     //   element.groups.forEach((groups:any,index:number) => {

      //     //     if(groups.id !=6){

      //     //     const element1: any = dom.querySelector("#plancheckcollapseone" +groups.id)
      //     //     element1.click()
      //     //     }

      //     //   });

      //     // }

      //   }

      //         });
    } else if (e.target.value == 'custom') {
      this.defaultAmount = '';
    }
    0;
  }

  public replaceCharacter(string, index, replacement) {
    return string.slice(0, index) + replacement + string.slice(index + 1);
  }

  public getExecCoverage(Single, Couple, Family) {
    var coverage = '000';
    // var coverage='';
    if (Family) {
      coverage = this.replaceCharacter(coverage, 0, '1');
    }
    if (Couple) {
      coverage = this.replaceCharacter(coverage, 1, '1');
    }
    if (Single) {
      coverage = this.replaceCharacter(coverage, 2, '1');
    }

    return coverage;
  }
  executiveplansCoverage(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {
    console.log(e);

    this._LoaderService.ShowLoader()


    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1000);
    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('mainresults') || '[]'
    );
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );

    let plans = summaryBlock1.filter(
      (plan) => plan.subGroupId == subgroupid);

    if (plans.length > 0) {
      let coverage = this.getExecCoverage($('#executiveplanssingle' + subgroupid).prop('checked'), $('#executiveplanscouple' + subgroupid).prop('checked'), $('#executiveplansfamily' + subgroupid).prop('checked'));

      if (coverage == "000" || coverage == "") {
        setTimeout(() => {
          $("#plancheck" + subgroupid).click()
        }, 100);

      }
      else {
        coverage = coverage
      }
      this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][
        subGrpIndex
      ]['coverage'] = coverage;
      // if(coverage == "111"){
      //   this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][
      //     subGrpIndex] =null

      // }else{
      //   this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][
      //     subGrpIndex
      //   ]['coverage'] = coverage;
      // }

      summaryBlock1.forEach((element: any) => {
        if (
          element.packageindex == packageIndex &&
          element.groupindex == grpIndex &&
          element.subgroupindex == subGrpIndex
        ) {
          element['coverage'] = coverage;
          // element['coverage'] = e.target.value;
        }
      });

      // console.log(this.plansNewBlock2)
      sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));

      sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock2));

      // sessionStorage.setItem('block2result', JSON.stringify(this.plansNewBlock2));


      let summaryBlock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );

      if (summaryBlock2 && summaryBlock2.length > 0) {

        let index = this.getslectedplansblock2(subgroupid)
        if (index > -1) {
          // let coveragercheck = summaryBlock2[index].coverage

          if (coverage == "000" || coverage == "") {
            summaryBlock2[index].coverage = "111"
          }
          else if (coverage == "001") {
            summaryBlock2[index].coverage = "110"
          }
          else if (coverage == "010") {
            summaryBlock2[index].coverage = "100"
          }
          else if (coverage == "011") {
            summaryBlock2[index].coverage = "100"
          }
          else if (coverage == "111") {
            summaryBlock2.splice(index, 1);
          }
          else if (coverage == "101") {
            summaryBlock2.splice(index, 1);
          }
          // summaryBlock2.splice(index, 1);
          sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));

        }

      }
      let summaryBlock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );

      if (summaryBlock3 && summaryBlock3.length > 0) {
        let index = this.getslectedplansblock3(subgroupid)
        if (index > -1) {
          // let coveragercheck = summaryBlock2[index].coverage

          if (coverage == "000" || coverage == "") {
            summaryBlock3[index].coverage = "111"
          }
          else if (coverage == "001") {
            summaryBlock3[index].coverage = "110"
          }
          else if (coverage == "010") {
            summaryBlock3[index].coverage = "100"
          }
          else if (coverage == "011") {
            summaryBlock3[index].coverage = "100"
          }
          else if (coverage == "111") {
            summaryBlock3.splice(index, 1);
          }
          else if (coverage == "101") {
            summaryBlock3.splice(index, 1);
          }
          // summaryBlock2.splice(index, 1);
          sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));

        }

      }

      this.checkvalidationblock2()

      this.checkvalidationblock3()
    } else {
      const element: any = $("#plancheck" + subgroupid);
      console.log({ element })
      if (element != null)
        element.click()
      setTimeout(() => {
        this.executiveplansCoverage(e, packageIndex, grpIndex, subGrpIndex, subgroupid)
      }, 1000);
    }



  }

  executiveplansCoverage2(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {

    console.log(packageIndex)
    console.log(grpIndex)
    console.log(subGrpIndex)
    console.log(subgroupid)
    this._LoaderService.ShowLoader()


    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1000);

    // [{"packageid":"5","parentId":"15","subGroupId":"18","orderId":"21","packagename":"Executive Benefits","groupname":"Exec","subGrpname":"Complete Executive Care","tiers":[],"packageindex":4,"groupindex":0,"subgroupindex":1}]
    this.Newplansresblack3 = JSON.parse(
      sessionStorage.getItem('block2result') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );


    let plans = this.selectedplansblock1.filter(
      (plan) => plan.subGroupId == subgroupid);

    if (plans.length > 0) {
      setTimeout(() => {
        let coverage = this.getExecCoverage($('#executiveplansblock2single' + subgroupid).prop('checked'),
          $('#executiveplansblock2couple' + subgroupid).prop('checked'),
          $('#executiveplansblock2family' + subgroupid).prop('checked'));

        // alert(coverage)

        console.log(coverage)
        if (coverage == "000" || coverage == "") {
          setTimeout(() => {
            $("#plancheck2Upgrade" + subgroupid).click()
          }, 100);


        }
        else {
          coverage = coverage
        }

        console.log()

        if (this.Newplansresblack3[packageIndex]['groups'][grpIndex]['subGroups'][
          subGrpIndex
        ] != null) {
          this.Newplansresblack3[packageIndex]['groups'][grpIndex]['subGroups'][
            subGrpIndex
          ]['coverage'] = coverage;
        }
        this.selectedplansblock1.forEach((element: any) => {
          if (
            element.packageindex == packageIndex &&
            element.groupindex == grpIndex &&
            element.subgroupindex == subGrpIndex
          ) {


            element['coverage'] = coverage;


          }
        });

        let summaryBlock3 = JSON.parse(
          sessionStorage.getItem('summaryBlock3') || '[]'
        );

        // if(summaryBlock3 && summaryBlock3.length>0){
        //   let index=this.getslectedplansblock3(subgroupid)
        //   if (index > -1) {
        //     summaryBlock3.splice(index, 1);
        //     sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));

        //   }

        // }
        if (summaryBlock3 && summaryBlock3.length > 0) {
          let index = this.getslectedplansblock3(subgroupid)
          if (index > -1) {
            // let coveragercheck = summaryBlock2[index].coverage

            if (coverage == "000" || coverage == "") {
              summaryBlock3[index].coverage = "111"
            }
            else if (coverage == "001") {
              summaryBlock3[index].coverage = "110"
            }
            else if (coverage == "010") {
              summaryBlock3[index].coverage = "100"
            }
            else if (coverage == "011") {
              summaryBlock3[index].coverage = "100"
            }
            else if (coverage == "111") {
              summaryBlock3.splice(index, 1);
            }
            else if (coverage == "101") {
              summaryBlock3.splice(index, 1);
            }
            // summaryBlock2.splice(index, 1);
            sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));

          }

        }

        sessionStorage.setItem(
          'summaryBlock2',
          JSON.stringify(this.selectedplansblock1)
        );

        sessionStorage.setItem(
          'block2result',
          JSON.stringify(this.Newplansresblack3)
        );

        setTimeout(() => {
          if (this.employeeplanpurchase == true) {
            // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
            // el.click();
            setTimeout(() => {
              let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
              el1.click();
              // this.plansblock3();

            }, 10);
          }
        }, 1000);
      }, 1000);

    }
    else {
      const element: any = $("#plancheck2Upgrade" + subgroupid);
      console.log({ element })
      if (element != null)
        element.click()
      setTimeout(() => {
        this.executiveplansCoverage2(e, packageIndex, grpIndex, subGrpIndex, subgroupid)
      }, 1000);
    }



  }
  executiveplansCoverage3(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {
    this._LoaderService.ShowLoader()


    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1000);
    // [{"packageid":"5","parentId":"15","subGroupId":"18","orderId":"21","packagename":"Executive Benefits","groupname":"Exec","subGrpname":"Complete Executive Care","tiers":[],"packageindex":4,"groupindex":0,"subgroupindex":1}]
    this.Newplansresblack3 = JSON.parse(
      sessionStorage.getItem('block3result') || '[]'
    );
    let sumamryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    let plans = sumamryBlock3.filter(
      (plan) => plan.subGroupId == subgroupid);
    console.log(plans)
    if (plans.length > 0) {
      // setTimeout(() => {
      let coverage = this.getExecCoverage($('#executiveplansblock3single' + subgroupid).prop('checked'), $('#executiveplansblock3couple' + subgroupid).prop('checked'), $('#executiveplansblock3family' + subgroupid).prop('checked'));


      if (coverage == "000" || coverage == "") {
        setTimeout(() => {
          $("#plancheck3Voluntry" + subgroupid).click()
        }, 100);


      }
      else {
        coverage = coverage
      }

      console.log(coverage)
      this.Newplansresblack3[packageIndex]['groups'][grpIndex]['subGroups'][
        subGrpIndex
      ]['coverage'] = coverage;
      sumamryBlock3.forEach((element: any) => {
        if (
          element.packageindex == packageIndex &&
          element.groupindex == grpIndex &&
          element.subgroupindex == subGrpIndex
        ) {
          element['coverage'] = coverage;
        }
      });
      console.log(sumamryBlock3)
      sessionStorage.setItem(
        'summaryBlock3',
        JSON.stringify(sumamryBlock3)
      );

      sessionStorage.setItem(
        'block3result',
        JSON.stringify(this.Newplansresblack3)
      );
      // }, 1000);

    }
    else {
      const element: any = $("#plancheck3Voluntry" + subgroupid);
      console.log({ element })
      if (element != null)
        element.click()
      setTimeout(() => {
        this.executiveplansCoverage3(e, packageIndex, grpIndex, subGrpIndex, subgroupid)
      }, 1000);
    }


  }
  executiveplansCoverageTier1(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {
    // [{"packageid":"5","parentId":"15","subGroupId":"18","orderId":"21","packagename":"Executive Benefits","groupname":"Exec","subGrpname":"Complete Executive Care","tiers":[],"packageindex":4,"groupindex":0,"subgroupindex":1}]
    let mainPlanTier = JSON.parse(
      sessionStorage.getItem('plansBlock1Tiers') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock1') || '[]'
    );
    // console.log(this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex])
    let coverage = this.getExecCoverage($('#executiveplansTiersingle' + subgroupid).prop('checked'), $('#executiveplansTiercouple' + subgroupid).prop('checked'), $('#executiveplansTierfamily' + subgroupid).prop('checked'));

    mainPlanTier[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex][
      'coverage'
    ] = coverage;
    //  this.seelctedplanLevelTierMapping[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex]['coverage'] = e.target.value

    this.selectedplansblock1.forEach((element: any) => {
      if (
        element.packageindex == packageIndex &&
        element.groupindex == grpIndex &&
        element.subgroupindex == subGrpIndex
      ) {
        element['coverage'] = coverage;
      }
    });

    sessionStorage.setItem(
      'selectedTiersBlock1',
      JSON.stringify(this.selectedplansblock1)
    );

    sessionStorage.setItem('plansBlock1Tiers', JSON.stringify(mainPlanTier));

    if (this.seelctedplanLevelTierMapping.length > 0) {
      for (let i = 0; i < this.seelctedplanLevelTierMapping.length; i++) {
        if (
          this.seelctedplanLevelTierMapping[i].packageindex == packageIndex &&
          this.seelctedplanLevelTierMapping[i].groupindex == grpIndex &&
          this.seelctedplanLevelTierMapping[i].subgroupindex == subGrpIndex
        ) {
          this.seelctedplanLevelTierMapping[i].coverage = coverage;
        }
      }
      console.log(this.seelctedplanLevelTierMapping);
    }
  }
  executiveplansCoverageTier2(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {
    // [{"packageid":"5","parentId":"15","subGroupId":"18","orderId":"21","packagename":"Executive Benefits","groupname":"Exec","subGrpname":"Complete Executive Care","tiers":[],"packageindex":4,"groupindex":0,"subgroupindex":1}]
    let mainPlanTier = JSON.parse(
      sessionStorage.getItem('block2resultTiers') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock2') || '[]'
    );
    // console.log(this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex])
    let coverage = this.getExecCoverage($('#executiveplansblock2Tiersingle' + subgroupid).prop('checked'), $('#executiveplansblock2Tiercouple' + subgroupid).prop('checked'), $('#executiveplansblock2Tierfamily' + subgroupid).prop('checked'));

    mainPlanTier[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex][
      'coverage'
    ] = coverage;

    this.selectedplansblock1.forEach((element: any) => {
      if (
        element.packageindex == packageIndex &&
        element.groupindex == grpIndex &&
        element.subgroupindex == subGrpIndex
      ) {
        element['coverage'] = coverage;
      }
    });

    sessionStorage.setItem(
      'selectedTiersBlock2',
      JSON.stringify(this.selectedplansblock1)
    );

    sessionStorage.setItem('block2resultTiers', JSON.stringify(mainPlanTier));
    if (this.seelctedplanLevelTierMappingBlock2.length > 0) {
      for (let i = 0; i < this.seelctedplanLevelTierMappingBlock2.length; i++) {
        if (
          this.seelctedplanLevelTierMappingBlock2[i].packageindex ==
          packageIndex &&
          this.seelctedplanLevelTierMappingBlock2[i].groupindex == grpIndex &&
          this.seelctedplanLevelTierMappingBlock2[i].subgroupindex ==
          subGrpIndex
        ) {
          this.seelctedplanLevelTierMappingBlock2[i].coverage = coverage;
        }
      }
      console.log(this.seelctedplanLevelTierMapping);
    }
  }
  executiveplansCoverageTier3(e, packageIndex, grpIndex, subGrpIndex, subgroupid) {
    // [{"packageid":"5","parentId":"15","subGroupId":"18","orderId":"21","packagename":"Executive Benefits","groupname":"Exec","subGrpname":"Complete Executive Care","tiers":[],"packageindex":4,"groupindex":0,"subgroupindex":1}]
    let mainPlanTier = JSON.parse(
      sessionStorage.getItem('block3resultTiers') || '[]'
    );
    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock3') || '[]'
    );
    // console.log(this.plansNewBlock2[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex])
    let coverage = this.getExecCoverage($('#executiveplansblock3Tiersingle' + subgroupid).prop('checked'), $('#executiveplansblock3Tiercouple' + subgroupid).prop('checked'), $('#executiveplansblock3Tierfamily' + subgroupid).prop('checked'));

    mainPlanTier[packageIndex]['groups'][grpIndex]['subGroups'][subGrpIndex][
      'coverage'
    ] = coverage;

    this.selectedplansblock1.forEach((element: any) => {
      if (
        element.packageindex == packageIndex &&
        element.groupindex == grpIndex &&
        element.subgroupindex == subGrpIndex
      ) {
        element['coverage'] = coverage;
      }
    });

    sessionStorage.setItem(
      'selectedTiersBlock3',
      JSON.stringify(this.selectedplansblock1)
    );

    sessionStorage.setItem('block3resultTiers', JSON.stringify(mainPlanTier));
    if (this.seelctedplanLevelTierMappingBlock3.length > 0) {
      for (let i = 0; i < this.seelctedplanLevelTierMappingBlock3.length; i++) {
        if (
          this.seelctedplanLevelTierMappingBlock3[i].packageindex ==
          packageIndex &&
          this.seelctedplanLevelTierMappingBlock3[i].groupindex == grpIndex &&
          this.seelctedplanLevelTierMappingBlock3[i].subgroupindex ==
          subGrpIndex
        ) {
          this.seelctedplanLevelTierMappingBlock3[i].coverage = coverage;
        }
      }
    }
  }

  unselectPlanLevelBulk(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]]?.includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]]?.includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck' + all_pl[i]);
        if (element.checked) {
          element.click();

          // this.unselectplan(dom2.querySelector('#plancheck' + all_pl[i]));
          // element.checked = false;
        } else {
          console.log('not checked ignore' + all_pl[i]);
        }

        // dom2.querySelector("planscheck"+all_pl[i])
        // matched_pl.push(all_pl[i])
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheck' + curr_planLevel_id
    );
    current_element.checked = true;
  }
  public colors = { 0: "#FF3131", 1: "#37FBB3", 2: "black" }
  public text = { 0: "Unpublished", 1: "Published", 2: "Published but Restricted" }
  // unpublished(red -0 ), restricted / reserved(black 2 or 3), published(1 - green)
  getStatus(published, restricted) {
    // console.log({ published, restricted })
    let data = -1;
    if (published) {
      if (restricted) {
        data = 2
      }
      else {
        data = 1
        // console.log({ data })
      }

    }
    else {
      data = 0
    }
    return data
  }

  getColorForPlans(published, restricted, name?) {
    // console.log(published, restricted, name)
    const pubStatus = { 0: false, 1: true, 2: true }
    // console.log(pubStatus[published], restricted)
    let data = this.getStatus(pubStatus[published], restricted)

    // console.log(data)
    return this.colors[data]
  }

  getTextForTooltip(published, restricted) {
    const pubStatus = { 0: false, 1: true, 2: true }
    let data = this.getStatus(pubStatus[published], restricted)
    return this.text[data]
  }

  getColorForPlans1(published, restricted) {

    let data: any = this.getStatus(published, restricted)
    const color = this.colors[data];
    return color;
  }
  getTextForTooltip1(published, restricted) {
    let data: any = this.getStatus(published, restricted)
    const text = this.text[data]
    return text
  }

  getSelectedPackage(packId) {
    console.log(packId)
    return this.selectedPackages.includes(packId)
  }

  preventNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '+' || event.key === '.') {
      event.preventDefault();
    }
  }

  preventNonNumeric(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if (!/^\d*$/.test(value)) {
      input.value = value.replace(/[^\d]/g, '');
    }
  }


  onCheckboxChangeBulkPlns(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
  ) {

    if (e.target.checked) {
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
    }

    this.headCountmiss = false
    this.headCountmiss1 = false
    // alert(packageid)

    // this._LoaderService.ShowLoader()

    // setTimeout(() => {
    //   this._LoaderService.HideLoader()

    // }, 5000);
    this.planselectedId = subgroupid;


    // let multiple = allow_multiple ? Boolean(allow_multiple.data[0]) : false;
    let multiple = allow_multiple == true ? true : false;

    // if (packageid == 2) {
    //   if (e.target.checked) {

    //     // alert(subgroupindex)
    //     this.unselectPlanLevelBulk(e.target.id.replace('plancheck', ''), parentid);
    //     this.showinputboxvalue = subgroupid
    //     this.hidementalplans = 2
    //     this.showinputbox = subgroupindex
    //   }
    //   else {
    //     this.hidementalplans = 222
    //     this.showinputbox = "1212"
    //     this.showEmployeeValue = ""
    //     this.showinputboxvalue = "1213"
    //   }
    // }

    // else {
    //   if (e.target.checked) {

    //     this.unselectPlanLevelBulk(e.target.id.replace('plancheck', ''), parentid);
    //     this.showinputboxvalue1 = subgroupid
    //     this.hidewaddellplans = 11
    //     this.showinputbox1 = subgroupindex
    //   }
    //   else {
    //     this.hidewaddellplans = 222
    //     this.showinputbox1 = "1212"
    //     this.showEmployeeValue1 = ""
    //     this.showinputboxvalue1 = "1213"
    //   }
    // }

    //new
    console.log(this.showinputboxvalue, this.checkboxCheck, this.showHeadCount)

    if (e.target.checked) {

      // this.unselectPlanLevelBulk(e.target.id.replace('plancheck', ''), parentid);
      if (subgroup.settings) {
        this.checkboxCheck[subgroupid] = subgroup.settings?.showHeadCount //? true : false
        this.showinputboxvalue[subgroupid] = subgroup.settings?.showMemberDetailsDB //? true : false
      }
      console.log('checkboxCheck after check:', this.checkboxCheck);
      this.hidementalplans = 2

    }
    else {
      this.hidementalplans = 222
      this.showinputbox = false
      this.showEmployeeValue = ""
      this.checkboxCheck[subgroupid] = false;
      console.log('checkboxCheck after uncheck:', this.checkboxCheck);
      console.log('checkboxCheck after uncheck:', this.checkboxCheck);
      this.showHeadCount[subgroupid] = ''
      this.showinputboxvalue[subgroupid] = false

    }
    console.log(this.showinputboxvalue, this.checkboxCheck, this.showHeadCount)

    console.log(disallowedPlanLevels);
    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      // const disallowed_elements = dom1.querySelectorAll(
      //   '.plansscreen input.block1');

      for (let i = 0; i < disallowed_plans.length; i++) {
        console.log(disallowed_plans[i]);
        console.log(disallowed_plans[i]);
        let elem: any = dom1.querySelector(`#plancheckboxbulk${disallowed_plans[i]}`)
        // elementcv.checked=false

        // if (!elem.attributes.data) {
        //   continue;
        // }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        // console.log(plandetailsobj)

        // // console.log('main', plandetailsobj);

        // console.log("disallowed_plans",disallowed_plans)
        // console.log(plandetailsobj[1])
        // console.log(plandetailsobj[4])

        if (e.target.checked) {
          if (!elem.disabled) {
            console.log('test');
            elem.disabled = true
            this.checkboxCheck[disallowed_plans[i]] = false
            this.showHeadCount[disallowed_plans[i]] = ''
            this.disabledelement =
              'Already included in GroupBenefitz All-In';

          }
          if (elem.checked) {
            // console.log(disallowed_plans)
            elem.checked = false;

            this.unselectplanBulk(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[10],
              plandetailsobj[11],
              plandetailsobj[12],
              disallowedPlanLevels
            );


          }
        }
        else {
          console.log('here');

          if (
            elem.disabled ||
            elem.previousElementSibling.style.opacity == '0.2'
          ) {
            elem.disabled = false;
            elem.previousElementSibling.style.opacity = 1;

          }
          if (elem.checked) {
            elem.checked = false;

          }
        }
      }
    }

    // ////console.log(e)
    let classname = e.target.className;
    classname = classname.split(' ').join('.');

    console.log(classname);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.' + classname);

    console.log(elements);

    // let plandetailsobj = plandetails.split('##');

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        // this.unselectplan(e.target)
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;
          let plandetails = element.attributes.data.value;
          let plandetailsobj = plandetails.split('##');

          if (element.checked) {

            console.log(e.target.id)
            console.log(element.id)

            if (e.target.id == element.id) {
              continue;
            }
            this.unselectplanBulk(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11],
              disallowedPlanLevels
            );
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
    } else {


    }
    setTimeout(() => {
      if (e.target.checked) {


        this.selectplanBulk(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          disallowedPlanLevels
        );

        this.executiveid = subgroupindex;

        console.log(this.executiveid);
      }
      else {
        console.log('indexx2 null');
        this.unselectplanBulk(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          packageindex,
          groupindex,
          subgroupindex,
          disallowedPlanLevels
        );
        // for (let i = 0; i < elements.length; i++) {
        //   let elem = elements[i];
        //   element = elem;
        //   let plandetails = element.attributes.data.value;
        //   let plandetailsobj = plandetails.split('##');

        //   console.log(plandetailsobj);

        //   this.unselectplanBulk(
        //     elem,
        //     pname,
        //     parentname,
        //     subgroupname,
        //     packageindex,
        //     groupindex,
        //     subgroupindex,
        //     plandetailsobj[9],
        //     plandetailsobj[10],
        //     plandetailsobj[11]
        //   );
        // }
        // this.unselectplan(e.target,pname,parentname,subgroupname,packageindex,groupindex,subgroupindex,null,null,null);
      }
    }, 10);
  }

  toggleCollapse(pack: any) {
    console.log("entering")
    let collapseTargets: any = [];

    if (pack.groups.length > 1) {
      pack.groups.forEach((group: any) => {
        collapseTargets.push(`collapseone${group.id}`);
      });
    }
    else {
      collapseTargets = [`collapseone${pack.id}`];
    }
    console.log(collapseTargets)

    collapseTargets.forEach(targetId => {
      // const collapseElement = document.getElementById(targetId);
      const elements = document.querySelectorAll(`#${targetId}`);

      if (elements.length > 0) {
        elements.forEach(element => {
          element.classList.toggle('show');
        });
      }
    });

    // if (pack.id == 1) {
    //   const elements = document.querySelectorAll('#collapseone6');
    //   elements.forEach(element => {
    //     element.classList.toggle('show');
    //   });
    // }
    // if (pack.groups.length > 1) {
    //   pack.groups.forEach((group: any) => {
    //     group.subGroups.forEach((sub: any) => {
    //       const collapseElement = document.getElementById(`collapseone${sub.parentId}`);
    //       console.log(collapseElement)
    //       if (collapseElement) {
    //         collapseElement.classList.toggle('show');
    //       }
    //     })
    //   });
    // }
    // else {
    //   pack.groups.forEach((group: any) => {
    //     group.subGroups.forEach((sub: any) => {
    //       const collapseElement = document.getElementById(`collapseone${pack.id}`);
    //       console.log(collapseElement)
    //       if (collapseElement) {
    //         collapseElement.classList.toggle('show');
    //       }
    //     })
    //   });
    // }
  }


  onCheckboxChange1(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {

    this._LoaderService.ShowLoader()

    if (e.target.checked) {
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }


      this.plansCoveragecheckboxCheck[subgroupid] = this.companyPaidCoveragePlanLevels[subgroupid]

      if (this.plansCoveragecheckboxCheck[subgroupid]) {
        this.finalCompanyPaidCoverages = this.companyPaidCoveragePlanLevels[subgroupid]
        console.group(this.plansCoveragecheckboxCheck[subgroupid])
      }

    }

    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1200);
    this.planselectedId = subgroupid;


    let multiple = allow_multiple == true ? true : false;
    // let multiple = false;

    if (e.target.checked) {
      // this.unselectPlanLevel(e.target.id.replace('plancheck', ''), parentid);
    }

    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      // const disallowed_elements = dom1.querySelectorAll(
      //   '.plansscreen input.block1');

      for (let i = 0; i < disallowed_plans.length; i++) {
        console.log(disallowed_plans[i]);
        console.log(disallowed_plans[i]);
        let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)


        if (!elem) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        console.log(plandetailsobj)

        // // console.log('main', plandetailsobj);

        // console.log("disallowed_plans",disallowed_plans)
        // console.log(plandetailsobj[1])
        // console.log(plandetailsobj[4])

        if (e.target.checked) {
          if (!elem.disabled) {
            console.log('test');
            elem.disabled = true

            this.disabledelement =
              'Already included in GroupBenefitz All-In';

          }
          if (elem.checked) {
            // console.log(disallowed_plans)
            elem.checked = false;



            this.unselectplan(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11]
            );


          }
        }
        else {
          console.log('here');

          if (
            elem.disabled ||
            elem.previousElementSibling.style.opacity == '0.2'
          ) {
            elem.disabled = false;
            elem.previousElementSibling.style.opacity = 1;

          }
          if (elem.checked) {
            elem.checked = false;

          }
        }
      }
    }

    // ////console.log(e)
    let classname = e.target.className;
    classname = classname.split(' ').join('.');

    console.log(classname);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.' + classname);

    console.log(elements);

    // let plandetailsobj = plandetails.split('##');

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        // this.unselectplan(e.target)
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;
          let plandetails = element.attributes.data.value;
          let plandetailsobj = plandetails.split('##');

          if (element.checked) {

            console.log(e.target.id)
            console.log(element.id)

            if (e.target.id == element.id) {
              continue;
            }

            this.unselectplan(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11]
            );
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
    } else {


    }
    setTimeout(() => {
      if (e.target.checked) {


        this.selectplan(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          subgroup,
          disallowedPlanLevels
        );

        this.executiveid = subgroupindex;

        console.log(this.executiveid);
      }
      else {
        console.log('indexx2 null');
        // for (let i = 0; i < elements.length; i++) {
        // let elem = elements[i];
        // element = elem;
        // let plandetails = element.attributes.data.value;
        // let plandetailsobj = plandetails.split('##');

        // console.log(plandetailsobj);



        // this.unselectplanBulk(
        //   e.target,
        //   pname,
        //   parentname,
        //   subgroupname,
        //   packageindex,
        //   groupindex,
        //   subgroupindex,
        //   plandetailsobj[9],
        //   plandetailsobj[10],
        //   plandetailsobj[11]
        // );

        this.unselectplan(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          packageindex,
          groupindex,
          subgroupindex
        );
        // }
        // this.unselectplan(e.target,pname,parentname,subgroupname,packageindex,groupindex,subgroupindex,null,null,null);
      }
    }, 10);
    if (this.employeeplanpurchase == true) {

      setTimeout(() => {
        let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
        el1.click();
      }, 10);
    }

  }
  onCheckboxChange2(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    this.block2execid = subgroupid;
    this._LoaderService.ShowLoader()

    if (e.target.checked) {
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
    }

    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1200);
    // let multiple = allow_multiple ? Boolean(allow_multiple.data[0]) : false;

    //  for(let i of block2filter){

    //    console.log(i)
    //    console.log(i.subGroupId)

    //    let element: any = dom2.querySelector('#plancheck2Upgrade' + i.subGroupId);
    //    if (element.checked) {

    //      element.click()
    //      element.click()
    //    }
    //  }


    let multiple = allow_multiple == true ? true : false;

    // let multiple = true;
    if (e.target.checked) {
      this.unselectPlanLevel2(e.target.id.replace('plancheck2Upgrade', ''), parentid);
    }
    else {
      //we are changg=ing fron select to unselect
      /* using for select checked plans in block2 */
      let block2 = JSON.parse(sessionStorage.getItem('summaryBlock2') || '[]');

      let block2filter = block2.filter(
        (item: any) => item.parentId == parentid
      );

      console.log(block2filter);
      const dom2: HTMLElement = this.elementRef.nativeElement;
      if (block2filter.length > 1) {
        let element1: any = dom2.querySelector('#plancheck2Upgrade' + subgroupid);

        if (element1.checked) {
          console.log('checked');

          element1.checked = false;
          return;
        }
        else {
          if (block2) {

            let index = this.getslectedplansblock2(subgroupid);

            if (index > -1) {
              block2.splice(index, 1);
              let summaryBlock2 = JSON.parse(sessionStorage.getItem('summaryBlock2') || '[]');
              let mainresults = JSON.parse(
                sessionStorage.getItem('mainresults') || '{}'
              );


              if (subgroupid == 17 || subgroupid == 18 || subgroupid == 28) {


                mainresults[packageindex]['groups'][groupindex][
                  'subGroups'
                ][subgroupindex]['checked'] = false;




                if (
                  mainresults[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Executive Health'
                ) {


                  $('#executiveplansblock2single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  let summaryBlock1 = JSON.parse(
                    sessionStorage.getItem('summaryBlock1') || '[]'
                  );


                  sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

                }


                if (
                  mainresults[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Provincial Health Replacement Plan'
                ) {
                  // this.plansresblack2[obj.packageIndex]['groups'][obj.groupIndex][
                  //   'subGroups'
                  // ][obj.subgroupIndex]['coverage'] = 'default';

                  $('#executiveplansblock2single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

                }

                if (
                  mainresults[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Complete Executive Care'
                ) {
                  // this.plansresblack2[obj.packageIndex]['groups'][obj.groupIndex][
                  //   'subGroups'
                  // ][obj.subgroupIndex]['coverage'] = 'default';

                  $('#executiveplansblock2single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock2single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock2family' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

                }

              }



              sessionStorage.setItem(
                'mainresults',
                JSON.stringify(mainresults)
              );


              var newselectedplans: any = {};
              for (var i = 0; i < summaryBlock2.length; i++) {
                newselectedplans[summaryBlock2[i].subGroupId] = i;
              }

              sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

              this.planssummarymain = [];
              this.planssummaryopt = [];

              summaryBlock2.forEach((element: any) => {
                if (element.packagename != 'Opt-in') {
                  this.planssummarymain.push(element);
                } else {
                  this.planssummaryopt.push(element);
                }
              });

              let selectedplansblock2 = JSON.parse(
                sessionStorage.getItem('summaryBlock2') || '[]'
              );
              let selectedplansblock3 = JSON.parse(
                sessionStorage.getItem('summaryBlock3') || '[]'
              );


              console.log(this.employeeplanpurchase)
              if (this.employeeplanpurchase == true) {

                // console.log("1")
                // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
                // el.click();
                setTimeout(() => {
                  let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                  el1.click();
                  setTimeout(() => {
                    const dom: HTMLElement = this.elementRef.nativeElement;
                    if (selectedplansblock3.length > 0) {
                      let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                      el1.click();
                      this.employeeplanpurchase == true;
                      setTimeout(() => {
                        for (let i = 0; i < selectedplansblock3.length; i++) {
                          const element2: any = dom.querySelector(
                            '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
                          );
                          // element2.checked = true;
                          // element2.click()

                          element2?.prop('checked', true);
                        }
                      }, 1500);
                    }
                  }, 1000);
                }, 100);
              }

              sessionStorage.setItem(
                'summaryBlock2main',
                JSON.stringify(this.planssummarymain)
              );
              sessionStorage.setItem(
                'summaryBlock2opt',
                JSON.stringify(this.planssummaryopt)
              );

              sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));


            } else {
              return;
            }
          }

          sessionStorage.setItem('summaryBlock2', JSON.stringify(block2));

          let selectedplansblock3 = JSON.parse(
            sessionStorage.getItem('summaryBlock3') || '[]'
          );


          console.log(this.employeeplanpurchase)
          if (this.employeeplanpurchase == true) {

            // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
            // el.click();
            setTimeout(() => {
              let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
              el1.click();
              setTimeout(() => {
                const dom: HTMLElement = this.elementRef.nativeElement;
                if (selectedplansblock3.length > 0) {
                  let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                  el1.click();
                  this.employeeplanpurchase == true;
                  setTimeout(() => {
                    for (let i = 0; i < selectedplansblock3.length; i++) {
                      const element2: any = dom.querySelector(
                        '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
                      );

                      element2?.prop('checked', true);
                      // element2.checked = true;
                    }
                  }, 1500);
                }
              }, 1000);
            }, 10);
          }
          return;
        }
      }
    }
    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      // const disallowed_elements = dom1.querySelectorAll(
      //   '.plansscreen input.block1');

      for (let i = 0; i < disallowed_plans.length; i++) {
        console.log(disallowed_plans[i]);
        console.log(disallowed_plans[i]);
        let elem: any = dom1.querySelector(`#plancheck2Upgrade${disallowed_plans[i]}`)
        //     const disallowed_elements = dom1.querySelectorAll(
        //   ".plansscreen input[type='checkbox']"
        // );
        console.log(elem)


        if (!elem) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        console.log(plandetailsobj)

        // // console.log('main', plandetailsobj);

        // console.log("disallowed_plans",disallowed_plans)
        // console.log(plandetailsobj[1])
        // console.log(plandetailsobj[4])

        if (e.target.checked) {
          if (!elem.disabled) {
            console.log('test');
            elem.disabled = true

            this.disabledelement =
              'Already included in GroupBenefitz All-In';

          }
          if (elem.checked) {
            // console.log(disallowed_plans)
            elem.checked = false;



            this.unselectplanblock2(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11]
            );


          }
        }
        else {
          console.log('here');

          if (
            elem.disabled ||
            elem.previousElementSibling.style.opacity == '0.2'
          ) {
            elem.disabled = false;
            elem.previousElementSibling.style.opacity = 1;

          }
          if (elem.checked) {
            elem.checked = false;

          }
        }
      }
    }

    // ////console.log(e)
    let classname = e.target.className;
    classname = classname.split(' ').join('.');

    console.log(classname);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.' + classname);

    console.log(elements);

    // let plandetailsobj = plandetails.split('##');

    let element: any;
    let elementcv: any;

    if (!multiple) {
      if (e.target.checked) {
        // this.unselectplan(e.target)
        for (let i = 0; i < elements.length; i++) {
          let elem = elements[i];
          element = elem;
          let plandetails = element.attributes.data.value;
          let plandetailsobj = plandetails.split('##');

          if (element.checked) {

            console.log(e.target.id)
            console.log(element.id)

            if (e.target.id == element.id) {
              continue;
            }

            this.unselectplanblock2(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11]
            );
            element.checked = false;
          }
        }

        e.checked = true;
        e.target.checked = true;
      } else {
      }
    } else {


    }
    setTimeout(() => {
      if (e.target.checked) {


        this.selectplanblock2(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          subgroup,
          disallowedPlanLevels
        );

        this.executiveid = subgroupindex;

        console.log(this.executiveid);
      }
      else {
        console.log('indexx2 null');
        // for (let i = 0; i < elements.length; i++) {
        // let elem = elements[i];
        // element = elem;
        // let plandetails = element.attributes.data.value;
        // let plandetailsobj = plandetails.split('##');

        // console.log(plandetailsobj);



        // this.unselectplanBulk(
        //   e.target,
        //   pname,
        //   parentname,
        //   subgroupname,
        //   packageindex,
        //   groupindex,
        //   subgroupindex,
        //   plandetailsobj[9],
        //   plandetailsobj[10],
        //   plandetailsobj[11]
        // );

        this.unselectplanblock2(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          packageindex,
          groupindex,
          subgroupindex
        );
        // }
        // this.unselectplan(e.target,pname,parentname,subgroupname,packageindex,groupindex,subgroupindex,null,null,null);
      }
    }, 10);
  }

  onCheckboxChange3(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    this._LoaderService.ShowLoader()

    if (e.target.checked) {
      const status = this.getTextForTooltip(subgroup.published?.data[0], subgroup.restricted)
      if (status == "Unpublished") {
        Swal.fire({
          title: this.lang.Info, text: this.lang.Plan_is_in_Unpublished_State_Selecting_this_plan_will_not_be_available_on_the_signup_forms,
          showConfirmButton: true,
          confirmButtonText: "Ok"
        })
      }
    }
    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 1200);
    // let multiple = true;
    let multiple = allow_multiple == true ? true : false;
    if (disallowedPlanLevels != null) {
      let disallowed_plans = disallowedPlanLevels.split(',');
      const dom1: HTMLElement = this.elementRef.nativeElement;

      // const disallowed_elements = dom1.querySelectorAll(
      //   '.plansscreen input.block1');

      for (let i = 0; i < disallowed_plans.length; i++) {
        console.log(disallowed_plans[i]);
        console.log(disallowed_plans[i]);
        let elem: any = dom1.querySelector(`#plancheck3Voluntry${disallowed_plans[i]}`)


        if (!elem) {
          continue;
        }

        let plandetails = elem.attributes.data.value;

        let plandetailsobj = plandetails.split('##');

        console.log(plandetailsobj)

        // // console.log('main', plandetailsobj);

        // console.log("disallowed_plans",disallowed_plans)
        // console.log(plandetailsobj[1])
        // console.log(plandetailsobj[4])

        if (e.target.checked) {
          if (!elem.disabled) {
            console.log('test');
            elem.disabled = true

            this.disabledelement =
              'Already included in GroupBenefitz All-In';

          }
          if (elem.checked) {
            // console.log(disallowed_plans)
            elem.checked = false;



            this.unselectplanblock3(
              elem,
              pname,
              parentname,
              subgroupname,
              packageindex,
              groupindex,
              subgroupindex,
              plandetailsobj[9],
              plandetailsobj[10],
              plandetailsobj[11]
            );


          }
        }
        else {
          console.log('here');

          if (
            elem.disabled ||
            elem.previousElementSibling.style.opacity == '0.2'
          ) {
            elem.disabled = false;
            elem.previousElementSibling.style.opacity = 1;

          }
          if (elem.checked) {
            elem.checked = false;

          }
        }
      }
    }

    // ////console.log(e)
    let classname = e.target.className;
    classname = classname.split(' ').join('.');

    console.log(classname);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const elements = dom.querySelectorAll('.' + classname);

    console.log(elements);

    // let plandetailsobj = plandetails.split('##');

    let element: any;
    let elementcv: any;

    // if (!multiple) {
    //   if (e.target.checked) {
    //     // this.unselectplan(e.target)
    //     for (let i = 0; i < elements.length; i++) {
    //       let elem = elements[i];
    //       element = elem;
    //       let plandetails = element.attributes.data.value;
    //       let plandetailsobj = plandetails.split('##');

    //       if (element.checked) {

    //         console.log(e.target.id)
    //         console.log(element.id)

    //         if (e.target.id == element.id) {
    //           continue;
    //         }

    //         this.unselectplanblock3(
    //           elem,
    //           pname,
    //           parentname,
    //           subgroupname,
    //           packageindex,
    //           groupindex,
    //           subgroupindex,
    //           plandetailsobj[9],
    //           plandetailsobj[10],
    //           plandetailsobj[11]
    //         );
    //         element.checked = false;
    //       }
    //     }

    //     e.checked = true;
    //     e.target.checked = true;
    //   } else {
    //   }
    // } else {


    // }
    setTimeout(() => {
      if (e.target.checked) {


        this.selectplanblock3(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          subgroup,
          disallowedPlanLevels
        );

        this.executiveid = subgroupindex;

        console.log(this.executiveid);
      }
      else {
        console.log('indexx2 null');
        // for (let i = 0; i < elements.length; i++) {
        // let elem = elements[i];
        // element = elem;
        // let plandetails = element.attributes.data.value;
        // let plandetailsobj = plandetails.split('##');

        // console.log(plandetailsobj);



        // this.unselectplanBulk(
        //   e.target,
        //   pname,
        //   parentname,
        //   subgroupname,
        //   packageindex,
        //   groupindex,
        //   subgroupindex,
        //   plandetailsobj[9],
        //   plandetailsobj[10],
        //   plandetailsobj[11]
        // );

        this.unselectplanblock3(
          e.target,
          pname,
          parentname,
          subgroupname,
          packageindex,
          groupindex,
          subgroupindex,
          packageindex,
          groupindex,
          subgroupindex
        );
        // }
        // this.unselectplan(e.target,pname,parentname,subgroupname,packageindex,groupindex,subgroupindex,null,null,null);
      }
    }, 10);
    if (e.target.checked) {
      this.unselectPlanLevel3(e.target.id.replace('plancheck3Voluntry', ''), parentid);
    }
    else {
      //we are changg=ing fron select to unselect
      /* using for select checked plans in block3 */
      let block3 = JSON.parse(sessionStorage.getItem('summaryBlock3') || '[]');

      let block3filter = block3.filter(
        (item: any) => item.parentId == parentid
      );

      const dom2: HTMLElement = this.elementRef.nativeElement;
      if (block3filter.length > 1) {
        let element1: any = dom2.querySelector('#plancheck3Voluntry' + subgroupid);

        if (element1.checked) {
          console.log('checked');

          element1.checked = false;
          return;
        } else {
          if (block3) {

            let index = this.getslectedplansblock3(subgroupid);

            if (index > -1) {
              block3.splice(index, 1);
              let summaryBlock3 = JSON.parse(sessionStorage.getItem('summaryBlock3') || '[]');



              if (subgroupid == 17 || subgroupid == 18 || subgroupid == 28) {


                this.plansresblack3[packageindex]['groups'][groupindex][
                  'subGroups'
                ][subgroupindex]['checked'] = false;

                if (
                  this.plansresblack3[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Executive Health'
                ) {


                  $('#executiveplansblock3single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'disabled',
                    true
                  );



                }

                if (
                  this.plansresblack3[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Complete Executive Care'
                ) {


                  $('#executiveplansblock3single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'disabled',
                    true
                  );

                }
                if (
                  this.plansresblack3[packageindex]['groups'][groupindex][
                  'subGroups'
                  ][subgroupindex]['name'] == 'Provincial Health Replacement Plan'
                ) {


                  $('#executiveplansblock3single' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'checked',
                    false
                  );
                  $('#executiveplansblock3single' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3couple' + subgroupid).prop(
                    'disabled',
                    true
                  );
                  $('#executiveplansblock3family' + subgroupid).prop(
                    'disabled',
                    true
                  );

                }


              }




              var newselectedplans: any = {};
              for (var i = 0; i < summaryBlock3.length; i++) {
                newselectedplans[summaryBlock3[i].subGroupId] = i;
              }

              sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

              this.planssummarymain = [];
              this.planssummaryopt = [];

              summaryBlock3.forEach((element: any) => {
                if (element.packagename != 'Opt-in') {
                  this.planssummarymain.push(element);
                } else {
                  this.planssummaryopt.push(element);
                }
              });


              let selectedplansblock3 = JSON.parse(
                sessionStorage.getItem('summaryBlock3') || '[]'
              );



              sessionStorage.setItem(
                'summaryBlock3main',
                JSON.stringify(this.planssummarymain)
              );
              sessionStorage.setItem(
                'summaryBlock3opt',
                JSON.stringify(this.planssummaryopt)
              );

              sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));


            } else {
              return;
            }
          }

          sessionStorage.setItem('summaryBlock3', JSON.stringify(block3));

          let selectedplansblock3 = JSON.parse(
            sessionStorage.getItem('summaryBlock3') || '[]'
          );

          return;
        }
      }
    }

  }
  clean(obj) {
    for (var propName in obj) {
      if (
        obj[propName] === null ||
        obj[propName] === undefined ||
        obj[propName].length === 0
      ) {
        delete obj[propName];
      }
    }

    return obj;
  }
  onCheckboxChange1Tier(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    backgroundColor: any
  ) {
    this.planselectedId = subgroupid;

    let obj = {
      packageId: packageid,
      subGroupid: subgroupid,
      subGroupName: subgroupname,
      packageName: pname,
      tiers: [],
      tiersidArray: [],
      disallowedPlanLevels: disallowedPlanLevels,
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      parentid: parentid,
      backgroundColor: backgroundColor,
    };

    let selectedTiersBlock1 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock1') || '[]'
    );

    console.log(selectedTiersBlock1);
    if (e.target.checked) {
      this.plansBlock1Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = true;
      this.selectedPlansInfoTierArray.push(obj);

      selectedTiersBlock1.push(obj);
      sessionStorage.setItem(
        'selectedTiersBlock1',
        JSON.stringify(selectedTiersBlock1)
      );

      if (!this.selectedPackagePlansInfoTier[pname]) {
        this.selectedPackagePlansInfoTier[pname] = [];
      }
      const exists =
        this.selectedPackagePlansInfoTier[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        console.log('check1');
        this.selectedPackagePlansInfoTier[pname].push(obj);

        this.selectedPackagePlansInfoTier = this.clean(
          this.selectedPackagePlansInfoTier
        );

        console.log(this.selectedPackagePlansInfoTier);
      }

      this.checkdisallowedPlans(subgroupid, parentid, packageid);


      if (
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;

        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansTiersingle' + obj.subGroupid).prop('disabled', false);
        $('#executiveplansTiercouple' + obj.subGroupid).prop('disabled', false);
        $('#executiveplansTierfamily' + obj.subGroupid).prop('disabled', false);
        // $('#executiveplansTiersingle' + obj.subGroupid).click();
      }
      if (
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;
        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansTiersingle' + obj.subGroupid).prop('disabled', false);
        $('#executiveplansTiercouple' + obj.subGroupid).prop('disabled', false);
        $('#executiveplansTierfamily' + obj.subGroupid).prop('disabled', false);
        // $('#executiveplansTiersingle' + obj.subGroupid).click();
      }
    }


    else {
      if (
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;

        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansTiersingle' + obj.subGroupid).prop('disabled', true);
        $('#executiveplansTiercouple' + obj.subGroupid).prop('disabled', true);
        $('#executiveplansTierfamily' + obj.subGroupid).prop('disabled', true);

      }
      if (
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        this.plansBlock1Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;
        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansTiersingle' + obj.subGroupid).prop('disabled', true);
        $('#executiveplansTiercouple' + obj.subGroupid).prop('disabled', true);
        $('#executiveplansTierfamily' + obj.subGroupid).prop('disabled', true);

      }

      this.plansBlock1Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = false;
      this.plansBlock1Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].coverage = '';  //default
      this.plansBlock1Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].tiers = [];

      console.log(this.selectedPackagesavailableTiers2);
      // this.selectedPackagesavailableTiers2[packageid]= this.configureTierList;

      console.log(this.selectedPackagesavailableTiers2);
      // this.selectedPackagesavailableTiers2[packageindex]['groups'][groupindex]['subGroups'][
      //   subgroupindex
      // ]= this.configureTierList;

      // Here to change
      const exists =
        this.selectedPackagePlansInfoTier[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;

      // var index = this.selectedPackagePlansInfoTier[pname].findIndex(function(item){ return item.subGroupid === subgroupid})

      let arr = this.selectedPackagePlansInfoTier[pname];
      let subGroupIdindex;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].subGroupid == subgroupid) {
          subGroupIdindex = i;
          break;
        }
      }

      if (subGroupIdindex > -1) {
        this.selectedPackagePlansInfoTier[pname].splice(subGroupIdindex, 1);
      }
      var index1 = selectedTiersBlock1.findIndex(function (item) {
        return item.subGroupid === subgroupid;
      });

      console.log(this.selectedPackagePlansInfoTier);

      console.log(this.selectedPackagePlansInfoTier);
      console.log(this.seelctedplanLevelTierMapping);
      selectedTiersBlock1.splice(index1, 1);

      for (let i = 0; i < this.seelctedplanLevelTierMapping.length; i++) {
        if (this.seelctedplanLevelTierMapping[i].subGroupid == subgroupid) {
          this.seelctedplanLevelTierMapping.splice(i, 1);
        }
      }
      sessionStorage.setItem(
        'selectedTiersBlock1',
        JSON.stringify(selectedTiersBlock1)
      );

      console.log(this.selectedPackagesavailableTiers2);
      if (exists) {
        console.log(exists);
      } else {
        this.selectedPackagePlansInfoTier[pname].push(obj);
        //   this.TiersArray.push(obj)
        //  sessionStorage.setItem('selectedTiersBlock1', JSON.stringify(this.TiersArray));

        console.log(this.selectedPackagePlansInfoTier);

        console.log(this.seelctedplanLevelTierMapping);
      }
    }

    sessionStorage.setItem(
      'plansBlock1Tiers',
      JSON.stringify(this.plansBlock1Tiers)
    );
    if (this.upgradeplansselectiontiers == true) {
      let el: HTMLElement = this.upgradeplanstiersfalse.nativeElement;
      el.click();
      // setTimeout(() => {
      //   let el1: HTMLElement = this.upgradeplanstierstrue.nativeElement;
      //   el1.click();
      // }, 10);
    }
    if (this.employeeplanpurchasetiers == true) {
      let el: HTMLElement = this.employeepurchaseTiersfalse.nativeElement;
      el.click();
      // setTimeout(() => {
      //   let el1: HTMLElement = this.employeepurchaseTierstrue.nativeElement;
      //   el1.click();
      // }, 10);
    }

    // this.selectedPlansInfoTierArray.push(obj);

    // if (!this.selectedPackagePlansInfoTier[pname]) {
    //   this.selectedPackagePlansInfoTier[pname] = [];
    // }
    // const exists =
    //   this.selectedPackagePlansInfoTier[pname].findIndex(
    //     (item) => item.subGroupid === subgroupid
    //   ) > -1;
    // if (exists) {
    //   console.log('check');
    // } else {

    //   this.selectedPackagePlansInfoTier[pname].push(obj);

    //   console.log(this.selectedPackagePlansInfoTier)
    // }
  }
  onCheckboxChange2Tier(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    backgroundColor: any
  ) {
    this.planselectedId = subgroupid;

    let obj = {
      packageId: packageid,
      subGroupid: subgroupid,
      subGroupName: subgroupname,
      packageName: pname,
      tiers: [],
      tiersidArray: [],
      disallowedPlanLevels: disallowedPlanLevels,
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      parentid: parentid,
      backgroundColor: backgroundColor,
    };

    let selectedTiersBlock2 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock2') || '[]'
    );

    console.log(selectedTiersBlock2);

    // seelctedplanLevelTierMappingBlock2
    if (e.target.checked) {
      this.plansresblack2Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = true;
      this.selectedPlansInfoTierArrayBlock2.push(obj);

      selectedTiersBlock2.push(obj);
      sessionStorage.setItem(
        'selectedTiersBlock2',
        JSON.stringify(selectedTiersBlock2)
      );

      if (!this.selectedPackagePlansInfoTierBlock2[pname]) {
        this.selectedPackagePlansInfoTierBlock2[pname] = [];
      }
      const exists =
        this.selectedPackagePlansInfoTierBlock2[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        console.log('check1');
        this.selectedPackagePlansInfoTierBlock2[pname].push(obj);

        this.selectedPackagePlansInfoTierBlock2 = this.clean(
          this.selectedPackagePlansInfoTierBlock2
        );
        console.log(this.selectedPackagePlansInfoTierBlock2);


      }

      if (
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        console.log('test1');
        $('#executiveplansblock2Tiersingle' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock2Tiercouple' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock2Tierfamily' + obj.subGroupid).prop(
          'disabled',
          false
        );
        // $('#executiveplansblock2Tiersingle' + obj.subGroupid).click();

        console.log(this.seelctedplanLevelTierMappingBlock2);
      }
      if (
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        $('#executiveplansblock2Tiersingle' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock2Tiercouple' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock2Tierfamily' + obj.subGroupid).prop(
          'disabled',
          false
        );
        // $('#executiveplansblock2Tiersingle' + obj.subGroupid).click();
      }

      console.log(this.seelctedplanLevelTierMapping)

      console.log(this.selectedPackagesavailableTiers2Block2)
      // selectedPackagesavailableTiers2Block2[planLevel.packageId][planLevel.subGroupid]
      let mappingtiers = this.seelctedplanLevelTierMapping;

      console.log(mappingtiers);


      if (mappingtiers.length > 0) {
        for (let i = 0; i < mappingtiers.length; i++) {

          if (mappingtiers[i] && mappingtiers[i].subGroupid == obj.subGroupid) {
            if (mappingtiers[i].tiers && mappingtiers[i].tiers.length > 0) {

              for (let j = 0; j < mappingtiers[i].tiers.length; j++) {



                for (let k = 0; k < this.configureTierList.length; k++) {
                  console.log(this.configureTierList[k].id);
                  console.log(mappingtiers[i].tiers[j].id);

                  if (this.configureTierList[k].id != mappingtiers[i].tiers[j].id) {


                    console.log(this.selectedPackagesavailableTiers2Block2)
                    console.log(obj.packageId)
                    console.log(obj.subGroupid)

                    if (!this.selectedPackagesavailableTiers2Block2[obj.packageId]) {

                      this.selectedPackagesavailableTiers2Block2[obj.packageId] = {};
                      this.selectedPackagesavailableTiers2Block2[obj.packageId][
                        obj.subGroupid
                      ] = this.configureTierList[k];
                    } else {

                      if (
                        !this.selectedPackagesavailableTiers2Block2[obj.packageId][
                        obj.subGroupid
                        ]
                      ) {
                        let array = []
                        array.push(this.configureTierList[k])
                        this.selectedPackagesavailableTiers2Block2[obj.packageId][
                          obj.subGroupid
                        ] = array;
                      }
                    }

                  }

                }


              }
            }
          }
          else {


            if (!this.selectedPackagesavailableTiers2Block2[obj.packageId]) {

              this.selectedPackagesavailableTiers2Block2[obj.packageId] = {};
              this.selectedPackagesavailableTiers2Block2[obj.packageId][
                obj.subGroupid
              ] = this.configureTierList;
            } else {

              if (
                !this.selectedPackagesavailableTiers2Block2[obj.packageId][
                obj.subGroupid
                ]
              ) {
                this.selectedPackagesavailableTiers2Block2[obj.packageId][
                  obj.subGroupid
                ] = this.configureTierList;
              }
            }
          }
        }
      }

      else {

        this.selectedPackagesavailableTiers2Block2[obj.packageId][
          obj.subGroupid
        ] = this.configureTierList;
      }


    }
    else {


      if (
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;

        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock2Tiersingle' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock2Tiercouple' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock2Tierfamily' + obj.subGroupid).prop(
          'disabled',
          true
        );

      }
      if (
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        this.plansresblack2Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;
        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock2Tiersingle' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock2Tiercouple' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock2Tierfamily' + obj.subGroupid).prop(
          'disabled',
          true
        );
      }
      this.plansresblack2Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = false;
      this.plansresblack2Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].tiers = [];
      this.plansresblack2Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].coverage = ''; //default

      // Here to change





      if (this.selectedPackagesavailableTiers2Block2[packageindex]['groups']) {
        this.selectedPackagesavailableTiers2Block2[packageindex]['groups'][
          groupindex
        ]['subGroups'][subgroupindex] = this.configureTierList;

        this.selectedPackagesavailableTiers2Block2[packageid] =
          this.configureTierList;
      }




      const exists =
        this.selectedPackagePlansInfoTierBlock2[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;

      // var index = this.selectedPackagePlansInfoTierBlock2[pname].findIndex(function(item){ return item.subGroupid === subgroupid})
      var index1 = selectedTiersBlock2.findIndex(function (item) {
        return item.subGroupid === subgroupid;
      });

      let arr = this.selectedPackagePlansInfoTierBlock2[pname];
      let subGroupIdindex;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].subGroupid == subgroupid) {
          subGroupIdindex = i;
          break;
        }
      }

      if (subGroupIdindex > -1) {
        this.selectedPackagePlansInfoTierBlock2[pname].splice(
          subGroupIdindex,
          1
        );
      }
      // this.selectedPackagePlansInfoTierBlock2[pname].splice(index,1)
      selectedTiersBlock2.splice(index1, 1);

      //  console.log(this.seelctedplanLevelTierMappingBlock2)
      for (let i = 0; i < this.seelctedplanLevelTierMappingBlock2.length; i++) {
        if (
          this.seelctedplanLevelTierMappingBlock2[i].subGroupid == subgroupid
        ) {
          this.seelctedplanLevelTierMappingBlock2.splice(i, 1);
        }
      }

      // console.log(selectedTiersBlock2)
      // console.log(this.selectedPackagePlansInfoTierBlock2)
      // console.log(this.seelctedplanLevelTierMappingBlock2)
      sessionStorage.setItem(
        'selectedTiersBlock2',
        JSON.stringify(selectedTiersBlock2)
      );
      if (exists) {
        console.log(exists);
      } else {
        this.selectedPackagePlansInfoTierBlock2[pname].push(obj);
        //   this.TiersArray.push(obj)
        //  sessionStorage.setItem('selectedTiersBlock1', JSON.stringify(this.TiersArray));

        //   console.log(this.selectedPackagePlansInfoTier)
      }
    }
    sessionStorage.setItem(
      'plansBlock2Tiers',
      JSON.stringify(this.plansresblack2Tiers)
    );

    if (this.employeeplanpurchasetiers == true) {
      let el: HTMLElement = this.employeepurchaseTiersfalse.nativeElement;
      el.click();
      // setTimeout(() => {
      //   let el1: HTMLElement = this.employeepurchaseTierstrue.nativeElement;
      //   el1.click();
      // }, 10);
    }
  }
  onCheckboxChange3Tier(
    e: any,
    allow_multiple: any,
    disallowedPlanLevels: any,
    packageid: any,
    subgroupid: any,
    pname: any,
    subgroupname: any,
    subgroup: any,
    ordering: any,
    parentid: any,
    parentname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    backgroundColor: any
  ) {
    this.planselectedId = subgroupid;

    let obj = {
      packageId: packageid,
      subGroupid: subgroupid,
      subGroupName: subgroupname,
      packageName: pname,
      tiers: [],
      tiersidArray: [],
      disallowedPlanLevels: disallowedPlanLevels,
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      parentid: parentid,
      backgroundColor: backgroundColor,
    };

    let selectedTiersBlock3 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock3') || '[]'
    );

    let block3TiersRes = JSON.parse(
      sessionStorage.getItem('block3resultTiers') || '[]'
    );

    //  if(block3TiersRes.length>0){
    //   this.plansresblack3Tiers = JSON.parse(sessionStorage.getItem('block3resultTiers') || '[]');
    //  }
    //  else{
    //   this.plansresblack3Tiers = this.plansresblack3Tiers
    //  }
    if (e.target.checked) {
      console.log(this.plansresblack3Tiers);
      // this.plansresblack3Tiers = JSON.parse(sessionStorage.getItem('block3resultTiers') || '[]');
      this.plansresblack3Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = true;
      this.selectedPlansInfoTierArrayBlock3.push(obj);

      selectedTiersBlock3.push(obj);
      sessionStorage.setItem(
        'selectedTiersBlock3',
        JSON.stringify(selectedTiersBlock3)
      );

      if (!this.selectedPackagePlansInfoTierBlock3[pname]) {
        this.selectedPackagePlansInfoTierBlock3[pname] = [];
      }
      const exists =
        this.selectedPackagePlansInfoTierBlock3[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        console.log('check1');
        this.selectedPackagePlansInfoTierBlock3[pname].push(obj);
        this.selectedPackagePlansInfoTierBlock3 = this.clean(
          this.selectedPackagePlansInfoTierBlock3
        );
      }

      if (
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        // this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
        //   obj.subgroupindex
        // ]['coverage'] = 'Exec';
        this.block1coverage = false;

        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock3Tiersingle' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock3Tiercouple' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock3Tierfamily' + obj.subGroupid).prop(
          'disabled',
          false
        );
        // $('#executiveplansblock3Tiersingle' + obj.subGroupid).click();
      }
      if (
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        // this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
        //   obj.subgroupindex
        // ]['coverage'] = 'Exec';
        this.block1coverage = false;
        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock3Tiersingle' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock3Tiercouple' + obj.subGroupid).prop(
          'disabled',
          false
        );
        $('#executiveplansblock3Tierfamily' + obj.subGroupid).prop(
          'disabled',
          false
        );
        // $('#executiveplansblock3Tiersingle' + obj.subGroupid).click();
      }


      if (this.seelctedplanLevelTierMappingBlock2.length > 0) {

        let mappingtiers = this.seelctedplanLevelTierMappingBlock2;

        console.log(mappingtiers);
        if (mappingtiers.length > 0) {
          for (let i = 0; i < mappingtiers.length; i++) {

            if (mappingtiers[i] && mappingtiers[i].subGroupid == obj.subGroupid) {
              if (mappingtiers[i].tiers && mappingtiers[i].tiers.length > 0) {

                for (let j = 0; j < mappingtiers[i].tiers.length; j++) {



                  for (let k = 0; k < this.configureTierList.length; k++) {
                    console.log(this.configureTierList[k].id);
                    console.log(mappingtiers[i].tiers[j].id);

                    if (this.configureTierList[k].id != mappingtiers[i].tiers[j].id) {

                      if (!this.selectedPackagesavailableTiers3Block3[obj.packageId]) {

                        this.selectedPackagesavailableTiers3Block3[obj.packageId] = {};
                        this.selectedPackagesavailableTiers3Block3[obj.packageId][
                          obj.subGroupid
                        ] = this.configureTierList[k];
                      } else {

                        if (
                          !this.selectedPackagesavailableTiers3Block3[obj.packageId][
                          obj.subGroupid
                          ]
                        ) {
                          let array = []
                          array.push(this.configureTierList[k])
                          this.selectedPackagesavailableTiers3Block3[obj.packageId][
                            obj.subGroupid
                          ] = array;
                        }
                      }

                    }

                  }


                }
              }
            }
            else {


              if (!this.selectedPackagesavailableTiers3Block3[obj.packageId]) {

                this.selectedPackagesavailableTiers3Block3[obj.packageId] = {};
                this.selectedPackagesavailableTiers3Block3[obj.packageId][
                  obj.subGroupid
                ] = this.configureTierList;
              } else {

                if (
                  !this.selectedPackagesavailableTiers3Block3[obj.packageId][
                  obj.subGroupid
                  ]
                ) {
                  this.selectedPackagesavailableTiers3Block3[obj.packageId][
                    obj.subGroupid
                  ] = this.configureTierList;
                }
              }
            }
          }
        }

        else {

          this.selectedPackagesavailableTiers3Block3[obj.packageId][
            obj.subGroupid
          ] = this.configureTierList;
        }
      }
      else {
        let mappingtiers = this.seelctedplanLevelTierMapping;

        console.log(mappingtiers);
        if (mappingtiers.length > 0) {
          for (let i = 0; i < mappingtiers.length; i++) {

            if (mappingtiers[i] && mappingtiers[i].subGroupid == obj.subGroupid) {
              if (mappingtiers[i].tiers && mappingtiers[i].tiers.length > 0) {

                for (let j = 0; j < mappingtiers[i].tiers.length; j++) {



                  for (let k = 0; k < this.configureTierList.length; k++) {
                    console.log(this.configureTierList[k].id);
                    console.log(mappingtiers[i].tiers[j].id);

                    if (this.configureTierList[k].id != mappingtiers[i].tiers[j].id) {

                      if (!this.selectedPackagesavailableTiers3Block3[obj.packageId]) {

                        this.selectedPackagesavailableTiers3Block3[obj.packageId] = {};
                        this.selectedPackagesavailableTiers3Block3[obj.packageId][
                          obj.subGroupid
                        ] = this.configureTierList[k];
                      } else {

                        if (
                          !this.selectedPackagesavailableTiers3Block3[obj.packageId][
                          obj.subGroupid
                          ]
                        ) {
                          let array = []
                          array.push(this.configureTierList[k])
                          this.selectedPackagesavailableTiers3Block3[obj.packageId][
                            obj.subGroupid
                          ] = array;
                        }
                      }

                    }

                  }


                }
              }
            }
            else {


              if (!this.selectedPackagesavailableTiers3Block3[obj.packageId]) {

                this.selectedPackagesavailableTiers3Block3[obj.packageId] = {};
                this.selectedPackagesavailableTiers3Block3[obj.packageId][
                  obj.subGroupid
                ] = this.configureTierList;
              } else {

                if (
                  !this.selectedPackagesavailableTiers3Block3[obj.packageId][
                  obj.subGroupid
                  ]
                ) {
                  this.selectedPackagesavailableTiers3Block3[obj.packageId][
                    obj.subGroupid
                  ] = this.configureTierList;
                }
              }
            }
          }
        }

        else {

          this.selectedPackagesavailableTiers3Block3[obj.packageId][
            obj.subGroupid
          ] = this.configureTierList;
        }
      }

    } else {
      if (
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Executive Health'
      ) {
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;

        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock3Tiersingle' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock3Tiercouple' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock3Tierfamily' + obj.subGroupid).prop(
          'disabled',
          true
        );

      }
      if (
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]['name'] == 'Complete Executive Care'
      ) {
        this.plansresblack3Tiers[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
        ][obj.subgroupindex]['coverage'] = 'Exec';
        this.block1coverage = false;
        // $("#executiveplans" + obj.subGroupId).prop("checked", false);
        $('#executiveplansblock3Tiersingle' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock3Tiercouple' + obj.subGroupid).prop(
          'disabled',
          true
        );
        $('#executiveplansblock3Tierfamily' + obj.subGroupid).prop(
          'disabled',
          true
        );

      }
      this.plansresblack3Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].checked = false;
      this.plansresblack3Tiers[packageindex]['groups'][groupindex]['subGroups'][
        subgroupindex
      ].tiers = [];
      this.selectedPackagesavailableTiers3Block3[packageid] =
        this.configureTierList;
      // this.plansresblack3Tiers[packageindex]['groups'][groupindex]['subGroups'][
      //   subgroupindex
      // ].coverage = "default";

      // Here to change
      this.selectedPackagesavailableTiers3Block3[packageindex]['groups'][
        groupindex
      ]['subGroups'][subgroupindex] = this.configureTierList;

      const exists =
        this.selectedPackagePlansInfoTierBlock3[pname].findIndex(
          (item) => item.subGroupid === subgroupid
        ) > -1;

      // var index = this.selectedPackagePlansInfoTierBlock3[pname].findIndex(function(item){ return item.subGroupid === subgroupid})
      var index1 = selectedTiersBlock3.findIndex(function (item) {
        return item.subGroupid === subgroupid;
      });

      let arr = this.selectedPackagePlansInfoTierBlock3[pname];
      let subGroupIdindex;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].subGroupid == subgroupid) {
          subGroupIdindex = i;
          break;
        }
      }

      if (subGroupIdindex > -1) {
        this.selectedPackagePlansInfoTierBlock3[pname].splice(
          subGroupIdindex,
          1
        );
      }
      for (let i = 0; i < this.seelctedplanLevelTierMappingBlock3.length; i++) {
        if (
          this.seelctedplanLevelTierMappingBlock3[i].subGroupid == subgroupid
        ) {
          this.seelctedplanLevelTierMappingBlock3.splice(i, 1);
        }
      }
      // this.selectedPackagePlansInfoTierBlock3[pname].splice(index,1)
      selectedTiersBlock3.splice(index1, 1);

      sessionStorage.setItem(
        'selectedTiersBlock3',
        JSON.stringify(selectedTiersBlock3)
      );
      if (exists) {
        console.log(exists);
      } else {
        this.selectedPackagePlansInfoTierBlock3[pname].push(obj);
        //   this.TiersArray.push(obj)
        //  sessionStorage.setItem('selectedTiersBlock1', JSON.stringify(this.TiersArray));

        //   console.log(this.selectedPackagePlansInfoTier)
      }
    }
  }


  checkdisallowedPlansextension(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number,
    curr_packageid: number,

  ) {

    setTimeout(() => {
      let availabelTiers = JSON.parse(sessionStorage.getItem("avilableTiersBlock1"))
      console.log(availabelTiers)

      if (!availabelTiers[curr_packageid]) {
        availabelTiers[curr_packageid] = {};
        availabelTiers[curr_packageid][curr_planLevel_id] =
          this.configureTierList;
      } else {
        if (
          !availabelTiers[curr_packageid][curr_planLevel_id]
        ) {
          availabelTiers[curr_packageid][
            curr_planLevel_id
          ] = this.configureTierList;
        }
        else {
          availabelTiers[curr_packageid][
            curr_planLevel_id
          ] = this.configureTierList;
        }
      }

      const dom2: HTMLElement = this.elementRef.nativeElement;

      let pl = this.disallowedplansTiers;
      var all_pl: any = Object.keys(pl);

      console.log(pl);
      console.log(all_pl);


      let availableTiers2 =
        availabelTiers[curr_packageid][
        curr_planLevel_id
        ];
      for (var i = 0; i < all_pl.length; i++) {
        console.log(all_pl[i]);
        if (
          pl[all_pl[i]]?.includes(curr_planLevel_id.toString()) ||
          pl[all_pl[i]]?.includes(curr_palnlevel_parentid.toString())
        ) {
          console.log(all_pl[i]);
          // console.log(dom2.querySelector("#plancheck"+all_pl[i]))

          let mappingtiers = this.seelctedplanLevelTierMapping;

          console.log(mappingtiers);
          let subGroupIdindex;

          for (let i = 0; i < mappingtiers.length; i++) {

            if (mappingtiers[i] && mappingtiers[i].subGroupid == all_pl[i]) {
              if (mappingtiers[i].tiers && mappingtiers[i].tiers.length > 0) {

                for (let j = 0; j < mappingtiers[i].tiers.length; j++) {

                  let arr = availableTiers2

                  for (let k = 0; k < arr.length; k++) {
                    console.log(arr[k].id);
                    console.log(mappingtiers[i].tiers[j].id);

                    if (arr[k].id == mappingtiers[i].tiers[j].id) {
                      subGroupIdindex = i;
                      break;
                    }
                  }

                  console.log(subGroupIdindex)


                  availableTiers2.splice(subGroupIdindex, 1);
                  console.log(JSON.parse(JSON.stringify(availableTiers2)));
                  console.log(availableTiers2.length);

                  if (!availableTiers2) {
                    continue;
                  }
                  console.log(JSON.parse(JSON.stringify(availableTiers2)));
                  console.log(availableTiers2.length);

                  availabelTiers[curr_packageid][
                    curr_planLevel_id
                  ] = JSON.parse(JSON.stringify(availableTiers2))

                  console.log(availabelTiers)

                  this.selectedPackagesavailableTiers2 = availabelTiers;

                }
              }
            }
          }




        }
      }
      let current_element: any = dom2.querySelector(
        '#plancheck' + curr_planLevel_id
      );
      current_element.checked = true;
    }, 1000);


  }
  checkdisallowedPlans(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number,
    curr_packageid: number
  ) {


    console.log(this.configureTierList);
    console.log(this.selectedPackagesavailableTiers2);
    console.log(
      this.selectedPackagesavailableTiers2[curr_packageid][curr_planLevel_id]
    );
    let availabelTiers = this.selectedPackagesavailableTiers2

    sessionStorage.setItem("avilableTiersBlock1", JSON.stringify(this.selectedPackagesavailableTiers2))
    this.checkdisallowedPlansextension(curr_planLevel_id, curr_palnlevel_parentid, curr_packageid)

  }

  unselectPlanLevelTier(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number,
    curr_tier_id: number,
    packageindex: number,
    groupindex: number,
    subgroupindex: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]]?.includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]]?.includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck' + all_pl[i]);

        let mappingtiers = this.seelctedplanLevelTierMapping;

        console.log(mappingtiers);

        for (let i = 0; i < mappingtiers.length; i++) {
          if (mappingtiers[i] && mappingtiers[i].subGroupid == all_pl[i]) {
            if (mappingtiers[i].tiersidArray?.includes(curr_tier_id)) {
              // if (mappingtiers[i].tierid == curr_tier_id) {
              //remove this plan from seelctedplanLevelTierMapping

              console.log(mappingtiers);
              this.plansBlock1Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].checked = false;
              this.plansBlock1Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].tiers = [];
              this.seelctedplanLevelTierMapping[i] = null; ///here
            }
          }
        }
      }
    }
    sessionStorage.setItem(
      'plansBlock1Tiers',
      JSON.stringify(this.plansBlock1Tiers)
    );
    console.log(this.seelctedplanLevelTierMapping);
    let current_element: any = dom2.querySelector(
      '#plancheck' + curr_planLevel_id
    );
    current_element.checked = true;
  }

  unselectPlanLevelTierBlock2(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number,
    curr_tier_id: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]]?.includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]]?.includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck2Upgrade' + all_pl[i]);

        let mappingtiers = this.seelctedplanLevelTierMappingBlock2;

        for (let i = 0; i < mappingtiers.length; i++) {
          if (mappingtiers[i] && mappingtiers[i].subGroupid == all_pl[i]) {
            if (mappingtiers[i].tiersidArray?.includes(curr_tier_id)) {
              // if (mappingtiers[i].tierid == curr_tier_id) {
              //remove this plan from seelctedplanLevelTierMapping

              this.plansresblack2Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].checked = false;
              this.plansresblack2Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].tiers = [];
              this.seelctedplanLevelTierMappingBlock2[i] = null;
            }
          }
        }
      }
    }

    sessionStorage.setItem(
      'block2resultTiers',
      JSON.stringify(this.plansresblack2Tiers)
    );
    let current_element: any = dom2.querySelector(
      '#plancheck2Upgrade' + curr_planLevel_id
    );
    current_element.checked = true;
  }
  unselectPlanLevelTierBlock3(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number,
    curr_tier_id: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]]?.includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]]?.includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck3Voluntry' + all_pl[i]);

        let mappingtiers = this.seelctedplanLevelTierMappingBlock3;

        for (let i = 0; i < mappingtiers.length; i++) {
          if (mappingtiers[i] && mappingtiers[i].subGroupid == all_pl[i]) {
            if (mappingtiers[i].tiersidArray?.includes(curr_tier_id)) {
              // if (mappingtiers[i].tierid == curr_tier_id) {
              //remove this plan from seelctedplanLevelTierMapping

              this.plansresblack3Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].checked = false;
              this.plansresblack3Tiers[mappingtiers[i].packageindex]['groups'][
                mappingtiers[i].groupindex
              ]['subGroups'][mappingtiers[i].subgroupindex].tiers = [];
              this.seelctedplanLevelTierMappingBlock3[i] = null;
            }
          }
        }
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheck3Voluntry' + curr_planLevel_id
    );
    current_element.checked = true;
  }
  unselectPlanLevel(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]]?.includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]]?.includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck' + all_pl[i]);
        if (element.checked) {
          element.click();

          // this.unselectplan(dom2.querySelector('#plancheck' + all_pl[i]));
          // element.checked = false;
        } else {
          console.log('not checked ignore' + all_pl[i]);
        }

        // dom2.querySelector("planscheck"+all_pl[i])
        // matched_pl.push(all_pl[i])
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheck' + curr_planLevel_id
    );
    current_element.checked = true;
  }

  //Select for drayed plans in block2
  unselectPlanLevel2(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]]?.includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]]?.includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck2Upgrade' + all_pl[i]);

        console.log(element);
        if (element && element.checked) {
          element.click();

          // this.unselectplan(dom2.querySelector('#plancheck' + all_pl[i]));
          // element.checked = false;
        } else {
          console.log('not checked ignore' + all_pl[i]);
        }

        // dom2.querySelector("planscheck"+all_pl[i])
        // matched_pl.push(all_pl[i])
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheck2Upgrade' + curr_planLevel_id
    );
    current_element.checked = true;
  }
  //Select for drayed plans in block3
  unselectPlanLevel3(
    curr_planLevel_id: number,
    curr_palnlevel_parentid: number
  ) {
    console.log(curr_planLevel_id);
    console.log(curr_palnlevel_parentid);
    const dom2: HTMLElement = this.elementRef.nativeElement;

    let pl = this.disallowedplans;
    var all_pl: any = Object.keys(pl);

    console.log(pl);

    for (var i = 0; i < all_pl.length; i++) {
      console.log(all_pl[i]);
      if (
        pl[all_pl[i]]?.includes(curr_planLevel_id.toString()) ||
        pl[all_pl[i]]?.includes(curr_palnlevel_parentid.toString())
      ) {
        // console.log(dom2.querySelector("#plancheck"+all_pl[i]))
        let element: any = dom2.querySelector('#plancheck3Voluntry' + all_pl[i]);
        if (element && element.checked) {
          element.click();

          // this.unselectplan(dom2.querySelector('#plancheck' + all_pl[i]));
          // element.checked = false;
        } else {
          console.log('not checked ignore' + all_pl[i]);
        }

        // dom2.querySelector("planscheck"+all_pl[i])
        // matched_pl.push(all_pl[i])
      }
    }
    let current_element: any = dom2.querySelector(
      '#plancheck3Voluntry' + curr_planLevel_id
    );
    current_element.checked = true;
  }

  public selectplan(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    subgroup: any,
    disallowedPlanLevels: any
  ) {


    this.tierconfig = [
      { id: 1, name: 'Employeee' },
      { id: 2, name: 'Employeee' },
    ];

    // console.log(elementcv)

    // console.log(packname);

    // console.log(grpname);

    // console.log(subgrpname);
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');
    console.log(plandetailsobj)

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      coverage: '',
      settingsAdditional: subgroup?.settingsAdditional || {},
      disallowedPlanLevels: disallowedPlanLevels
    };

    console.log(obj);

    this.addtosummaryBlock1(obj);
  }

  public addtosummaryBlock1(obj: any) {
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );

    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('selectedBlock1') || '[]'
    );

    this.addtoslectplans(obj.subGroupId, summaryBlock1.length);
    summaryBlock1.push(obj);

    // console.log(summaryBlock1)
    this.planssummarymain = [];
    this.planssummaryopt = [];

    summaryBlock1.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }

      if (!this.packagePlanLevelTiers[element.packagename]) {
        this.packagePlanLevelTiers[element.packagename] = [];
      }
      const exists =
        this.packagePlanLevelTiers[element.packagename].findIndex(
          (item) => item.subGroupId === element.subGroupId
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        this.packagePlanLevelTiers[element.packagename].push(element);
      }
    });
    sessionStorage.setItem(
      'packagePlanLevelTiers',
      JSON.stringify(this.packagePlanLevelTiers)
    );

    if (selectedBlock1[obj.packageid]) {
      if (selectedBlock1[obj.packageid][obj.parentId]) {
        console.log(selectedBlock1[obj.packageid][obj.parentId]);
      } else {
        // console.log('firstelse');
        selectedBlock1[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log('secondelse');
      selectedBlock1[obj.packageid] = {};
      selectedBlock1[obj.packageid][obj.parentId] = [];
    }

    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel);

    let subGroupIdindex;
    // console.log(summaryBlock2);
    if (summaryBlock2 && summaryBlock2.length > 0) {
      console.log('1');
      for (let i = 0; i < summaryBlock2.length; i++) {
        if (summaryBlock2[i].subGroupId == obj.subGroupId) {
          console.log('3');
          subGroupIdindex = i;
          console.log(subGroupIdindex);
          break;
        }
      }
      // console.log(subGroupIdindex);
      if (subGroupIdindex > -1) {
        console.log(subGroupIdindex);
        summaryBlock2.splice(subGroupIdindex, 1);
      } else {
        console.log('check1');
      }
    }
    // console.log(summaryBlock2)
    // console.log(JSON.stringify(summaryBlock2))

    setTimeout(() => {

      sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));

    }, 10);

    let selectedplansblock2;
    let selectedplansblock3;





    sessionStorage.setItem(
      'summaryBlock1main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock1opt',
      JSON.stringify(this.planssummaryopt)
    );
    sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));


    // setTimeout(() => {

    //   sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));

    // }, 3000);

    // sessionStorage.setItem('summaryBlock2', '[]');

    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );


    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );

    this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
      obj.subgroupindex
    ]['checked'] = true;

    if (
      this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
      obj.subgroupindex
      ]['name'] == 'Executive Health' || this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
      obj.subgroupindex
      ]['name'] == 'Complete Executive Care' || this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
      obj.subgroupindex
      ]['name'] == 'Provincial Health Replacement Plan'
    ) {


      this.plansBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
        obj.subgroupindex
      ]['coverage'] = '';
      this.block1coverage = false;

      $('#executiveplanssingle' + obj.subGroupId).prop('disabled', false);
      $('#executiveplanscouple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansfamily' + obj.subGroupId).prop('disabled', false);

      let plans = this.paidByCompany.filter(
        (plan) => plan.planLevelId == obj.subGroupId
      );
      console.log(this.paidByCompany)
      if (plans.length > 0) {


        let plancheck1Coverage = this.getExecutiveCoveragesFromCode(plans[0].coverage)

        console.log({ plancheck1Coverage })

        if (
          plancheck1Coverage
        ) {
          if (plancheck1Coverage.single) {


            this.checkconditionforblock1()
            setTimeout(() => {
              $("#executiveplanssingle" + obj.subGroupId).click()
            }, 1000);

          } if (plancheck1Coverage.couple) {
            setTimeout(() => {
              $("#executiveplanscouple" + obj.subGroupId).click()
            }, 1000);
          } if (plancheck1Coverage.family) {
            setTimeout(() => {
              $("#executiveplansfamily" + obj.subGroupId).click()
            }, 1000);
          }

        }

      }
      else {


        this.checkconditionforblock1()
        setTimeout(() => {
          $("#executiveplanssingle" + obj.subGroupId).click()
        }, 1000);

      }

    }
    else {
      this.checkconditionforblock1()
    }

  }

  checkconditionforblock1() {
    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );

    this.plansNewBlock1.map((packagelevel: any, index: any) => {
      packagelevel.groups.map((groups: any, index1: any) => {
        this.selectedplansblock1.map((selectplan: any) => {
          if (
            packagelevel.id == selectplan.packageid &&
            packagelevel.groups.id == selectplan.parentid
          ) {
            var allAvailble =
              this.plansNewBlock1[index]['groups'][index1]['subGroups'];

            console.log(allAvailble)

            allAvailble.map((element1: any, index2: any) => {
              if (element1 != null) {


                if (selectplan.disallowedPlanLevels) {
                  let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

                  console.log(disallowed_plans)

                  disallowed_plans.forEach((disallowed: any, index9) => {
                    console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'])

                    this.plansNewBlock1[index]['groups'][index1]['subGroups'].forEach((plan: any, index10) => {
                      if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] != null) {
                        console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id)
                        console.log(disallowed)
                        if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id == disallowed) {

                          this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] = null
                        }
                      }
                    })



                  })
                  console.log(this.plansNewBlock1)

                }
                // res.map((res1: any, index4: any) => {
                //   res1.groups.map((groups1: any, index5: any) => {
                //     // console.log(groups1)
                //     groups1.subGroups.forEach(
                //       (subgrp: any, index6: any) => {
                //         console.log(element1.disallowedPlanLevels);
                //         if (
                //           element1.disallowedPlanLevels.indexOf(
                //             groups1.id
                //           ) > -1
                //         ) {
                //           this.plansBlock1[index4]['groups'][index5][
                //             'subGroups'
                //           ][index6]['tiers'] = [];
                //           // this.plansBlock1[index4]['groups'][index5][
                //           //   'subGroups'
                //           // ][index6]['checked'] = false;

                //           res[index4]['groups'][index5]['subGroups'][
                //             index6
                //           ] = null;
                //         }
                //       }
                //     );
                //   });
                // });
                //   }
                // }
              }
            });
          }
        });
      });
    });
    console.log(this.plansNewBlock1)
    //  this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['tiers'] = []
    // this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['checked'] = false

    // sessionStorage.setItem('planResults', JSON.stringify(this.plansNewBlock1));


    // sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

    sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock1));

    this.checkvalidationblock2()
    this.checkvalidationblock3()
  }

  public checkvalidationblock2() {



    setTimeout(() => {
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );


      console.log(selectedplansblock2)
      if (this.upgradeplansselection == true) {
        // let el: HTMLElement = this.upgradeplansfalse.nativeElement;
        // el.click();
        setTimeout(() => {
          let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
          if (el1 != null) el1.click();
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            if (selectedplansblock2.length > 0) {

              this.upgradeplansselection == true;
              setTimeout(() => {
                for (let i = 0; i < selectedplansblock2.length; i++) {
                  const element1: any = dom.querySelector(
                    '#plancheck2Upgrade' + selectedplansblock2[i].subGroupId
                  );
                  // element1.checked = true;
                  $("#plancheck2Upgrade" + selectedplansblock2[i].subGroupId).prop("checked", true);
                  let plancheck2Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)

                  setTimeout(() => {
                    if (
                      plancheck2Coverage
                    ) {
                      if (plancheck2Coverage.single) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock2single' +
                          selectedplansblock2[i].subGroupId
                        );
                        // element2.checked = true;

                        $("#executiveplansblock2single" + selectedplansblock2[i].subGroupId).prop("checked", true);

                      } if (plancheck2Coverage.couple) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock2couple' +
                          selectedplansblock2[i].subGroupId
                        );
                        // element2.checked = true;

                        $("#executiveplansblock2couple" + selectedplansblock2[i].subGroupId).prop("checked", true);

                      } if (plancheck2Coverage.family) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock2family' +
                          selectedplansblock2[i].subGroupId
                        );
                        // element2.checked = true;

                        $("#executiveplansblock2family" + selectedplansblock2[i].subGroupId).prop("checked", true);

                      }
                    }
                  }, 1000);

                  if (selectedplansblock2[i].disallowedPlanLevels != null) {
                    let disallowed_plans = selectedplansblock2[i].disallowedPlanLevels.split(',');
                    const dom1: HTMLElement = this.elementRef.nativeElement;
                    for (let i = 0; i < disallowed_plans.length; i++) {
                      // console.log(disallowed_plans[i]);
                      // console.log(disallowed_plans[i]);
                      setTimeout(() => {
                        let elem: any = dom1.querySelector(`#plancheck2Upgrade${disallowed_plans[i]}`)

                        if (elem != null) {
                          if (!elem.disabled) {

                            elem.disabled = true
                          }
                        }
                      }, 100);

                    }
                  }
                }

              }, 1000);
            }
          }, 1000);
        }, 10);

      }
    }, 1000);



  }

  public checkvalidationblock3() {
    let selectedplansblock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    setTimeout(() => {
      // if (selectedplansblock3.length > 0) {

      //   this.employeeplanpurchase = true

      if (this.employeeplanpurchase == true) {
        this.employeeplanpurchase = true
        // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        // el.click();
        setTimeout(() => {
          let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
          el1.click();
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            if (selectedplansblock3.length > 0) {
              let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
              el1.click();
              this.employeeplanpurchase == true;
              setTimeout(() => {
                for (let i = 0; i < selectedplansblock3.length; i++) {
                  const element2: any = dom.querySelector(
                    '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
                  );
                  $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

                  // element2.checked = true;
                  let plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)

                  setTimeout(() => {
                    if (
                      plancheck3Coverage
                    ) {
                      if (plancheck3Coverage.single) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock3single' +
                          selectedplansblock3[i].subGroupId
                        );
                        $("#executiveplansblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      } if (plancheck3Coverage.couple) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock3couple' +
                          selectedplansblock3[i].subGroupId
                        );
                        $("#executiveplansblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      } if (plancheck3Coverage.family) {
                        const element2: any = dom.querySelector(
                          '#executiveplansblock3family' +
                          selectedplansblock3[i].subGroupId
                        );
                        $("#executiveplansblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      }
                    }
                  }, 1000);

                  if (selectedplansblock3[i].disallowedPlanLevels != null) {
                    let disallowed_plans = selectedplansblock3[i].disallowedPlanLevels.split(',');
                    const dom1: HTMLElement = this.elementRef.nativeElement;
                    for (let i = 0; i < disallowed_plans.length; i++) {
                      // console.log(disallowed_plans[i]);
                      // console.log(disallowed_plans[i]);
                      setTimeout(() => {
                        let elem: any = dom1.querySelector(`#plancheck3Voluntry${disallowed_plans[i]}`)

                        if (elem != null) {
                          if (!elem.disabled) {

                            elem.disabled = true
                          }
                        }
                      }, 100);

                    }
                  }

                }
              }, 1500);
            }
          }, 1000);
        }, 100);
      }
      else {
      }
      // }
    }, 3000);
  }

  public addtoslectplans(planid: number, plansumamryindex: number) {
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //console.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;

    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public unselectplanBulk(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number,
    disallowedPlanLevels: any
  ) {
    console.log(elementcv);

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    console.log(plandetailsobj);

    // let obj = {
    //   packageid: plandetailsobj[2],
    //   parentId: plandetailsobj[3],
    //   subGroupId: plandetailsobj[4],
    //   orderId: plandetailsobj[8],
    // };

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageIndex,
      groupIndex: groupIndex,
      subgroupIndex: subgroupIndex,
      disallowedPlanLevels: disallowedPlanLevels
    };

    console.log(obj);
    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1]?.includes(plandetailsobj[2])) {
      }
    }

    this.removesummaryBlock1Bulk(obj);
  }

  public removesummaryBlock1Bulk(obj: any) {


    console.log(obj);
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    console.log(obj.subGroupId)


    if (summaryBlock1 && summaryBlock1.length > 0) {
      let index = this.getslectedplansBulk(obj.subGroupId);

      console.log(index)

      if (index > -1) {
        console.log(obj);

        console.log(index)
        summaryBlock1.splice(index, 1);
        console.log(this.checkboxCheck)
        // this.checkboxCheck[obj.subGroupId] = subgroup.settings?.showMemberDetailsDB ? true : false

        // this.checkboxCheck[obj.subGroupId] = false
        // console.log(this.checkboxCheck)
        // this.showHeadCount[obj.subGroupId] = ''




        console.log(this.employeeList)

        let arrayEmployee = []
        let arrayEmployee1 = []
        for (let i = 0; i < this.employeeList.length; i++) {
          if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == obj.subGroupId) {
            if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
              this.deletedId.push(this.employeeList[i].uId);
            }
            else {
              arrayEmployee.push(this.employeeList[i]);
            }
          }
          else {
            arrayEmployee1.push(this.employeeList[i]);

          }
        }

        console.log(arrayEmployee)
        console.log(arrayEmployee1)
        setTimeout(() => {
          if (this.deletedId && this.deletedId.length > 0) {
            this.deleteEmployee1(this.deletedId);
          }
          if (arrayEmployee.length > 0) {
            this.deleteEmployee(arrayEmployee);
          }
        }, 1000);


        console.log(this.employeeList)






        sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

        this.checkvalidationblock2()

        this.checkvalidationblock3()
      } else {
        return;
      }

      // if(index >-1){

      //   alert(index)
      //   selectedBlock1.splice(index,1)

      // }
      // else{
      //   return
      // }

      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock1.length; i++) {
        newselectedplans[summaryBlock1[i].subGroupId] = i;
      }

      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      this.planssummarymain = [];
      this.planssummaryopt = [];

      summaryBlock1.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });






      sessionStorage.setItem(
        'summaryBlock1main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock1opt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('summaryBlockBulk', JSON.stringify(summaryBlock1));

    }

    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );

    var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');


    // console.log(this.selectedplansblock1)

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]')

    this.plansNewBlock1.map((packagelevel: any, index: any) => {
      packagelevel.groups.map((groups: any, index1: any) => {
        this.selectedplansblock1.map((selectplan: any) => {
          if (
            packagelevel.id == selectplan.packageid &&
            packagelevel.groups.id == selectplan.parentid
          ) {
            var allAvailble =
              this.plansNewBlock1[index]['groups'][index1]['subGroups'];

            allAvailble.map((element1: any, index2: any) => {
              if (element1 != null) {

                console.log(element1.disallowedPlanLevels)
                if (element1.disallowedPlanLevels) {
                  console.log(element1.id)
                  console.log(obj.subGroupId)
                  if (element1.id == obj.subGroupId) {

                    console.log(element1.id)
                    console.log(obj.subGroupId)
                    res.map((res1: any, index4: any) => {
                      res1.groups.map((groups1: any, index5: any) => {
                        // console.log(groups1)
                        groups1.subGroups.forEach(
                          (subgrp: any, index6: any) => {
                            console.log(subgrp);
                            if (
                              element1.disallowedPlanLevels.indexOf(
                                groups1.id
                              ) > -1
                            ) {
                              this.plansBlock1[index4]['groups'][index5][
                                'subGroups'
                              ][index6]['tiers'] = [];
                              // this.plansBlock1[index4]['groups'][index5][
                              //   'subGroups'
                              // ][index6]['checked'] = false;

                              res[index4]['groups'][index5]['subGroups'][
                                index6
                              ] = subgrp;
                            }
                          }
                        );
                      });
                    });
                    sessionStorage.setItem('mainresults', JSON.stringify(res));

                  }
                }
              }
            });
          }
        });
      });
    });

    // for (let i = 0; i < this.selectedplansblock1.length; i++) {


    console.log(obj)
    // if (obj.disallowedPlanLevels != null) {
    //   setTimeout(() => {
    //     let elem: any = dom1.querySelector(`#plancheck${obj.subGroupId}`)

    //     if(elem!=null){
    //     if (elem.disabled) {

    //       elem.disabled = false
    //     }
    //   }
    //   }, 100);
    //   let disallowed_plans = obj.disallowedPlanLevels.split(',');
    //   const dom1: HTMLElement = this.elementRef.nativeElement;
    //   for (let i = 0; i < disallowed_plans.length; i++) {
    //     setTimeout(() => {
    //       let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

    //       if(elem!=null){
    //       if (elem.disabled) {

    //         elem.disabled = false
    //       }
    //     }
    //     }, 100);

    //   }
    // }
    // else{
    //   setTimeout(() => {
    //     const dom1: HTMLElement = this.elementRef.nativeElement;

    //     let elem: any = dom1.querySelector(`#plancheck${obj.subGroupId}`)

    //     if(elem!=null){
    //     if (elem.disabled) {

    //       elem.disabled = false
    //     }
    //   }
    //   }, 100);
    // }

    // }

  }

  public getslectedplansBulk(planid: number) {
    //console.log(planid)
    // let selectedPlans = JSON.parse(
    //   sessionStorage.getItem('selectedPlans') || '{}'
    // );
    // // console.log(selectedPlans)
    // return selectedPlans[planid];


    console.log(planid)
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock1.length; i++) {
      console.log(summaryBlock1[i].subGroupId)
      console.log(planid)
      if (summaryBlock1[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }

    return subGroupIdindex;
  }

  public selectplanBulk(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    disallowedPlanLevels: any
  ) {


    this.tierconfig = [
      { id: 1, name: 'Employeee' },
      { id: 2, name: 'Employeee' },
    ];

    // console.log(elementcv)

    console.log(packname);

    console.log(grpname);

    console.log(subgrpname);
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      coverage: '',
      disallowedPlanLevels: disallowedPlanLevels
    };

    console.log(obj);

    this.addtosummaryBlock1Bulk(obj);
  }

  public addtosummaryBlock1Bulk(obj: any) {
    let summaryBlockBulk = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );

    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );


    this.addtoslectplans(obj.subGroupId, summaryBlockBulk.length);
    summaryBlockBulk.push(obj);


    this.planssummarymain = [];
    this.planssummaryopt = [];

    summaryBlockBulk.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }

      if (!this.packagePlanLevelTiers[element.packagename]) {
        this.packagePlanLevelTiers[element.packagename] = [];
      }
      const exists =
        this.packagePlanLevelTiers[element.packagename].findIndex(
          (item) => item.subGroupId === element.subGroupId
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        this.packagePlanLevelTiers[element.packagename].push(element);
      }
    });
    sessionStorage.setItem(
      'packagePlanLevelTiers',
      JSON.stringify(this.packagePlanLevelTiers)
    );

    if (selectedBlock1[obj.packageid]) {
      if (selectedBlock1[obj.packageid][obj.parentId]) {
        console.log(selectedBlock1[obj.packageid][obj.parentId]);
      } else {
        // console.log('firstelse');
        selectedBlock1[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log('secondelse');
      selectedBlock1[obj.packageid] = {};
      selectedBlock1[obj.packageid][obj.parentId] = [];
    }

    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel);

    let subGroupIdindex;
    console.log(summaryBlock1);
    // if (summaryBlock1 && summaryBlock1.length > 0) {
    //   console.log('1');
    //   for (let i = 0; i < summaryBlock1.length; i++) {
    //     if (summaryBlock1[i].subGroupId == obj.subGroupId) {
    //       console.log('3');
    //       subGroupIdindex = i;
    //       console.log(subGroupIdindex);
    //       if (summaryBlock1[i].disallowedPlanLevels != null) {
    //         let disallowed_plans = summaryBlock1[i].disallowedPlanLevels.split(',');
    //         const dom1: HTMLElement = this.elementRef.nativeElement;
    //         console.log(disallowed_plans)
    //         // for (let i = 0; i < disallowed_plans.length; i++) {

    //         //   setTimeout(() => {
    //         //     let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

    //         //     if(elem!=null){
    //         //     if (elem.disabled) {

    //         //       elem.disabled = false
    //         //     }
    //         //   }
    //         //   }, 100);

    //         // }
    //       }
    //       break;
    //     }
    //   }
    //   console.log(subGroupIdindex);
    //   if (subGroupIdindex > -1) {
    //     console.log(subGroupIdindex);
    //     $("#plancheck" + obj.subGroupId).prop("checked", false);

    //     summaryBlock1.splice(subGroupIdindex, 1);

    //   } else {
    //     console.log('check1');
    //   }
    // }
    console.log(summaryBlock1)
    console.log(JSON.stringify(summaryBlock1))

    setTimeout(() => {

      sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));

    }, 10);







    sessionStorage.setItem(
      'summaryBlock1main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock1opt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('summaryBlockBulk', JSON.stringify(summaryBlockBulk));
    // sessionStorage.setItem('summaryBlock2', '[]');

    // this.plansNewBlock1 = JSON.parse(
    //   sessionStorage.getItem('planResults') || '[]'
    // );

    // var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );


    // this.plansNewBlock1.map((packagelevel: any, index: any) => {
    //   packagelevel.groups.map((groups: any, index1: any) => {
    //     this.selectedplansblock1.map((selectplan: any) => {
    //       if (
    //         packagelevel.id == selectplan.packageid &&
    //         packagelevel.groups.id == selectplan.parentid
    //       ) {
    //         var allAvailble =
    //           this.plansNewBlock1[index]['groups'][index1]['subGroups'];

    //         allAvailble.map((element1: any, index2: any) => {
    //           if (element1 != null) {
    //             if (element1.disallowedPlanLevels) {
    //               if (element1.id == selectplan.subGroupId) {
    //                 res.map((res1: any, index4: any) => {
    //                   res1.groups.map((groups1: any, index5: any) => {
    //                     // console.log(groups1)
    //                     groups1.subGroups.forEach(
    //                       (subgrp: any, index6: any) => {
    //                         console.log(element1.disallowedPlanLevels);
    //                         if (
    //                           element1.disallowedPlanLevels.indexOf(
    //                             groups1.id
    //                           ) > -1
    //                         ) {
    //                           this.plansBlock1[index4]['groups'][index5][
    //                             'subGroups'
    //                           ][index6]['tiers'] = [];
    //                           // this.plansBlock1[index4]['groups'][index5][
    //                           //   'subGroups'
    //                           // ][index6]['checked'] = false;

    //                           res[index4]['groups'][index5]['subGroups'][
    //                             index6
    //                           ] = null;
    //                         }
    //                       }
    //                     );
    //                   });
    //                 });
    //               }
    //             }
    //           }
    //         });
    //       }
    //     });
    //   });
    // });

    //  this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['tiers'] = []
    // this.plansNewBlock1[obj.packageindex]['groups'][obj.groupindex]['subGroups'][obj.subgroupindex]['checked'] = false

    // sessionStorage.setItem('planResults', JSON.stringify(this.plansNewBlock1));

    //     this.plansBlock1 = JSON.parse(
    //       sessionStorage.getItem('mainresults') || '[]')
    //       this.plansBlock1.forEach((packagelevel: any, index: any) => {
    //         if (!packagelevel) {
    //         } else {
    //        packagelevel.groups.forEach((groups: any, index1: any) => {
    //         groups?.subGroups.forEach((subGroups: any, index2: any) => {
    //         if(subGroups){
    //           this.selectedplansblock1.forEach((selectplan: any) => {
    //           if (
    //             subGroups.id ==selectplan.subGroupId
    //           ) {
    //             this.plansBlock1[index]['groups'][index1]['subGroups'].splice(index2,1)

    //             if (selectplan.disallowedPlanLevels != null) {
    //               let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

    //               console.log(disallowed_plans)

    //               disallowed_plans.forEach((disallowed: any,index9) => {


    //                 this.plansBlock1[index]['groups'][index1]['subGroups'].forEach((plan: any,index10) => {

    // if(this.plansBlock1[index]['groups'][index1]['subGroups'][index10] !=null){
    //                   if(this.plansBlock1[index]['groups'][index1]['subGroups'][index10].id==disallowed){
    //                     this.plansBlock1[index]['groups'][index1]['subGroups'].splice(index10,1)
    //                   }
    //                 }
    //                 })



    //               })


    //             }


    //           }
    //         })

    //       }

    //       });

    //     });
    //   }

    //     })
    sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

    // sessionStorage.setItem('mainresults', JSON.stringify(res));

    this.checkvalidationblock2()
    this.checkvalidationblock3()

    // for (let i = 0; i < this.selectedplansblock1.length; i++) {

    //   if (this.selectedplansblock1[i].disallowedPlanLevels != null) {
    //     // setTimeout(() => {
    //     //   let elem: any = dom1.querySelector(`#plancheck${this.selectedplansblock1[i].subGroupId}`)

    //     //   if(elem!=null){
    //     //   if (!elem.disabled) {

    //     //     elem.disabled = true
    //     //   }
    //     // }
    //     // }, 100);
    //     // let disallowed_plans = this.selectedplansblock1[i].disallowedPlanLevels.split(',');
    //     // const dom1: HTMLElement = this.elementRef.nativeElement;
    //     // for (let i = 0; i < disallowed_plans.length; i++) {
    //     //   setTimeout(() => {
    //     //     let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

    //     //     if(elem!=null){
    //     //     if (!elem.disabled) {

    //     //       elem.disabled = true
    //     //     }
    //     //   }
    //     //   }, 100);

    //     // }
    //   }
    //   else{
    //     setTimeout(() => {
    //       const dom1: HTMLElement = this.elementRef.nativeElement;

    //       let elem: any = dom1.querySelector(`#plancheck${this.selectedplansblock1[i].subGroupId}`)

    //       if(elem!=null){
    //       if (!elem.disabled) {

    //         elem.disabled = true
    //       }
    //     }
    //     }, 100);
    //   }

    // }

  }

  public unselectplan(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number
  ) {
    console.log(elementcv);

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    console.log(plandetailsobj);

    // let obj = {
    //   packageid: plandetailsobj[2],
    //   parentId: plandetailsobj[3],
    //   subGroupId: plandetailsobj[4],
    //   orderId: plandetailsobj[8],
    // };

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageIndex,
      groupIndex: groupIndex,
      subgroupIndex: subgroupIndex,
    };

    console.log(obj);
    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1]?.includes(plandetailsobj[2])) {
      }
    }

    this.removesummaryBlock1(obj);
  }

  // public removesummaryBlock1(obj: any) {


  //   console.log(obj);
  //   let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

  //   let summaryBlock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );
  //   let selectedBlock1 = JSON.parse(
  //     sessionStorage.getItem('selectedBlock1') || '[]'
  //   );
  //   console.log(obj.subGroupId)
  //   if (summaryBlock1 && summaryBlock1.length > 0) {
  //     let index = this.getslectedplansblock1(obj.subGroupId);
  //     let index1 = this.getslectedblockplans(obj);

  //     console.log(index)

  //     if (index > -1) {

  //       summaryBlock1.splice(index, 1);

  //       if (obj.packageIndex >= 0 && obj.groupIndex >= 0 && obj.subgroupIndex >= 0) {
  //         //  if(!this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex] || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups']){

  //         //  }
  //         //  else{
  //         this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //           'subGroups'
  //         ][obj.subgroupIndex]['tiers'] = [];
  //         this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //           'subGroups'
  //         ][obj.subgroupIndex]['checked'] = false;

  //         if (
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //           'subGroups'
  //           ][obj.subgroupIndex]['name'] == 'Executive Health'
  //         ) {
  //           console.log('Executive Health');
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //             'subGroups'
  //           ][obj.subgroupIndex]['coverage'] = '';  //default
  //           sessionStorage.setItem('mainresults', JSON.stringify(this.plansBlock1));
  //           this.block1coverage = true;


  //           // element.checked =false
  //           $('#executiveplanssingle' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanssingle' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('disabled', true);
  //         }

  //         if (
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //           'subGroups'
  //           ][obj.subgroupIndex]['name'] == 'Complete Executive Care'
  //         ) {
  //           console.log('Complete Executive Care');
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //             'subGroups'
  //           ][obj.subgroupIndex]['coverage'] = ''; //default
  //           sessionStorage.setItem('mainresults', JSON.stringify(this.plansBlock1));

  //           this.block1coverage = true;

  //           // element.checked =false
  //           $('#executiveplanssingle' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanssingle' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('disabled', true);
  //         }

  //         if (
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //           'subGroups'
  //           ][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan'
  //         ) {
  //           console.log('Complete Executive Care');
  //           this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
  //             'subGroups'
  //           ][obj.subgroupIndex]['coverage'] = ''; //default
  //           sessionStorage.setItem('mainresults', JSON.stringify(this.plansBlock1));

  //           this.block1coverage = true;

  //           // element.checked =false
  //           $('#executiveplanssingle' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('checked', false);
  //           $('#executiveplanssingle' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplanscouple' + obj.subGroupId).prop('disabled', true);
  //           $('#executiveplansfamily' + obj.subGroupId).prop('disabled', true);
  //         }
  //       }

  //       // sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));


  //     } else {
  //       return;
  //     }

  //     // if(index >-1){

  //     //   alert(index)
  //     //   selectedBlock1.splice(index,1)

  //     // }
  //     // else{
  //     //   return
  //     // }

  //     var newselectedplans: any = {};
  //     for (var i = 0; i < summaryBlock1.length; i++) {
  //       newselectedplans[summaryBlock1[i].subGroupId] = i;
  //     }

  //     sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

  //     this.planssummarymain = [];
  //     this.planssummaryopt = [];

  //     summaryBlock1.forEach((element: any) => {
  //       if (element.packagename != 'Opt-in') {
  //         this.planssummarymain.push(element);
  //       } else {
  //         this.planssummaryopt.push(element);
  //       }
  //     });

  //     let selectedplansblock2 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock2') || '[]'
  //     );
  //     let selectedplansblock3 = JSON.parse(
  //       sessionStorage.getItem('summaryBlock3') || '[]'
  //     );



  //     // if (this.upgradeplansselection == true) {
  //     //   let el: HTMLElement = this.upgradeplansfalse.nativeElement;
  //     //   el.click();
  //     //   setTimeout(() => {
  //     //     let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
  //     //     el1.click();
  //     //     setTimeout(() => {
  //     //       const dom: HTMLElement = this.elementRef.nativeElement;
  //     //       if (selectedplansblock2.length > 0) {
  //     //         let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
  //     //         el1.click();
  //     //         this.upgradeplansselection == true;
  //     //         setTimeout(() => {
  //     //           for (let i = 0; i < selectedplansblock2.length; i++) {
  //     //             const element1: any = dom.querySelector(
  //     //               '#plancheck2Upgrade' + selectedplansblock2[i].subGroupId
  //     //             );
  //     //             $("#plancheck2Upgrade" + selectedplansblock2[i].subGroupId).prop("checked", true);

  //     //             let plancheck2Coverage =  this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)


  //     //             // console.log("rakess"+JSON.parse(plancheck2Coverage))
  //     //             console.log("rakess"+JSON.stringify(plancheck2Coverage))


  //     //             setTimeout(() => {
  //     //               if (
  //     //                 plancheck2Coverage
  //     //               ) {
  //     //                 if (plancheck2Coverage.single) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock2single' +
  //     //                       selectedplansblock2[i].subGroupId
  //     //                   );
  //     //                   // element2.checked = true;

  //     //                   $("#executiveplansblock2single" + selectedplansblock2[i].subGroupId).prop("checked", true);

  //     //                 } if (plancheck2Coverage.couple) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock2couple' +
  //     //                       selectedplansblock2[i].subGroupId
  //     //                   );
  //     //                   // element2.checked = true;

  //     //                   $("#executiveplansblock2couple" + selectedplansblock2[i].subGroupId).prop("checked", true);

  //     //                 } if (plancheck2Coverage.family) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock2family' +
  //     //                       selectedplansblock2[i].subGroupId
  //     //                   );
  //     //                   // element2.checked = true;

  //     //                   $("#executiveplansblock2family" + selectedplansblock2[i].subGroupId).prop("checked", true);

  //     //                 }
  //     //               }
  //     //             }, 1000);
  //     //           }
  //     //         }, 1000);
  //     //       }
  //     //     }, 1000);
  //     //   }, 400);
  //     // }


  //     // alert(this.employeeplanpurchase)
  //     // if (this.employeeplanpurchase == true) {
  //     //   let el: HTMLElement = this.employeepurchasefalse.nativeElement;
  //     //   el.click();
  //     //   setTimeout(() => {
  //     //     let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
  //     //     el1.click();
  //     //     setTimeout(() => {
  //     //       const dom: HTMLElement = this.elementRef.nativeElement;
  //     //       if (selectedplansblock3.length > 0) {
  //     //         let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
  //     //         el1.click();
  //     //         this.employeeplanpurchase == true;
  //     //         setTimeout(() => {
  //     //           for (let i = 0; i < selectedplansblock3.length; i++) {
  //     //             const element2: any = dom.querySelector(
  //     //               '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
  //     //             );
  //     //             $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

  //     //             // element2.checked = true;
  //     //             let plancheck3Coverage =  this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)

  //     //             setTimeout(() => {
  //     //               if (
  //     //                 plancheck3Coverage
  //     //               ) {
  //     //                 if (plancheck3Coverage.single) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock3single' +
  //     //                       selectedplansblock3[i].subGroupId
  //     //                   );
  //     //                   $("#executiveplansblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);

  //     //                   // element2.checked = true;
  //     //                 } if (plancheck3Coverage.couple) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock3couple' +
  //     //                       selectedplansblock3[i].subGroupId
  //     //                   );
  //     //                   $("#executiveplansblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);

  //     //                   // element2.checked = true;
  //     //                 } if (plancheck3Coverage.family) {
  //     //                   const element2: any = dom.querySelector(
  //     //                     '#executiveplansblock3family' +
  //     //                       selectedplansblock3[i].subGroupId
  //     //                   );
  //     //                   $("#executiveplansblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);

  //     //                   // element2.checked = true;
  //     //                 }
  //     //               }
  //     //             }, 1000);
  //     //           }
  //     //         }, 1500);
  //     //       }
  //     //     }, 1000);
  //     //   }, 3000);
  //     // }

  //     // let el: HTMLElement = this.upgradeplansfalse.nativeElement;
  //     // el.click();
  //     // let el1: HTMLElement = this.employeepurchasefalse.nativeElement;
  //     // el1.click();

  //     sessionStorage.setItem(
  //       'summaryBlock1main',
  //       JSON.stringify(this.planssummarymain)
  //     );
  //     sessionStorage.setItem(
  //       'summaryBlock1opt',
  //       JSON.stringify(this.planssummaryopt)
  //     );

  //     sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));
  //   }

  //   this.plansNewBlock1 = JSON.parse(
  //     sessionStorage.getItem('planResults') || '[]'
  //   );

  //   var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');


  //   this.selectedplansblock1 = JSON.parse(
  //     sessionStorage.getItem('summaryBlock1') || '[]'
  //   );

  //   // this.plansNewBlock1.map((packagelevel: any, index: any) => {
  //   //   packagelevel.groups.map((groups: any, index1: any) => {
  //   //     this.selectedplansblock1.map((selectplan: any) => {
  //   //       if (
  //   //         packagelevel.id == selectplan.packageid &&
  //   //         packagelevel.groups.id == selectplan.parentid
  //   //       ) {
  //   //         var allAvailble =
  //   //           this.plansNewBlock1[index]['groups'][index1]['subGroups'];

  //   //         allAvailble.map((element1: any, index2: any) => {
  //   //           if (element1 != null) {

  //   //             console.log(element1.disallowedPlanLevels)
  //   //             if (element1.disallowedPlanLevels) {
  //   //               console.log(element1.id)
  //   //               console.log(obj.subGroupId)
  //   //               if (element1.id == obj.subGroupId) {

  //   //                 console.log(element1.id)
  //   //                 console.log(obj.subGroupId)
  //   //                 res.map((res1: any, index4: any) => {
  //   //                   res1.groups.map((groups1: any, index5: any) => {
  //   //                     // console.log(groups1)
  //   //                     groups1.subGroups.forEach(
  //   //                       (subgrp: any, index6: any) => {
  //   //                         console.log(subgrp);
  //   //                         if (
  //   //                           element1.disallowedPlanLevels.indexOf(
  //   //                             groups1.id
  //   //                           ) > -1
  //   //                         ) {
  //   //                           this.plansBlock1[index4]['groups'][index5][
  //   //                             'subGroups'
  //   //                           ][index6]['tiers'] = [];
  //   //                           // this.plansBlock1[index4]['groups'][index5][
  //   //                           //   'subGroups'
  //   //                           // ][index6]['checked'] = false;

  //   //                           res[index4]['groups'][index5]['subGroups'][
  //   //                             index6
  //   //                           ] = subgrp;
  //   //                         }
  //   //                       }
  //   //                     );
  //   //                   });
  //   //                 });
  //   //                 sessionStorage.setItem('mainresults', JSON.stringify(res));

  //   //               }
  //   //             }
  //   //           }
  //   //         });
  //   //       }
  //   //     });
  //   //   });
  //   // });
  //   this.plansNewBlock1.map((packagelevel: any, index: any) => {
  //     packagelevel.groups.map((groups: any, index1: any) => {
  //       this.selectedplansblock1.map((selectplan: any) => {
  //         if (
  //           packagelevel.id == selectplan.packageid &&
  //           packagelevel.groups.id == selectplan.parentid
  //         ) {
  //           var allAvailble =
  //             this.plansNewBlock1[index]['groups'][index1]['subGroups'];

  //             console.log(allAvailble)

  //           allAvailble.map((element1: any, index2: any) => {
  //             if (element1 != null) {


  //                   if(selectplan.disallowedPlanLevels){
  //                     let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

  //                     console.log(disallowed_plans)

  //                     disallowed_plans.forEach((disallowed: any,index9) => {
  //                     console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'])

  //                       this.plansNewBlock1[index]['groups'][index1]['subGroups'].forEach((plan: any,index10) => {
  //                         if(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10]!=null){
  //                             console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id)
  //                           console.log(disallowed)
  //                         if(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id==disallowed){
  //                           this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10]=null
  //                         }
  //                       }
  //                       })



  //                     })
  //                     console.log(this.plansNewBlock1)

  //                   }

  //             }
  //           });
  //         }
  //       });
  //     });
  //   });
  //          sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock1));
  //          this.checkvalidationblock2()

  //          this.checkvalidationblock3()

  //   //        this.selectedplansblock1 = JSON.parse(sessionStorage.getItem("summaryBlock1") || "{}")

  //   // this.plansNewBlock2.forEach((packagelevel:any,index:any) => {

  //   // packagelevel.groups.forEach((groups:any,index1:any) => {
  //   // this.selectedplansblock1.forEach((selectplan:any) => {
  //   // if(packagelevel.id==selectplan.packageid && packagelevel.groups.id==selectplan.parentid){

  //   //  var allAvailble = this.plansNewBlock2[index]["groups"][index1]["subGroups"]

  //   // console.log(allAvailble)

  //   //  allAvailble.forEach((element1:any,index2:any) => {

  //   //    if(element1 !=null){

  //   //        if(element1.disallowedPlanLevels){

  //   //          console.log(element1)
  //   //            if(element1.id==selectplan.subGroupId){
  //   //          res.forEach((res1:any,index4:any) => {

  //   //            res1.groups.forEach((groups1:any,index5:any) => {
  //   //              console.log(groups1)
  //   //              groups1.subGroups.forEach((subgrp:any,index6:any) => {

  //   //                if(groups1.id==15){
  //   //               res[index4]["groups"][index5]["subGroups"][index6]=null
  //   //                }
  //   //               })

  //   //            })

  //   //          });

  //   //        }

  //   //        }

  //   //  }

  //   //  })

  //   // }

  //   // })
  //   // });

  //   // });
  //   // console.log(res)
  // }
  public removesummaryBlock1(obj: any) {


    console.log(obj);
    let Mainplanres = JSON.parse(sessionStorage.getItem('planResults'));

    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let selectedBlock1 = JSON.parse(
      sessionStorage.getItem('selectedBlock1') || '[]'
    );
    console.log(obj.subGroupId)
    if (summaryBlock1 && summaryBlock1.length > 0) {
      let index = this.getslectedplansblock1(obj.subGroupId);
      let index1 = this.getslectedblockplans(obj);

      console.log(index)

      if (index > -1) {

        summaryBlock1.splice(index, 1);

        if (obj.packageIndex >= 0 && obj.groupIndex >= 0 && obj.subgroupIndex >= 0) {
          //  if(!this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex] || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex]['subGroups']){

          //  }
          //  else{
          this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['tiers'] = [];
          this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['checked'] = false;

          if (
            this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Executive Health' || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Complete Executive Care' || this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan'
          ) {
            console.log('Executive Health');
            this.plansBlock1[obj.packageIndex]['groups'][obj.groupIndex][
              'subGroups'
            ][obj.subgroupIndex]['coverage'] = '';  //default
            sessionStorage.setItem('mainresults', JSON.stringify(this.plansBlock1));
            this.block1coverage = true;


            // element.checked =false
            $('#executiveplanssingle' + obj.subGroupId).prop('checked', false);
            $('#executiveplanscouple' + obj.subGroupId).prop('checked', false);
            $('#executiveplansfamily' + obj.subGroupId).prop('checked', false);
            $('#executiveplanssingle' + obj.subGroupId).prop('disabled', true);
            $('#executiveplanscouple' + obj.subGroupId).prop('disabled', true);
            $('#executiveplansfamily' + obj.subGroupId).prop('disabled', true);
          }


        }



      } else {
        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock1.length; i++) {
        newselectedplans[summaryBlock1[i].subGroupId] = i;
      }

      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      this.planssummarymain = [];
      this.planssummaryopt = [];

      summaryBlock1.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );

      sessionStorage.setItem(
        'summaryBlock1main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock1opt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('summaryBlock1', JSON.stringify(summaryBlock1));
    }

    this.plansNewBlock1 = JSON.parse(
      sessionStorage.getItem('planResults') || '[]'
    );

    var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');


    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );


    this.plansNewBlock1.map((packagelevel: any, index: any) => {
      packagelevel.groups.map((groups: any, index1: any) => {
        this.selectedplansblock1.map((selectplan: any) => {
          if (
            packagelevel.id == selectplan.packageid &&
            packagelevel.groups.id == selectplan.parentid
          ) {
            var allAvailble =
              this.plansNewBlock1[index]['groups'][index1]['subGroups'];

            console.log(allAvailble)

            allAvailble.map((element1: any, index2: any) => {
              if (element1 != null) {

                console.log(selectplan)
                if (selectplan.disallowedPlanLevels) {
                  let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

                  console.log(disallowed_plans)



                  disallowed_plans.forEach((disallowed: any, index9) => {
                    const dom1: HTMLElement = this.elementRef.nativeElement;

                    setTimeout(() => {
                      let elem: any = dom1.querySelector(`#plancheck${disallowed}`)

                      if (elem != null) {
                        if (!elem.disabled) {

                          elem.disabled = true
                        }
                      }
                    }, 100);

                    this.plansNewBlock1[index]['groups'][index1]['subGroups'].forEach((plan: any, index10) => {
                      if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] != null) {
                        console.log(this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id)
                        console.log(disallowed)
                        if (this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10].id == disallowed) {
                          this.plansNewBlock1[index]['groups'][index1]['subGroups'][index10] = null
                        }
                      }
                    })



                  })
                  console.log(this.plansNewBlock1)

                }

              }
            });
          }
        });
      });
    });

    sessionStorage.setItem('mainresults', JSON.stringify(this.plansNewBlock1));
    this.checkvalidationblock2()

    this.checkvalidationblock3()

  }
  public removeslectplans(planid: number, plansumamryindex: number) {
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //console.log(selectedPlans)
    delete selectedPlans[planid];

    for (const planid in selectedPlans) {
      if (selectedPlans[planid] != 0) {
        selectedPlans[planid] = selectedPlans[planid] - 1;
        if (selectedPlans[planid]) {
        }
      }
    }
    //console.log("adjustedselectedPlans")
    //console.log(selectedPlans)
    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public selectplanblock3(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    subgroup: any,
    disallowedPlanLevels: any
  ) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      settingsAdditional: subgroup?.settingsAdditional || {},
      disallowedPlanLevels: disallowedPlanLevels

    };
    console.log(obj);

    this.addtosummaryBlock3(obj);
  }

  public addtosummaryBlock3(obj: any) {
    console.log(obj);
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );

    let selectedBlock3 = JSON.parse(
      sessionStorage.getItem('selectedBlock3') || '{}'
    );

    this.addtoslectplansblock3(obj.subGroupId, summaryBlock3.length);
    summaryBlock3.push(obj);

    this.planssummarymain = [];
    this.planssummaryopt = [];

    summaryBlock3.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }
    });

    if (selectedBlock3[obj.packageid]) {
      if (selectedBlock3[obj.packageid][obj.parentId]) {
        // console.log(selectedBlock3[obj.packageid][obj.parentId])
      } else {
        // console.log("firstelse")
        selectedBlock3[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log("secondelse")
      selectedBlock3[obj.packageid] = {};
      selectedBlock3[obj.packageid][obj.parentId] = [];
    }

    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock3[obj.packageid][obj.parentId].push(selectedPlanLevel);

    // sessionStorage.setItem('selectedBlock3', JSON.stringify(selectedBlock3));
    sessionStorage.setItem(
      'summaryBlock3main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock3opt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));

    console.log(obj.packageindex);
    console.log(obj.groupindex);
    console.log(obj.subgroupindex);

    if (
      !this.plansresblack3[obj.packageindex] ||
      this.plansresblack3[obj.packageindex]['groups'] ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex] ||
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ]
    ) {
      console.log(
        this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
        ][obj.subgroupindex]
      );

      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
      ][obj.subgroupindex]['checked'] = true;
    }

    if (
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Executive Health'
    ) {
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
      ][obj.subgroupindex]['coverage'] == 'Exe'
      $('#executiveplansblock3single' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3couple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3family' + obj.subGroupId).prop('disabled', false);
      let plans = this.paidByEmployee.filter(
        (plan) => plan.planLevelId == obj.subGroupId
      );

      if (plans.length > 0) {


        let plancheck1Coverage = this.getExecutiveCoveragesFromCode(plans[0].coverage)

        console.log({ plancheck1Coverage })

        if (
          plancheck1Coverage
        ) {

          if (plancheck1Coverage.single) {

            setTimeout(() => {
              $('#executiveplansblock3single' + obj.subGroupId).click()

            }, 100);

          } if (plancheck1Coverage.couple) {
            setTimeout(() => {
              $('#executiveplansblock3couple' + obj.subGroupId).click()
            }, 100);
          } if (plancheck1Coverage.family) {
            setTimeout(() => {
              $('#executiveplansblock3family' + obj.subGroupId).click()
            }, 100);
          }
        }

      }
      else {
        $('#executiveplansblock3single' + obj.subGroupId).click();
        $('#executiveplansblock3couple' + obj.subGroupId).click();
        $('#executiveplansblock3family' + obj.subGroupId).click();
      }
    }
    if (
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Complete Executive Care'
    ) {
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
      ][obj.subgroupindex]['coverage'] == 'Complete'
      $('#executiveplansblock3single' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3couple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3family' + obj.subGroupId).prop('disabled', false);
      let plans = this.paidByEmployee.filter(
        (plan) => plan.planLevelId == obj.subGroupId
      );

      if (plans.length > 0) {


        let plancheck1Coverage = this.getExecutiveCoveragesFromCode(plans[0].coverage)

        console.log({ plancheck1Coverage })

        if (
          plancheck1Coverage
        ) {

          if (plancheck1Coverage.single) {

            setTimeout(() => {
              $('#executiveplansblock3single' + obj.subGroupId).click()

            }, 100);

          } if (plancheck1Coverage.couple) {
            setTimeout(() => {
              $('#executiveplansblock3couple' + obj.subGroupId).click()
            }, 100);
          } if (plancheck1Coverage.family) {
            setTimeout(() => {
              $('#executiveplansblock3family' + obj.subGroupId).click()
            }, 100);
          }
        }

      }
      else {
        $('#executiveplansblock3single' + obj.subGroupId).click();
        $('#executiveplansblock3couple' + obj.subGroupId).click();
        $('#executiveplansblock3family' + obj.subGroupId).click();
      }
    }

    if (
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Provincial Health Replacement Plan'
    ) {
      this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
        'subGroups'
      ][obj.subgroupindex]['coverage'] == 'PHR'
      $('#executiveplansblock3single' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3couple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock3family' + obj.subGroupId).prop('disabled', false);
      let plans = this.paidByEmployee.filter(
        (plan) => plan.planLevelId == obj.subGroupId
      );

      if (plans.length > 0) {


        let plancheck1Coverage = this.getExecutiveCoveragesFromCode(plans[0].coverage)

        console.log({ plancheck1Coverage })

        if (
          plancheck1Coverage
        ) {

          if (plancheck1Coverage.single) {

            setTimeout(() => {
              $('#executiveplansblock3single' + obj.subGroupId).click()

            }, 100);

          } if (plancheck1Coverage.couple) {
            setTimeout(() => {
              $('#executiveplansblock3couple' + obj.subGroupId).click()
            }, 100);
          } if (plancheck1Coverage.family) {
            setTimeout(() => {
              $('#executiveplansblock3family' + obj.subGroupId).click()
            }, 100);
          }
        }

      }
      else {
        $('#executiveplansblock3single' + obj.subGroupId).click();
        $('#executiveplansblock3couple' + obj.subGroupId).click();
        $('#executiveplansblock3family' + obj.subGroupId).click();
      }
    }

    sessionStorage.setItem('block3result', JSON.stringify(this.plansresblack3));
  }

  public addtoslectplansblock3(planid: number, plansumamryindex: number) {
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //console.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;

    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public unselectplanblock3(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number
  ) {

    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    // console.log(plandetailsobj)
    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageindex, //packageIndex,
      groupIndex: groupindex, //groupIndex,
      subgroupIndex: subgroupindex //subgroupIndex,
    };

    if (obj.parentId == '15') {
      this.block3coverage = true;
    }
    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1]?.includes(plandetailsobj[2])) {
      }
    }

    this.removesummaryBlock3(obj);
  }

  public removesummaryBlock3(obj: any) {
    // console.log("remove")

    // console.log(obj)

    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    let selectedBlock3 = JSON.parse(
      sessionStorage.getItem('selectedBlock3') || '{}'
    );
    // console.log(summaryBlock2)

    if (selectedBlock3[obj.packageid]) {
      if (selectedBlock3[obj.packageid][obj.parentId]) {
        delete selectedBlock3[obj.packageid][obj.parentId];

        // console.log(selectedBlock3[obj.packageid][obj.parentId])
      } else {
        // console.log("firstelse")
        selectedBlock3[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log("secondelse")
      selectedBlock3[obj.packageid] = {};
      selectedBlock3[obj.packageid][obj.parentId] = [];
    }

    // var selectedPlanLevel={"id":obj.subGroupId, "order":obj.orderId}
    // selectedBlock1[obj.packageid][obj.parentId].push(selectedPlanLevel)

    // selectedBlock1.splice(obj.parentId)

    // console.log(selectedBlock2)

    // sessionStorage.setItem('selectedBlock2', JSON.stringify(selectedBlock3));
    if (summaryBlock3) {
      let index = this.getslectedplansblock3(obj.subGroupId);

      if (index > -1) {
        summaryBlock3.splice(index, 1);



        // if (
        //   !this.plansresblack3[obj.packageindex] ||
        //   this.plansresblack3[obj.packageindex]['groups'] ||
        //   this.plansresblack3[obj.packageindex]['groups'][obj.groupindex] ||
        //   this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
        //     'subGroups'
        //   ]
        // ) {

        console.log(
          this.plansresblack3[obj.packageindex]['groups'][obj.groupindex][
          'subGroups'
          ][obj.subgroupindex]
        );

        // this.plansresblack3[obj.packageindex]['groups'][obj.groupindex]['subGroups'][
        //   obj.subgroupindex
        // ]['checked'] = false;
        console.log(obj)

        if (this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
          'subGroups'
        ][obj.subgroupIndex]) {
          this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['tiers'] = [];
          this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['checked'] = false;


          if (
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Executive Health'
          ) {



            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'disabled',
              true
            );
          }

          if (
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Complete Executive Care'
          ) {


            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'disabled',
              true
            );
          }

          if (
            this.plansresblack3[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan'
          ) {


            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock3single' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3couple' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock3family' + obj.subGroupId).prop(
              'disabled',
              true
            );
          }
        }
        // }
      } else {
        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock3.length; i++) {
        newselectedplans[summaryBlock3[i].subGroupId] = i;
      }

      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      this.planssummarymain = [];
      this.planssummaryopt = [];

      summaryBlock3.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      // let el1: HTMLElement = this.employeepurchasefalse.nativeElement;
      // el1.click();

      sessionStorage.setItem(
        'summaryBlock3main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock3opt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));
    }
  }

  public selectplanblock2(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    subgroup: any,
    disallowedPlanLevels: any
  ) {


    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    // console.log(plandetailsobj)

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      coverage: '',
      settingsAdditional: subgroup?.settingsAdditional || {},
      disallowedPlanLevels: disallowedPlanLevels

    };

    // console.log(obj)

    this.addtosummaryBlock2(obj);
  }

  public addtosummaryBlock2(obj: any) {
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );
    let selectedBlock2 = JSON.parse(
      sessionStorage.getItem('selectedBlock2') || '{}'
    );

    let mainresults = JSON.parse(
      sessionStorage.getItem('mainresults') || '{}'
    );

    this.addtoslectplansblock2(obj.subGroupId, summaryBlock2.length);
    summaryBlock2.push(obj);

    this.planssummarymain = [];
    this.planssummaryopt = [];

    summaryBlock2.forEach((element: any) => {
      if (element.packagename != 'Opt-in') {
        this.planssummarymain.push(element);
      } else {
        this.planssummaryopt.push(element);
      }

      if (!this.packagePlanLevelTiers[element.packagename]) {
        this.packagePlanLevelTiers[element.packagename] = [];
      }
      const exists =
        this.packagePlanLevelTiers[element.packagename].findIndex(
          (item) => item.subGroupId === element.subGroupId
        ) > -1;
      if (exists) {
        console.log('check');
      } else {
        this.packagePlanLevelTiers[element.packagename].push(element);
      }
    });

    if (selectedBlock2[obj.packageid]) {
      if (selectedBlock2[obj.packageid][obj.parentId]) {
        // console.log(selectedBlock2[obj.packageid][obj.parentId])
      } else {
        // console.log("firstelse")
        selectedBlock2[obj.packageid][obj.parentId] = [];
      }
    } else {
      // console.log("secondelse")
      selectedBlock2[obj.packageid] = {};
      selectedBlock2[obj.packageid][obj.parentId] = [];
    }

    //now push
    var selectedPlanLevel = { id: obj.subGroupId, order: obj.orderId };
    selectedBlock2[obj.packageid][obj.parentId].push(selectedPlanLevel);

    let subGroupIdindex;

    if (summaryBlock3 && summaryBlock3.length > 0) {
      for (let i = 0; i < summaryBlock3.length; i++) {
        if (summaryBlock3[i].subGroupId == obj.subGroupId) {
          subGroupIdindex = i;

          break;
        }
      }

      if (subGroupIdindex > -1) {
        summaryBlock3.splice(subGroupIdindex, 1);
      } else {
        console.log('check1');
      }
    }

    let selectedplansblock3;
    setTimeout(() => {
      sessionStorage.setItem('summaryBlock3', JSON.stringify(summaryBlock3));

    }, 50);
    setTimeout(() => {
      selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );
    }, 100);




    // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
    // el.click();

    // sessionStorage.setItem('selectedBlock2', JSON.stringify(selectedBlock2));
    sessionStorage.setItem(
      'summaryBlock2main',
      JSON.stringify(this.planssummarymain)
    );
    sessionStorage.setItem(
      'summaryBlock2opt',
      JSON.stringify(this.planssummaryopt)
    );

    sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));



    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    // this.plansresblack2--mainresults
    mainresults[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
    ][obj.subgroupindex]['checked'] = true;

    if (
      mainresults[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Executive Health' || mainresults[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Complete Executive Care' || mainresults[obj.packageindex]['groups'][obj.groupindex][
      'subGroups'
      ][obj.subgroupindex]['name'] == 'Provincial Health Replacement Plan'
    ) {

      // alert("1")
      $('#executiveplansblock2single' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock2couple' + obj.subGroupId).prop('disabled', false);
      $('#executiveplansblock2family' + obj.subGroupId).prop('disabled', false);

      let plans = this.coveredByCompany.filter(
        (plan) => plan.planLevelId == obj.subGroupId
      );

      if (plans.length > 0) {


        let plancheck1Coverage = this.getExecutiveCoveragesFromCode(plans[0].coverage)

        console.log({ plancheck1Coverage })

        if (
          plancheck1Coverage
        ) {

          if (plancheck1Coverage.single) {

            // setTimeout(() => {
            $('#executiveplansblock2single' + obj.subGroupId).click()

            // }, 1000);

          } if (plancheck1Coverage.couple) {

            $('#executiveplansblock2couple' + obj.subGroupId).click()

          } if (plancheck1Coverage.family) {
            $('#executiveplansblock2family' + obj.subGroupId).click()

          }
        }

      }
      else {
        $('#executiveplansblock2single' + obj.subGroupId).click()
        $('#executiveplansblock2couple' + obj.subGroupId).click()
        $('#executiveplansblock2family' + obj.subGroupId).click()
      }

    }

    if (this.employeeplanpurchase == true) {
      // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
      // el.click();
      setTimeout(() => {
        let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
        el1.click();
        setTimeout(() => {
          const dom: HTMLElement = this.elementRef.nativeElement;

          if (selectedplansblock3.length > 0) {
            let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
            el1.click();
            this.employeeplanpurchase == true;
            setTimeout(() => {
              for (let i = 0; i < selectedplansblock3.length; i++) {
                const element2: any = dom.querySelector(
                  '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
                );
                // element2.checked = true;
                $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

                if (selectedplansblock3[i].disallowedPlanLevels != null) {
                  let disallowed_plans = selectedplansblock3[i].disallowedPlanLevels.split(',');
                  const dom1: HTMLElement = this.elementRef.nativeElement;
                  for (let i = 0; i < disallowed_plans.length; i++) {

                    setTimeout(() => {
                      let elem: any = dom1.querySelector(`#plancheck3Voluntry${disallowed_plans[i]}`)

                      if (elem != null) {
                        if (!elem.disabled) {

                          elem.disabled = true
                        }
                      }
                    }, 100);

                  }
                }

              }
            }, 1000);
          }
        }, 1000);
      }, 100);
    }

    sessionStorage.setItem('mainresults', JSON.stringify(mainresults));

    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('block2result') || '[]'
    );

    var res = JSON.parse(sessionStorage.getItem('block2result') || '[]');

    this.plansNewBlock2.map((packagelevel: any, index: any) => {

      if (!packagelevel) {

      }
      else {
        packagelevel.groups.map((groups: any, index1: any) => {
          this.selectedplansblock1.map((selectplan: any) => {
            if (
              packagelevel.id == selectplan.packageid &&
              packagelevel.groups.id == selectplan.parentid
            ) {

              if (
                !this.plansNewBlock2[index] ||
                !this.plansNewBlock2[index]['groups'] ||
                !this.plansNewBlock2[index]['groups'][index1] ||
                !this.plansNewBlock2[index]['groups'][index1]['subGroups']
              ) {
              }
              else {

                var allAvailble =
                  this.plansNewBlock2[index]['groups'][index1]['subGroups'];


                allAvailble.map((element1: any, index2: any) => {
                  if (element1 != null) {
                    if (element1.disallowedPlanLevels) {
                      if (element1.id == selectplan.subGroupId) {

                        console.log("check here data")
                        res.map((res1: any, index4: any) => {

                          if (!res[index4] || !res[index4]['groups'][index]) {

                          }
                          else {
                            res1.groups.map((groups1: any, index5: any) => {
                              console.log(groups1)
                              groups1.subGroups.forEach(
                                (subgrp: any, index6: any) => {
                                  console.log(element1.disallowedPlanLevels);
                                  if (
                                    element1.disallowedPlanLevels.indexOf(
                                      groups1.id
                                    ) > -1
                                  ) {

                                    if (
                                      !this.plansresblack2[index4] ||
                                      !this.plansresblack2[index4]['groups'] ||
                                      !this.plansresblack2[index4]['groups'][index5] ||
                                      !this.plansresblack2[index4]['groups'][index5]['subGroups']
                                    ) {
                                    }
                                    else {
                                      console.log(this.plansresblack2)
                                      // this.plansresblack2[index4]['groups'][index5][
                                      //   'subGroups'
                                      // ][index6]['tiers'] = [];
                                      // this.plansresblack2[index4]['groups'][index5][
                                      //   'subGroups'
                                      // ][index6]['checked'] = false;

                                      res[index4]['groups'][index5]['subGroups'][
                                        index6
                                      ] = null;
                                    }


                                  }
                                }
                              );
                            });
                          }
                        });
                      }
                    }
                  }
                });
              }
            }
          });
        });
      }

    });

    console.log(res)
    sessionStorage.setItem('block2result', JSON.stringify(res));
  }

  public addtoslectplansblock2(planid: number, plansumamryindex: number) {
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedPlans') || '{}'
    );
    //console.log(selectedPlans)
    selectedPlans[planid] = plansumamryindex;

    sessionStorage.setItem('selectedPlans', JSON.stringify(selectedPlans));
  }

  public unselectplanblock2(
    elementcv: any,
    packname: any,
    grpname: any,
    subgrpname: any,
    packageindex: number,
    groupindex: number,
    subgroupindex: number,
    packageIndex: number,
    groupIndex: number,
    subgroupIndex: number
  ) {
    let plandetails = elementcv.attributes.data.value;

    let plandetailsobj = plandetails.split('##');

    // console.log(plandetailsobj)

    let obj = {
      packageid: plandetailsobj[2],
      parentId: plandetailsobj[3],
      subGroupId: plandetailsobj[4],
      orderId: plandetailsobj[8],
      packagename: packname,
      groupname: grpname,
      subGrpname: subgrpname,
      tiers: [],
      packageindex: packageindex,
      groupindex: groupindex,
      subgroupindex: subgroupindex,
      packageIndex: packageIndex,
      groupIndex: groupIndex,
      subgroupIndex: subgroupIndex,
    };

    // if(obj.parentId =='15'){
    //   this.block2coverage =true
    // }

    if (plandetailsobj[1] != null || plandetailsobj[1] != 'null') {
      if (plandetailsobj[1]?.includes(plandetailsobj[2])) {
      }
    }

    this.removesummaryBlock2(obj);
  }



  public removesummaryBlock2(obj: any) {
    console.log(obj);

    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );
    let selectedBlock2 = JSON.parse(
      sessionStorage.getItem('selectedBlock2') || '{}'
    );
    let mainresults = JSON.parse(
      sessionStorage.getItem('mainresults') || '{}'
    );
    // console.log(summaryBlock2)

    // if (selectedBlock2[obj.packageid]) {
    //   if (selectedBlock2[obj.packageid][obj.parentId]) {
    //     delete selectedBlock2[obj.packageid][obj.parentId];

    //     // console.log(selectedBlock2[obj.packageid][obj.parentId])
    //   } else {
    //     // console.log("firstelse")
    //     selectedBlock2[obj.packageid][obj.parentId] = [];
    //   }
    // }

    // else {
    //   // console.log("secondelse")
    //   selectedBlock2[obj.packageid] = {};
    //   selectedBlock2[obj.packageid][obj.parentId] = [];
    // }

    if (summaryBlock2 && summaryBlock2.length > 0) {

      console.log("TestHere")
      let index = this.getslectedplansblock2(obj.subGroupId);

      console.log(index)

      if (index > -1) {
        console.log(obj);
        summaryBlock2.splice(index, 1);

        // if (!this.packagePlanLevelTiers[obj.packagename]) {
        //   this.packagePlanLevelTiers[obj.packagename] = [];
        // }

        // this.packagePlanLevelTiers[obj.packagename].splice(obj, 1);

        // sessionStorage.setItem(
        //   'packagePlanLevelTiers',
        //   JSON.stringify(this.packagePlanLevelTiers) || '[]'
        // );


        console.log(obj.packageIndex);
        console.log(obj.groupIndex);
        console.log(this.plansresblack2);

        // this.plansresblack2 = JSON.parse(sessionStorage.getItem('block2result') || '[]');

        if (obj.packageIndex >= 0 && obj.groupIndex >= 0 && obj.subgroupIndex >= 0) {
          mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['tiers'] = [];
          mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
          ][obj.subgroupIndex]['checked'] = false;

          if (
            mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Executive Health' || mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Complete Executive Care' || mainresults[obj.packageIndex]['groups'][obj.groupIndex][
            'subGroups'
            ][obj.subgroupIndex]['name'] == 'Provincial Health Replacement Plan'
          ) {




            $('#executiveplansblock2single' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2couple' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2family' + obj.subGroupId).prop(
              'checked',
              false
            );
            $('#executiveplansblock2single' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock2couple' + obj.subGroupId).prop(
              'disabled',
              true
            );
            $('#executiveplansblock2family' + obj.subGroupId).prop(
              'disabled',
              true
            );
            let summaryBlock1 = JSON.parse(
              sessionStorage.getItem('summaryBlock1') || '[]'
            );


            sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

          }



        }

        sessionStorage.setItem(
          'mainresults',
          JSON.stringify(mainresults)
        );
      } else {
        return;
      }

      var newselectedplans: any = {};
      for (var i = 0; i < summaryBlock2.length; i++) {
        newselectedplans[summaryBlock2[i].subGroupId] = i;
      }

      sessionStorage.setItem('selectedPlans', JSON.stringify(newselectedplans));

      this.planssummarymain = [];
      this.planssummaryopt = [];

      summaryBlock2.forEach((element: any) => {
        if (element.packagename != 'Opt-in') {
          this.planssummarymain.push(element);
        } else {
          this.planssummaryopt.push(element);
        }
      });

      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );


      console.log(this.employeeplanpurchase)
      if (this.employeeplanpurchase == true) {

        // console.log("1")
        let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        el.click();
        setTimeout(() => {
          let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
          el1.click();
          setTimeout(() => {
            const dom: HTMLElement = this.elementRef.nativeElement;
            if (selectedplansblock3.length > 0) {
              let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
              el1.click();
              this.employeeplanpurchase == true;
              setTimeout(() => {
                for (let i = 0; i < selectedplansblock3.length; i++) {
                  const element2: any = dom.querySelector(
                    '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
                  );
                  element2?.prop('checked', true);
                  // element2.checked = true;
                  // element2.click()
                }
              }, 1500);
            }
          }, 1000);
        }, 100);
      }

      sessionStorage.setItem(
        'summaryBlock2main',
        JSON.stringify(this.planssummarymain)
      );
      sessionStorage.setItem(
        'summaryBlock2opt',
        JSON.stringify(this.planssummaryopt)
      );

      sessionStorage.setItem('summaryBlock2', JSON.stringify(summaryBlock2));
    }
    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('block2result') || '[]'
    );

    var res = JSON.parse(sessionStorage.getItem('planResults') || '[]');

    this.plansNewBlock2.map((packagelevel: any, index: any) => {
      if (!packagelevel) {

      }
      else {
        packagelevel.groups.map((groups: any, index1: any) => {
          this.selectedplansblock1.map((selectplan: any) => {
            if (
              packagelevel.id == selectplan.packageid &&
              packagelevel.groups.id == selectplan.parentid
            ) {


              if (
                !this.plansNewBlock2[index] ||
                !this.plansNewBlock2[index]['groups'] ||
                !this.plansNewBlock2[index]['groups'][index1] ||
                !this.plansNewBlock2[index]['groups'][index1]['subGroups']
              ) {
              }
              else {
                var allAvailble =
                  this.plansNewBlock2[index]['groups'][index1]['subGroups'];

                allAvailble.map((element1: any, index2: any) => {
                  if (element1 != null) {

                    console.log(element1.disallowedPlanLevels)
                    if (element1.disallowedPlanLevels) {
                      console.log(element1.id)
                      console.log(obj.subGroupId)
                      if (element1.id == obj.subGroupId) {

                        console.log(element1.id)
                        console.log(obj.subGroupId)
                        res.map((res1: any, index4: any) => {
                          if (!res[index4] || !res[index4]['groups'][index]) {

                          } else {
                            res1.groups.map((groups1: any, index5: any) => {
                              // console.log(groups1)
                              groups1.subGroups.forEach(
                                (subgrp: any, index6: any) => {
                                  console.log(subgrp);
                                  if (
                                    element1.disallowedPlanLevels.indexOf(
                                      groups1.id
                                    ) > -1
                                  ) {
                                    if (
                                      !this.plansresblack2[index4] ||
                                      !this.plansresblack2[index4]['groups'] ||
                                      !this.plansresblack2[index4]['groups'][index5] ||
                                      !this.plansresblack2[index4]['groups'][index5]['subGroups']
                                    ) {
                                    }
                                    else {
                                      // this.plansresblack2[index4]['groups'][index5][
                                      //   'subGroups'
                                      // ][index6]['tiers'] = [];
                                      // this.plansresblack2[index4]['groups'][index5][
                                      //   'subGroups'
                                      // ][index6]['checked'] = false;

                                      res[index4]['groups'][index5]['subGroups'][
                                        index6
                                      ] = subgrp;
                                    }
                                  }
                                }
                              );
                            });
                          }
                        });
                        sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

                      }
                    }
                  }
                });
              }
            }
          });
        });
      }
    });
  }

  public getslectedplansblock1(planid: number) {
    //console.log(planid)
    // let selectedPlans = JSON.parse(
    //   sessionStorage.getItem('selectedPlans') || '{}'
    // );
    // // console.log(selectedPlans)
    // return selectedPlans[planid];


    console.log(planid)
    let summaryBlock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock1.length; i++) {
      console.log(summaryBlock1[i].subGroupId)
      console.log(planid)
      if (summaryBlock1[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }

    return subGroupIdindex;
  }

  public getslectedplansblock2(planid: number) {
    //console.log(planid)
    // let selectedPlans = JSON.parse(
    //   sessionStorage.getItem('selectedPlans') || '{}'
    // );
    // // console.log(selectedPlans)
    // return selectedPlans[planid];


    console.log(planid)
    let summaryBlock2 = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock2.length; i++) {
      console.log(summaryBlock2[i].subGroupId)
      console.log(planid)
      if (summaryBlock2[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }

    return subGroupIdindex;
  }
  public getslectedplansblock3(planid: number) {
    //console.log(planid)
    // let selectedPlans = JSON.parse(
    //   sessionStorage.getItem('selectedPlans') || '{}'
    // );
    // // console.log(selectedPlans)
    // return selectedPlans[planid];


    console.log(planid)
    let summaryBlock3 = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '{}'
    );
    let subGroupIdindex;
    for (let i = 0; i < summaryBlock3.length; i++) {
      console.log(summaryBlock3[i].subGroupId)
      console.log(planid)
      if (summaryBlock3[i].subGroupId == planid) {
        subGroupIdindex = i;
        break;
      }
    }

    return subGroupIdindex;
  }
  public getslectedblockplans(obj: any) {
    //console.log(planid)
    let selectedPlans = JSON.parse(
      sessionStorage.getItem('selectedBlock1') || '{}'
    );

    if (selectedPlans[obj.packageid]) {
      if (selectedPlans[obj.packageid][obj.parentId]) {
        var res = selectedPlans[obj.packageid][obj.parentId];

        res.forEach((element: any, index: any) => {
          if ((element.id = obj.subGroupId && element.order == obj.orderId)) {
            return selectedPlans[index];
          }
        });
      } else {
        // console.log("firstelse")
        selectedPlans[obj.packageid][obj.parentId] = [];
      }
    }
  }

  checkPaymentInfo(e: any) {
    if (e.target.value == 'pad') {
      this.bankDetails = false;
    } else {
      this.bankDetails = false;
    }
  }

  public provincelist(event: any) {
    // alert(event.target.value)

    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;

        this.stateId = element.id;
        this.fusebillStateId = element.fusebillId;
        this.countryId = element.country_id;
        this.fusebillCountryId = element.country_id;
      }
    });

    if (this.clientregform.value.postalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.clientregform.value.postalCode[0]
        ) == -1
      ) {
        this.invalidpostalcodeprivince = true;

        this.client['postalCode'].markAsTouched();
        this.client['postalCode'].updateValueAndValidity();
      } else {
        this.invalidpostalcodeprivince = false;
        // console.log("test1")
      }

      if (this.clientregform.value.postalCode.length == 0) {
        this.invalidpostalcodeprivince = false;
        // console.log("test11")
      }
    }
  }
  public provincelistwaddell(event: any) {
    // alert(event.target.value)

    this.configprovinceres.forEach((element: any) => {
      if (element.shortName == event.target.value) {
        this.provincialHealthcareUrl = element.provincialHealthcareUrl;
        this.provincialZipcodes = element.zipcodes.split(',');
        this.provincelistid = element.id;
        this.state_id = parseInt(element.fusebillId);
        this.statename = element.name;
      }
    });


    console.log(this.addEmployeeformListwaddell.value.employeePostalCode)
    console.log(this.provincialZipcodes)
    if (this.addEmployeeformListwaddell.value.employeePostalCode) {
      if (
        this.provincialZipcodes.indexOf(
          this.addEmployeeformListwaddell.value.employeePostalCode[0]
        ) == -1
      ) {

        this.invalidpostalcodeprivincewaddell = true;

        this.empwaddell['employeePostalCode'].markAsTouched();
        this.empwaddell['employeePostalCode'].updateValueAndValidity();
      } else {
        this.invalidpostalcodeprivincewaddell = false;
        // console.log("test1")
      }

      if (this.addEmployeeformListwaddell.value.employeePostalCode.length == 0) {
        this.invalidpostalcodeprivincewaddell = false;
        // console.log("test11")
      }
    }
  }
  public getprovincelist(event: any) {
    if (event.target.value.toLowerCase() == 'canada') {
      this.postalCodeDisplay = this.lang.Postal_Code;
      this.provianceDispaly = this.lang.Province;
      this.selectedCountry = 'Canada';
      this.clientregform.get('postalCode').setValidators([postalcodeValidator]);
      this.clientregform.get('postalCode').updateValueAndValidity();
      this.clientregform
        .get('multiSelectProviance')
        .setValidators([Validators.required]);
      this.clientregform.get('multiSelectProviance').updateValueAndValidity();
      this.isCountrySelected = true;
    } else {
      this.postalCodeDisplay = this.lang.Zip_Code;
      this.provianceDispaly = this.lang.State;
      this.selectedCountry = 'USA';
      this.clientregform.get('postalCode').reset();
      this.clientregform.get('postalCode').clearValidators();
      this.clientregform.get('postalCode').updateValueAndValidity();
      this.invalidpostalcodeprivince = false;
      this.clientregform.get('multiSelectProviance').clearValidators();
      this.clientregform.get('multiSelectProviance').updateValueAndValidity();
      this.multiSelectProviance = [];
      this.isCountrySelected = true;
    }

    this.countryList.forEach((element: any) => {

      if (element.name == event.target.value) {
        this.configprovincereslist = element.countryStates
      }
      this.configprovincereslist = [...this.configprovincereslist].sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
    })


  }
  public getprovincelist1(event: any) {
    // alert("!")

    if (event.target?.value?.toLowerCase() == 'canada') {
      this.postalCodeDisplay = 'Postal Code';
      this.provianceDispaly = 'Province';
      this.selectedCountry = 'Canada';
      this.clientregform.get('postalCode').setValidators([postalcodeValidator]);
      this.clientregform.get('postalCode').updateValueAndValidity();
      this.clientregform
        .get('multiSelectProviance')
        .setValidators([Validators.required]);
      this.clientregform.get('multiSelectProviance').updateValueAndValidity();
      this.isCountrySelected = true;
    } else {
      this.postalCodeDisplay = 'Zip Code';
      this.provianceDispaly = 'State';
      this.selectedCountry = 'USA';
      this.clientregform.get('postalCode').reset();
      this.clientregform.get('postalCode').clearValidators();
      this.clientregform.get('postalCode').updateValueAndValidity();
      this.invalidpostalcodeprivince = false;
      this.clientregform.get('multiSelectProviance').clearValidators();
      this.clientregform.get('multiSelectProviance').updateValueAndValidity();
      this.multiSelectProviance = [];
      this.isCountrySelected = true;
    }

    this.countryList.forEach((element: any) => {

      if (element.name == event) {
        this.configprovincereslist = element.countryStates
      }
      this.configprovincereslist = [...this.configprovincereslist].sort(
        (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
      );
    })


  }
  changeTextToUppercase(field: any, event: any) {
    console.log(field);
    const obj = {};
    // obj[field] = this.clientregform.controls[field].value.toUpperCase();
    // this.clientregform.patchValue(obj);

    this.postalvalue = event.target.value;

    console.log(this.postalvalue);

    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      // console.log("r")
      this.invalidpostalcodeprivince = true;
      this.client['postalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivince = false;
    }

    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivince = false;
    }

    console.log(this.invalidpostalcodeprivince);

    //  postalcodeValidator1(this.invalidpostalcodeprivince )
  }
  changeTextToUppercasewaddell(field: any, event: any) {
    console.log(field);
    const obj = {};
    // obj[field] = this.clientregform.controls[field].value.toUpperCase();
    // this.clientregform.patchValue(obj);

    this.postalvalue = event.target.value;

    console.log(this.postalvalue);

    if (this.provincialZipcodes.indexOf(this.postalvalue[0]) == -1) {
      // console.log("r")
      this.invalidpostalcodeprivincewaddell = true;
      this.empwaddell['employeePostalCode'].markAsTouched();
    } else {
      this.invalidpostalcodeprivincewaddell = false;
    }

    if (this.postalvalue.length == 0) {
      this.invalidpostalcodeprivincewaddell = false;
    }

    console.log(this.invalidpostalcodeprivincewaddell);

    //  postalcodeValidator1(this.invalidpostalcodeprivince )
  }

  addRow() {
    this.basicTiersCount++;
    this.dynamicArray.push({
      sno: '',
      tierName: this.capitalize(''),
      walletAmount: '$',
    });
    // console.log('New row added successfully', 'New Row')
  }
  deleteRowBlock1(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (this.dynamicArray.length == 1) {
      Swal.fire({
        title: 'Warning',
        text: "Can't delete the row when there is only one row",
      });
      return false;
    } else {
      if (dynamic.id && dynamic.id > 0) {
        this.defaulttiers.push(dynamic.id);
        let requestBody = {
          default: this.defaulttiers,
          lengthOfService: [],
          annualIncome: [],
        };

        var corporateId = sessionStorage.getItem('corporateId');

        var DeleteTiers =
          '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
        var accessToken = sessionStorage.getItem('accessToken');
        this.http
          .post(environment.apiUrl + DeleteTiers, requestBody, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe((response: any) => {
            if (response.status == '200') {
              Swal.fire({
                title: 'Success',
                text: response.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.configuretiers();
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          }, (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: this.lang.Proceed,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
                else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          });
      } else {
        this.dynamicArray.splice(index, 1);
      }
    }
  }
  deleteRowBlock2(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (this.dynamicArray.length == 1) {
      Swal.fire({
        title: 'Warning',
        text: "Can't delete the row when there is only one row",
      });
      return false;
    } else {
      if (dynamic.id && dynamic.id > 0) {
        this.defaulttiers.push(dynamic.id);
        let requestBody = {
          default: this.defaulttiers,
          lengthOfService: [],
          annualIncome: [],
        };

        var corporateId = sessionStorage.getItem('corporateId');

        var DeleteTiers =
          '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
        var accessToken = sessionStorage.getItem('accessToken');
        this.http
          .post(environment.apiUrl + DeleteTiers, requestBody, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe((response: any) => {
            if (response.status == '200') {
              Swal.fire({
                title: 'Success',
                text: response.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.configuretiers();
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          }, (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: this.lang.Proceed,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
                else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          });
      } else {
        this.dynamicArray.splice(index, 1);
      }
    }
  }
  deleteRowBlock3(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (this.dynamicArray.length == 1) {
      Swal.fire({
        title: 'Warning',
        text: "Can't delete the row when there is only one row",
      });
      return false;
    } else {
      if (dynamic.id && dynamic.id > 0) {
        this.defaulttiers.push(dynamic.id);
        let requestBody = {
          default: this.defaulttiers,
          lengthOfService: [],
          annualIncome: [],
        };

        var corporateId = sessionStorage.getItem('corporateId');

        var DeleteTiers =
          '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
        var accessToken = sessionStorage.getItem('accessToken');
        this.http
          .post(environment.apiUrl + DeleteTiers, requestBody, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe((response: any) => {
            if (response.status == '200') {
              Swal.fire({
                title: 'Success',
                text: response.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              }).then((result) => {
                if (result.isConfirmed) {
                  this.configuretiers();
                }
              });
            } else {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            }
          }, (error) => {
            if (
              error.status == 400 ||
              error.status == 401 ||
              error.status == 402 ||
              error.status == 403
            ) {
              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: error.error.error.message,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang.Proceed,
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
                else {
                  sessionStorage.clear();
                  this.router.navigate(['/login']);
                }
              });
            } else {
              // Swal.fire(error.error.error.message)
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
            // this.toastrService.error("Invalid Credentials", 'Error!');
          });
      } else {
        this.dynamicArray.splice(index, 1);
      }
    }
  }
  deleteRow(index: number) {
    return false;
    if (this.dynamicArray.length == 1) {
      Swal.fire({
        title: 'Warning',
        text: "Can't delete the row when there is only one row",
      });
      return false;
    } else {
      // if(dynamic.id  && dynamic.id>0){

      this.defaulttiers.push(1119);
      let requestBody = {
        default: this.defaulttiers,
        lengthOfService: [],
        annualIncome: [],
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe((response: any) => {
          if (response.status == '200') {
            Swal.fire({
              title: 'Success',
              text: response.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.isConfirmed) {
                this.configuretiers();
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }, (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        });

      // }

      // else{
      //   // this.dynamicArray.splice(index, 1);

      // }
    }
  }
  addRowService() {
    this.serviceCount++;
    this.dynamicArrayService.push({
      sno: '',
      tierName: '',
      from: '',
      to: '',
      period: '',
      walletAmount: '$',
    });
    // console.log('New row added successfully', 'New Row')
  }
  deleteRowService(index: number) {
    this.dynamicArrayService.splice(index, 1);
    // this.serviceCount--
  }
  deleteRowServiceBlock1(index: number, dynamic: any) {
    // console.log(this.dynamicArray)

    this.defaulttiers = [];

    if (dynamic.id && dynamic.id > 0) {
      console.log(dynamic.id);

      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: this.defaulttiers,
        annualIncome: [],
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe((response: any) => {
          if (response.status == '200') {
            Swal.fire({
              title: 'Success',
              text: response.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.isConfirmed) {
                this.configuretiers();
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }, (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        });
    } else {
      this.dynamicArrayService.splice(index, 1);
    }
  }
  deleteRowServiceBlock2(index: number, dynamic: any) {
    // console.log(this.dynamicArray)

    this.defaulttiers = [];

    if (dynamic.id && dynamic.id > 0) {
      console.log(dynamic.id);

      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: this.defaulttiers,
        annualIncome: [],
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe((response: any) => {
          if (response.status == '200') {
            Swal.fire({
              title: 'Success',
              text: response.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.isConfirmed) {
                this.configuretiers();
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }, (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        });
    } else {
      this.dynamicArrayService.splice(index, 1);
    }
  }
  deleteRowServiceBlock3(index: number, dynamic: any) {
    // console.log(this.dynamicArray)

    this.defaulttiers = [];

    if (dynamic.id && dynamic.id > 0) {
      console.log(dynamic.id);

      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: this.defaulttiers,
        annualIncome: [],
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe((response: any) => {
          if (response.status == '200') {
            Swal.fire({
              title: 'Success',
              text: response.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.isConfirmed) {
                this.configuretiers();
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }, (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        });
    } else {
      this.dynamicArrayService.splice(index, 1);
    }
  }
  addRowAnnual() {
    this.AnnualCount++;
    this.dynamicArrayAnnualIncome.push({
      sno: '',
      tierName: '',
      percentage: '',
      from: '',
      to: '',
      walletAmount: '$',
    });
    // console.log('New row added successfully', 'New Row')
  }
  deleteRowAnnual(index: number) {
    this.dynamicArrayAnnualIncome.splice(index, 1);
  }

  deleteRowAnnualBlock1(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (dynamic.id && dynamic.id > 0) {
      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: [],
        annualIncome: this.defaulttiers,
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe((response: any) => {
          if (response.status == '200') {
            Swal.fire({
              title: 'Success',
              text: response.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.isConfirmed) {
                this.configuretiers();
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }, (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        });
    } else {
      this.dynamicArrayAnnualIncome.splice(index, 1);
    }
  }
  deleteRowAnnualBlock2(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (dynamic.id && dynamic.id > 0) {
      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: [],
        annualIncome: this.defaulttiers,
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe((response: any) => {
          if (response.status == '200') {
            Swal.fire({
              title: 'Success',
              text: response.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.isConfirmed) {
                this.configuretiers();
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }, (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        });
    } else {
      this.dynamicArrayAnnualIncome.splice(index, 1);
    }
  }
  deleteRowAnnualBlock3(index: number, dynamic: any) {
    this.defaulttiers = [];
    if (dynamic.id && dynamic.id > 0) {
      this.defaulttiers.push(dynamic.id);
      let requestBody = {
        default: [],
        lengthOfService: [],
        annualIncome: this.defaulttiers,
      };

      var corporateId = sessionStorage.getItem('corporateId');

      var DeleteTiers =
        '/api/ap/admin/corporate/' + corporateId + '/deleteTiers';
      var accessToken = sessionStorage.getItem('accessToken');
      this.http
        .post(environment.apiUrl + DeleteTiers, requestBody, {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe((response: any) => {
          if (response.status == '200') {
            Swal.fire({
              title: 'Success',
              text: response.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: 'Ok',
            }).then((result) => {
              if (result.isConfirmed) {
                this.configuretiers();
              }
            });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }, (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        });
    } else {
      this.dynamicArrayAnnualIncome.splice(index, 1);
    }
  }
  public ngAfterViewInit(): void {
    const modalElement = document.getElementById('wsadata');
  if (modalElement) {
    modalElement.addEventListener('hidden.bs.modal', () => {
      this.closeEditTierdModel();
    
    });
  }
    // this.createChartGauge();
    // setTimeout(() => {
    //   this.GetCorpDetails();
    // }, 1500);
  }

  get client() {
    return this.clientregform.controls;
  }

  get bank() {
    return this.bankingInfoForm.controls;
  }

  get tier() {
    return this.addTierForm.controls;
  }

  get wallet() {
    return this.addWalletForm.controls
  }
  get deletetier() {
    return this.deleteTierForm.controls
  }


  toggleAllPlans(event: any) {
    if (event.target.checked) {

      this.changePackageCheckedValues(true)

    }
    else {
      this.changePackageCheckedValues(false)

    }

  }
  changePackageCheckedValues(bool: boolean) {
    this.tierMembers['packageCheckbox'] = bool;
    Object.keys(this.tierMembers).forEach((p, id) => {
      if (typeof this.tierMembers[p] === 'object') {
        this.tierMembers[p]['planCheckbox'] = bool;
      }
    })


    console.log({ plansArray: this.tierMembers })

  }
  planCheckbox(customerId: any, event: any) {
    let disabled = true

    console.log(customerId)
    console.log(this.tierMembers)
    if (event.target.checked) {

      const customer: any = this.tierMembers.find(
        (detail) => detail.staxbillId == customerId
      );
      customer.planCheckbox = true;

      customer.tierKey = this.getTierKeyFromId(this.selectedTierName[customer.staxbillId], '5')
      customer.tierId = this.selectedTierName[customer.staxbillId]

      console.log(customer)
      console.log(this.selectedTierName[customer.staxbillId])

      // console.log(this.tierMembers)
      // this.terminateMemberDetails[customerId].planCheckbox = true;
      this.changePlanCheckedValues(customerId)

    }
    else {
      const customer: any = this.tierMembers.find(
        (detail) => detail.staxbillId == customerId
      );
      customer.planCheckbox = false;
      // customer.tierName = ''
      this.changePlanCheckedValues(customerId)
    }
    this.checkForAllPlansChecked(customerId)

  }
  changePlanCheckedValues(customerId: any) {
    const customer: any = this.tierMembers.find(
      (detail) => detail.staxbillId == customerId
    );
    customer.packageCheckbox = false;
    customer.checked = false;

    this.checkForAllPlansChecked(customerId)

    console.log(this.tierMembers)

  }
  checkForAllPlansChecked(customerId: any) {


  }
  isAnyPlanCheckboxSelected(): boolean {
    return this.tierMembers?.some(item => item.planCheckbox) || false;
  }
  onTierChange(customerId: any, event: any) {
    // console.log(event)
    // console.log(tier)
    const customer: any = this.tierMembers.find(
      (detail) => detail.staxbillId == customerId
    );

    if (customer.planCheckbox = true) {
      customer.tierName = this.selectedTierName[customer.staxbillId]
    }

    console.log(this.tierMembers)

  }
  async submitterminationTiersWithMembers() {


    console.log(this.tierMembers)

    const customer: any = this.tierMembers.find(
      (detail) => detail.planCheckbox == true
    );

    // const memberDetails: any = this.tierMembers.filter(
    //   (detail) => detail.planCheckbox == true
    // );

    // let formData = JSON.parse(sessionStorage.getItem('formData') || '');
    // var corporateId = sessionStorage.getItem('corporateId');

    // var DeleteTiers = `${environment.apiUrl}/api/ap/customer/v3/plans/nochecks`;

    // var accessToken = sessionStorage.getItem('accessToken');


    // for (let i = 0; i < memberDetails.length; i++) {
    //   memberDetails[i]['workingProvienceId'] = memberDetails[i].workingProvinceDetails.id


    //   this.http
    //     .post(DeleteTiers, memberDetails[i], {
    //       headers: {
    //         Authorization: 'Bearer ' + accessToken,
    //         'Content-Type': 'application/json',
    //       },
    //     })
    //     .subscribe((response: any) => {
    //       if (response.status == '200') {

    //         let accessTokensession = sessionStorage.getItem('accessToken');
    //         let date = '01-05-2025'
    //         let membertermination = `/api/ap/member/${memberDetails[i].id}/configureMemberTermination?terminationDate=${date}`
    //         let endPoint = '/api/ap/admin/customer/' + memberDetails[i].id + '/tier-change';
    //         let accessToken = sessionStorage.getItem('accessToken');

    //         this.http
    //           .get(environment.apiUrl + membertermination, {
    //             headers: {
    //               Authorization: 'Bearer ' + accessToken,
    //               'Content-Type': 'application/json',
    //             },
    //           })
    //           .subscribe(
    //             (response: any) => {
    //               if (response['status'] == 200) {
    //                 let plansummarymain = JSON.parse(sessionStorage.getItem("plansummarymain")) || "";



    //                 this.gigterminationRes = response.data


    //                 if (this.continueWithExistingPlans == false && this.samePlansWithCorporate == false) {

    //                   if (!this.gigterminationRes.plans) {
    //                     this.gigterminationRes.plans = [];
    //                   }

    //                   plansummarymain.forEach((source) => {
    //                     this.gigterminationRes.plans.push(source);
    //                   });

    //                 }

    //                 else if (this.continueWithExistingPlans == false && this.samePlansWithCorporate == true) {

    //                   if (!this.gigterminationRes.plans) {
    //                     this.gigterminationRes.plans = [];
    //                   }


    //                   // this.gigterminationRes.plans = this.plansDataarray;
    //                 }
    //                 else {
    //                   if (!this.gigterminationRes.plans) {
    //                     this.gigterminationRes.plans = [];
    //                   }
    //                 }

    //                 let obj = {
    //                   corporateDetails: { "id": memberDetails[i].brokerId, 'parentId': memberDetails[i].corporateParentId }, //dev/test/prod/dummy
    //                   continueWithExistingPlans: false,
    //                   samePlansWithCorporate: false,
    //                   provisioning: true,
    //                   plansDataarray: this.gigterminationRes.plans,
    //                   data: this.gigterminationRes,
    //                   newTierId: memberDetails[i].tierId
    //                 }
    //                 this.http
    //                   .post(environment.apiUrl + endPoint, obj, {
    //                     headers: {
    //                       Authorization: 'Bearer ' + accessToken,
    //                       'Content-Type': 'application/json',
    //                     },
    //                   })
    //                   .subscribe(
    //                     (response: any) => {
    //                       if (response['status'] == 200) {
    //                         $('#deleteMembers-modal').modal('hide');
    //                         if (i === memberDetails?.length - 1) {
    //                           var DeleteTiers =
    //                             `/api/ap/admin/corporate/${corporateId}/tier/${this.tierDetails.id}/delete`;

    //                           let requestBody = {
    //                             reason: 'Delete Tier',
    //                             tierName: this.tierDetails.name,
    //                             corporateName: sessionStorage.getItem('corporateClientName'),
    //                             setupTier: formData.tierConfig,
    //                             moveEmployees: true,
    //                             moveEmployeesToTier: this.corporateTiersDeleteList[0].id    //default first tier in remaning tiers

    //                           }

    //                           this.http
    //                             .post(environment.apiUrl + DeleteTiers, requestBody, {
    //                               headers: {
    //                                 Authorization: 'Bearer ' + accessToken,
    //                                 'Content-Type': 'application/json',
    //                               },
    //                             })
    //                             .subscribe((response: any) => {
    //                               if (response.status == '200') {
    //                                 this.getExistingTiers();
    //                               } else {
    //                                 Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
    //                               }
    //                             }, (error) => {
    //                               if (
    //                                 error.status == 400 ||
    //                                 error.status == 401 ||
    //                                 error.status == 402 ||
    //                                 error.status == 403
    //                               ) {
    //                                 Swal.fire({
    //                                   title: this.lang.Error ?? 'Error',
    //                                   text: error.error.error.message,
    //                                   showDenyButton: false,
    //                                   showCancelButton: true,
    //                                   confirmButtonText: this.lang.Proceed,
    //                                 }).then((result) => {
    //                                   /* Read more about isConfirmed, isDenied below */
    //                                   if (result.isConfirmed) {
    //                                     sessionStorage.clear();
    //                                     this.router.navigate(['/login']);
    //                                   }
    //                                   else {
    //                                     sessionStorage.clear();
    //                                     this.router.navigate(['/login']);
    //                                   }
    //                                 });
    //                               } else {
    //                                 // Swal.fire(error.error.error.message)
    //                                 Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
    //                               }
    //                               // this.toastrService.error("Invalid Credentials", 'Error!');
    //                             });
    //                         }
    //                       }
    //                     })



    //               }
    //               else {
    //                 Swal.fire({ title: this.lang.Info, text: response.message || response.data.message })
    //               }
    //             })




    //       } else {
    //         Swal.fire({ title: 'Info', text: response.message });
    //       }
    //     }, (error) => {
    //       if (
    //         error.status == 400 ||
    //         error.status == 401 ||
    //         error.status == 402 ||
    //         error.status == 403
    //       ) {
    //         Swal.fire({
    //           title: this.lang.Error ?? 'Error',
    //           text: error.error.error.message,
    //           showDenyButton: false,
    //           showCancelButton: true,
    //           confirmButtonText: this.lang.Proceed,
    //         }).then((result) => {
    //           /* Read more about isConfirmed, isDenied below */
    //           if (result.isConfirmed) {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //           else {
    //             sessionStorage.clear();
    //             this.router.navigate(['/login']);
    //           }
    //         });
    //       } else {
    //         // Swal.fire(error.error.error.message)
    //         Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
    //       }
    //       // this.toastrService.error("Invalid Credentials", 'Error!');
    //     });

    // }



      const memberDetails = this.tierMembers.filter(detail => detail.planCheckbox === true);
      const formData = JSON.parse(sessionStorage.getItem('formData') || '{}');
      const corporateId = sessionStorage.getItem('corporateId');
      const accessToken = sessionStorage.getItem('accessToken');
      const DeleteTiersUrl = `${environment.apiUrl}/api/ap/customer/v3/plans/nochecks`;

      from(memberDetails).pipe(
        concatMap((member) => {
          member['workingProvienceId'] = member.workingProvinceDetails.id;

          // Step 1: Call /nochecks
          return this.http.post(DeleteTiersUrl, member, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          }).pipe(
            // Step 2: Call configureMemberTermination
            switchMap((noCheckResponse: any) => {
              if (noCheckResponse.status == '200') {
                const date = '01-05-2025';
                const terminationUrl = `/api/ap/member/${member.id}/configureMemberTermination?terminationDate=${date}`;

                return this.http.get(environment.apiUrl + terminationUrl, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  },
                });
              }
                else {
                Swal.fire({ title: 'Info', text: noCheckResponse.message });

              }
            }),
            // Step 3: Call tier-change
            switchMap((terminationResponse: any) => {
              if (terminationResponse.status == '200') {

                this.gigterminationRes = terminationResponse.data;
                const plansummarymain = JSON.parse(sessionStorage.getItem("plansummarymain")) || [];

                if (!this.gigterminationRes.plans) {
                  this.gigterminationRes.plans = [];
                }

                if (!this.continueWithExistingPlans && !this.samePlansWithCorporate) {
                  plansummarymain.forEach(source => {
                    this.gigterminationRes.plans.push(source);
                  });
                }

                const tierChangePayload = {
                  corporateDetails: {
                    id: member.brokerId,
                    parentId: member.corporateParentId,
                  },
                  continueWithExistingPlans: false,
                  samePlansWithCorporate: false,
                  provisioning: true,
                  plansDataarray: this.gigterminationRes.plans,
                  data: this.gigterminationRes,
                  newTierId: member.tierId,
                };

                const tierChangeUrl = `/api/ap/admin/customer/${member.id}/tier-change`;

                return this.http.post(environment.apiUrl + tierChangeUrl, tierChangePayload, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  },
                });
              }
              else {
                Swal.fire({ title: 'Info', text: terminationResponse.message });

              }
            }),
            catchError(error => {
              this.handleHttpError(error);
              return of(null); // continue to next member
            })
          );
        }),
        finalize(() => {
          // After all members are processed, delete the tier
          const deleteTierUrl = `/api/ap/admin/corporate/${corporateId}/tier/${this.tierDetails.id}/delete`;
          const requestBody = {
            reason: 'Delete Tier',
            tierName: this.tierDetails.name,
            corporateName: sessionStorage.getItem('corporateClientName'),
            setupTier: formData.tierConfig,
            moveEmployees: true,
            moveEmployeesToTier: this.corporateTiersDeleteList[0].id,
          };

          this.http.post(environment.apiUrl + deleteTierUrl, requestBody, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          }).subscribe({
            next: (response: any) => {
              if (response.status == '200') {
                this.getExistingTiers();
              } else {
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
              }
            },
            error: (error) => {
              this.handleHttpError(error);
            }
          });
        })
      ).subscribe({
        next: (res) => {
          // per-member modal hide or message if needed
          $('#deleteMembers-modal').modal('hide');
        }
      });






  }
  handleHttpError(error: any) {
    if ([400, 401, 402, 403].includes(error.status)) {
      Swal.fire({
        title: this.lang.Error ?? 'Error',
        text: error.error?.error?.message,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed,
      }).then((result) => {
        sessionStorage.clear();
        this.router.navigate(['/login']);
      });
    } else {
      Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error?.error?.message || 'Something went wrong' });
    }
  }
  submitChangetierMembers() {


    console.log(this.tierMembers)

    const customer: any = this.tierMembers.find(
      (detail) => detail.planCheckbox == true
    );

    const memberDetails: any = this.tierMembers.filter(
      (detail) => detail.planCheckbox == true
    );

    let formData = JSON.parse(sessionStorage.getItem('formData') || '');
    var corporateId = sessionStorage.getItem('corporateId');

    var DeleteTiers = `${environment.apiUrl}/api/ap/customer/v3/plans/nochecks`;

    var accessToken = sessionStorage.getItem('accessToken');


    for (let i = 0; i < memberDetails.length; i++) {
      memberDetails[i]['workingProvienceId'] = memberDetails[i].workingProvinceDetails.id


      this.http
        .post(DeleteTiers, memberDetails[i], {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe((response: any) => {
          if (response.status == '200') {




            let accessTokensession = sessionStorage.getItem('accessToken');
            let date = '01-05-2025'
            let gigtermination = `/api/ap/member/${memberDetails[i].id}/configureMemberTermination?terminationDate=${date}`
            let endPoint = '/api/ap/admin/customer/' + memberDetails[i].id + '/tier-change';
            let accessToken = sessionStorage.getItem('accessToken');

            this.http
              .get(environment.apiUrl + gigtermination, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                },
              })
              .subscribe(
                (response: any) => {
                  if (response['status'] == 200) {
                    let plansummarymain = JSON.parse(sessionStorage.getItem("plansummarymain")) || "";



                    this.gigterminationRes = response.data


                    if (this.continueWithExistingPlans == false && this.samePlansWithCorporate == false) {

                      if (!this.gigterminationRes.plans) {
                        this.gigterminationRes.plans = [];
                      }

                      plansummarymain.forEach((source) => {
                        this.gigterminationRes.plans.push(source);
                      });

                    }

                    else if (this.continueWithExistingPlans == false && this.samePlansWithCorporate == true) {

                      if (!this.gigterminationRes.plans) {
                        this.gigterminationRes.plans = [];
                      }


                      // this.gigterminationRes.plans = this.plansDataarray;
                    }
                    else {
                      if (!this.gigterminationRes.plans) {
                        this.gigterminationRes.plans = [];
                      }
                    }

                    let obj = {
                      corporateDetails: { "id": memberDetails[i].brokerId, 'parentId': memberDetails[i].corporateParentId }, //dev/test/prod/dummy
                      continueWithExistingPlans: false,
                      samePlansWithCorporate: false,
                      provisioning: true,
                      plansDataarray: this.gigterminationRes.plans,
                      data: this.gigterminationRes,
                      newTierId: memberDetails[i].tierId
                    }
                    this.http
                      .post(environment.apiUrl + endPoint, obj, {
                        headers: {
                          Authorization: 'Bearer ' + accessToken,
                          'Content-Type': 'application/json',
                        },
                      })
                      .subscribe(
                        (response: any) => {
                          if (response['status'] == 200) {
                            $('#membersList-modal').modal('hide');
                            this.checkMemeberTier = false
                          }
                        })



                  }
                  else {
                    Swal.fire({ title: this.lang.Info, text: response.message || response.data.message })
                  }
                })




          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }, (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        });

    }




  }
  assignAllplanLvelwithdisallowed(plans: any) {
    this.disallowedplans = {};

    plans.forEach((packagelevel: any, index: number) => {
      packagelevel.groups.forEach((groups: any, index1: number) => {
        groups.subGroups.forEach((planlevel: any, index2: number) => {
          console.log(planlevel.id);
          console.log(planlevel.disallowedPlanLevels);

          if (planlevel.disallowedPlanLevels) {
            this.disallowedplans[planlevel.id] =
              planlevel.disallowedPlanLevels.split(',');
          }
        });
      });
    });
  }
  assignAllplanLvelwithdisallowedTiers(plans: any) {
    this.disallowedplansTiers = {};

    plans.forEach((packagelevel: any, index: number) => {
      packagelevel.groups.forEach((groups: any, index1: number) => {
        groups.subGroups.forEach((planlevel: any, index2: number) => {
          console.log(planlevel.id);
          console.log(planlevel.disallowedPlanLevels);

          if (planlevel.disallowedPlanLevels) {
            this.disallowedplansTiers[planlevel.id] =
              planlevel.disallowedPlanLevels.split(',');
          }
        });
      });
    });
  }
  public capitalize(input: any) {
    // if (str) {
    //   return str.charAt(0).toUpperCase() + str.slice(1);
    // }

    // if (str) {
    //   return str.replace(/(?:^|\s)\S/g, function (match) {
    //     return match.toUpperCase();
    //   });
    // }


    if (!input) return ''; // Handle empty string or undefined
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();


  }

  public dummyData() {
    this.showtierbasicplans = true;
    if (this.clientregform.value.tierConfig == true) {
      this.showemptytierconfig = true;
    } else {
      this.showemptytierconfig = false;
    }
    if (this.clientregform.value.walletConfig == false) {
      this.showemptywalletConfig = false;
    } else {
      this.showemptywalletConfig = true;
    }

    // this.headerComponent.headerDetails('login');
    this.basicInfo = false;
    this.plansInfo = true;

    this.plansBlock1 = [
      {
        description: 'Health & Dental Insurance',
        id: 1,
        logo: null,
        name: 'Health & Dental Insurance',
        published: true,
        ordering: 1,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 1,
            name: 'Classic',
            subGroups: [
              {
                backgroundColor: '#b08d57',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 3,
                level: 2,
                name: 'Classic Bronze',
                ordering: 4,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#aaa9ad',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 4,
                level: 2,
                name: 'Classic Silver',
                ordering: 5,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#d4af37',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 5,
                level: 2,
                name: 'Classic Gold',
                ordering: 6,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: 4,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
          {
            id: 6,
            name: 'All-In',
            subGroups: [
              {
                backgroundColor: '#b08d57',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 7,
                level: 2,
                name: 'All-In Bronze',
                ordering: 8,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#aaa9ad',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 8,
                level: 2,
                name: 'All-In Silver',
                ordering: 9,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#d4af37',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 9,
                level: 2,
                name: 'All-In Gold',
                ordering: 10,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
        ],
      },
      {
        description: 'Opt-in plans',
        id: 8,
        logo: null,
        name: 'Opt-in',
        published: true,
        ordering: 2,
        allowMultiple: true,
        applyFilters: true,
        optIn: true,
        groups: [
          {
            id: 16,
            name: 'Opt-In',
            subGroups: [
              {
                backgroundColor: '#4e2a84',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 16,
                level: null,
                name: 'Opt-In',
                ordering: 1,
                parentId: null,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
                plans: [
                  {
                    code: null,
                    corporatePlan: false,
                    cost: 0,
                    description:
                      'YES! I would like to activate PocketPills Digital Pharmacy to get the 10% coinsurance enhancement available in most GroupBenefitz Platform health plans including free shipping. Please share my information with PocketPills to activate my account.',
                    frqMonthly: null,
                    frqYearly: null,
                    fusebillId: null,
                    id: 429,
                    insuranceCompanyId: null,
                    isMonthlyCost: null,
                    logo: null,
                    maxAge: null,
                    minAge: null,
                    name: 'PocketPills Digital Pharmacy - Activate My Account',
                    ordering: 1,
                    packageId: 8,
                    planCoverage: null,
                    planLevel: 16,
                    published: {
                      type: 'Buffer',
                      data: [1],
                    },
                    package_id: 8,
                    plan_level: 16,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        description: 'Mental Health & Wellness',
        id: 2,
        logo: null,
        name: 'Mental Health & Wellbeing',
        published: true,
        ordering: 3,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 14,
            name: 'Wellness',
            subGroups: [
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 19,
                level: 2,
                name: 'EAP 2.0',
                ordering: 18,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 21,
                level: 2,
                name: 'Mind & Body',
                ordering: 19,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 20,
                level: 2,
                name: 'Complete Wellness',
                ordering: 21,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description: 'Catastrophic Medication Insurance',
        id: 3,
        logo: null,
        name: 'Catastrophic Medication Insurance',
        published: true,
        ordering: 4,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 24,
            name: 'Medication',
            subGroups: [
              {
                backgroundColor: '#423894',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 10,
                level: 2,
                name: 'High-Cost Drugs',
                ordering: 12,
                parentId: 24,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description: 'Accident & Serious Illness Disability Insurance',
        id: 4,
        logo: null,
        name: 'Accident & Serious Illness Disability Insurance',
        published: true,
        ordering: 5,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 11,
            name: 'Protect',
            subGroups: [
              {
                backgroundColor: '#354a9f',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 12,
                level: 2,
                name: 'Protect 100',
                ordering: 14,
                parentId: 11,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#354a9f',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 13,
                level: 2,
                name: 'Protect 200',
                ordering: 15,
                parentId: 11,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description:
          'Executive Benefits- Executive Health, Complete Executive Care',
        id: 5,
        logo: null,
        name: 'Executive Benefits',
        published: true,
        ordering: 6,
        allowMultiple: false,
        applyFilters: false,
        optIn: false,
        groups: [
          {
            id: 15,
            name: 'Executive',
            subGroups: [
              {
                backgroundColor: '#5e152e',
                childMaxAge: 24,
                description: null,
                disallowedPlanLevels: null,
                id: 17,
                level: 2,
                name: 'Executive Health',
                ordering: 23,
                parentId: 15,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#5e152e',
                childMaxAge: 24,
                description: null,
                disallowedPlanLevels: null,
                id: 18,
                level: 2,
                name: 'Complete Executive Care',
                ordering: 24,
                parentId: 15,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
        ],
      },
    ];

    this.plansBlock1Tiers = [
      {
        description: 'Health & Dental Insurance',
        id: 1,
        logo: null,
        name: 'Health & Dental Insurance',
        published: true,
        ordering: 1,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 1,
            name: 'Classic',
            subGroups: [
              {
                backgroundColor: '#b08d57',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 3,
                level: 2,
                name: 'Classic Bronze',
                ordering: 4,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#aaa9ad',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 4,
                level: 2,
                name: 'Classic Silver',
                ordering: 5,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#d4af37',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 5,
                level: 2,
                name: 'Classic Gold',
                ordering: 6,
                parentId: 1,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: 4,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
          {
            id: 6,
            name: 'All-In',
            subGroups: [
              {
                backgroundColor: '#b08d57',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 7,
                level: 2,
                name: 'All-In Bronze',
                ordering: 8,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#aaa9ad',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 8,
                level: 2,
                name: 'All-In Silver',
                ordering: 9,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#d4af37',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: '1,10,14',
                id: 9,
                level: 2,
                name: 'All-In Gold',
                ordering: 10,
                parentId: 6,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
        ],
      },
      {
        description: 'Opt-in plans',
        id: 8,
        logo: null,
        name: 'Opt-in',
        published: true,
        ordering: 2,
        allowMultiple: true,
        applyFilters: true,
        optIn: true,
        groups: [
          {
            id: 16,
            name: 'Opt-In',
            subGroups: [
              {
                backgroundColor: '#4e2a84',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 16,
                level: null,
                name: 'Opt-In',
                ordering: 1,
                parentId: null,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
                plans: [
                  {
                    code: null,
                    corporatePlan: false,
                    cost: 0,
                    description:
                      'YES! I would like to activate PocketPills Digital Pharmacy to get the 10% coinsurance enhancement available in most GroupBenefitz Platform health plans including free shipping. Please share my information with PocketPills to activate my account.',
                    frqMonthly: null,
                    frqYearly: null,
                    fusebillId: null,
                    id: 429,
                    insuranceCompanyId: null,
                    isMonthlyCost: null,
                    logo: null,
                    maxAge: null,
                    minAge: null,
                    name: 'PocketPills Digital Pharmacy - Activate My Account',
                    ordering: 1,
                    packageId: 8,
                    planCoverage: null,
                    planLevel: 16,
                    published: {
                      type: 'Buffer',
                      data: [1],
                    },
                    package_id: 8,
                    plan_level: 16,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        description: 'Mental Health & Wellness',
        id: 2,
        logo: null,
        name: 'Mental Health & Wellbeing',
        published: true,
        ordering: 3,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 14,
            name: 'Wellness',
            subGroups: [
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 19,
                level: 2,
                name: 'EAP 2.0',
                ordering: 18,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 21,
                level: 2,
                name: 'Mind & Body',
                ordering: 19,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#694586',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 20,
                level: 2,
                name: 'Complete Wellness',
                ordering: 21,
                parentId: 14,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description: 'Catastrophic Medication Insurance',
        id: 3,
        logo: null,
        name: 'Catastrophic Medication Insurance',
        published: true,
        ordering: 4,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 24,
            name: 'Medication',
            subGroups: [
              {
                backgroundColor: '#423894',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 10,
                level: 2,
                name: 'High-Cost Drugs',
                ordering: 12,
                parentId: 24,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description: 'Accident & Serious Illness Disability Insurance',
        id: 4,
        logo: null,
        name: 'Accident & Serious Illness Disability Insurance',
        published: true,
        ordering: 5,
        allowMultiple: false,
        applyFilters: true,
        optIn: false,
        groups: [
          {
            id: 11,
            name: 'Protect',
            subGroups: [
              {
                backgroundColor: '#354a9f',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 12,
                level: 2,
                name: 'Protect 100',
                ordering: 14,
                parentId: 11,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
              {
                backgroundColor: '#354a9f',
                childMaxAge: 21,
                description: null,
                disallowedPlanLevels: null,
                id: 13,
                level: 2,
                name: 'Protect 200',
                ordering: 15,
                parentId: 11,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'name',
              },
            ],
          },
        ],
      },
      {
        description:
          'Executive Benefits- Executive Health, Complete Executive Care',
        id: 5,
        logo: null,
        name: 'Executive Benefits',
        published: true,
        ordering: 6,
        allowMultiple: false,
        applyFilters: false,
        optIn: false,
        groups: [
          {
            id: 15,
            name: 'Executive',
            subGroups: [
              {
                backgroundColor: '#5e152e',
                childMaxAge: 24,
                description: null,
                disallowedPlanLevels: null,
                id: 17,
                level: 2,
                name: 'Executive Health',
                ordering: 23,
                parentId: 15,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
              {
                backgroundColor: '#5e152e',
                childMaxAge: 24,
                description: null,
                disallowedPlanLevels: null,
                id: 18,
                level: 2,
                name: 'Complete Executive Care',
                ordering: 24,
                parentId: 15,
                published: {
                  type: 'Buffer',
                  data: [1],
                },
                requirePlanLevel: null,
                textColor: '#FFFFFF',
                tooltipTitle: 'plan_coverage',
              },
            ],
          },
        ],
      },
    ];

    this.plansBlock1.forEach((planlevel: any) => {
      planlevel.groups.forEach((groups: any) => {
        groups.subGroups.forEach((subgroup: any) => {
          subgroup.tiers = [];
          subgroup.checked = false;
          subgroup.coverage = ''; //default
        });
      });
    });
    this.plansBlock1Tiers.forEach((planlevel: any) => {
      this.selectedPackagePlansInfoTier[planlevel.id] = [];
      this.selectedPackagePlansInfoTiername[planlevel.id] = planlevel.name;
      this.selectedPackagePlansInfoTierBlock2[planlevel.id] = [];
      this.selectedPackagePlansInfoTiernameBlock2[planlevel.id] =
        planlevel.name;
      this.selectedPackagePlansInfoTierBlock3[planlevel.id] = [];
      this.selectedPackagePlansInfoTiernameBlock3[planlevel.id] =
        planlevel.name;

      this.selectedPackagesavailableTiers2[planlevel.id] = {};
      this.selectedPackagesassignedTiers2[planlevel.id] = {};
      this.selectedPackagesavailableTiers2Block2[planlevel.id] = {};
      this.selectedPackagesassignedTiers2Block2[planlevel.id] = {};

      this.selectedPackagesavailableTiers3[planlevel.id] = {};
      this.selectedPackagesassignedTiers3[planlevel.id] = {};
      this.selectedPackagesavailableTiers3Block3[planlevel.id] = {};
      this.selectedPackagesassignedTiers3Block3[planlevel.id] = {};
      planlevel.groups.forEach((groups: any) => {
        groups.subGroups.forEach((subgroup: any) => {
          this.selectedPackagesavailableTiers2[planlevel.id][subgroup.id] =
            null;
          this.selectedPackagesassignedTiers2[planlevel.id][subgroup.id] = [];
          this.selectedPackagesavailableTiers2Block2[planlevel.id][
            subgroup.id
          ] = null;
          this.selectedPackagesassignedTiers2Block2[planlevel.id][subgroup.id] =
            [];

          this.selectedPackagesavailableTiers3[planlevel.id][subgroup.id] =
            null;
          this.selectedPackagesassignedTiers3[planlevel.id][subgroup.id] = [];
          this.selectedPackagesavailableTiers3Block3[planlevel.id][
            subgroup.id
          ] = null;
          this.selectedPackagesassignedTiers3Block3[planlevel.id][subgroup.id] =
            [];
          subgroup.tiers = [];
          subgroup.checked = false;
          subgroup.coverage = ''; //default
        });
      });
    });

    sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));
    sessionStorage.setItem(
      'plansBlock1Tiers',
      JSON.stringify(this.plansBlock1Tiers)
    );
    this.assignAllplanLvelwithdisallowed(this.plansBlock1);
    const dom: HTMLElement = this.elementRef.nativeElement;
    const element: any = dom.querySelector('#plancheck' + 16);
    element.click();

    setTimeout(() => {
      this.plansBlock1.forEach((element: any, index: number) => {
        if (element.id != 1) {
          const element1: any = dom.querySelector(
            '#plancheckcollapseone' + element.id
          );
          element1.click();
        } else {
          element.groups.forEach((groups: any, index1: number) => {
            const element1: any = dom.querySelector(
              '#plancheckcollapseone' + groups.id
            );
            console.log(element1);
          });
        }
      });
    }, 10);
  }
  public plansButtonDisable = false;

  showPackageName(groups, category) {
    // if (category == 'upgrade') console.log(groups[0].name)
    // return
    // console.log(category)

    for (let grp of groups) {
      if (!grp || grp?.length <= 0) return false
      if (!grp || !grp?.subGroups || grp?.subGroups?.length <= 0) return false
      for (let sub of grp?.subGroups) {
        // if (category == 'upgrade') console.log(groups[0].name, sub)

        if (sub != null) {
          if (sub && sub?.settings) {
            if (sub?.settings[category]) {
              // if (category == 'upgrade') console.log(sub.settings[category])
              return true
            }
          }
        }
      }
    }


    return false
  }
  showPackageName1(groups, category) {
    // if (category == 'upgrade') console.log(groups[0].name)
    // return
    console.log("upgrade" + category)
    if (!groups || groups?.length <= 0) return false
    if (!groups[0] || !groups[0]?.subGroups || groups[0]?.subGroups?.length <= 0) return false
    for (let sub of groups[0]?.subGroups) {
      // if (category == 'upgrade') console.log(groups[0].name, sub)
      console.log(sub)
      if (sub && sub?.settings) {
        if (sub?.settings[category]) {
          // if (category == 'upgrade') console.log(sub.settings[category])
          return true
        }
      }
    }
    return false
  }

  public addNewTier() {
    // Clear WSA-related options
this.wsaOptions = {};
this.wsaSelected = {};
this.allowCarryOver1 = '';
this.maxCarryOverLimit = '';
this.maxCarryOverAmount = null;
this.selectedGracePeriodKey = '';
this.wsaReimbursementFreeze = 'No';
this.freezeStartDate = '';
this.categorySelection = {};
this.subCategorySelection = {};

// Also optionally clear from session storage if used
sessionStorage.removeItem('wsaOptions');

    this.balkPlans = []
    this.plansBlock1 = []
    this.submitbasicInfoCheck()
    this.isAddTier = true;
    this.showAddTier = false;
    this.showEditTier = false;

    // $('#addTierandWalletConfig-modal').modal('show');
    this.addTierForm.reset()
    this.addWalletForm.reset()


    sessionStorage.setItem('summaryBlock1', '[]');
    sessionStorage.setItem('summaryBlockBulk', '[]');

    sessionStorage.setItem('walletConfig', '{}');
    // sessionStorage.setItem('selectedPlans', '{}');
    sessionStorage.setItem('summaryBlock1main', '[]');
    sessionStorage.setItem('summaryBlock1opt', '[]');
    // sessionStorage.setItem('selectedBlock1', '{}');
    sessionStorage.setItem('summaryBlock2', '[]');

    // sessionStorage.setItem('summaryBlock2main', '[]');
    sessionStorage.setItem('summaryBlock2opt', '[]');
    // sessionStorage.setItem('selectedBlock2', '{}');

    sessionStorage.setItem('summaryBlock3', '[]');

    sessionStorage.setItem('summaryBlock3main', '[]');
    sessionStorage.setItem('summaryBlock3opt', '[]');
    // showTierConfig = false;
    // showWalletConfig = false;
    this.showTiersTable = false
    this.plansInfo = true
    if (this.clientregform.value.walletConfig == true && this.clientregform.value.tierConfig == true) {
      this.showTierConfig = true
      this.showWalletConfig = true
    }
    else if (this.clientregform.value.tierConfig == true) {
      this.showTierConfig = true
      this.showWalletConfig = false

      Object.keys(this.addWalletForm.controls).forEach(key => {
        this.addWalletForm.controls[key].clearValidators();
        this.addWalletForm.controls[key].updateValueAndValidity();
      });
      //  Object.keys(this.addTierForm.controls).forEach(key => {
      //    this.addTierForm.controls[key].setValidators([Validators.required]); // Add required validator
      //    this.addTierForm.controls[key].updateValueAndValidity();
      //  });
    }
    else if (this.clientregform.value.walletConfig == true) {
      this.showTierConfig = false
      this.showWalletConfig = true

      Object.keys(this.addTierForm.controls).forEach(key => {
        this.addTierForm.controls[key].clearValidators();
        this.addTierForm.controls[key].updateValueAndValidity();
      });
    }
    else {
      this.showTierConfig = false
      this.showWalletConfig = false
    }

  }
  public addNewTier12() {

    this.addTierForm.reset()
    this.addWalletForm.reset()
    sessionStorage.setItem('summaryBlock1', '[]');
    sessionStorage.setItem('summaryBlockBulk', '[]');


    sessionStorage.setItem('walletConfig', '{}');
    // sessionStorage.setItem('selectedPlans', '{}');
    sessionStorage.setItem('summaryBlock1main', '[]');
    sessionStorage.setItem('summaryBlock1opt', '[]');
    // sessionStorage.setItem('selectedBlock1', '{}');
    sessionStorage.setItem('summaryBlock2', '[]');

    // sessionStorage.setItem('summaryBlock2main', '[]');
    sessionStorage.setItem('summaryBlock2opt', '[]');
    // sessionStorage.setItem('selectedBlock2', '{}');

    sessionStorage.setItem('summaryBlock3', '[]');

    sessionStorage.setItem('summaryBlock3main', '[]');
    sessionStorage.setItem('summaryBlock3opt', '[]');
    // showTierConfig = false;
    // showWalletConfig = false;
    this.showTiersTable = false
    this.plansInfo = true
    if (this.clientregform.value.walletConfig == true && this.clientregform.value.tierConfig == true) {
      this.showTierConfig = true
      this.showWalletConfig = true
    }
    else if (this.clientregform.value.tierConfig == true) {
      this.showTierConfig = true
      this.showWalletConfig = false

      Object.keys(this.addWalletForm.controls).forEach(key => {
        this.addWalletForm.controls[key].clearValidators();
        this.addWalletForm.controls[key].updateValueAndValidity();
      });
      //  Object.keys(this.addTierForm.controls).forEach(key => {
      //    this.addTierForm.controls[key].setValidators([Validators.required]); // Add required validator
      //    this.addTierForm.controls[key].updateValueAndValidity();
      //  });
    }
    else if (this.clientregform.value.walletConfig == true) {
      this.showTierConfig = false
      this.showWalletConfig = true

      Object.keys(this.addTierForm.controls).forEach(key => {
        this.addTierForm.controls[key].clearValidators();
        this.addTierForm.controls[key].updateValueAndValidity();
      });
    }
    else {
      this.showTierConfig = false
      this.showWalletConfig = false
    }
  }
  public maxServiceCheck(event: any) {
    console.log(event.target.value)
    if (this.addTierForm.value.mintierTimeOfService) {
      if (this.addTierForm.value.mintierTimeOfService < this.addTierForm.value.maxtierTimeOfService) {

      }
      else {
        Swal.fire({ title: 'Info', text: 'Min Length of Service must be greater than Max Length of Service ' });
        this.addTierForm.get('mintierTimeOfService').reset()
        this.addTierForm.get('maxtierTimeOfService').reset();
      }
    }
  }
  public minServiceCheck(event: any) {
    console.log(event.target.value)
    if (this.addTierForm.value.maxtierTimeOfService) {
      if (this.addTierForm.value.mintierTimeOfService < this.addTierForm.value.maxtierTimeOfService) {

      }
      else {
        Swal.fire({ title: 'Info', text: 'Min Length of Service must be greater than Max Length of Service ' });
        this.addTierForm.get('mintierTimeOfService').reset()
        this.addTierForm.get('maxtierTimeOfService').reset();
      }
    }
  }

  public tiersServiceCheck(event: any) {

    console.log(event.target.value)

    if (event.target.value == 'true') {

      this.addTierForm.get('mintierTimeOfService').setValidators(Validators.required);
      this.addTierForm.get('maxtierTimeOfService').setValidators(Validators.required);
      this.addTierForm.get('mintierTimeOfService').updateValueAndValidity();
      this.addTierForm.get('maxtierTimeOfService').updateValueAndValidity();

    }
    else {
      this.addTierForm.get('mintierTimeOfService').reset()
      this.addTierForm.get('maxtierTimeOfService').reset();

      this.addTierForm.get('mintierTimeOfService').clearValidators();
      this.addTierForm.get('maxtierTimeOfService').clearValidators();

      this.addTierForm.get('mintierTimeOfService').updateValueAndValidity();
      this.addTierForm.get('maxtierTimeOfService').updateValueAndValidity();
    }

  }

  public checkAllocationTier(event: any) {

    console.log(event.target.value)

    // if (event.target.value == 'true') {

    //   this.addTierForm.get('allocation').setValidators(Validators.required);

    //   this.addTierForm.get('allocation').updateValueAndValidity();

    // }
    // else {
    //   this.addWalletForm.get('allocation').reset()

    //   this.addWalletForm.get('allocation').clearValidators();


    //   this.addWalletForm.get('allocation').updateValueAndValidity();
    // }

  }
  checkwalletConfig(event: any) {
    // if (this.clientregform.get('walletConfig')?.value === true) {



    //   this.clientregform.get('bankCode').reset();
    //   this.clientregform.get('bankCode').clearValidators();

    //   this.clientregform.get('BankTransit').reset();
    //   this.clientregform.get('BankTransit').clearValidators();

    //   this.clientregform.get('accounNum').reset();
    //   this.clientregform.get('accounNum').clearValidators();
    //   this.clientregform.get('bankCode').updateValueAndValidity();
    //   this.clientregform.get('BankTransit').updateValueAndValidity();
    //   this.clientregform.get('accounNum').updateValueAndValidity();
    // } else {
    //   this.clientregform.get('bankCode').setValidators(Validators.required);
    //   this.clientregform.get('BankTransit').setValidators(Validators.required);
    //   this.clientregform.get('accounNum').setValidators(Validators.required);

    //   this.clientregform.get('bankCode').updateValueAndValidity();
    //   this.clientregform.get('BankTransit').updateValueAndValidity();
    //   this.clientregform.get('accounNum').updateValueAndValidity();

    // }
  }

  copyToClipboard(link) {

    // const text = this.generateInviteLinkCopy.nativeElement.innerText;
    const text = link;

    const button = document.getElementById("copyButton") as HTMLButtonElement;
    if (button) {
      button.disabled = true;
      button.style.color = 'white';
      setTimeout(() => {
        button.disabled = false;
      }, 1000);
    }

    const clipboard = new ClipboardJS('#copyButton', {
      text: () => text
    });

    clipboard.on('success', (e) => {
      this.logger.log(`Text "${text}" was copied to the clipboard`);
      e.clearSelection();
    });

    clipboard.on(this.lang.Error ?? 'Error', (e) => {
      console.error('Unable to copy text to clipboard', e);
    });



    Swal.fire({
      text: 'Link Copied',
      // icon: 'info',
      timer: 1500, // Set the timer to 3000 milliseconds (3 seconds)
      showConfirmButton: false, // Hide the "OK" button
      width: 270
    });


  }
  public showHistory(tier: any) {
    $('#historyInvoice-modal').modal('show');

    var tiersHistory =
      `/api/ap/get-history/tiers/${tier.id}`;
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(environment.apiUrl + tiersHistory, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response.status == '200') {
          this.historyDetails = response.data
        } else {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
        }
      }, (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: this.lang.Error ?? 'Error',
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: this.lang.Proceed,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      });
  }

  public showTierMember(tier: any) {


    if (tier.memberCount > 0) {
      $('#membersList-modal').modal('show');
    }
    var corporateId = sessionStorage.getItem('corporateId');

    var accessToken = sessionStorage.getItem('accessToken');
    var getMembersList = `/api/ap/admin/corporate/${corporateId}/tier/${tier.id}/members`;

    this.http
      .get(environment.apiUrl + getMembersList, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response.status == '200') {
          this.tierMembers = response.data.members
          this.checkMemeberTier = true
        } else {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
        }
      }, (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: this.lang.Error ?? 'Error',
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: this.lang.Proceed,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      });

  }
  public editTierDetails() {

    if (this.addTierForm.invalid) {
      this.addTierForm.markAllAsTouched();
      return;
    }

    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/tiers';
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    let tiersObj = {
      name: this.addTierForm.value.tierName,
      description: this.addTierForm.value.tierDescription,
      effectiveDate: this.datePipe.transform(this.addTierForm.value.tierEffectiveDate, 'yyyy-MM-dd') || '',
      timeOfService: JSON.parse(this.addTierForm.value.tierTimeOfService),
      timeOfServiceValue: 'Years',
      minimumTimeOfSerivce: +this.addTierForm.value.mintierTimeOfService || 0,
      maximumTimeOfService: +this.addTierForm.value.maxtierTimeOfService || 0,
      wawanesaApplicable: false,
      tierId: this.tierDetails.id
    }

    this.http
      .put(environment.apiUrl + endPoint, tiersObj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            Swal.fire({ title: 'Info', text: response.message });

          }
        })

  }
  public editTierDetails12() {


    if (this.addTierForm.invalid) {
      this.addTierForm.markAllAsTouched();
      return;
    }
    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/tiers';
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    let tiersObj = {
      name: this.addTierForm.value.tierName,
      description: this.addTierForm.value.tierDescription,
      effectiveDate: this.datePipe.transform(this.addTierForm.value.tierEffectiveDate, 'yyyy-MM-dd') || '',
      timeOfService: JSON.parse(this.addTierForm.value.tierTimeOfService),
      timeOfServiceValue: 'Years',
      minimumTimeOfSerivce: +this.addTierForm.value.mintierTimeOfService || 0,
      maximumTimeOfService: +this.addTierForm.value.maxtierTimeOfService || 0,
      wawanesaApplicable: false,
      tierId: this.tierDetails.id
    }

    this.http
      .put(environment.apiUrl + endPoint, tiersObj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            Swal.fire({ title: 'Info', text: response.message });

          }
        })

  }

  public editWalletDetails() {

    if (this.addWalletForm.invalid) {
      this.addWalletForm.markAllAsTouched();
      return;
    }

    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');
    var walletendPoint = '/api/ap/admin/corporate/' + corporateId + '/tier';
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');
    let amount = this.addWalletForm.value?.walletAmount;
    amount = amount.toString();
    if (amount.includes(',')) {
      amount = parseFloat(amount.replace(/,/g, '')); // Remove commas and parse
    } else {
      amount = parseFloat(amount); // Parse normally
    }
    let walletObj = {
      walletType: this.addWalletForm.value.walletType,
      walletAmount: amount,
      effectiveDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd') || '',
      coveragePercentage: +this.addWalletForm.value.coveragePerecentage,
      industryCategory: "Accounting Services",
      carryForwardUnusedAmount: JSON.parse(this.addWalletForm.value.carryForwordAmount),
      rolloverAllocationPeriod: this.addWalletForm.value.allocation,
      initialBalanceSetup: this.addWalletForm.value.intialBalanceSetup,
      advisorFeeStructure: 12,
    };


    if (walletObj.walletType == 'MYWSA') {
      walletObj['wsaOptions']= this.wsaOptions
    }
   console.log('walletObj',walletObj);

    

    if (this.tierDetails?.walletConfig?.id) {
      walletObj['walletId'] = this.tierDetails.walletConfig.id
      this.http
        .put(environment.apiUrl + walletendPoint + "/" + this.crateTierid + "/wallet/edit", walletObj, {

          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              Swal.fire({ title: 'Info', text: response.message });
            }
          })
    }

    else {
      this.http
        .post(environment.apiUrl + walletendPoint + "/" + this.crateTierid + "/wallet", walletObj, {

          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              Swal.fire({ title: 'Info', text: response.message });
            }
          })

    }




  }

  public editWalletDetails12() {
    if (this.addWalletForm.invalid) {
      this.addWalletForm.markAllAsTouched();
      return;
    }

    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');
    var walletendPoint = '/api/ap/admin/corporate/' + corporateId + '/tier';
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    let walletObj = {
      walletType: this.addWalletForm.value.walletType,
      walletAmount: parseFloat(this.addWalletForm.value?.walletAmount?.replace(/,/g, '')),
      effectiveDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd') || '',
      coveragePercentage: +this.addWalletForm.value.coveragePerecentage,
      industryCategory: "Accounting Services",
      carryForwardUnusedAmount: JSON.parse(this.addWalletForm.value.carryForwordAmount),
      rolloverAllocationPeriod: this.addWalletForm.value.allocation,
      initialBalanceSetup: this.addWalletForm.value.intialBalanceSetup,
      advisorFeeStructure: 12,

      // walletId: this.tierDetails.walletConfig ? this.tierDetails.walletConfig.id:0

    }
    if (this.tierDetails?.walletConfig?.id) {
      walletObj['walletId'] = this.tierDetails.walletConfig.id
      this.http
        .put(environment.apiUrl + walletendPoint + "/" + this.crateTierid + "/wallet", walletObj, {

          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              Swal.fire({ title: 'Info', text: response.message });
            }
          })
    }

    else {
      this.http
        .post(environment.apiUrl + walletendPoint + "/" + this.crateTierid + "/wallet", walletObj, {

          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        })
        .subscribe(
          (response: any) => {
            if (response['status'] == 200) {
              Swal.fire({ title: 'Info', text: response.message });
            }
          })

    }




  }
  onWalletTypeClick(item): void{
    console.log('Wallet Type clicked:', item.walletConfig.walletType);
    console.log('ok');

  }

  public touchedmsg() {
    // this.invalidbankdetails = false;
    // this.bankerrormsg = ''
    // if (
    //   this.bankpayForm.controls['banknumber'].value?.length == 3 &&
    //   this.bankpayForm.controls['transitnumber'].value?.length == 5 &&
    //   (this.bankpayForm.controls['accountnumber'].value?.length ?? 0) >= 5
    // ) {
    //   this.verifybankdetails = true;
    //   this.verifybutton = true;
    // } else {
    //   this.verifybankdetails = false;
    //   this.verifybutton = false;
    // }
  }

  public submitBankInfo() {

    var accessToken = sessionStorage.getItem('accessToken');


    let obj = {
      "bankCode": this.bankingInfoForm.value.bankCode,
      "branchCode": this.bankingInfoForm.value.BankTransit
    }
    var getBankList = `/api/ap/admin/bank/verify`;

    this.http
      .post(environment.apiUrl + getBankList, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response.status == '200') {
          Swal.fire({ title: this.lang.Info, text: response.message })

          if (this.clientregform.value.walletConfig) {

            var accessToken = sessionStorage.getItem('accessToken');
            var corporateId = sessionStorage.getItem('corporateId');

            let obj = {
              "industryCategory": this.bankingInfoForm.value.bankindustryCategory,
              "advisorCommission": Number(this.bankingInfoForm.value.bankadvsiorFee ?? 0),
              "myhsaBankingDetails": {
                "bankCode": this.bankingInfoForm.value.bankCode,
                "branchCode": this.bankingInfoForm.value.BankTransit,
                "accountNumber": this.bankingInfoForm.value.accounNum
              }
            }
            var getBankList = `/api/ap/admin/corporate/${corporateId}/myhsaFields`;

            this.http
              .post(environment.apiUrl + getBankList, obj, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                },
              })
              .subscribe((response: any) => {
                if (response.status == '200') {
                  // Swal.fire({ title: this.lang.Info, text: response.message })

                } else {
                  Swal.fire({ title: this.lang.Info ?? 'Info', text: response.message });
                }
              }, (error) => {
                if (
                  error.status == 400 ||
                  error.status == 401 ||
                  error.status == 402 ||
                  error.status == 403
                ) {
                  Swal.fire({
                    title: this.lang.Info ?? 'Info',
                    text: error.error.error.message,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: this.lang.Proceed,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    }
                    else {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    }
                  });
                } else {
                  // Swal.fire(error.error.error.message)
                  Swal.fire({ title: this.lang.Info ?? 'Info', text: error.error.error.message });
                }
                // this.toastrService.error("Invalid Credentials", 'Error!');
              });
          }

        } else {
          Swal.fire({ title: this.lang.Info ?? 'Info', text: response.message });
        }
      }, (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: this.lang.Info ?? 'Info',
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: this.lang.Proceed,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: this.lang.Info ?? 'Error', text: error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      });
  }
  public submitBankInfo12() {

    var accessToken = sessionStorage.getItem('accessToken');

    let obj = {
      "bankCode": this.bankingInfoForm.value.bankCode,
      "branchCode": this.bankingInfoForm.value.BankTransit
    }
    var getBankList = `/api/ap/admin/bank/verify`;

    this.http
      .post(environment.apiUrl + getBankList, obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response.status == '200') {
          Swal.fire({ title: this.lang.Info, text: response.message })

        } else {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
        }
      }, (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: this.lang.Error ?? 'Error',
            text: error.message,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: this.lang.Proceed,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // console.log(error)
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      });
  }
  // formatAmount() {
  //   if (this.walletAmount) {
  //     this.walletAmount = this.walletAmount?.replace(/,/g, ''); // Remove existing commas
  //     this.walletAmount = parseFloat(this.walletAmount).toLocaleString('en-US'); // Format with commas
  //   }
  // }
  formatAmount() {
  if (this.walletAmount != null && this.walletAmount !== '') {
    const rawAmount = this.walletAmount.toString().replace(/,/g, ''); // Ensure it's a string and remove commas
    const numericAmount = parseFloat(rawAmount);

    // Only format if it's a valid number
    if (!isNaN(numericAmount)) {
      this.walletAmount = numericAmount.toLocaleString('en-US'); // Add commas
    } else {
      this.walletAmount = '';
    }
  }
}




  // public clearIfStartsWithZero() {
  //   if (this.clientregform.get('walletAmount').value.startsWith('0')) {
  //     this.clientregform.get('walletAmount').reset();
  //   }
  // }

  public checkAllocation(event: any) {

    const walletAmount = parseInt(this.addWalletForm.get('walletAmount')?.value?.replace(/,/g, ""), 10)

    console.log(walletAmount)
    if (event.target.value == 'Monthly') {
      if (walletAmount % 12 === 0) {

      }
      else {
        const walletAmountData: any = (walletAmount / 12)
        console.log(walletAmountData)

        let roundedNum = Math.ceil(walletAmountData * 10) / 10;
        console.log(roundedNum.toFixed(2)); // Output: 83.4

        let finalAmount: any = roundedNum.toFixed(2)
        // const amount = Number((finalAmount * 12).toFixed(2));;
        // this.walletAmount = amount.toLocaleString("en-US");
        const amount = (finalAmount * 12).toFixed(2); // Keep it as a string
        this.walletAmount = Number(amount).toLocaleString("en-US", { minimumFractionDigits: 2 });

      }

    }



  }
  public checkAdvisorCommision() {
    const walletAdvisorFeeControl = this.addWalletForm.get('advsiorFee').value;

    console.log(walletAdvisorFeeControl)

    if (walletAdvisorFeeControl > 15) {
      this.addWalletForm.get('advsiorFee').reset();
    }
    if (this.walletAdvsiorFeeStructure > 15) {
      this.walletAdvsiorFeeStructure = 15
    }
    if (this.walletAdvsiorFeeStructure < 0) {
      this.walletAdvsiorFeeStructure = 0
    }
  }
  public clearIfStartsWithZero() {
    const walletAmountControl = this.addWalletForm.get('walletAmount').value;

    console.log(walletAmountControl)
    const value = walletAmountControl?.toString(); // Ensure value is a string

    if (value && value.startsWith('0')) {
      this.addWalletForm.get('walletAmount').reset();
    }
  }

  public editTier(tier) {
    //     alert("!")
    this.balkPlans = []
    this.plansBlock1 = []
    this.submitbasicInfoCheck()
    this.isAddTier = false;
    this.showAddTier = false;
    this.showEditTier = false;

    // alert("!")
    //     return false
    sessionStorage.setItem('summaryBlock1', '[]');
    sessionStorage.setItem('summaryBlockBulk', '[]');

    sessionStorage.setItem('walletConfig', '{}');
    // sessionStorage.setItem('selectedPlans', '{}');
    sessionStorage.setItem('summaryBlock1main', '[]');
    sessionStorage.setItem('summaryBlock1opt', '[]');
    // sessionStorage.setItem('selectedBlock1', '{}');
    sessionStorage.setItem('summaryBlock2', '[]');

    // sessionStorage.setItem('summaryBlock2main', '[]');
    sessionStorage.setItem('summaryBlock2opt', '[]');
    // sessionStorage.setItem('selectedBlock2', '{}');

    sessionStorage.setItem('summaryBlock3', '[]');

    sessionStorage.setItem('summaryBlock3main', '[]');
    sessionStorage.setItem('summaryBlock3opt', '[]');
    $('#EditTierandWalletConfig-modal').modal('show');

    this.tierDetails = tier
    this.crateTierid = tier.id
    sessionStorage.setItem('createId', this.crateTierid);
    console.log(tier)

    // showTierConfig = false;
    // showWalletConfig = false;
    // this.showTiersTable = false
    // this.plansInfo = true
    if (this.clientregform.value.walletConfig == true && this.clientregform.value.tierConfig == true) {
      this.showTierConfig = true
      this.showWalletConfig = true
    }
    else if (this.clientregform.value.tierConfig == true) {
      this.showTierConfig = true
      this.showWalletConfig = false

      Object.keys(this.addWalletForm.controls).forEach(key => {
        this.addWalletForm.controls[key].clearValidators();
        this.addWalletForm.controls[key].updateValueAndValidity();
      });
      //  Object.keys(this.addTierForm.controls).forEach(key => {
      //    this.addTierForm.controls[key].setValidators([Validators.required]); // Add required validator
      //    this.addTierForm.controls[key].updateValueAndValidity();
      //  });
    }
    else if (this.clientregform.value.walletConfig == true) {
      this.showTierConfig = false
      this.showWalletConfig = true

      Object.keys(this.addTierForm.controls).forEach(key => {
        this.addTierForm.controls[key].clearValidators();
        this.addTierForm.controls[key].updateValueAndValidity();
      });
    }
    else {
      this.showTierConfig = false
      this.showWalletConfig = false
    }

    this.tierName = tier?.name
    this.tierDescription = tier?.description
    this.tierStatus = tier?.status
    this.tierEffectiveDate =
      new Date(tier?.effectiveDate).toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }).replace(",", "").split(" ").join("-");
    this.tierTimeofService = tier?.timeOfService
    this.tierMinTimeofService = tier?.minimumTimeOfSerivce
    this.tierMaxTimeofService = tier?.maximumTimeOfService
    this.walletAmount = tier?.walletConfig?.walletAmount
    console.log('walletAmount',this.walletAmount);
    this.walletCarryForwordAmount = tier?.walletConfig?.carryForwardUnusedAmount
    console.log("walletCarryForwordAmount",this.walletCarryForwordAmount)
    this.walletAllocation = tier?.walletConfig?.rolloverAllocationPeriod
    // this.walletIndustryCategory = tier?.walletConfig?.industryCategory
    this.walletIntialBalanceSetup = tier?.walletConfig?.initialBalanceSetup
    // this.walletAdvsiorFeeStructure = tier?.walletConfig?.advisorFeeStructure
    this.walletCoveragePercentage = tier?.walletConfig?.coveragePercentage
    this.walletType = tier?.walletConfig?.walletType
    if(this.walletType = 'MYWSA'){
      this.wsaSelected=tier?.walletConfig?.wsaOptions;
    }else{
      this.wsaSelected={};
    }
    console.log('wsaSelected',this.wsaSelected);


    if (this.tierTimeofService == true) {
      this.showTierlist = true
      this.addTierForm.get('tierTimeOfService')?.setValue(true);
    }
    else {
      this.showTierlist = false
    }

    setTimeout(() => {
      return new Promise((resolve, reject) => {
        // First block of code
        console.log("Executing block 1");

        console.log(this.bulkplans)


        if (tier.plans?.paidByCompany?.length > 0 || tier.plans?.coveredByCompany?.length > 0 || tier.plans?.paidByEmployee?.length > 0) {

          for (let i = 0; i < tier.plans?.paidByCompany?.length; i++) {
            setTimeout(() => {
              let selectedCoverage = tier.plans.paidByCompany[i].companyPaidCoverage ?? "DIRECT"
              if (selectedCoverage == "null") {
                selectedCoverage = "DIRECT"
              }


              // console.log(this.capitalize(selectedCoverage))
              this.getPlanCoverage[tier.plans.paidByCompany[i].planLevelId] = selectedCoverage
              const element: any = $("#plancheck" + tier.plans.paidByCompany[i].planLevelId);
              console.log(element)
              if (element != null)
                element.click()
              console.log(`Block 1 - Task ${i + 1} completed`);
              console.log(i)
              console.log(tier.plans?.paidByCompany?.length - 1)
              if (i === tier.plans?.paidByCompany?.length - 1) {
                // Second block of code

                console.log("Executing block 2");


                setTimeout(() => {
                  if (tier.plans?.coveredByCompany?.length > 0) {
                    console.log("cehckheree")
                    let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
                    if (el1 != null) el1.click();
                    this.upgradeplansselection == true;

                    for (let j = 0; j < tier.plans?.coveredByCompany?.length; j++) {
                      setTimeout(() => {
                        const element: any = $("#plancheck2Upgrade" + tier.plans.coveredByCompany[j].planLevelId);
                        if (element != null) element.click();


                        if (j === tier.plans?.coveredByCompany?.length - 1) {
                          // Third block of code
                          console.log("Executing block 3");

                          setTimeout(() => {
                            if (tier.plans?.paidByEmployee?.length > 0) {
                              let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                              if (el1 != null) el1.click();
                              this.employeeplanpurchase == true
                              for (let k = 0; k < tier.plans?.paidByEmployee?.length; k++) {
                                setTimeout(() => {
                                  const element: any = $("#plancheck3Voluntry" + tier.plans.paidByEmployee[k].planLevelId);
                                  element.click()
                                  console.log(`Block 3 - Task ${k + 1} completed`);
                                  if (k === tier.plans?.paidByEmployee?.length - 1) {
                                    resolve("All blocks executed successfully");
                                  }
                                }, 1500);
                              }
                            }
                          }, 1000);

                        }
                      }, 1000);
                    }
                  }
                  if (tier.plans?.coveredByCompany?.length == 0 && tier.plans?.paidByEmployee?.length > 0) {
                    let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                    if (el1 != null) el1.click();
                    this.employeeplanpurchase == true
                    for (let k = 0; k < tier.plans?.paidByEmployee?.length; k++) {
                      setTimeout(() => {
                        const element: any = $("#plancheck3Voluntry" + tier.plans.paidByEmployee[k].planLevelId);
                        element.click()
                        console.log(`Block 3 - Task ${k + 1} completed`);
                        if (k === tier.plans?.paidByEmployee?.length - 1) {
                          resolve("All blocks executed successfully");
                        }
                      }, 1500);
                    }
                  }
                }, 2000);





              }
            }, 1000);
          }
        }

        setTimeout(() => {
          let block1 = JSON.parse(
            sessionStorage.getItem('summaryBlock1') || '[]'
          );
          for (let i = 0; i < tier.plans?.paidByCompany?.length; i++) {
            for (let z = 0; z < block1.length; z++) {

              if (block1[z].subGroupId == tier.plans.paidByCompany[i].planLevelId) {
                block1[z].id = tier.plans.paidByCompany[i].id
              }
            }
          }
          sessionStorage.setItem('summaryBlock1', JSON.stringify(block1))

          let block2 = JSON.parse(
            sessionStorage.getItem('summaryBlock2') || '[]'
          );
          console.log(tier.plans.coveredByCompany)
          for (let i = 0; i < tier.plans?.coveredByCompany?.length; i++) {
            for (let z = 0; z < block2.length; z++) {

              if (block2[z].subGroupId == tier.plans.coveredByCompany[i].planLevelId) {
                block2[z].id = tier.plans.coveredByCompany[i].id
              }
            }
          }
          console.log({ block2 })
          sessionStorage.setItem('summaryBlock2', JSON.stringify(block2))

          let block3 = JSON.parse(
            sessionStorage.getItem('summaryBlock3') || '[]'
          );
          for (let i = 0; i < tier.plans?.paidByEmployee?.length; i++) {
            for (let z = 0; z < block3.length; z++) {

              if (block3[z].subGroupId == tier.plans.paidByEmployee[i].planLevelId) {
                block3[z].id = tier.plans.paidByEmployee[i].id
              }
            }
          }
          sessionStorage.setItem('summaryBlock3', JSON.stringify(block3))
        }, 10000)


      })
    }, 3000);




  }
  public editTier12(tier) {

    $('#EditTierandWalletConfig-modal').modal('show');

    this.tierDetails = tier
    this.crateTierid = tier.id

    console.log(tier)

    // showTierConfig = false;
    // showWalletConfig = false;
    // this.showTiersTable = false
    // this.plansInfo = true
    if (this.clientregform.value.walletConfig == true && this.clientregform.value.tierConfig == true) {
      this.showTierConfig = true
      this.showWalletConfig = true
    }
    else if (this.clientregform.value.tierConfig == true) {
      this.showTierConfig = true
      this.showWalletConfig = false

      Object.keys(this.addWalletForm.controls).forEach(key => {
        this.addWalletForm.controls[key].clearValidators();
        this.addWalletForm.controls[key].updateValueAndValidity();
      });
      //  Object.keys(this.addTierForm.controls).forEach(key => {
      //    this.addTierForm.controls[key].setValidators([Validators.required]); // Add required validator
      //    this.addTierForm.controls[key].updateValueAndValidity();
      //  });
    }
    else if (this.clientregform.value.walletConfig == true) {
      this.showTierConfig = false
      this.showWalletConfig = true

      Object.keys(this.addTierForm.controls).forEach(key => {
        this.addTierForm.controls[key].clearValidators();
        this.addTierForm.controls[key].updateValueAndValidity();
      });
    }
    else {
      this.showTierConfig = false
      this.showWalletConfig = false
    }

    this.tierName = tier?.name
    this.tierDescription = tier?.description
    this.tierStatus = tier?.status
    this.tierEffectiveDate =
      new Date(tier?.effectiveDate).toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric"
      }).replace(",", "").split(" ").join("-");
    this.tierTimeofService = tier?.timeOfService
    this.tierMinTimeofService = tier?.minimumTimeOfSerivce
    this.tierMaxTimeofService = tier?.maximumTimeOfService
    this.walletAmount = tier?.walletConfig?.walletAmount
    this.walletCarryForwordAmount = tier?.walletConfig?.carryForwardUnusedAmount
    this.walletAllocation = tier?.walletConfig?.rolloverAllocationPeriod
    // this.walletIndustryCategory = tier?.walletConfig?.industryCategory
    this.walletIntialBalanceSetup = tier?.walletConfig?.initialBalanceSetup
    // this.walletAdvsiorFeeStructure = tier?.walletConfig?.advisorFeeStructure
    this.walletCoveragePercentage = tier?.walletConfig?.coveragePercentage
    this.walletType = tier?.walletConfig?.walletType


    if (this.tierTimeofService == true) {
      this.showTierlist = true
      this.addTierForm.get('tierTimeOfService')?.setValue(true);
    }
    else {
      this.showTierlist = false
    }


    return new Promise((resolve, reject) => {
      // First block of code
      console.log("Executing block 1");

      console.log(this.bulkplans)


      if (tier.plans?.paidByCompany?.length > 0 || tier.plans?.coveredByCompany?.length > 0 || tier.plans?.paidByEmployee?.length > 0) {

        for (let i = 0; i < tier.plans?.paidByCompany?.length; i++) {
          setTimeout(() => {
            let selectedCoverage = tier.plans.paidByCompany[i].companyPaidCoverage ?? "DIRECT"
            if (selectedCoverage == "null") {
              selectedCoverage = "DIRECT"
            }


            // console.log(this.capitalize(selectedCoverage))
            this.getPlanCoverage[tier.plans.paidByCompany[i].planLevelId] = selectedCoverage
            const element: any = $("#plancheck" + tier.plans.paidByCompany[i].planLevelId);
            console.log({ element })
            if (element != null)
              element.click()
            console.log(`Block 1 - Task ${i + 1} completed`);
            console.log(i)
            console.log(tier.plans?.paidByCompany?.length - 1)
            if (i === tier.plans?.paidByCompany?.length - 1) {
              // Second block of code

              console.log("Executing block 2");


              setTimeout(() => {
                if (tier.plans?.coveredByCompany?.length > 0) {
                  console.log("cehckheree")
                  let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
                  if (el1 != null) el1.click();
                  this.upgradeplansselection == true;

                  for (let j = 0; j < tier.plans?.coveredByCompany?.length; j++) {
                    setTimeout(() => {
                      const element: any = $("#plancheck2Upgrade" + tier.plans.coveredByCompany[j].planLevelId);
                      if (element != null) element.click();


                      if (j === tier.plans?.coveredByCompany?.length - 1) {
                        // Third block of code
                        console.log("Executing block 3");

                        setTimeout(() => {
                          if (tier.plans?.paidByEmployee?.length > 0) {
                            let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                            if (el1 != null) el1.click();
                            this.employeeplanpurchase == true
                            for (let k = 0; k < tier.plans?.paidByEmployee?.length; k++) {
                              setTimeout(() => {
                                const element: any = $("#plancheck3Voluntry" + tier.plans.paidByEmployee[k].planLevelId);
                                element.click()
                                console.log(`Block 3 - Task ${k + 1} completed`);
                                if (k === tier.plans?.paidByEmployee?.length - 1) {
                                  resolve("All blocks executed successfully");
                                }
                              }, 1500);
                            }
                          }
                        }, 1000);

                      }
                    }, 1000);
                  }
                }
                if (tier.plans?.coveredByCompany?.length == 0 && tier.plans?.paidByEmployee?.length > 0) {
                  let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                  if (el1 != null) el1.click();
                  this.employeeplanpurchase == true
                  for (let k = 0; k < tier.plans?.paidByEmployee?.length; k++) {
                    setTimeout(() => {
                      const element: any = $("#plancheck3Voluntry" + tier.plans.paidByEmployee[k].planLevelId);
                      element.click()
                      console.log(`Block 3 - Task ${k + 1} completed`);
                      if (k === tier.plans?.paidByEmployee?.length - 1) {
                        resolve("All blocks executed successfully");
                      }
                    }, 1500);
                  }
                }
              }, 2000);





            }
          }, 1000);
        }
      }

      setTimeout(() => {
        let block1 = JSON.parse(
          sessionStorage.getItem('summaryBlock1') || '[]'
        );
        for (let i = 0; i < tier.plans?.paidByCompany?.length; i++) {
          for (let z = 0; z < block1.length; z++) {

            if (block1[z].subGroupId == tier.plans.paidByCompany[i].planLevelId) {
              block1[z].id = tier.plans.paidByCompany[i].id
            }
          }
        }
        sessionStorage.setItem('summaryBlock1', JSON.stringify(block1))

        let block2 = JSON.parse(
          sessionStorage.getItem('summaryBlock2') || '[]'
        );
        console.log(tier.plans.coveredByCompany)
        for (let i = 0; i < tier.plans?.coveredByCompany?.length; i++) {
          for (let z = 0; z < block2.length; z++) {

            if (block2[z].subGroupId == tier.plans.coveredByCompany[i].planLevelId) {
              block2[z].id = tier.plans.coveredByCompany[i].id
            }
          }
        }
        console.log({ block2 })
        sessionStorage.setItem('summaryBlock2', JSON.stringify(block2))

        let block3 = JSON.parse(
          sessionStorage.getItem('summaryBlock3') || '[]'
        );
        for (let i = 0; i < tier.plans?.paidByEmployee?.length; i++) {
          for (let z = 0; z < block3.length; z++) {

            if (block3[z].subGroupId == tier.plans.paidByEmployee[i].planLevelId) {
              block3[z].id = tier.plans.paidByEmployee[i].id
            }
          }
        }
        sessionStorage.setItem('summaryBlock3', JSON.stringify(block3))
      }, 10000)


    })



  }
  getTierKeyFromId(tierId: any, tierIndex: any): any {
    // return "ct" + tierId + index.toString().padStart(3,'0');
    return `ct${tierId}${tierIndex.toString().padStart(3, '0')}`;
  }
  public membersTierCheck(event: any) {

    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');

    var accessToken = sessionStorage.getItem('accessToken');
    var getMembersList = `/api/ap/admin/corporate/${corporateId}/tier/${this.tierDetails.id}/members`;

    this.http
      .get(environment.apiUrl + getMembersList, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response.status == '200') {
          this.tierMembers = response.data.members

          this.corporateTiersDeleteList = this.corporateTiers.filter(obj => obj.name !== this.tierDetails.name);
          // this.selectedTierName = this.corporateTiers[0].name
          this.tierMembers.forEach(member => {
            this.selectedTierName[member.staxbillId] = this.corporateTiersDeleteList[0].id; // Set default to 'Gold'
          });
        } else {
          Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
        }
      }, (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: this.lang.Error ?? 'Error',
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: this.lang.Proceed,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      });

  }
  public deleteTierwithoutMembers() {
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');
    var corporateId = sessionStorage.getItem('corporateId');

    var DeleteTiers =
      `/api/ap/admin/corporate/${corporateId}/tier/${this.tierDetails.id}/delete`;

    var accessToken = sessionStorage.getItem('accessToken');


    let requestBody = {
      reason: 'Delete Tier',
      tierName: this.tierDetails.name,
      corporateName: sessionStorage.getItem('corporateClientName'),
      setupTier: formData.tierConfig,
      moveEmployees: false,
      moveEmployeesToTier: 0

    }

    this.http
      .post(environment.apiUrl + DeleteTiers, requestBody, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (response.status == '200') {
          this.deleteTierForm.reset()
          $('#deleteMembers-modal').modal('hide');
          this.getExistingTiers();
        } else {
          Swal.fire({ title: 'Info', text: response.message });
        }
      }, (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: this.lang.Error ?? 'Error',
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: this.lang.Proceed,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      });

  }

  public deleteTier(tier) {

    console.log(tier)
    this.deleteTierName = tier.name
    this.tierDetails = tier

    this.checkDeleteTier = true
    Swal.fire({
      title: this.lang.Info,
      text: 'Are you sure want to delete this Tier?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: this.lang.Proceed,
      cancelButtonText: 'No'
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {

        let formData = JSON.parse(sessionStorage.getItem('formData') || '');
        var corporateId = sessionStorage.getItem('corporateId');

        var DeleteTiers =
          `/api/ap/admin/corporate/${corporateId}/tier/${tier.id}/delete`;

        var accessToken = sessionStorage.getItem('accessToken');
        let requestBody
        if (tier.memberCount == 0) {

          requestBody = {
            reason: 'Delete Tier',
            tierName: tier.name,
            corporateName: sessionStorage.getItem('corporateClientName'),
            setupTier: formData.tierConfig,
            moveEmployees: false,
            moveEmployeesToTier: 0

          }

          this.http
            .post(environment.apiUrl + DeleteTiers, requestBody, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe((response: any) => {
              if (response.status == '200') {
                Swal.fire({ title: 'Info', text: response.message });

                this.getExistingTiers();
              } else {
                Swal.fire({ title: this.lang.Info ?? 'Info', text: response.message });
              }
            }, (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: true,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            });
        }
        else {
          $('#deleteMembers-modal').modal('show');

          // requestBody = {
          //   reason: 'Delete Tier',
          //   tierName: tier.name,
          //   corporateName: sessionStorage.getItem('corporateClientName'),
          //   setupTier: formData.tierConfig,
          //   moveEmployees: false,
          //   moveEmployeesToTier: 0

          // }
        }



      }
      else {
        // sessionStorage.clear();
        // this.router.navigate(['/login']);
      }
    });
  }

  public submitbasicInfo() {
    console.log("entering")
    // this._LoaderService.ShowLoader();
    // $('#basicformSubmit1stScreen').prop('disabled',true)
    let controls = this.clientregform.controls
    let invalid = [];
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    console.log(invalid)
    this.plansButtonDisable = true;
    this.showEmployeeValue = this.clientregform.value.expectednoofEmployees || ""
    this.showEmployeeValue1 = this.clientregform.value.expectednoofEmployees || ""
    //  this.headerComponent.headerDetails('login');
    // this.dummyData()
    // this.headerComponent.headerDetails('login');

    console.log(this.clientregform);
    let customSelectedError = false;
    this.clientregform.get('waitingPeriod').setValue(this.clientregform.get('waitingPeriod').value ?? '');
    // if(this.customSelected&&this.clientregform.get('waitingPeriod').value=='Custom'){
    //    customSelectedError=true;
    // }

    // if (this.clientregform.invalid||(this.clientregform.get('waitingPeriod').value===''&&this.customSelected)) {
    if (this.clientregform.invalid) {
      // this._LoaderService.HideLoader();
      // $('#basicformSubmit1stScreen').prop('disabled',false)
      console.log(JSON.stringify(this.clientregform.value, null, 2));
      this.clientregform.markAllAsTouched();
      this.scrollToFirstInvalidControl1();
    } else {
      // console.log("ok")
      var accessToken = sessionStorage.getItem('accessToken');
      var customerValidation = '/api/ap/admin/v2/corporate/customer/validation';

      this.configprovinceres.forEach((element: any) => {
        if (element.shortName.toLowerCase() == this.clientregform.value.Province.toLowerCase()) {
          this.provincialHealthcareUrl = element.provincialHealthcareUrl;
          this.provincialZipcodes = element.zipcodes.split(',');
          this.provincelistid = element.id;
          this.state_id = parseInt(element.fusebillId);
          this.statename = element.name;

          this.stateId = element.id;
          this.fusebillStateId = element.fusebillId;
          this.countryId = element.country_id;
          this.fusebillCountryId = element.country_id;
        }
      });

      sessionStorage.setItem('summaryBlock1', '[]');
      sessionStorage.setItem('summaryBlockBulk', '[]');


      sessionStorage.setItem('walletConfig', '{}');
      // sessionStorage.setItem('selectedPlans', '{}');
      sessionStorage.setItem('summaryBlock1main', '[]');
      sessionStorage.setItem('summaryBlock1opt', '[]');
      // sessionStorage.setItem('selectedBlock1', '{}');
      sessionStorage.setItem('summaryBlock2', '[]');

      // sessionStorage.setItem('summaryBlock2main', '[]');
      sessionStorage.setItem('summaryBlock2opt', '[]');
      // sessionStorage.setItem('selectedBlock2', '{}');

      sessionStorage.setItem('summaryBlock3', '[]');

      sessionStorage.setItem('summaryBlock3main', '[]');
      sessionStorage.setItem('summaryBlock3opt', '[]');
      sessionStorage.setItem(
        'requireEmployeeName',
        this.clientregform.value.ShowEmployer
      );
      this.checkboxCheck = {}
      this.showHeadCount = {}
      this.showinputboxvalue = {}

      // sessionStorage.setItem('selectedBlock3', '{}');

      // sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

      this.maxEmployeeCount = this.clientregform.value.expectednoofEmployees;
      var voidfileExtension = '';
      let voidcheckDetails = '';
      let logoDetails = '';

      if (this.bankDetails) {
        voidfileExtension = '.' + this.voidcheckfile.name.split('.').pop();
        (voidcheckDetails = this.voidcheckfile),
          'void_cheque_' + Date.now() + voidfileExtension.toLowerCase();
      } else {
        voidcheckDetails = '';
      }

      if (this.uploadadminlogoimg) {
        (logoDetails = this.uploadadminlogoimg),
          'Admin_logo' +
          Date.now() +
          '.' +
          this.uploadadminlogoimg.name.split('.').pop().toLowerCase();
      } else {
        logoDetails = '';
      }

      this.session = sessionStorage.getItem('session');

      var padinfo: any;
      var creditCardinfo;
      var invoicemonthy;
      if (this.clientregform.value.paymentInfo == 'pad') {
        padinfo = 'true';
      } else if (this.clientregform.value.paymentInfo == 'creditcard') {
        creditCardinfo = 'true';
      } else {
        invoicemonthy = 'true';
      }

      var formdata = new FormData();

      formdata.append(
        'corporationName',
        this.clientregform.value.corporationName
      );

      formdata.append('brokerType', 'CORPORATE');
      formdata.append(
        'workingProvinces',
        JSON.stringify(this.multiSelectProviance)
      );
      formdata.append('cpPlanAutoSelection', this.clientregform.value.autoSelectEmp);
      formdata.append('showEmployeeAddScreen', this.clientregform.value.showEmployeeListData);

      formdata.append(
        'policyStartDate',
        this.datePipe.transform(
          this.clientregform.value.PolicyStartDate,
          'yyyy-MM-dd'
        ) || '0000-00-00'
      );

      formdata.append('logo', logoDetails);

      formdata.append('fuseBillCustomerCreation', 'true');

      formdata.append('voidCheck', voidcheckDetails);

      formdata.append('gropupAdmin', JSON.stringify(this.adminData));
      let waitingPeriod;
      if (this.customSelected && this.clientregform.value.waitingPeriod == 'Custom') {
        waitingPeriod = this.clientregform.value.waitingPeriodCustom || 0;

      } else {
        waitingPeriod = this.clientregform.value.waitingPeriod || 0;
      }
      formdata.append(
        'waitingPeriod',
        waitingPeriod || 0
      );

      formdata.append(
        'corporateEmployeesInitialSignupWaittime',
        this.clientregform.value.waitingPeriodinitialsignup
      );

      formdata.append('useCreditCard', creditCardinfo ? 'true' : 'false');

      // formdata.append('invoicePayment', invoicemonthy ? 'true' : 'false');
      //Invoices are not using so send as false
      formdata.append('invoicePayment', invoicemonthy ? 'false' : 'false');

      formdata.append('padPayment', padinfo ? 'true' : 'false');

      formdata.append('session', this.session);

      // change back - remove bottom 2 lines
      // this.clientregform.get('walletConfig').setValue(false);
      // this.clientregform.get('tierConfig').setValue(false);

      formdata.append('setupWallet', this.clientregform.value.walletConfig);


      formdata.append(
        'setUplevelofCoverage',
        this.clientregform.value.tierConfig
      );

      formdata.append(
        'exptNumofEmp',
        this.clientregform.value.expectednoofEmployees || 0
      );
      formdata.append('requireEmployeeName', JSON.parse(sessionStorage.getItem('requireEmployeeName')))


      formdata.append(
        'streetAddressLine1',
        this.capitalize(this.clientregform.value.streetAddress) || ''
      );

      formdata.append(
        'streetAddressLine2',
        this.capitalize(this.clientregform.value.streetAddress2) || ''
      );
      formdata.append('apt', this.clientregform.value.apt_suite || '');

      formdata.append('city', this.capitalize(this.clientregform.value.city));

      formdata.append('province', this.clientregform.value.Province);

      formdata.append('provinceId', this.provincelistid);

      formdata.append('state', this.clientregform.value.Province);

      // formdata.append('stateId', this.state_id);
      formdata.append('stateId', this.stateId);
      formdata.append('fusebillStateId', this.fusebillStateId);
      // formdata.append('countryId', this.countryId);
      formdata.append('fusebillCountryId', this.fusebillCountryId);

      formdata.append('country', this.clientregform.value.country);

      formdata.append('countryId', '1');
      formdata.append('fbcountryId', '124');
      // formdata.append('parentId', this.clientregform.value.brokerName || 0);
      formdata.append('parentId', this.updatedBrokerId || 0);



      formdata.append('postalCode', this.clientregform.value.postalCode);
      formdata.append(
        'corporateClientId',
        sessionStorage.getItem('corporateClientId') ||
        environment.corporateClientId
      ); //fusebillid
      formdata.append(
        'corporateId',
        sessionStorage.getItem('corporateId') || '0'
      ); //corporateid

      this.clientregform.value['logo'] = logoDetails

      sessionStorage.setItem(
        'formData',
        JSON.stringify(this.clientregform.value)
      );
      // formdata.append('paymentPlatform', this.clientregform.value.paymentPlatform ?? this.paymentPlatform);
      formdata.append('paymentPlatform', this.paymentPlatform);
      formdata.append('authorizenetCustomerId', this.clientregform.value.authorizenetCustomerId);
      formdata.append('contactEmail', this.contactEmail);
      // console.log({ logoDetails })
      // formdata.forEach((val, key) => console.log(`${key}:${val}`))
      // return;


      var requestOptions: any = {
        method: 'POST',

        body: formdata,

        redirect: 'follow',
        headers: { Authorization: 'Bearer ' + accessToken },
      };

      console.log({ disable: this.plansButtonDisable })

      fetch(environment.apiUrl + customerValidation, requestOptions)
        .then((response) => response.text())

        .then(async (response: any) => {
          // console.log(response);
          response = JSON.parse(response);
          // $('#basicformSubmit1stScreen').prop('disabled',false)
          // this._LoaderService.HideLoader();
          if (response['status'] == 200) {
            var corporateId = sessionStorage.getItem('corporateId');
            var CreateNewTiers =
              `/api/ap/admin/corporate/${corporateId}/tiers/default`;

            var accessToken = sessionStorage.getItem('accessToken');

            let crateTierid = response.data.defaultActiveTierId;
            sessionStorage.setItem('createId', crateTierid);
            if (crateTierid == 0) {
              var endPoint = '/api/ap/admin/corporate/' + response?.data?.corporateId + '/tiers/default';
              this.http
                .post(environment.apiUrl + endPoint, {}, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  },
                })
                .subscribe((response: any) => {
                  if (response['status'] == 200) {
                    crateTierid = response.data
                    sessionStorage.setItem('createId', crateTierid);
                  }
                });
            }

            // if (this.clientregform.value.walletConfig) {

            //   var accessToken = sessionStorage.getItem('accessToken');

            //   let obj = {
            //     "bankCode": this.clientregform.value.bankCode,
            //     "branchCode": this.clientregform.value.BankTransit,
            //     "accountNumber": this.clientregform.value.accounNum
            //   }
            //   var getBankList = `/api/ap/admin/bank/myhsa/register`;

            //   this.http
            //     .post(environment.apiUrl + getBankList, obj, {
            //       headers: {
            //         Authorization: 'Bearer ' + accessToken,
            //         'Content-Type': 'application/json',
            //       },
            //     })
            //     .subscribe((response: any) => {
            //       if (response.status == '200') {
            //         // Swal.fire({ title: this.lang.Info, text: response.message })

            //       } else {
            //         Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            //       }
            //     }, (error) => {
            //       if (
            //         error.status == 400 ||
            //         error.status == 401 ||
            //         error.status == 402 ||
            //         error.status == 403
            //       ) {
            //         Swal.fire({
            //           title: this.lang.Error ?? 'Error',
            //           text: error.error.error.message,
            //           showDenyButton: false,
            //           showCancelButton: true,
            //           confirmButtonText: this.lang.Proceed,
            //         }).then((result) => {
            //           /* Read more about isConfirmed, isDenied below */
            //           if (result.isConfirmed) {
            //             sessionStorage.clear();
            //             this.router.navigate(['/login']);
            //           }
            //           else {
            //             sessionStorage.clear();
            //             this.router.navigate(['/login']);
            //           }
            //         });
            //       } else {
            //         // Swal.fire(error.error.error.message)
            //         Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            //       }
            //       // this.toastrService.error("Invalid Credentials", 'Error!');
            //     });
            // }

            if (response.data.corporateTiers.length == 0) {

              this.http
                .post(environment.apiUrl + CreateNewTiers, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  },
                })
                .subscribe((response: any) => {
                  if (response.status == '200') {
                    // this.crateTierid = response.data.tierId
                    this.crateTierid = response.data

                  } else {
                    Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
                  }
                }, (error) => {
                  if (
                    error.status == 400 ||
                    error.status == 401 ||
                    error.status == 402 ||
                    error.status == 403
                  ) {
                    Swal.fire({
                      title: this.lang.Error ?? 'Error',
                      text: error.error.error.message,
                      showDenyButton: false,
                      showCancelButton: true,
                      confirmButtonText: this.lang.Proceed,
                    }).then((result) => {
                      /* Read more about isConfirmed, isDenied below */
                      if (result.isConfirmed) {
                        sessionStorage.clear();
                        this.router.navigate(['/login']);
                      }
                      else {
                        sessionStorage.clear();
                        this.router.navigate(['/login']);
                      }
                    });
                  } else {
                    // Swal.fire(error.error.error.message)
                    Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
                  }
                  // this.toastrService.error("Invalid Credentials", 'Error!');
                });

            }

            console.log({ disable: this.plansButtonDisable })

            let CorpId = this.route.snapshot.params['id']
            var endPoint = '/api/ap/admin/corporate/' + CorpId + '/details';
            // await postServiceWorkerMessage(WorkerMessageType.Delete, [
            //   environment.apiUrl + endPoint
            // ]);
            this.coreplantemplateValue = null;
            this.plansBlock1 = response.plans.packages;
            this.balkPlans = response.plans.bulkPackages;

            this.corporateTiers = response.data.corporateTiers

            // if (this.clientregform.value.walletConfig == false) {

            //   if (this.corporateTiers.length > 0) {

            //     for (let i = 0; i < this.corporateTiers.length; i++){

            //       let requestBody = {
            //         id: this.corporateTiers[i].walletConfig.id,
            //         corporateId: corporateId,
            //         tierId: this.corporateTiers[i].id,
            //         currentStatus: 'Active',
            //         newStatus: 'Inactive'
            //       }
            //       let walletStatusChange =
            //         `/api/ap/admin/corporate/${corporateId}/tier/wallet/statusChange`;
            //       if (this.corporateTiers[i].wallet == true) {
            //         this.http
            //           .post(environment.apiUrl + walletStatusChange, requestBody, {
            //             headers: {
            //               Authorization: 'Bearer ' + accessToken,
            //               'Content-Type': 'application/json',
            //             },
            //           })
            //           .subscribe((response: any) => {
            //             if (response.status == '200') {
            //             } else {
            //               Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
            //             }
            //           }, (error) => {
            //             if (
            //               error.status == 400 ||
            //               error.status == 401 ||
            //               error.status == 402 ||
            //               error.status == 403
            //             ) {
            //               Swal.fire({
            //                 title: this.lang.Error ?? 'Error',
            //                 text: error.error.error.message,
            //                 showDenyButton: false,
            //                 showCancelButton: true,
            //                 confirmButtonText: this.lang.Proceed,
            //               }).then((result) => {
            //                 /* Read more about isConfirmed, isDenied below */
            //                 if (result.isConfirmed) {
            //                   sessionStorage.clear();
            //                   this.router.navigate(['/login']);
            //                 }
            //                 else {
            //                   sessionStorage.clear();
            //                   this.router.navigate(['/login']);
            //                 }
            //               });
            //             } else {
            //               // Swal.fire(error.error.error.message)
            //               Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            //             }
            //             // this.toastrService.error("Invalid Credentials", 'Error!');
            //           });
            //       }
            //     }

            //   }

            // }


            this.plansBlock1Tiers = response.plans.packages;

            this.plansBlock1.forEach((planlevel: any) => {
              planlevel.groups.forEach((groups: any) => {
                groups.subGroups.forEach((subgroup: any) => {
                  subgroup.tiers = [];
                  subgroup.checked = false;
                });
              });
            });
            this.plansBlock1Tiers.forEach((planlevel: any) => {
              this.selectedPackagePlansInfoTier[planlevel.id] = [];
              this.selectedPackagePlansInfoTiername[planlevel.id] =
                planlevel.name;
              this.selectedPackagePlansInfoTierBlock2[planlevel.id] = [];
              this.selectedPackagePlansInfoTiernameBlock2[planlevel.id] =
                planlevel.name;
              this.selectedPackagePlansInfoTierBlock3[planlevel.id] = [];
              this.selectedPackagePlansInfoTiernameBlock3[planlevel.id] =
                planlevel.name;

              this.selectedPackagesavailableTiers2[planlevel.id] = {};
              this.selectedPackagesassignedTiers2[planlevel.id] = {};
              this.selectedPackagesavailableTiers2Block2[planlevel.id] = {};
              this.selectedPackagesassignedTiers2Block2[planlevel.id] = {};

              this.selectedPackagesavailableTiers3[planlevel.id] = {};
              this.selectedPackagesassignedTiers3[planlevel.id] = {};
              this.selectedPackagesavailableTiers3Block3[planlevel.id] = {};
              this.selectedPackagesassignedTiers3Block3[planlevel.id] = {};
              planlevel.groups.forEach((groups: any) => {
                groups.subGroups.forEach((subgroup: any) => {
                  this.selectedPackagesavailableTiers2[planlevel.id][
                    subgroup.id
                  ] = null;
                  this.selectedPackagesassignedTiers2[planlevel.id][
                    subgroup.id
                  ] = [];
                  this.selectedPackagesavailableTiers2Block2[planlevel.id][
                    subgroup.id
                  ] = null;
                  this.selectedPackagesassignedTiers2Block2[planlevel.id][
                    subgroup.id
                  ] = [];

                  this.selectedPackagesavailableTiers3[planlevel.id][
                    subgroup.id
                  ] = null;
                  this.selectedPackagesassignedTiers3[planlevel.id][
                    subgroup.id
                  ] = [];
                  this.selectedPackagesavailableTiers3Block3[planlevel.id][
                    subgroup.id
                  ] = null;
                  this.selectedPackagesassignedTiers3Block3[planlevel.id][
                    subgroup.id
                  ] = [];
                  subgroup.tiers = [];
                  subgroup.checked = false;
                  subgroup.coverage = ''; //default
                });
              });
            });

            // if (this.clientregform.value.tierConfig == false) {
            //   this.executeBlocks()
            //     .then((message) => console.log(message))
            //     .catch((error) => console.error("An error occurred:", error));

            // }
            // setTimeout(() => {
            //   const dom: HTMLElement = this.elementRef.nativeElement;
            //   console.log('this.paidByCompany',this.paidByCompany);
            //   if(this.paidByCompany?.length>0){
            //   for(let i=0;i<this.paidByCompany?.length;i++){
            //     const element: any = dom.querySelector("#plancheck" + this.paidByCompany[i].planLevelId);
            //    if(element!=null)
            //     element.click()
            //   }
            // }

            // setTimeout(() => {
            //   if(this.coveredByCompany?.length>0){
            //     let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
            //    if(el1!=null) el1.click();
            //     this.upgradeplansselection == true;

            //     setTimeout(() => {
            //     for(let j=0;j<this.coveredByCompany?.length;j++){
            //       const element: any = dom.querySelector("#plancheck2Upgrade" + this.coveredByCompany[j].planLevelId);
            //      if(element!=null) element.click();
            //     }
            //   }, 1500);
            //   }
            //   setTimeout(() => {
            //     if(this.paidByEmployee?.length>0){
            //       let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
            //       if(el1!=null) el1.click();
            //       this.employeeplanpurchase == true
            //       setTimeout(() => {
            //       for(let k=0;k<this.paidByEmployee?.length;k++){
            //         const element: any = dom.querySelector("#plancheck3Voluntry" + this.paidByEmployee[k].planLevelId);
            //         element.click()


            //       }
            //     }, 1000);
            //     }
            //   }, 2000);
            // }, 1500);



            // }, 1000);

            sessionStorage.setItem(
              'planResults',
              JSON.stringify(this.plansBlock1)
            );
            sessionStorage.setItem(
              'plansBlock1Tiers',
              JSON.stringify(this.plansBlock1Tiers)
            );

            setTimeout(() => {
              $('#executiveplanssingle17').prop('disabled', true);
              $('#executiveplanscouple17').prop('disabled', true);
              $('#executiveplansfamily17').prop('disabled', true);
              $('#executiveplanssingle18').prop('disabled', true);
              $('#executiveplanscouple18').prop('disabled', true);
              $('#executiveplansfamily18').prop('disabled', true);
              $('#executiveplanssingle28').prop('disabled', true);
              $('#executiveplanscouple28').prop('disabled', true);
              $('#executiveplansfamily28').prop('disabled', true);

              $('#executiveplansTiersingle17').prop('disabled', true);
              $('#executiveplansTiercouple17').prop('disabled', true);
              $('#executiveplansTierfamily17').prop('disabled', true);
              $('#executiveplansTiersingle18').prop('disabled', true);
              $('#executiveplansTiercouple18').prop('disabled', true);
              $('#executiveplansTierfamily18').prop('disabled', true);
              $('#executiveplansTiersingle28').prop('disabled', true);
              $('#executiveplansTiercouple28').prop('disabled', true);
              $('#executiveplansTierfamily28').prop('disabled', true);

              $('#executiveplansblock2single17').prop('disabled', true);
              $('#executiveplansblock2couple17').prop('disabled', true);
              $('#executiveplansblock2family17').prop('disabled', true);
              $('#executiveplansblock2single18').prop('disabled', true);
              $('#executiveplansblock2couple18').prop('disabled', true);
              $('#executiveplansblock2family18').prop('disabled', true);
              $('#executiveplansblock2single28').prop('disabled', true);
              $('#executiveplansblock2couple28').prop('disabled', true);
              $('#executiveplansblock2family28').prop('disabled', true);
              this.plansButtonDisable = false;
            }, 1000);

            // if(this.existingPlans.length>0){
            //   for()
            // }

            this.updateAllStatus();

            this.assignAllplanLvelwithdisallowed(this.plansBlock1);
            // this.headerComponent.headerDetails('login');
            // this.headerComponent.applicationStatus(this.lengthofstatus);
            // this.plansBlock1 =response.plans.packages
            this.corporateId = response.data.corporateId;
            this.corporateClientId = response.data.fuseBillId;
            this.assignAllplanLvelwithdisallowedTiers(this.plansBlock1Tiers);
            sessionStorage.setItem('corporateId', this.corporateId);
            sessionStorage.setItem('corporateClientId', this.corporateClientId);
            sessionStorage.setItem(
              'corporateClientName',
              response.data.corporateName
            );
            sessionStorage.setItem(
              'mainresults',
              JSON.stringify(this.plansBlock1)
            );
            sessionStorage.setItem(
              'planResults',
              JSON.stringify(this.plansBlock1)
            );

            this.basicInfo = false;
            // this.plansInfo = false;

            if (this.clientregform.value.walletConfig == true && this.clientregform.value.tierConfig == true) {
              // this.showTierConfig = true
              // this.showWalletConfig = true
              // this.plansInfo = true;
              this.showTiersTable = true;
              this.showAddTier = false;
              this.isAddTier = false;

              // change back
              // this.showTierConfig = false
              // this.showWalletConfig = false
              // this.plansInfo = true;
              // this.showTiersTable = false;
            }
            else if (this.clientregform.value.tierConfig == true && this.clientregform.value.walletConfig == false) {
              // this.showTierConfig = true
              // this.showWalletConfig = false
              this.plansInfo = false;
              this.showTiersTable = true;
              this.showAddTier = false;
              this.isAddTier = false;

              // change back
              // this.showTierConfig = false
              // this.showWalletConfig = false
              // this.plansInfo = true;
              // this.showTiersTable = false;
            }
            else if (this.clientregform.value.walletConfig == true && this.clientregform.value.tierConfig == false) {
              this.showTiersTable = false;
              this.showWalletConfig = true;
              this.showTierConfig = false
              this.plansInfo = true;
              this.showAddTier = true;

              // change back
              // this.showTierConfig = false
              // this.showWalletConfig = false
              // this.plansInfo = true;
              // this.showTiersTable = false;
            }
            else {
              this.showTierConfig = false
              this.showWalletConfig = false
              this.plansInfo = true;
              this.showTiersTable = false;
              this.showAddTier = true;
            }
            // if (this.clientregform.value.tierConfig == true) {

            //   this.showTiersTable = true;
            //   this.plansInfo = false;
            // }
            // else {
            //   this.showTiersTable = false;
            //   this.plansInfo = true;
            // }


            // if (this.clientregform.value.walletConfig || this.clientregform.value.tierConfig) {
            //   this.showTierandWalletConfig = true
            // }
            // else {
            //   this.showTierandWalletConfig = false
            // }
            // if (this.clientregform.value.walletConfig) {
            // this.
            // }
            // else {

            // }

            // if (this.clientregform.value.tierConfig) {

            // }
            // else {

            // }


            const dom: HTMLElement = this.elementRef.nativeElement;

            // this.headerComponent.headerDetails('login');

            if (this.clientregform.value.tierConfig == true) {
              this.showtierbasicplans = false;
              this.showtieradvplans = true;
              // this.showtierbasicplans = false;
              this.showtieradvplans = true;
              this.showconfigurebutton = true;

              // change back
              // this.showtierbasicplans = true;
              // this.showtieradvplans = false;
              // // this.showtierbasicplans = true;
              // this.showtieradvplans = false;
              // this.showconfigurebutton = false;
            } else {
              this.showtierbasicplans = true;
              this.showtieradvplans = false;
              // this.showtierbasicplans = true;
              this.showtieradvplans = false;
              this.showconfigurebutton = false;
            }
            if (this.clientregform.value.tierConfig == true) {
              this.showemptytierconfig = true;

              // change back
              // this.showemptytierconfig = false;
            } else {
              this.showemptytierconfig = false;
            }
            if (this.clientregform.value.walletConfig == false) {
              this.showemptywalletConfig = false;
            } else {
              this.showemptywalletConfig = true;

              // change back
              // this.showemptywalletConfig = false;
            }
            // setTimeout(() => {
            //   // const element: any = dom.querySelector('#plancheck' + 16);
            //   // element.click();
            //   let el1: HTMLElement = this.upgradeplansfalse.nativeElement;
            //   el1.click();
            //   this.upgradeplansselection == false;
            //   let el2: HTMLElement = this.employeepurchasefalse.nativeElement;
            //   el2.click();
            //   this.employeeplanpurchase == false;
            // }, 1000);
            let selectedplansblock1 = JSON.parse(
              sessionStorage.getItem('summaryBlock1') || '[]'
            );
            let selectedplansblock2 = JSON.parse(
              sessionStorage.getItem('summaryBlock2') || '[]'
            );
            let selectedplansblock3 = JSON.parse(
              sessionStorage.getItem('summaryBlock3') || '[]'
            );
            // setTimeout(() => {
            //   const dom: HTMLElement = this.elementRef.nativeElement;
            //   if(selectedplansblock1.length>0){
            //   for(let i=0;i<selectedplansblock1.length;i++){
            //     const element: any = dom.querySelector("#plancheck" + selectedplansblock1[i].subGroupId);
            //     element.checked =true
            //     this.plancheckCoverage = selectedplansblock1[i].coverage

            //   }
            // }
            //   if(selectedplansblock2.length>0){
            //     let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
            //     el1.click();
            //     this.upgradeplansselection == true
            //     setTimeout(() => {
            //     for(let i=0;i<selectedplansblock2.length;i++){
            //       const element1: any = dom.querySelector("#plancheck2Upgrade" + selectedplansblock2[i].subGroupId);
            //       element1.checked =true
            //       this.plancheck2Coverage = selectedplansblock2[i].coverage
            //     }
            //   },1000)
            //   }
            //   if(selectedplansblock3.length>0){
            //     let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
            //     el1.click();
            //     this.employeeplanpurchase == true
            //     setTimeout(() => {
            //     for(let i=0;i<selectedplansblock3.length;i++){
            //       const element2: any = dom.querySelector("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId);
            //       element2.checked =true
            //       this.plancheck3Coverage = selectedplansblock3[i].coverage
            //     }
            //   },1500)
            //   }
            // }, 1000);
            sessionStorage.setItem('selectedTiersBlock1', '[]');
            sessionStorage.setItem('selectedTiersBlock2', '[]');
            sessionStorage.setItem('selectedTiersBlock3', '[]');
            this.selectedPackagePlansInfoTier = {};
            this.selectedPackagePlansInfoTierBlock2 = {};
            this.selectedPackagePlansInfoTierBlock3 = {};
            this.selectedPackagePlansInfoTier2 = {};
            this.selectedPackagePlansInfoTier2Block2 = {};
            this.selectedPackagePlansInfoTier3Block3 = {};

            this.seelctedplanLevelTierMapping = []
            this.seelctedplanLevelTierMappingBlock2 = []
            this.seelctedplanLevelTierMappingBlock3 = []

            if (this.employeeList.length > 0) {
              for (let i = 0; i < this.employeeList.length; i++) {
                if (this.employeeList[i].isBulk == true) {
                  this.bulkemployeeList.push(this.employeeList[i])
                }
              }

            }
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                "message": "Corporates information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
            this.corporateDetails = {
              ...this.corporateDetails,
              name: this.clientregform.value.corporationName,
            }
            this.corporateDetails = { ...this.corporateDetails, email: this.adminData[0]?.email ?? this.adminform.value.adminemail }
            console.log('this.corporateDetails email', this.corporateDetails)
            console.log(this.corporateDetails);
            this.clientList = this.clientList.map(corp =>
              corp.id == response.data?.corporateId ? { ...corp, ...this.corporateDetails } : corp
            );
            console.log('this.corporateDetails final', this.corporateDetails, this.clientList)
            this.store.dispatch(loadCorporateDataSuccess({ corporateData: this.clientList }))

            // this.store.dispatch(loadCorporateDataSuccess({ corporateData: [...this.clientList,{...this.corporateDetails}] }));
            // this.http.post(environment.apiUrl+'/api/ap/v2/global/set-adminCorporates',{wait:true}).subscribe((newResponse) => {
            //   this.store.dispatch(loadCorporateDataSuccess({ corporateData: [] }));
            //   this.store.dispatch(loadCorporateData());
            // })
          }
          else if (response['status'] == 202) {
            // Swal.fire(this.lang.Error??'Error',response.message);
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          } else {
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        }, (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        })

      // .catch((error) => console.log(this.lang.Error??'Error', error));
    }

    // if (this.clientregform.invalid) {
    //   return;
    // }

  }

  public submitbasicInfoCheck() {

    // $('#basicformSubmit1stScreen').prop('disabled',true)
    // this._LoaderService.ShowLoader();
    // sessionStorage.setItem('summaryBlockBulk', '[]');
    // sessionStorage.setItem('summaryBlock1', '[]');
    // sessionStorage.setItem('summaryBlock2', '[]');
    // sessionStorage.setItem('summaryBlock3', '[]');

    this.showEmployeeValue = this.clientregform.value.expectednoofEmployees || ""
    this.showEmployeeValue1 = this.clientregform.value.expectednoofEmployees || ""

    this.showinputbox = "121"

    this._LoaderService.ShowLoader();
    console.log(this.clientregform);
    let customSelectedError = false;
    this.clientregform
      .get('waitingPeriod')
      .setValue(this.clientregform.get('waitingPeriod').value ?? '');






    var accessToken = sessionStorage.getItem('accessToken');
    var customerValidation = '/api/ap/admin/v2/corporate/customer/validation';

    // this.checkboxCheck = {}
    // this.showHeadCount = {}
    // this.showinputboxvalue = {}

    sessionStorage.setItem(
      'requireEmployeeName',
      this.clientregform.value.ShowEmployer
    );

    // sessionStorage.setItem('planResults', JSON.stringify(this.plansBlock1));

    this.maxEmployeeCount = this.clientregform.value.expectednoofEmployees;
    var voidfileExtension = '';
    let voidcheckDetails = '';
    let logoDetails = '';

    if (this.bankDetails) {
      voidfileExtension = '.' + this.voidcheckfile.name.split('.').pop();
      (voidcheckDetails = this.voidcheckfile),
        'void_cheque_' + Date.now() + voidfileExtension.toLowerCase();
    } else {
      voidcheckDetails = '';
    }

    if (this.uploadadminlogoimg) {
      (logoDetails = this.uploadadminlogoimg),
        'Admin_logo' +
        Date.now() +
        '.' +
        this.uploadadminlogoimg.name.split('.').pop().toLowerCase();
    } else {
      logoDetails = '';
    }

    this.session = sessionStorage.getItem('session');

    var padinfo: any;
    var creditCardinfo;
    var invoicemonthy;
    if (this.clientregform.value.paymentInfo == 'pad') {
      padinfo = 'true';
    } else if (this.clientregform.value.paymentInfo == 'creditcard') {
      creditCardinfo = 'true';
    } else {
      invoicemonthy = 'true';
    }

    var formdata = new FormData();


    // formdata.append('corporationName',
    //   this.capitalize(this.clientregform.value.corporationName)
    // );
    formdata.append('corporationName', (this.clientregform.value.corporationName));
    formdata.append(
      'requireEmployeeName',
      this.clientregform.value.ShowEmployer
    );
    // this.clientregform.value.ShowEmployer
    formdata.append('brokerType', 'CORPORATE');
    formdata.append(
      'workingProvinces',
      JSON.stringify(this.multiSelectProviance)
    );
    formdata.append('cpPlanAutoSelection', this.clientregform.value.autoSelectEmp);
    formdata.append('showEmployeeAddScreen', this.clientregform.value.showEmployeeListData);


    formdata.append(
      'policyStartDate',
      this.datePipe.transform(
        this.clientregform.value.PolicyStartDate,
        'yyyy-MM-dd'
      ) || '0000-00-00'
    );

    formdata.append('logo', logoDetails);

    formdata.append('fuseBillCustomerCreation', 'true');

    formdata.append('voidCheck', voidcheckDetails);

    formdata.append('gropupAdmin', JSON.stringify(this.adminData));
    let waitingPeriod;
    if (this.customSelected && this.clientregform.value.waitingPeriod == 'Custom') {
      waitingPeriod = this.clientregform.value.waitingPeriodCustom || 0;

    } else {
      waitingPeriod = this.clientregform.value.waitingPeriod || 0;
    }
    formdata.append(
      'waitingPeriod',
      waitingPeriod || 0
    );
    // formdata.append(
    //   'waitingPeriod',
    //   this.clientregform.value.waitingPeriod || 0
    // );
    formdata.append(
      'corporateEmployeesInitialSignupWaittime',
      this.clientregform.value.waitingPeriodinitialsignup
    );

    formdata.append('useCreditCard', creditCardinfo ? 'true' : 'false');

    // formdata.append('invoicePayment', invoicemonthy ? 'true' : 'false');
    //Invoices are not using so send as false
    formdata.append('invoicePayment', invoicemonthy ? 'false' : 'false');

    formdata.append('padPayment', padinfo ? 'true' : 'false');

    formdata.append('session', this.session);

    formdata.append('setupWallet', this.clientregform.value.walletConfig);

    formdata.append(
      'setUplevelofCoverage',
      this.clientregform.value.tierConfig
    );

    formdata.append(
      'exptNumofEmp',
      this.clientregform.value.expectednoofEmployees || 0
    );

    formdata.append(
      'streetAddressLine1',
      this.capitalize(this.clientregform.value.streetAddress) || ''
    );

    formdata.append(
      'streetAddressLine2',
      this.capitalize(this.clientregform.value.streetAddress2) || ''
    );
    formdata.append('apt', this.clientregform.value.apt_suite || '');

    formdata.append('city', this.capitalize(this.clientregform.value.city));

    formdata.append('province', this.clientregform.value.Province);

    formdata.append('provinceId', this.provincelistid);

    formdata.append('state', this.clientregform.value.Province);

    // formdata.append('stateId', this.state_id);
    formdata.append('stateId', this.stateId);
    formdata.append('fusebillStateId', this.fusebillStateId);
    // formdata.append('countryId', this.countryId);
    formdata.append('fusebillCountryId', this.fusebillCountryId);

    formdata.append('country', this.clientregform.value.country);

    formdata.append('countryId', '1');
    formdata.append('fbcountryId', '124');
    // formdata.append('parentId', this.clientregform.value.brokerName || 0);
    // formdata.append('parentId', this.clientregform.value.profile || 1); //1 is Groupbenefitz TPA/MGA
    formdata.append('parentId', this.updatedBrokerId); //1 is Groupbenefitz TPA/MGA


    formdata.append('postalCode', this.clientregform.value.postalCode);
    // formdata.append(
    //   'corporateClientId',
    //   sessionStorage.getItem('corporateClientId') ||
    //   environment.corporateClientId
    // ); //fusebillid
    formdata.append(
      'corporateId',
      sessionStorage.getItem('corporateId') || '0'
    ); //corporateid
    // formdata.append('originalBrokerId', this.clientregform.value.profile);
    // formdata.append('paymentPlatform', this.clientregform.value.paymentPlatform ?? this.paymentPlatform);
    formdata.append('paymentPlatform', this.paymentPlatform);
    formdata.append('authorizenetCustomerId', this.clientregform.value.authorizenetCustomerId);
    formdata.append('contactEmail', this.contactEmail);

    formdata.append('corporateClientId', sessionStorage.getItem('corporateClientId')!='0'?
      sessionStorage.getItem('corporateClientId'):(sessionStorage.getItem('corporateId')||environment.corporateClientId));

    this.clientregform.value['logo'] = logoDetails;
    sessionStorage.setItem(
      'formData',
      JSON.stringify(this.clientregform.value)
    );

    var requestOptions: any = {
      method: 'POST',
      body: formdata,
      redirect: 'follow',
      headers: { Authorization: 'Bearer ' + accessToken },
    };

    // console.log(requestOptions)

    fetch(environment.apiUrl + customerValidation, requestOptions)
      .then((response) => response.text())

      .then(
        async (response: any) => {
          // console.log(response);
          response = JSON.parse(response);
          if (response['status'] == 200) {
            this.plansBlock1 = response.plans.packages;
            this.balkPlans = response.plans.bulkPackages;

            this.corporateTiers = response.data.corporateTiers


            this.plansBlock1Tiers = response.plans.packages;

            this.showAddTier = false;
            setTimeout(()=>{
              if(this.isAddTier){
                this.showAddTier = true;
              }else{
                this.showEditTier = true;
              }
              this.ref.detectChanges();
            },100)

          } else if (response['status'] == 202) {
            // this._LoaderService.HideLoader()
            // $('#basicformSubmit1stScreen').prop('disabled',false)
            // Swal.fire(this.lang.Error??'Error',response.message);
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          } else {
            // this._LoaderService.HideLoader()
            // $('#basicformSubmit1stScreen').prop('disabled',false)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message || response.error || response.error.error });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message || error.error || error.error.message || error.message,
              showDenyButton: false,
              showCancelButton: true,
              confirmButtonText: 'Proceed',
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
    this.scrollToFirstInvalidControl1();
    setTimeout(() => {
      this._LoaderService.HideLoader();
    }, 1000);

    setTimeout(() => {
      this._LoaderService.HideLoader();
    }, 2000);


  }
  executeBlocks() {
    return new Promise((resolve, reject) => {
      // First block of code
      console.log("Executing block 1");

      console.log(this.bulkplans)

      if (this.bulkplans.length > 0) {
        for (let i = 0; i < this.bulkplans.length; i++) {


          setTimeout(() => {
            // this.showHeadCount[this.bulkplans[i].planLevelId] = this.bulkplans[i].quantity

            const element: any = $("#plancheckboxbulk" + this.bulkplans[i].planLevelId);
            if (element != null && !element.prop("checked")) {
              // Only click or check if it's not already checked
              element.click()
              this.showHeadCount[this.bulkplans[i].planLevelId] = this.bulkplans[i].quantity
            }
            // if (this.bulkplans[i].planLevelId == 20) {
            //   const element: any = $("#plancheckboxbulk" + this.bulkplans[i].planLevelId);
            //   if (element != null)
            //     element.click()
            //   // setTimeout(() => {
            //   //   // this.showEmployeeValue = this.bulkplans[i].quantity

            //   // }, 10);

            //   if (this.bulkplans[i].subscriptionId && this.bulkplans[i].status != "Draft") {
            //     $("#plancheckboxbulk19").prop("disabled", true);
            //     $("#plancheckboxbulk20").prop("disabled", true);
            //     $("#plancheckboxbulk21").prop("disabled", true);
            //     $("#plancheckboxbulk33").prop("disabled", true);

            //   }
            // }
            // else if (this.bulkplans[i].planLevelId == 34) {
            //   const element: any = $("#plancheckboxbulk" + this.bulkplans[i].planLevelId);
            //   if (element != null)
            //     element.click()
            //   // setTimeout(() => {
            //   //   this.showEmployeeValue1 = this.bulkplans[i].quantity
            //   // }, 10);



            // }
            // else {
            //   const element: any = $("#plancheckboxbulk" + this.bulkplans[i].planLevelId);
            //   if (element != null)
            //     element.click()
            //   // setTimeout(() => {
            //   //   this.showEmployeeValue = this.bulkplans[i].quantity
            //   // }, 10);



            // }

            if (i === this.bulkplans.length - 1) {
              if (this.paidByCompany?.length > 0 || this.coveredByCompany?.length > 0 || this.paidByEmployee?.length > 0) {
                for (let i = 0; i < this.paidByCompany?.length; i++) {
                  setTimeout(() => {
                    let selectedCoverage = this.paidByCompany[i].companyPaidCoverage ?? "DIRECT"
                    if (selectedCoverage == "null") {
                      selectedCoverage = "DIRECT"
                    }

                    console.log(selectedCoverage)
                    this.getPlanCoverage[this.paidByCompany[i].planLevelId] = selectedCoverage
                    const element: any = $("#plancheck" + this.paidByCompany[i].planLevelId);
                    console.log({ element })
                    if (element != null)
                      element.click()




                    console.log(`Block 1 - Task ${i + 1} completed`);
                    console.log(i)
                    console.log(this.paidByCompany?.length - 1)
                    if (i === this.paidByCompany?.length - 1) {
                      // Second block of code

                      console.log("Executing block 2");


                      setTimeout(() => {
                        if (this.coveredByCompany?.length > 0) {
                          console.log("cehckheree")
                          let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
                          if (el1 != null) el1.click();
                          this.upgradeplansselection == true;

                          for (let j = 0; j < this.coveredByCompany?.length; j++) {
                            setTimeout(() => {
                              const element: any = $("#plancheck2Upgrade" + this.coveredByCompany[j].planLevelId);
                              if (element != null) element.click();

                              console.log(`Block 2 - Task ${j + 1} completed`);
                              if (j === this.coveredByCompany?.length - 1) {
                                // Third block of code
                                console.log("Executing block 3");

                                setTimeout(() => {
                                  if (this.paidByEmployee?.length > 0) {
                                    let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                                    if (el1 != null) el1.click();
                                    this.employeeplanpurchase == true
                                    for (let k = 0; k < this.paidByEmployee?.length; k++) {
                                      setTimeout(() => {
                                        const element: any = $("#plancheck3Voluntry" + this.paidByEmployee[k].planLevelId);
                                        element.click()


                                        console.log(`Block 3 - Task ${k + 1} completed`);
                                        if (k === this.paidByEmployee?.length - 1) {
                                          resolve("All blocks executed successfully");
                                        }
                                      }, 1500);
                                    }
                                  }
                                }, 1000);

                              }
                            }, 1000);
                          }
                        }
                        if (this.coveredByCompany?.length == 0 && this.paidByEmployee?.length > 0) {
                          let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                          if (el1 != null) el1.click();
                          this.employeeplanpurchase == true
                          for (let k = 0; k < this.paidByEmployee?.length; k++) {
                            setTimeout(() => {
                              const element: any = $("#plancheck3Voluntry" + this.paidByEmployee[k].planLevelId);
                              element.click()

                              // setTimeout(() => {
                              //   let block1 = JSON.parse(
                              //     sessionStorage.getItem('summaryBlock3') || '[]'
                              //   );
                              //   for (let z = 0; z < block1.length; z++) {
                              //     if (block1[z].subGroupId == this.paidByEmployee[i].planLevelId) {
                              //       block1[z].id = this.paidByEmployee[i].id
                              //     }
                              //   }
                              //   sessionStorage.setItem('summaryBlock3', JSON.stringify(block1))
                              // }, 4000)

                              let plancheck3Coverage = this.getExecutiveCoveragesFromCode(this.paidByEmployee[k].coverage)


                              if (
                                plancheck3Coverage
                              ) {
                                console.log(this.plancheck3Coverage);
                                if (plancheck3Coverage.single) {
                                  setTimeout(() => {
                                    $("#executiveplansblock3single" + this.paidByEmployee[k].planLevelId).click()
                                  }, 100);
                                } if (plancheck3Coverage.couple) {
                                  setTimeout(() => {
                                    $("#executiveplansblock3couple" + this.paidByEmployee[k].planLevelId).click()
                                  }, 100);
                                } if (plancheck3Coverage.family) {
                                  setTimeout(() => {
                                    $("#executiveplansblock3family" + this.paidByEmployee[k].planLevelId).click()
                                  }, 100);
                                }
                              }
                              console.log(`Block 3 - Task ${k + 1} completed`);
                              if (k === this.paidByEmployee?.length - 1) {
                                resolve("All blocks executed successfully");
                              }
                            }, 1500);
                          }
                        }
                      }, 2000);

                    }
                  }, 1000);
                }


              }
            }
          }, 1000);



        }
      }
      else if (this.paidByCompany?.length > 0 || this.coveredByCompany?.length > 0 || this.paidByEmployee?.length > 0) {

        for (let i = 0; i < this.paidByCompany?.length; i++) {
          setTimeout(() => {
            let selectedCoverage = this.paidByCompany[i].companyPaidCoverage ?? "DIRECT"
            if (selectedCoverage == "null") {
              selectedCoverage = "DIRECT"
            }


            // console.log(this.capitalize(selectedCoverage))
            this.getPlanCoverage[this.paidByCompany[i].planLevelId] = selectedCoverage
            const element: any = $("#plancheck" + this.paidByCompany[i].planLevelId);
            console.log({ element })
            if (element != null)
              element.click()
            console.log(`Block 1 - Task ${i + 1} completed`);
            console.log(i)
            console.log(this.paidByCompany?.length - 1)
            if (i === this.paidByCompany?.length - 1) {
              // Second block of code

              console.log("Executing block 2");


              setTimeout(() => {
                if (this.coveredByCompany?.length > 0) {
                  console.log("cehckheree")
                  let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
                  if (el1 != null) el1.click();
                  this.upgradeplansselection == true;

                  for (let j = 0; j < this.coveredByCompany?.length; j++) {
                    setTimeout(() => {
                      const element: any = $("#plancheck2Upgrade" + this.coveredByCompany[j].planLevelId);
                      if (element != null) element.click();


                      if (j === this.coveredByCompany?.length - 1) {
                        // Third block of code
                        console.log("Executing block 3");

                        setTimeout(() => {
                          if (this.paidByEmployee?.length > 0) {
                            let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                            if (el1 != null) el1.click();
                            this.employeeplanpurchase == true
                            for (let k = 0; k < this.paidByEmployee?.length; k++) {
                              setTimeout(() => {
                                const element: any = $("#plancheck3Voluntry" + this.paidByEmployee[k].planLevelId);
                                element.click()
                                console.log(`Block 3 - Task ${k + 1} completed`);
                                if (k === this.paidByEmployee?.length - 1) {
                                  resolve("All blocks executed successfully");
                                }
                              }, 1500);
                            }
                          }
                        }, 1000);

                      }
                    }, 1000);
                  }
                }
                if (this.coveredByCompany?.length == 0 && this.paidByEmployee?.length > 0) {
                  let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                  if (el1 != null) el1.click();
                  this.employeeplanpurchase == true
                  for (let k = 0; k < this.paidByEmployee?.length; k++) {
                    setTimeout(() => {
                      const element: any = $("#plancheck3Voluntry" + this.paidByEmployee[k].planLevelId);
                      element.click()
                      console.log(`Block 3 - Task ${k + 1} completed`);
                      if (k === this.paidByEmployee?.length - 1) {
                        resolve("All blocks executed successfully");
                      }
                    }, 1500);
                  }
                }
              }, 2000);





            }
          }, 1000);
        }
      }

      setTimeout(() => {
        let block1 = JSON.parse(
          sessionStorage.getItem('summaryBlock1') || '[]'
        );
        for (let i = 0; i < this.paidByCompany?.length; i++) {
          for (let z = 0; z < block1.length; z++) {

            if (block1[z].subGroupId == this.paidByCompany[i].planLevelId) {
              block1[z].id = this.paidByCompany[i].id
            }
          }
        }
        sessionStorage.setItem('summaryBlock1', JSON.stringify(block1))

        let block2 = JSON.parse(
          sessionStorage.getItem('summaryBlock2') || '[]'
        );
        console.log(this.coveredByCompany)
        for (let i = 0; i < this.coveredByCompany?.length; i++) {
          for (let z = 0; z < block2.length; z++) {

            if (block2[z].subGroupId == this.coveredByCompany[i].planLevelId) {
              block2[z].id = this.coveredByCompany[i].id
            }
          }
        }
        console.log({ block2 })
        sessionStorage.setItem('summaryBlock2', JSON.stringify(block2))

        let block3 = JSON.parse(
          sessionStorage.getItem('summaryBlock3') || '[]'
        );
        for (let i = 0; i < this.paidByEmployee?.length; i++) {
          for (let z = 0; z < block3.length; z++) {

            if (block3[z].subGroupId == this.paidByEmployee[i].planLevelId) {
              block3[z].id = this.paidByEmployee[i].id
            }
          }
        }
        sessionStorage.setItem('summaryBlock3', JSON.stringify(block3))
      }, 10000)


    })
  }

  async executeBlocks2() {
    try {
      // First block of code
      console.log("Executing block 1");
      await this.block1();

      // Second block of code
      console.log("Executing block 2");
      await this.block2();

      // Third block of code
      console.log("Executing block 3");
      await this.block3();

      console.log("All blocks executed successfully");
    } catch (error) {
      console.error("An error occurred:", error);
    }
  }

  async block1() {
    return new Promise<void>((resolve, reject) => {
      // Simulating some asynchronous operation
      setTimeout(() => {
        if (this.paidByCompany?.length > 0) {
          for (let i = 0; i < this.paidByCompany?.length; i++) {
            const element: any = $("#plancheck" + this.paidByCompany[i].planLevelId);
            if (element != null)
              element.click()
          }

        }


        resolve();
      }, 1000);
    });
  }

  async block2() {
    return new Promise<void>((resolve, reject) => {
      // Simulating some asynchronous operation
      setTimeout(() => {
        if (this.coveredByCompany?.length > 0) {
          let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
          if (el1 != null) el1.click();
          this.upgradeplansselection == true;

          setTimeout(() => {
            for (let i = 0; i < this.coveredByCompany?.length; i++) {
              const element: any = $("#plancheck2Upgrade" + this.coveredByCompany[i].planLevelId);
              if (element != null) element.click();
            }
          }, 1500);
        }
        resolve();
      }, 1000);
    });
  }

  async block3() {
    return new Promise<void>((resolve, reject) => {
      // Simulating some asynchronous operation
      setTimeout(() => {

        if (this.paidByEmployee?.length > 0) {
          let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
          if (el1 != null) el1.click();
          this.employeeplanpurchase == true
          // setTimeout(() => {
          for (let i = 0; i < this.paidByEmployee?.length; i++) {
            const element: any = $("#plancheck3Voluntry" + this.paidByEmployee[i].planLevelId);
            element.click()


          }
          // }, 1000);
        }
        resolve();
      }, 1000);
    });
  }

  scrollToFirstInvalidControl1() {
    const firstInvalidControl: HTMLElement =
      this.elementRef.nativeElement.querySelector(
        'form .ng-invalid'
      );

    // console.log(firstInvalidControl)
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: 'smooth',
    });
  }
  getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 300;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

  getIds(arr) {
    console.log({ arr })
    let i = arr.map((i) => i.id)
    console.log({ i })
    return i
  }

  getcorporateTieredplanLevelIds(paidByCompany, coveredByCompany, paidByEmployees) {
    let ids: any = []

    if (paidByCompany?.length > 0) {
      ids = [...ids, ...this.getIds(paidByCompany)]
      console.log(ids)

    }
    if (coveredByCompany?.length > 0) {
      ids = [...ids, ...this.getIds(coveredByCompany)]
      console.log(ids)

    }

    if (paidByEmployees?.length > 0) {
      ids = [...ids, ...this.getIds(paidByEmployees)]
      console.log(ids)

    }
    console.log(ids)
    ids = Array.from(new Set(ids));
    console.log(ids)
    return ids
  }
  getPaidByCompanyPlanLevelNames(plans: any[]): string {
    return plans
      .map(plan => plan?.planLevelName || '') // Ensure safe access
      .filter(name => name !== '') // Remove empty values
      .join(`<br>`);
  }
  getCoveredByCompanyPlanLevelNames(plans: any[]): string {
    return plans.map(plan => plan.planLevelName).join(`<br>`);
  }
  getEmployeePaidPlanLevelNames(plans: any[]): string {
    return plans.map(plan => plan.planLevelName).join(`<br>`);
  }
  getCoverage(coverage: any): string {
    if (coverage == '001') {
      return 'Single'
    } else if (coverage == '010') {
      return 'Couple'
    } else if (coverage == '100') {
      return 'Family'
    }

  }

  public submitplansInfo() {
    let palnRes = sessionStorage.getItem('planResults') || '[]';

    let Block1 = sessionStorage.getItem('summaryBlock1') || '[]';

    // return false;

    this.corporationclient = this.clientregform.value.corporationName;
    // let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    // return false
    var corporateId = sessionStorage.getItem('corporateId');

    var accessToken = sessionStorage.getItem('accessToken');
    // var endPoint = '/api/ap/admin/corporate/' + corporateId + '/planSelections';
    var endPoint = `/api/ap/admin/corporate/${corporateId}/tier/${this.crateTierid}/plans`

    let paidByCompany: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let coveredByCompany: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let paidByEmployees: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let bulkPlans: { planLevelId: any; quantity: any, tierId: number; parentPlanLevelId: number; subGrpname: any }[] = [];

    // let TierlistforGrapsh: { planLevelName: any; tierId: number }[] = [];
    let summaryBluckplans = [];
    let summaryBlock1 = [];
    let summaryBlock2 = [];
    let summaryBlock3 = [];

    let summaryBlockBulkA = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    let summaryBlock1A = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let summaryBlock2A = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );

    let summaryBlock3A = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );

    console.log({ summaryBlock1A })

    summaryBluckplans = summaryBlockBulkA.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      )));
    summaryBlock1 = summaryBlock1A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      ))
    );
    summaryBlock2 = summaryBlock2A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      ))
    );
    summaryBlock3A = summaryBlock3A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.subGroupId === item.subGroupId
      ))
    );


    let summaryTiersBlock3 = JSON.parse(
      sessionStorage.getItem('selectedTiersBlock3') || '[]'
    );
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    this.tierConfigCheck = formData.tierConfig == true ? true : false;
    this.walletConfigCheck = formData.walletConfig == true ? true : false;


    this.upgradertierscheck = this.upgradeplansselection;
    this.employeeplanpurchasetierscheck = this.employeeplanpurchase;

    if (this.tierConfigCheck || this.walletConfigCheck) {

      if (this.tierConfigCheck) {
        if (this.addTierForm.invalid) {

          console.log(JSON.stringify(this.addTierForm.value, null, 2));
          this.addTierForm.markAllAsTouched();

          this.scrollToFirstInvalidControl1()
          return;
        }
      }
      if (this.addWalletForm.invalid) {
        if (this.addWalletForm.invalid) {
          this.addWalletForm.markAllAsTouched();
          this.scrollToFirstInvalidControl1()
          return;
        }
      }
      else {
        var accessToken = sessionStorage.getItem('accessToken');
        var corporateId = sessionStorage.getItem('corporateId');
        var endPoint = '/api/ap/admin/corporate/' + corporateId + '/tiers';
        var walletendPoint = '/api/ap/admin/corporate/' + corporateId + '/tier';
        let formData = JSON.parse(sessionStorage.getItem('formData') || '');

        if (this.tierConfigCheck && this.walletConfigCheck) {

          let tiersObj = {
            name: this.addTierForm.value.tierName,
            description: this.addTierForm.value.tierDescription,
            effectiveDate: this.datePipe.transform(this.addTierForm.value.tierEffectiveDate, 'yyyy-MM-dd') || '',
            timeOfService: JSON.parse(this.addTierForm.value.tierTimeOfService),
            timeOfServiceValue: 'Years',
            minimumTimeOfSerivce: +this.addTierForm.value.mintierTimeOfService || 0,
            maximumTimeOfService: +this.addTierForm.value.maxtierTimeOfService || 0,
            wawanesaApplicable: false
          }

          this.http
            .post(environment.apiUrl + endPoint, tiersObj, {
              // .post(environment.apiUrl + endPoint, {...this.planRequestBody, mode:'edit'}, {
              // .post('http://[::1]:3002' + endPoint, {...this.planRequestBody,mode:'edit'}, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  this.crateTierid = response.data.id

                  let walletObj = {
                    walletType: this.addWalletForm.value.walletType,
                    walletAmount: parseFloat(this.addWalletForm.value?.walletAmount?.replace(/,/g, '')),
                    effectiveDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd') || '',
                    coveragePercentage: +this.addWalletForm.value.coveragePerecentage,
                    industryCategory: "Accounting Services",
                    carryForwardUnusedAmount: JSON.parse(this.addWalletForm.value.carryForwordAmount),
                    rolloverAllocationPeriod: this.addWalletForm.value.allocation,
                    initialBalanceSetup: this.addWalletForm.value.intialBalanceSetup,
                    advisorFeeStructure: 12,

                  }

                  this.http
                    .post(environment.apiUrl + walletendPoint + "/" + this.crateTierid + "/wallet", walletObj, {

                      headers: {
                        Authorization: 'Bearer ' + accessToken,
                        'Content-Type': 'application/json',
                      },
                    })
                    .subscribe(
                      (response: any) => {
                        if (response['status'] == 200) {

                          summaryBlockBulkA.forEach((element: any) => {
                            let obj: any = {
                              planLevelId: parseInt(element.subGroupId),//subGroupId
                              tierId: this.crateTierid,
                              quantity: element.subGroupId != 38 ? parseInt(this.showHeadCount[element.subGroupId]) : 0,
                              coverage: element.coverage ? element.coverage : '',
                              parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                              subGrpname: element.subGrpname,
                              planLevelName: element.subGrpname
                              // subscriptionId: subscriptionId
                            };

                            let subsId = this.bulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
                            console.log({ subsId })
                            if (subsId && subsId.length > 0 && subsId[0].subscriptionId) {
                              obj.subscriptionId = subsId[0].subscriptionId
                            }
                            else {
                              obj.subscriptionId = 0
                            }

                            bulkPlans.push(obj);

                          });
                          summaryBlock1A.forEach((element: any) => {
                            console.log("1212121212", element)
                            let obj = {
                              id: element.id,
                              planLevelId: parseInt(element.subGroupId),//subGroupId
                              tierId: this.crateTierid,
                              coverage: element.coverage ? element.coverage : '',
                              parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                              settings: element?.settingsAdditional || {},
                              companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT",
                              planLevelName: element.subGrpname
                            };
                            paidByCompany.push(obj);
                          });


                          summaryBlock2A.forEach((element: any) => {

                            let obj = {
                              id: element.id,
                              planLevelId: parseInt(element.subGroupId),
                              tierId: this.crateTierid,
                              coverage: element.coverage ? element.coverage : '',
                              parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                              settings: element?.settingsAdditional || {},
                              planLevelName: element.subGrpname

                            };
                            coveredByCompany.push(obj);
                          });

                          summaryBlock3A.forEach((element: any) => {
                            let obj = {
                              id: element.id,
                              planLevelId: parseInt(element.subGroupId),
                              tierId: this.crateTierid,
                              coverage: element.coverage ? element.coverage : '',
                              parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                              settings: element?.settingsAdditional || {},
                              planLevelName: element.subGrpname

                            };
                            paidByEmployees.push(obj);
                          });
                          
                          
                          this.planRequestBody = {
                            configuration: {
                              tier: formData.tierConfig == true ? true : false,
                              wallet: formData.walletConfig == true ? true : false,
                            },
                            paidByCompany: paidByCompany,
                            bulkPlans: bulkPlans,
                            bulkPlansIncluded: bulkPlans.length > 0 ? true : false,
                            // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
                            // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
                            coveredByCompany: coveredByCompany?.length > 0 ? coveredByCompany : [],
                            paidByEmployee: paidByEmployees?.length > 0 ? paidByEmployees : [],
                            enableCoveredByCompany: this.upgradeplansselection
                              ? true
                              : false || this.upgradeplansselectiontiers
                                ? true
                                : false,
                            enablePaidByEmployee: this.employeeplanpurchase
                              ? true
                              : false || this.employeeplanpurchasetiers
                                ? true
                                : false,
                            corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompanyDefault, this.coveredByCompanyDefault, this.paidByEmployeeDefault),
                            defaultTier: 0,
                            payRollDeduction: "YES",
                            requireEmployeeName: JSON.parse(sessionStorage.getItem('requireEmployeeName')),
                          };
                          console.log(this.planRequestBody)
                          if (this.upgradeplansselection == true) {
                            let selectedplansblock2 = JSON.parse(
                              sessionStorage.getItem('summaryBlock2') || '[]'
                            );

                            if (selectedplansblock2.length > 0) {

                            } else {
                              Swal.fire({ title: this.lang.Info, text: "Please select one Upgrade plan" });
                              return false;
                            }
                          }

                          if (this.employeeplanpurchase == true) {
                            let selectedplansblock3 = JSON.parse(
                              sessionStorage.getItem('summaryBlock3') || '[]'
                            );

                            if (selectedplansblock3.length > 0) {

                            } else {
                              Swal.fire({ title: this.lang.Info, text: "Please select one voluntary plan" });
                              return false;
                            }
                          }
                          console.log(paidByCompany)
                          const paidByCompanyfilteredPlans = summaryBlock1A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                          const paidByCompanyfilteredExecutive = summaryBlock1A.filter((plan: any) => plan.subGroupId == 18);

                          const coveredByCompanyfilteredPlans = summaryBlock2A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                          const coveredByCompanyfilteredExecutive = summaryBlock2A.filter((plan: any) => plan.subGroupId == 18);

                          const paidByEmployeesfilteredPlans = summaryBlock3A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                          const paidByEmployeesfilteredExecutive = summaryBlock3A.filter((plan: any) => plan.subGroupId == 18);

                          console.log(coveredByCompanyfilteredPlans)
                          console.log(coveredByCompanyfilteredExecutive)
                          if (paidByCompanyfilteredPlans.length > 0) {
                            if (paidByCompanyfilteredExecutive.length > 0) {

                            } else {
                              Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Core Plans" });
                              return false;
                            }
                          }
                          if (coveredByCompanyfilteredPlans.length > 0) {
                            if (coveredByCompanyfilteredExecutive.length > 0) {

                            } else {
                              Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Upgrade Plans" });
                              return false;
                            }
                          }
                          if (paidByEmployeesfilteredPlans.length > 0) {
                            if (paidByEmployeesfilteredExecutive.length > 0) {

                            } else {
                              Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Voluntry Plans" });
                              return false;
                            }
                          }


                          // this.submitplansSections()
                          if (coveredByCompany?.length > 1) {
                            // $('#payrolldeduction-modal').modal('show');
                            // this.payrolldeductionoption.reset();

                            let bulkplansCheck = bulkPlans.filter(
                              (element: any) => Number.isNaN(element.quantity)
                            );
                            let bulkplansCheckCloud = bulkPlans.filter(
                              (element: any) => element.planLevelId == "33"
                            );

                            if (bulkplansCheck.length > 0) {
                              for (let i = 0; i < bulkplansCheck.length; i++) {
                                Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                                return false;
                              }
                            } else {
                              this.plansSumitInfo()
                            }
                            console.log(bulkplansCheck)
                            // if (bulkplansCheck.length > 0) {
                            //   Swal.fire({ title: this.lang.Info, text: "Please enter head count" });
                            //   return false;
                            // }
                            // else {
                            //   if (bulkplansCheckCloud.length > 0) {
                            //     if (bulkplansCheckCloud[0].quantity >= 100) {

                            //       this.plansSumitInfo()

                            //     }
                            //     else {
                            //       Swal.fire({ title: this.lang.Info, text: "This is allowed only if the head count is minimum of 100" });
                            //       return false;


                            //     }
                            //   }
                            //   else {
                            //     this.submitplansSections();
                            //   }

                            // }

                          }
                          else {
                            this.payrollOptions = ""
                            // this.payrolldeduction=
                            let bulkplansCheck = bulkPlans.filter(
                              (element: any) => Number.isNaN(element.quantity)
                            );
                            let bulkplansCheckCloud = bulkPlans.filter(
                              (element: any) => element.planLevelId == "33"
                            );


                            console.log(bulkplansCheck)


                            if (bulkplansCheck.length > 0) {
                              for (let i = 0; i < bulkplansCheck.length; i++) {
                                Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                                return false;
                              }
                            } else {
                              this.plansSumitInfo()
                            }


                          }
                        } else {
                          Swal.fire({title:this.lang?.Info??'Info',text:response?.message});
                        }
                      })


                } else {
                  Swal.fire({title:this.lang?.Info??'Info',text:response?.message});
                }
              })
        }

        else if (this.tierConfigCheck) {
          let tiersObj = {
            name: this.addTierForm.value.tierName,
            description: this.addTierForm.value.tierDescription,
            effectiveDate: this.datePipe.transform(this.addTierForm.value.tierEffectiveDate, 'yyyy-MM-dd') || '',
            timeOfService: JSON.parse(this.addTierForm.value.tierTimeOfService),
            timeOfServiceValue: 'Years',
            minimumTimeOfSerivce: +this.addTierForm.value.mintierTimeOfService || 0,
            maximumTimeOfService: +this.addTierForm.value.maxtierTimeOfService || 0,
            wawanesaApplicable: false
          }

          this.http
            .post(environment.apiUrl + endPoint, tiersObj, {
              // .post(environment.apiUrl + endPoint, {...this.planRequestBody, mode:'edit'}, {
              // .post('http://[::1]:3002' + endPoint, {...this.planRequestBody,mode:'edit'}, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  this.crateTierid = response.data.id



                  summaryBlockBulkA.forEach((element: any) => {
                    let obj: any = {
                      planLevelId: parseInt(element.subGroupId),//subGroupId
                      tierId: this.crateTierid,
                      quantity: element.subGroupId != 38 ? parseInt(this.showHeadCount[element.subGroupId]) : 0,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      subGrpname: element.subGrpname,
                      planLevelName: element.subGrpname
                      // subscriptionId: subscriptionId
                    };

                    let subsId = this.bulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
                    console.log({ subsId })
                    if (subsId && subsId.length > 0 && subsId[0].subscriptionId) {
                      obj.subscriptionId = subsId[0].subscriptionId
                    }
                    else {
                      obj.subscriptionId = 0
                    }

                    bulkPlans.push(obj);

                  });
                  summaryBlock1A.forEach((element: any) => {
                    console.log("1212121212", element)
                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),//subGroupId
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT",
                      planLevelName: element.subGrpname
                    };
                    paidByCompany.push(obj);
                  });


                  summaryBlock2A.forEach((element: any) => {

                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      planLevelName: element.subGrpname

                    };
                    coveredByCompany.push(obj);
                  });

                  summaryBlock3A.forEach((element: any) => {
                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      planLevelName: element.subGrpname

                    };
                    paidByEmployees.push(obj);
                  });

                  this.planRequestBody = {
                    configuration: {
                      tier: formData.tierConfig == true ? true : false,
                      wallet: formData.walletConfig == true ? true : false,
                    },
                    paidByCompany: paidByCompany,
                    bulkPlans: bulkPlans,
                    bulkPlansIncluded: bulkPlans.length > 0 ? true : false,
                    // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
                    // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
                    coveredByCompany: coveredByCompany?.length > 0 ? coveredByCompany : [],
                    paidByEmployee: paidByEmployees?.length > 0 ? paidByEmployees : [],
                    enableCoveredByCompany: this.upgradeplansselection
                      ? true
                      : false || this.upgradeplansselectiontiers
                        ? true
                        : false,
                    enablePaidByEmployee: this.employeeplanpurchase
                      ? true
                      : false || this.employeeplanpurchasetiers
                        ? true
                        : false,
                    corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompanyDefault, this.coveredByCompanyDefault, this.paidByEmployeeDefault),
                    defaultTier: 0,
                    payRollDeduction: "YES",
                    requireEmployeeName: JSON.parse(sessionStorage.getItem('requireEmployeeName')),
                  };
                  console.log(this.planRequestBody)
                  if (this.upgradeplansselection == true) {
                    let selectedplansblock2 = JSON.parse(
                      sessionStorage.getItem('summaryBlock2') || '[]'
                    );

                    if (selectedplansblock2.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Please select one Upgrade plan" });
                      return false;
                    }
                  }

                  if (this.employeeplanpurchase == true) {
                    let selectedplansblock3 = JSON.parse(
                      sessionStorage.getItem('summaryBlock3') || '[]'
                    );

                    if (selectedplansblock3.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Please select one voluntary plan" });
                      return false;
                    }
                  }
                  console.log(paidByCompany)
                  const paidByCompanyfilteredPlans = summaryBlock1A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const paidByCompanyfilteredExecutive = summaryBlock1A.filter((plan: any) => plan.subGroupId == 18);

                  const coveredByCompanyfilteredPlans = summaryBlock2A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const coveredByCompanyfilteredExecutive = summaryBlock2A.filter((plan: any) => plan.subGroupId == 18);

                  const paidByEmployeesfilteredPlans = summaryBlock3A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const paidByEmployeesfilteredExecutive = summaryBlock3A.filter((plan: any) => plan.subGroupId == 18);

                  console.log(coveredByCompanyfilteredPlans)
                  console.log(coveredByCompanyfilteredExecutive)
                  if (paidByCompanyfilteredPlans.length > 0) {
                    if (paidByCompanyfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Core Plans" });
                      return false;
                    }
                  }
                  if (coveredByCompanyfilteredPlans.length > 0) {
                    if (coveredByCompanyfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Upgrade Plans" });
                      return false;
                    }
                  }
                  if (paidByEmployeesfilteredPlans.length > 0) {
                    if (paidByEmployeesfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Voluntry Plans" });
                      return false;
                    }
                  }


                  // this.submitplansSections()
                  if (coveredByCompany?.length > 1) {
                    // $('#payrolldeduction-modal').modal('show');
                    // this.payrolldeductionoption.reset();

                    let bulkplansCheck = bulkPlans.filter(
                      (element: any) => Number.isNaN(element.quantity)
                    );
                    let bulkplansCheckCloud = bulkPlans.filter(
                      (element: any) => element.planLevelId == "33"
                    );

                    if (bulkplansCheck.length > 0) {
                      for (let i = 0; i < bulkplansCheck.length; i++) {
                        Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                        return false;
                      }
                    } else {
                      this.plansSumitInfo()
                    }
                    console.log(bulkplansCheck)
                    // if (bulkplansCheck.length > 0) {
                    //   Swal.fire({ title: this.lang.Info, text: "Please enter head count" });
                    //   return false;
                    // }
                    // else {
                    //   if (bulkplansCheckCloud.length > 0) {
                    //     if (bulkplansCheckCloud[0].quantity >= 100) {

                    //       this.plansSumitInfo()

                    //     }
                    //     else {
                    //       Swal.fire({ title: this.lang.Info, text: "This is allowed only if the head count is minimum of 100" });
                    //       return false;


                    //     }
                    //   }
                    //   else {
                    //     this.submitplansSections();
                    //   }

                    // }

                  }
                  else {
                    this.payrollOptions = ""
                    // this.payrolldeduction=
                    let bulkplansCheck = bulkPlans.filter(
                      (element: any) => Number.isNaN(element.quantity)
                    );
                    let bulkplansCheckCloud = bulkPlans.filter(
                      (element: any) => element.planLevelId == "33"
                    );


                    console.log(bulkplansCheck)


                    if (bulkplansCheck.length > 0) {
                      for (let i = 0; i < bulkplansCheck.length; i++) {
                        Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                        return false;
                      }
                    } else {
                      this.plansSumitInfo()
                    }


                  }



                } else {
                  Swal.fire({title:this.lang?.Info??'Info',text:response?.message});
                }
              })
        }

        else if (this.walletConfigCheck) {

          let walletObj = {
            walletType: this.addWalletForm.value.walletType,
            walletAmount: parseFloat(this.addWalletForm.value?.walletAmount?.replace(/,/g, '')),
            effectiveDate: this.datePipe.transform(new Date(), 'yyyy-MM-dd') || '',
            coveragePercentage: +this.addWalletForm.value.coveragePerecentage,
            industryCategory: "Accounting Services",
            carryForwardUnusedAmount: JSON.parse(this.addWalletForm.value.carryForwordAmount),
            rolloverAllocationPeriod: this.addWalletForm.value.allocation,
            initialBalanceSetup: this.addWalletForm.value.intialBalanceSetup,
            advisorFeeStructure: 12,



          }

          this.http
            .post(environment.apiUrl + walletendPoint + "/" + this.crateTierid + "/wallet", walletObj, {

              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {

                  summaryBlockBulkA.forEach((element: any) => {
                    let obj: any = {
                      planLevelId: parseInt(element.subGroupId),//subGroupId
                      tierId: this.crateTierid,
                      quantity: element.subGroupId != 38 ? parseInt(this.showHeadCount[element.subGroupId]) : 0,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      subGrpname: element.subGrpname,
                      planLevelName: element.subGrpname
                      // subscriptionId: subscriptionId
                    };

                    let subsId = this.bulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
                    console.log({ subsId })
                    if (subsId && subsId.length > 0 && subsId[0].subscriptionId) {
                      obj.subscriptionId = subsId[0].subscriptionId
                    }
                    else {
                      obj.subscriptionId = 0
                    }

                    bulkPlans.push(obj);

                  });
                  summaryBlock1A.forEach((element: any) => {
                    console.log("1212121212", element)
                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),//subGroupId
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT",
                      planLevelName: element.subGrpname
                    };
                    paidByCompany.push(obj);
                  });


                  summaryBlock2A.forEach((element: any) => {

                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      planLevelName: element.subGrpname

                    };
                    coveredByCompany.push(obj);
                  });

                  summaryBlock3A.forEach((element: any) => {
                    let obj = {
                      id: element.id,
                      planLevelId: parseInt(element.subGroupId),
                      tierId: this.crateTierid,
                      coverage: element.coverage ? element.coverage : '',
                      parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
                      settings: element?.settingsAdditional || {},
                      planLevelName: element.subGrpname

                    };
                    paidByEmployees.push(obj);
                  });

                  this.planRequestBody = {
                    configuration: {
                      tier: formData.tierConfig == true ? true : false,
                      wallet: formData.walletConfig == true ? true : false,
                    },
                    paidByCompany: paidByCompany,
                    bulkPlans: bulkPlans,
                    bulkPlansIncluded: bulkPlans.length > 0 ? true : false,
                    // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
                    // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
                    coveredByCompany: coveredByCompany?.length > 0 ? coveredByCompany : [],
                    paidByEmployee: paidByEmployees?.length > 0 ? paidByEmployees : [],
                    enableCoveredByCompany: this.upgradeplansselection
                      ? true
                      : false || this.upgradeplansselectiontiers
                        ? true
                        : false,
                    enablePaidByEmployee: this.employeeplanpurchase
                      ? true
                      : false || this.employeeplanpurchasetiers
                        ? true
                        : false,
                    corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompanyDefault, this.coveredByCompanyDefault, this.paidByEmployeeDefault),
                    defaultTier: 0,
                    payRollDeduction: "YES",
                    requireEmployeeName: JSON.parse(sessionStorage.getItem('requireEmployeeName')),
                  };
                  console.log(this.planRequestBody)
                  if (this.upgradeplansselection == true) {
                    let selectedplansblock2 = JSON.parse(
                      sessionStorage.getItem('summaryBlock2') || '[]'
                    );

                    if (selectedplansblock2.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Please select one Upgrade plan" });
                      return false;
                    }
                  }

                  if (this.employeeplanpurchase == true) {
                    let selectedplansblock3 = JSON.parse(
                      sessionStorage.getItem('summaryBlock3') || '[]'
                    );

                    if (selectedplansblock3.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Please select one voluntary plan" });
                      return false;
                    }
                  }
                  console.log(paidByCompany)
                  const paidByCompanyfilteredPlans = summaryBlock1A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const paidByCompanyfilteredExecutive = summaryBlock1A.filter((plan: any) => plan.subGroupId == 18);

                  const coveredByCompanyfilteredPlans = summaryBlock2A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const coveredByCompanyfilteredExecutive = summaryBlock2A.filter((plan: any) => plan.subGroupId == 18);

                  const paidByEmployeesfilteredPlans = summaryBlock3A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
                  const paidByEmployeesfilteredExecutive = summaryBlock3A.filter((plan: any) => plan.subGroupId == 18);

                  console.log(coveredByCompanyfilteredPlans)
                  console.log(coveredByCompanyfilteredExecutive)
                  if (paidByCompanyfilteredPlans.length > 0) {
                    if (paidByCompanyfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Core Plans" });
                      return false;
                    }
                  }
                  if (coveredByCompanyfilteredPlans.length > 0) {
                    if (coveredByCompanyfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Upgrade Plans" });
                      return false;
                    }
                  }
                  if (paidByEmployeesfilteredPlans.length > 0) {
                    if (paidByEmployeesfilteredExecutive.length > 0) {

                    } else {
                      Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Voluntry Plans" });
                      return false;
                    }
                  }


                  // this.submitplansSections()
                  if (coveredByCompany?.length > 1) {
                    // $('#payrolldeduction-modal').modal('show');
                    // this.payrolldeductionoption.reset();

                    let bulkplansCheck = bulkPlans.filter(
                      (element: any) => Number.isNaN(element.quantity)
                    );
                    let bulkplansCheckCloud = bulkPlans.filter(
                      (element: any) => element.planLevelId == "33"
                    );

                    if (bulkplansCheck.length > 0) {
                      for (let i = 0; i < bulkplansCheck.length; i++) {
                        Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                        return false;
                      }
                    } else {
                      this.plansSumitInfo()
                    }
                    console.log(bulkplansCheck)
                    // if (bulkplansCheck.length > 0) {
                    //   Swal.fire({ title: this.lang.Info, text: "Please enter head count" });
                    //   return false;
                    // }
                    // else {
                    //   if (bulkplansCheckCloud.length > 0) {
                    //     if (bulkplansCheckCloud[0].quantity >= 100) {

                    //       this.plansSumitInfo()

                    //     }
                    //     else {
                    //       Swal.fire({ title: this.lang.Info, text: "This is allowed only if the head count is minimum of 100" });
                    //       return false;


                    //     }
                    //   }
                    //   else {
                    //     this.submitplansSections();
                    //   }

                    // }

                  }
                  else {
                    this.payrollOptions = ""
                    // this.payrolldeduction=
                    let bulkplansCheck = bulkPlans.filter(
                      (element: any) => Number.isNaN(element.quantity)
                    );
                    let bulkplansCheckCloud = bulkPlans.filter(
                      (element: any) => element.planLevelId == "33"
                    );


                    console.log(bulkplansCheck)


                    if (bulkplansCheck.length > 0) {
                      for (let i = 0; i < bulkplansCheck.length; i++) {
                        Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

                        return false;
                      }
                    } else {
                      this.plansSumitInfo()
                    }


                  }
                } else {
                  Swal.fire({title:this.lang?.Info??'Info',text:response?.message});
                }
              })

        }

      }
    }
    else {
      summaryBlockBulkA.forEach((element: any) => {
        let obj: any = {
          planLevelId: parseInt(element.subGroupId),//subGroupId
          tierId: 0,
          quantity: element.subGroupId != 38 ? parseInt(this.showHeadCount[element.subGroupId]) : 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          planLevelName: element.subGrpname
          // subscriptionId: subscriptionId
        };

        let subsId = this.bulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
        console.log({ subsId })
        if (subsId && subsId.length > 0 && subsId[0].subscriptionId) {
          obj.subscriptionId = subsId[0].subscriptionId
        }
        else {
          obj.subscriptionId = 0
        }

        bulkPlans.push(obj);

      });
      summaryBlock1A.forEach((element: any) => {
        console.log("1212121212", element)
        let obj = {
          id: element.id,
          planLevelId: parseInt(element.subGroupId),//subGroupId
          tierId: 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          settings: element?.settingsAdditional || {},
          companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT",
          planLevelName: element.subGrpname
        };
        paidByCompany.push(obj);
      });

      summaryBlock2A.forEach((element: any) => {

        let obj = {
          id: element.id,
          planLevelId: parseInt(element.subGroupId),
          tierId: 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          settings: element?.settingsAdditional || {},
          planLevelName: element.subGrpname

        };
        coveredByCompany.push(obj);
      });

      summaryBlock3A.forEach((element: any) => {
        let obj = {
          id: element.id,
          planLevelId: parseInt(element.subGroupId),
          tierId: 0,
          coverage: element.coverage ? element.coverage : '',
          parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
          settings: element?.settingsAdditional || {},
          planLevelName: element.subGrpname

        };
        paidByEmployees.push(obj);
      });
      this.planRequestBody = {
        configuration: {
          tier: formData.tierConfig == true ? true : false,
          wallet: formData.walletConfig == true ? true : false,
        },
        paidByCompany: paidByCompany,
        bulkPlans: bulkPlans,
        bulkPlansIncluded: bulkPlans.length > 0 ? true : false,
        // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
        // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
        coveredByCompany: coveredByCompany?.length > 0 ? coveredByCompany : [],
        paidByEmployee: paidByEmployees?.length > 0 ? paidByEmployees : [],
        enableCoveredByCompany: this.upgradeplansselection
          ? true
          : false || this.upgradeplansselectiontiers
            ? true
            : false,
        enablePaidByEmployee: this.employeeplanpurchase
          ? true
          : false || this.employeeplanpurchasetiers
            ? true
            : false,
        corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompanyDefault, this.coveredByCompanyDefault, this.paidByEmployeeDefault),
        defaultTier: 0,
        payRollDeduction: "YES",
        requireEmployeeName: JSON.parse(sessionStorage.getItem('requireEmployeeName')),
      };
      console.log(this.planRequestBody)
      if (this.upgradeplansselection == true) {
        let selectedplansblock2 = JSON.parse(
          sessionStorage.getItem('summaryBlock2') || '[]'
        );

        if (selectedplansblock2.length > 0) {

        } else {
          Swal.fire({ title: this.lang.Info, text: "Please select one Upgrade plan" });
          return false;
        }
      }

      if (this.employeeplanpurchase == true) {
        let selectedplansblock3 = JSON.parse(
          sessionStorage.getItem('summaryBlock3') || '[]'
        );

        if (selectedplansblock3.length > 0) {

        } else {
          Swal.fire({ title: this.lang.Info, text: "Please select one voluntary plan" });
          return false;
        }
      }
      console.log(paidByCompany)
      const paidByCompanyfilteredPlans = summaryBlock1A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
      const paidByCompanyfilteredExecutive = summaryBlock1A.filter((plan: any) => plan.subGroupId == 18);

      const coveredByCompanyfilteredPlans = summaryBlock2A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
      const coveredByCompanyfilteredExecutive = summaryBlock2A.filter((plan: any) => plan.subGroupId == 18);

      const paidByEmployeesfilteredPlans = summaryBlock3A.filter((plan: any) => plan.subGrpname.includes('La Vie'));
      const paidByEmployeesfilteredExecutive = summaryBlock3A.filter((plan: any) => plan.subGroupId == 18);

      console.log(coveredByCompanyfilteredPlans)
      console.log(coveredByCompanyfilteredExecutive)
      if (paidByCompanyfilteredPlans.length > 0) {
        if (paidByCompanyfilteredExecutive.length > 0) {

        } else {
          Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Core Plans" });
          return false;
        }
      }
      if (coveredByCompanyfilteredPlans.length > 0) {
        if (coveredByCompanyfilteredExecutive.length > 0) {

        } else {
          Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Upgrade Plans" });
          return false;
        }
      }
      if (paidByEmployeesfilteredPlans.length > 0) {
        if (paidByEmployeesfilteredExecutive.length > 0) {

        } else {
          Swal.fire({ title: this.lang.Info, text: "Select Complete Executive Care Plan along with La Vie in Voluntry Plans" });
          return false;
        }
      }


      // this.submitplansSections()
      if (coveredByCompany?.length > 1) {
        // $('#payrolldeduction-modal').modal('show');
        // this.payrolldeductionoption.reset();

        let bulkplansCheck = bulkPlans.filter(
          (element: any) => Number.isNaN(element.quantity)
        );
        let bulkplansCheckCloud = bulkPlans.filter(
          (element: any) => element.planLevelId == "33"
        );

        if (bulkplansCheck.length > 0) {
          for (let i = 0; i < bulkplansCheck.length; i++) {
            Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

            return false;
          }
        } else {
          this.plansSumitInfo()
        }
        console.log(bulkplansCheck)
        // if (bulkplansCheck.length > 0) {
        //   Swal.fire({ title: this.lang.Info, text: "Please enter head count" });
        //   return false;
        // }
        // else {
        //   if (bulkplansCheckCloud.length > 0) {
        //     if (bulkplansCheckCloud[0].quantity >= 100) {

        //       this.plansSumitInfo()

        //     }
        //     else {
        //       Swal.fire({ title: this.lang.Info, text: "This is allowed only if the head count is minimum of 100" });
        //       return false;


        //     }
        //   }
        //   else {
        //     this.submitplansSections();
        //   }

        // }

      }
      else {
        this.payrollOptions = ""
        // this.payrolldeduction=
        let bulkplansCheck = bulkPlans.filter(
          (element: any) => Number.isNaN(element.quantity)
        );
        let bulkplansCheckCloud = bulkPlans.filter(
          (element: any) => element.planLevelId == "33"
        );


        console.log(bulkplansCheck)

        if (bulkplansCheck.length > 0) {
          for (let i = 0; i < bulkplansCheck.length; i++) {
            Swal.fire({ title: this.lang.Info, text: `Please enter head count for ${bulkplansCheck[i].subGrpname} ` });

            return false;
          }
        } else {
          this.plansSumitInfo()
        }


      }

    }

    // if (formData.tierConfig == false) {


    //   this.upgradertierscheck = this.upgradeplansselection;
    //   this.employeeplanpurchasetierscheck = this.employeeplanpurchase;
    //   // console.l


    //   summaryBlockBulkA.forEach((element: any) => {
    //     let obj: any = {
    //       planLevelId: parseInt(element.subGroupId),//subGroupId
    //       tierId: 0,
    //       quantity: element.subGroupId != 38 ? parseInt(this.showHeadCount[element.subGroupId]) : 0,
    //       coverage: element.coverage ? element.coverage : '',
    //       parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
    //       subGrpname: element.subGrpname
    //       // subscriptionId: subscriptionId
    //     };

    //     let subsId = this.bulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
    //     console.log({ subsId })
    //     if (subsId && subsId.length > 0 && subsId[0].subscriptionId) {
    //       obj.subscriptionId = subsId[0].subscriptionId
    //     }
    //     else {
    //       obj.subscriptionId = 0
    //     }

    //     bulkPlans.push(obj);

    //   });
    //   summaryBlock1A.forEach((element: any) => {
    //     console.log("1212121212", element)
    //     let obj = {
    //       id: element.id,
    //       planLevelId: parseInt(element.subGroupId),//subGroupId
    //       tierId: 0,
    //       coverage: element.coverage ? element.coverage : '',
    //       parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
    //       settings: element?.settingsAdditional || {},
    //       companyPaidCoverage: this.getPlanCoverage[element.subGroupId]
    //     };
    //     paidByCompany.push(obj);
    //   });

    //   console.log({ paidByCompany },)

    //   summaryBlock2A.forEach((element: any) => {

    //     let obj = {
    //       id: element.id,
    //       planLevelId: parseInt(element.subGroupId),
    //       tierId: 0,
    //       coverage: element.coverage ? element.coverage : '',
    //       parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
    //       settings: element?.settingsAdditional || {}

    //     };
    //     coveredByCompany.push(obj);
    //   });

    //   summaryBlock3A.forEach((element: any) => {
    //     let obj = {
    //       id: element.id,
    //       planLevelId: parseInt(element.subGroupId),
    //       tierId: 0,
    //       coverage: element.coverage ? element.coverage : '',
    //       parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
    //       settings: element?.settingsAdditional || {}

    //     };
    //     paidByEmployees.push(obj);
    //   });
    // }
    // else {
    //   this.upgradertierscheck = this.upgradeplansselectiontiers;
    //   this.employeeplanpurchasetierscheck = this.employeeplanpurchasetiers;
    //   this.seelctedplanLevelTierMapping.forEach((element: any) => {
    //     element.tiers.forEach((tiers: any) => {
    //       let obj = {
    //         planLevelId: parseInt(element.subGroupid),
    //         tierId: parseInt(tiers.id),
    //         coverage: element.coverage,
    //         parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
    //       };
    //       paidByCompany.push(obj);
    //     });
    //   });
    //   console.log({ paidByCompany })

    //   this.seelctedplanLevelTierMapping.forEach((element: any) => {
    //     let array = [];
    //     element.tiers.forEach((tiers: any) => {
    //       let obj: any = {
    //         planLevelName: element.subGroupName,
    //         tierId: tiers.name,
    //       };
    //       this.TierlistforGrapsh.push(obj);
    //     });
    //   });
    //   this.seelctedplanLevelTierMappingBlock2.forEach((element: any) => {
    //     element.tiers.forEach((tiers: any) => {
    //       let obj = {
    //         planLevelId: parseInt(element.subGroupid),
    //         tierId: parseInt(tiers.id),
    //         coverage: element.coverage,
    //         parentPlanLevelId: element.parentId ? parseInt(element.parentId) : null,
    //       };
    //       coveredByCompany.push(obj);
    //     });
    //   });
    //   this.seelctedplanLevelTierMappingBlock3.forEach((element: any) => {
    //     element.tiers.forEach((tiers: any) => {
    //       let obj = {
    //         planLevelId: parseInt(element.subGroupid),
    //         tierId: parseInt(tiers.id),
    //         coverage: element.coverage,
    //         parentPlanLevelId: element.parentId ? parseInt(element.parentId) : null,
    //       };
    //       paidByEmployees.push(obj);
    //     });
    //   });
    // }

    // console.log(typeof  formData.tierConfig)
    // console.log(formData.walletConfig)



  }

  public payrolldeductionConfirm() {

    console.log(this.payrolldeductionoption.value.payrolloption)
    this.payrollOptions = this.payrolldeductionoption.value.payrolloption

    this.planRequestBody['payRollDeduction'] = this.payrolldeductionoption.value.payrolloption
    $('#payrolldeduction-modal').modal('hide');
    this.planRequestBody['requireEmployeeName'] = sessionStorage.getItem(
      'requireEmployeeName'
    );
    this.submitplansSections()
  }
  public payrolldeductionCancel() {
    this.payrollOptions = ""
    this.planRequestBody['payRollDeduction'] = ""

    this.submitplansSections()

    //   console.log(this.planRequestBody.coveredByCompany)
    //   this.planRequestBody.coveredByCompany.forEach((element: any) => {
    //     let obj = {
    //       planLevelId: parseInt(element.subGroupId),
    //       tierId: 0,
    //       coverage: element.coverage ? element.coverage : '',
    //     };
    // if(obj.planLevelId ==17 || obj.planLevelId ==18){

    //   if(obj.coverage=="" || obj.coverage == "000"){
    //     alert("test")
    //   }
    // }
    // else{
    //   this.submitplansSections()
    // }

    //   });

  }

  submitplansSections() {




    // let bulkplancehck = this.planRequestBody.bulkPlans

    let summaryBlockBulk = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]')

    if (summaryBlockBulk.length > 0) {
      let bulkplancehck = this.planRequestBody.bulkPlans

      let array = []

      if (this.employeeList.length > 0) {
        for (let i = 0; i < this.employeeList.length; i++) {
          if (this.employeeList[i].isBulk == true) {
            array.push(this.employeeList[i])
          }
        }

      }

      for (let i = 0; i < bulkplancehck.length; i++) {

        if (bulkplancehck[i].quantity >= 0) {
          let block1Bulkres = JSON.parse(sessionStorage.getItem('summaryBlockBulk'))
          // let obj={"quantity":this.showEmployeeValue}
          for (let i = 0; i < block1Bulkres.length; i++) {
            block1Bulkres[i]["quantity"] = +this.showEmployeeValue
          }
          // block1Bulkres["quantity"]=this.showEmployeeValue
          sessionStorage.setItem('summaryBlockBulk', JSON.stringify(block1Bulkres));

          // JSON.parse(sessionStorage.etItem('summaryBlockBulk'))
          // if (bulkplancehck[i].planLevelId == "20") {
          //   this.addedEmployeelist = this.employeeList
          //   this.plansSumitInfo()
          //   // if (bulkplancehck[i].quantity == array.length) {
          //   //   this.addedEmployeelist = this.employeeList
          //   //   this.plansSumitInfo()
          //   // }
          //   // else {
          //   //   if (array.length <= 0) {
          //   //     Swal.fire({ title: this.lang.Info, text: "Please upload Employee/Entity List" });

          //   //   } else {
          //   //     Swal.fire({ title: this.lang.Info, text: `Please check, head count is ${bulkplancehck[i].quantity} and upload Employee/Entity List is ${array.length}` });

          //   //   }

          //   // }

          // }

          // else if (bulkplancehck[i].planLevelId == "33") {


          //   if (bulkplancehck[i].quantity >= 100) {
          //     this.plansSumitInfo()
          //   }
          //   else {
          //     Swal.fire({ title: this.lang.Info, text: "This is allowed only if the head count is minimum of 100" });



          //   }

          // }
          // else {
          //   this.addedEmployeelist = this.showEmployeelist

          //   this.plansSumitInfo()

          // }

        }
        else {
          Swal.fire({ title: this.lang.Info, text: "Please enter head count" });

        }

      }
      this.plansSumitInfo()
    }
    else {
      this.plansSumitInfo()
    }

  }

  getPlanNames(plans: any) {
    let plansString: any = '';
    if (plans && plans.length > 0) {
      plansString = plans.map(item => item.name).join(', ');
    }

    return plansString;
  }
  gotoEmployeeScreen() {
    var corporateId = sessionStorage.getItem('corporateId');
    let goNext = false;
    let corporateTiers = this.corporateTiers?.filter((tier: any) => tier.status == 'Active')
    for (let i = 0; i < corporateTiers?.length; i++) {
      let item = corporateTiers[i];
      if (item.plans.paidByCompany.length > 0 ||
        item.plans.coveredByCompany.length > 0 ||
        item.plans.paidByEmployee.length > 0) {
        goNext = true;
        continue;
      }
    }
    if (goNext == false) {
      Swal.fire({
        title: "Info",
        text: 'Please select a plan before proceeding to the next step.'
      })
      return;
    }

    this.basicInfo = false;
    this.plansInfo = false;
    this.wallettierInfo = false;
    this.showTiersTable = false;
    this.nowalletnotierInfo = false;
    this.walletData = 'Selected';
    this.TierData = 'Yes';
    this.GetCorpDetails2(corporateId)
  }

  // gotoEmployeeScreen() {
  //   var corporateId = sessionStorage.getItem('corporateId');

  //   this.basicInfo = false;
  //   this.plansInfo = false;
  //   this.wallettierInfo = false;
  //   this.showTiersTable = false;
  //   this.nowalletnotierInfo = false;
  //   this.walletData = 'Selected';
  //   this.TierData = 'Yes';
  //   this.GetCorpDetails1(corporateId)
  // }
  plansSumitInfo() {

    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint;
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    this.crateTierid = Number(sessionStorage.getItem('createId') ?? 0) ?? 0;
    endPoint = `/api/ap/admin/corporate/${corporateId}/tier/${this.crateTierid}/plans`;

    // if (formData.tierConfig == true) {
    //   endPoint = `/api/ap/admin/corporate/' + corporateId + '/tier/${this.crateTierid}/plans`;
    // }
    // else {
    //   endPoint = '/api/ap/admin/corporate/' + corporateId + '/planSelections';
    // }
    // console.log('this.planRequestBody',this.planRequestBody)
    // return;

    console.log('this.planRequestBody'+JSON.stringify(this.planRequestBody))
    this.planRequestBody = JSON.parse(sessionStorage.getItem('planRequestBody') ?? '[]')
    console.log('this.planRequestBody'+JSON.stringify(this.planRequestBody))
    let sessionBulkPlans = JSON.parse(sessionStorage.getItem('bulkplans') ?? '[]')
    
    const today = new Date();
    const firstOfMonth = new Date(today.getFullYear(), today.getMonth() + 2, 1);

    const yyyy = firstOfMonth.getFullYear();
    const mm = String(firstOfMonth.getMonth() + 1).padStart(2, '0');
    const dd = String(firstOfMonth.getDate()).padStart(2, '0');
    const nextMonth = `${yyyy}-${mm}-${dd}`;

    // this.planRequestBody.bulkPlans = this.planRequestBody?.bulkPlans.map((plan:any)=>{
    //   let foundPlan = sessionBulkPlans.find(pla=>pla.planLevelId==plan.planLevelId)
    //   if(foundPlan){
    //     if(foundPlan.terminationDate != undefined){
    //       return {
    //         ...plan, 
    //         terminationDate:foundPlan?.terminationDate ?? nextMonth,
    //         removePreviousPlanTermination: foundPlan?.removePreviousPlanTermination
    //       }
    //     }else if(foundPlan?.effectiveDate != undefined){
    //       return {...plan, effectiveDate:foundPlan?.effectiveDate}
    //     } else if(foundPlan?.activationDate != undefined && foundPlan?.status!='Draft'){
    //       return {...plan, activationDate: foundPlan.activationDate??''}
    //     }else return {...plan, effectiveDate: foundPlan.activationDate??''}
    //   }else{
    //     return {...plan}
    //   }
    // })

    for(let bulkPlan of this.bulkplans){
      let foundPlan = this.planRequestBody.bulkPlans.find(plan=>plan.planLevelId == bulkPlan.planLevelId);
      console.log('cancellation',!foundPlan)
      if(!foundPlan){
        this.planRequestBody.bulkPlans.push({
          ...bulkPlan,
          cancellation: true,
        })
      }else if(foundPlan && bulkPlan.status?.toLowerCase()=='draft'){
        this.planRequestBody.bulkPlans.push({
          ...bulkPlan,
          effectiveDate: foundPlan.activationDate,
        })
      }
    }

    console.log('this.planRequestBody'+JSON.stringify(this.planRequestBody))
    for(let plan of this.planRequestBody.bulkPlans){
      if(plan.terminationDate){
        console.log('plan.terminationDate',plan.terminationDate)
        console.log('plan.activationDate',plan.activationDate)
        if(moment(new Date(plan.terminationDate)).isBefore(moment(new Date(plan.activationDate)),'day')){
          Swal.fire({title:'Info',text:'Plan expiry date cannot be prior than activation date'})
          return;
        }
      }
      let foundPlan = this.bulkplans?.find(pla=>pla?.planLevelId == plan?.planLevelId);
      if(plan?.terminationDate == undefined && plan?.effectiveDate == undefined && plan?.cancellation == undefined && plan?.activationDate == undefined  && !foundPlan){
        console.log('plan',JSON.stringify(plan))
        console.log('plan',JSON.stringify(foundPlan))
        Swal.fire({title:'Info',text:'Please choose effective date for '+ plan?.planLevelName})
        return;
      }
    }

    console.log('this.planRequestBody'+JSON.stringify(this.planRequestBody))

    this.http
      .post(environment.apiUrl + endPoint, this.planRequestBody, {
      // .post(environment.apiUrl + endPoint, {...this.planRequestBody, mode:'edit'}, {
      // .post('http://[::1]:3002' + endPoint, this.planRequestBody, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {

            // show popup and if set ok then move next

            if (formData.tierConfig == true) {
              sessionStorage.setItem('summaryBlockBulk', '[]');
              sessionStorage.setItem('summaryBlock1', '[]');
              sessionStorage.setItem('summaryBlock2', '[]');
              sessionStorage.setItem('summaryBlock3', '[]');
            }


            if (response.data && Array.isArray(response.data.planSelections) && response.data.planSelections.length > 0) {
              let plansHtml: any = `<ul>`;
              if (response.data.planSelections.subscriptionUpdation && response.data.planSelections.subscriptionUpdation.plans.length > 0) {
                plansHtml += `<li style="color: ${response.data.planSelections.subscriptionUpdation.bgColor};">${this.getPlanNames(response.data.planSelections.subscriptionUpdation.plans) + ' ' + response.data.planSelections.subscriptionUpdation.note}</li>`;
              }

              if (response.data.planSelections.subscriptionConfirmation && response.data.planSelections.subscriptionConfirmation.plans.length > 0) {
                plansHtml += `<li style="color: ${response.data.planSelections.subscriptionConfirmation.bgColor};">${this.getPlanNames(response.data.planSelections.subscriptionConfirmation.plans) + ' ' + response.data.planSelections.subscriptionConfirmation.note}</li>`;
              }

              if (response.data.planSelections.subscriptionUpdationThroughCorporate && response.data.planSelections.subscriptionUpdationThroughCorporate.plans.length > 0) {
                plansHtml += `<li style="color: ${response.data.planSelections.subscriptionUpdationThroughCorporate.bgColor};">${this.getPlanNames(response.data.planSelections.subscriptionUpdationThroughCorporate.plans) + ' ' + response.data.planSelections.subscriptionUpdationThroughCorporate.note}</li>`;
              }

              plansHtml += `</ul>`;
              Swal.fire({
                title: 'Info',
                html: plansHtml,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.isAddTier = false;
                  this.showAddTier = false;
                  this.updateAllStatus();
                  this.EmployeeAddData = response.data.employeeKeys;

                  // this.employeeWorkingProviance=response.data.working_provinces;
                  this.employeeWorkingProviance = response.data.working_provinces.sort(
                    (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
                  );
                  // this.headerComponent.applicationStatus(7);

                  if (
                    formData.tierConfig == false &&
                    formData.walletConfig == false
                  ) {

                    let bulkplans = JSON.parse(sessionStorage.getItem('summaryBlock1'));
                    this.basicInfo = false;
                    this.plansInfo = false;
                    this.wallettierInfo = false;
                    this.nowalletnotierInfo = false;
                    this.EmployeeInfo = false;
                    this.datagraphInfo = false;
                    this.showTiersTable = false;
                    this.walletData = 'No';
                    this.TierData = 'No';
                    this.addedEmployeelist = this.employeeList

                    console.log(this.addedEmployeelist)
                    this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                      this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                        "message": "Corporates information has been updated. Please refresh screen."
                      }, {
                        headers: {
                          Authorization: 'Bearer ' + accessToken,
                          'Content-Type': 'application/json',
                        }
                      }).subscribe((res) => {
                        console.log({ res })
                      })
                    })
                    this.GetCorpDetails1(corporateId)
                    // this.getServiceWorkerDetails()
                    // if(bulkplans && bulkplans.length>0){

                    //   bulkplans.forEach(element => {

                    //     if(element.subGroupId=="20"){
                    //       this.basicInfo = false;
                    //       this.plansInfo = false;
                    //       this.wallettierInfo = false;
                    //       this.nowalletnotierInfo = false;
                    //       this.EmployeeInfo = true;
                    //       this.datagraphInfo = false;
                    //       this.walletData = 'No';
                    //       this.TierData = 'No';
                    //       this.GetCorpDetails1(corporateId)

                    //     }else{
                    //       this.basicInfo = false;
                    //       this.plansInfo = false;
                    //       this.wallettierInfo = false;
                    //       this.nowalletnotierInfo = false;
                    //       this.EmployeeInfo = false;
                    //       this.datagraphInfo = true;
                    //       this.walletData = 'No';
                    //       this.TierData = 'No';
                    //       this.GetCorpDetails1(corporateId)
                    //     }

                    //   });

                    // }
                    // else{
                    //   this.basicInfo = false;
                    //   this.plansInfo = false;
                    //   this.wallettierInfo = false;
                    //   this.nowalletnotierInfo = false;
                    //   this.EmployeeInfo = true;
                    //   this.walletData = 'No';
                    //   this.TierData = 'No';
                    //   this.GetCorpDetails1(corporateId)
                    // }

                  } else if (
                    formData.tierConfig == false &&
                    formData.walletConfig == true
                  ) {
                    this.basicInfo = false;
                    this.plansInfo = false;
                    this.wallettierInfo = false;
                    this.showTiersTable = false;
                    this.nowalletnotierInfo = false;
                    this.walletData = 'Selected';
                    this.TierData = 'No';
                    this.GetCorpDetails1(corporateId)
                    // this.getServiceWorkerDetails()
                  }
                  else if (
                    formData.tierConfig == true &&
                    formData.walletConfig == true
                  ) {
                    this.basicInfo = false;
                    this.plansInfo = false;
                    this.wallettierInfo = false;
                    this.showTiersTable = false;
                    this.nowalletnotierInfo = false;
                    this.walletData = 'Selected';
                    this.TierData = 'Selected';
                    this.GetCorpDetails1(corporateId)
                    // this.getServiceWorkerDetails()
                  } else if (
                    formData.tierConfig == true &&
                    formData.walletConfig == false
                  ) {
                    this.basicInfo = false;
                    this.plansInfo = false;
                    this.wallettierInfo = false;
                    this.showTiersTable = false;
                    this.nowalletnotierInfo = false;
                    this.EmployeeInfo = false;
                    this.walletData = 'No';
                    this.TierData = 'Selected';
                    this.GetCorpDetails1(corporateId)
                    // this.getServiceWorkerDetails()
                  }

                  this.wallettierInfoandtier = false;
                }
              })
            }

            else {
              this.isAddTier = false;
              this.showAddTier = false;
              this.updateAllStatus();
              this.EmployeeAddData = response.data.employeeKeys;

              // this.employeeWorkingProviance=response.data.working_provinces;
              this.employeeWorkingProviance = response.data.working_provinces.sort(
                (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
              );
              // this.headerComponent.applicationStatus(7);

              if (
                formData.tierConfig == false &&
                formData.walletConfig == false
              ) {

                let bulkplans = JSON.parse(sessionStorage.getItem('summaryBlock1'));
                this.basicInfo = false;
                this.plansInfo = false;
                this.wallettierInfo = false;
                this.nowalletnotierInfo = false;
                this.EmployeeInfo = false;
                this.datagraphInfo = false;
                this.walletData = 'No';
                this.TierData = 'No';
                this.addedEmployeelist = this.employeeList

                console.log(this.addedEmployeelist)
                this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                    "message": "Corporates information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                })
                this.GetCorpDetails1(corporateId)
                // this.getServiceWorkerDetails()
                // if(bulkplans && bulkplans.length>0){

                //   bulkplans.forEach(element => {

                //     if(element.subGroupId=="20"){
                //       this.basicInfo = false;
                //       this.plansInfo = false;
                //       this.wallettierInfo = false;
                //       this.nowalletnotierInfo = false;
                //       this.EmployeeInfo = true;
                //       this.datagraphInfo = false;
                //       this.walletData = 'No';
                //       this.TierData = 'No';
                //       this.GetCorpDetails1(corporateId)

                //     }else{
                //       this.basicInfo = false;
                //       this.plansInfo = false;
                //       this.wallettierInfo = false;
                //       this.nowalletnotierInfo = false;
                //       this.EmployeeInfo = false;
                //       this.datagraphInfo = true;
                //       this.walletData = 'No';
                //       this.TierData = 'No';
                //       this.GetCorpDetails1(corporateId)
                //     }

                //   });

                // }
                // else{
                //   this.basicInfo = false;
                //   this.plansInfo = false;
                //   this.wallettierInfo = false;
                //   this.nowalletnotierInfo = false;
                //   this.EmployeeInfo = true;
                //   this.walletData = 'No';
                //   this.TierData = 'No';
                //   this.GetCorpDetails1(corporateId)
                // }

              } else if (
                formData.tierConfig == false &&
                formData.walletConfig == true
              ) {
                this.basicInfo = false;
                this.plansInfo = false;
                this.wallettierInfo = true;
                this.nowalletnotierInfo = false;
                this.walletData = 'Selected';
                this.TierData = 'No';
                this.GetCorpDetails1(corporateId)
                // this.getServiceWorkerDetails()
              } else if (
                formData.tierConfig == true &&
                formData.walletConfig == true
              ) {
                this.basicInfo = false;
                this.plansInfo = false;
                this.wallettierInfo = true;
                this.nowalletnotierInfo = false;
                this.walletData = 'Selected';
                this.TierData = 'Selected';
                this.GetCorpDetails1(corporateId)
                // this.getServiceWorkerDetails()
              } else if (
                formData.tierConfig == true &&
                formData.walletConfig == false
              ) {
                this.basicInfo = false;
                this.plansInfo = false;
                this.wallettierInfo = false;
                this.nowalletnotierInfo = false;
                this.EmployeeInfo = false;
                this.walletData = 'No';
                this.TierData = 'Selected';
                this.GetCorpDetails1(corporateId)
                // this.getServiceWorkerDetails()
              }

              this.wallettierInfoandtier = false;
            }








          }

          else {
            Swal.fire({ title: this.lang.Info ?? 'Info', text: response.message });

            // this.toastrService.error(this.lang.Error??'Error', response.message);
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Info ?? 'Info',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            console.log(error)
            Swal.fire({ title: this.lang.Info ?? 'Info', text: error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
    // }
  }

  editTierPlansInfo() {
    this.employeeplanpurchase = sessionStorage.getItem('employeeplanpurchase')=='true'?true:false
    this.employeeplanpurchasetiers = sessionStorage.getItem('employeeplanpurchasetiers')=='true'?true:false
    this.upgradeplansselection = sessionStorage.getItem('upgradeplansselection')=='true'?true:false
    this.upgradeplansselectiontiers = sessionStorage.getItem('upgradeplansselectiontiers')=='true'?true:false

    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint;
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');
    let summaryBluckplans = [];
    let summaryBlock1 = [];
    let summaryBlock2 = [];
    let summaryBlock3 = [];
    let paidByCompany: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let coveredByCompany: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let paidByEmployees: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let bulkPlans: { planLevelId: any; quantity: any, tierId: number; parentPlanLevelId: number; subGrpname: any }[] = [];

    let summaryBlockBulkA = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') ?? '[]'
    );
    let summaryBlock1A = JSON.parse(
      sessionStorage.getItem('summaryBlock1') ?? '[]'
    );
    let summaryBlock2A = JSON.parse(
      sessionStorage.getItem('summaryBlock2') ?? '[]'
    );

    let summaryBlock3A = JSON.parse(
      sessionStorage.getItem('summaryBlock3') ?? '[]'
    );
    this.showHeadCount = JSON.parse(
      sessionStorage.getItem('showHeadCount') ?? '{}'
    );

    console.log({ summaryBlock1A })

    summaryBluckplans = summaryBlockBulkA.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      )));
    summaryBlock1 = summaryBlock1A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      ))
    );
    summaryBlock2 = summaryBlock2A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      ))
    );
    summaryBlock3A = summaryBlock3A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.subGroupId === item.subGroupId
      ))
    );


    summaryBlockBulkA.forEach((element: any) => {
      let obj: any = {
        planLevelId: parseInt(element.subGroupId),//subGroupId
        tierId: this.tierDetails.id,
        quantity: element.subGroupId != 38 ? parseInt(this.showHeadCount[element.subGroupId]) : 0,
        coverage: element.coverage ? element.coverage : '',
        parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
        subGrpname: element.subGrpname,
        planLevelName: element.subGrpname
        // subscriptionId: subscriptionId
      };

      let subsId = this.bulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
      console.log({ subsId })
      if (subsId && subsId.length > 0 && subsId[0].subscriptionId) {
        obj.subscriptionId = subsId[0].subscriptionId
      }
      else {
        obj.subscriptionId = 0
      }

      bulkPlans.push(obj);

    });
    summaryBlock1A.forEach((element: any) => {
      console.log("1212121212", element)
      let obj = {
        id: element.id,
        planLevelId: parseInt(element.subGroupId),//subGroupId
        tierId: this.tierDetails.id,
        coverage: element.coverage ? element.coverage : '',
        parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
        settings: element?.settingsAdditional || {},
        companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT",
        planLevelName: element.subGrpname
      };
      paidByCompany.push(obj);
    });

    summaryBlock2A.forEach((element: any) => {

      let obj = {
        id: element.id,
        planLevelId: parseInt(element.subGroupId),
        tierId: this.tierDetails.id,
        coverage: element.coverage ? element.coverage : '',
        parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
        settings: element?.settingsAdditional || {},
        planLevelName: element.subGrpname

      };
      coveredByCompany.push(obj);
    });

    summaryBlock3A.forEach((element: any) => {
      let obj = {
        id: element.id,
        planLevelId: parseInt(element.subGroupId),
        tierId: this.tierDetails.id,
        coverage: element.coverage ? element.coverage : '',
        parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
        settings: element?.settingsAdditional || {},
        planLevelName: element.subGrpname

      };
      paidByEmployees.push(obj);
    });
    this.planRequestBody = {
      configuration: {
        tier: formData.tierConfig == true ? true : false,
        wallet: formData.walletConfig == true ? true : false,
      },
      paidByCompany: paidByCompany,
      bulkPlans: bulkPlans,
      bulkPlansIncluded: bulkPlans.length > 0 ? true : false,
      // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
      // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
      coveredByCompany: coveredByCompany?.length > 0 ? coveredByCompany : [],
      paidByEmployee: paidByEmployees?.length > 0 ? paidByEmployees : [],
      enableCoveredByCompany: this.upgradeplansselection
        ? true
        : false || this.upgradeplansselectiontiers
          ? true
          : false,
      enablePaidByEmployee: this.employeeplanpurchase
        ? true
        : false || this.employeeplanpurchasetiers
          ? true
          : false,
      corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompanyDefault, this.coveredByCompanyDefault, this.paidByEmployeeDefault),
      defaultTier: 0,
      payRollDeduction: "YES",
      requireEmployeeName: JSON.parse(sessionStorage.getItem('requireEmployeeName')),
    };

    endPoint = `/api/ap/admin/corporate/${corporateId}/tier/${this.tierDetails.id}/plans`;




    this.http
      .post(environment.apiUrl + endPoint, this.planRequestBody, {
        // .post(environment.apiUrl + endPoint, {...this.planRequestBody, mode:'edit'}, {
        // .post('http://[::1]:3002' + endPoint, {...this.planRequestBody,mode:'edit'}, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            $('#EditTierandWalletConfig-modal').modal('hide');
            this.showEditTier = false;
            this.ref.detectChanges();
            // show popup and if set ok then move next

            if (formData.tierConfig == true) {
              sessionStorage.setItem('summaryBlockBulk', '[]');
              sessionStorage.setItem('summaryBlock1', '[]');
              sessionStorage.setItem('summaryBlock2', '[]');
              sessionStorage.setItem('summaryBlock3', '[]');
            }


            if (response.data && Array.isArray(response.data.planSelections) && response.data.planSelections.length > 0) {
              let plansHtml: any = `<ul>`;
              if (response.data.planSelections.subscriptionUpdation && response.data.planSelections.subscriptionUpdation.plans.length > 0) {
                plansHtml += `<li style="color: ${response.data.planSelections.subscriptionUpdation.bgColor};">${this.getPlanNames(response.data.planSelections.subscriptionUpdation.plans) + ' ' + response.data.planSelections.subscriptionUpdation.note}</li>`;
              }

              if (response.data.planSelections.subscriptionConfirmation && response.data.planSelections.subscriptionConfirmation.plans.length > 0) {
                plansHtml += `<li style="color: ${response.data.planSelections.subscriptionConfirmation.bgColor};">${this.getPlanNames(response.data.planSelections.subscriptionConfirmation.plans) + ' ' + response.data.planSelections.subscriptionConfirmation.note}</li>`;
              }

              if (response.data.planSelections.subscriptionUpdationThroughCorporate && response.data.planSelections.subscriptionUpdationThroughCorporate.plans.length > 0) {
                plansHtml += `<li style="color: ${response.data.planSelections.subscriptionUpdationThroughCorporate.bgColor};">${this.getPlanNames(response.data.planSelections.subscriptionUpdationThroughCorporate.plans) + ' ' + response.data.planSelections.subscriptionUpdationThroughCorporate.note}</li>`;
              }

              plansHtml += `</ul>`;
              Swal.fire({
                title: 'Info',
                html: plansHtml,
              }).then((result) => {
                if (result.isConfirmed) {

                  this.updateAllStatus();
                  this.EmployeeAddData = response.data.employeeKeys;

                  // this.employeeWorkingProviance=response.data.working_provinces;
                  this.employeeWorkingProviance = response.data.working_provinces.sort(
                    (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
                  );
                  // this.headerComponent.applicationStatus(7);

                  if (
                    formData.tierConfig == false &&
                    formData.walletConfig == false
                  ) {

                    let bulkplans = JSON.parse(sessionStorage.getItem('summaryBlock1'));
                    this.basicInfo = false;
                    this.plansInfo = false;
                    this.wallettierInfo = false;
                    this.nowalletnotierInfo = false;
                    this.EmployeeInfo = false;
                    this.datagraphInfo = false;
                    this.showTiersTable = false;
                    this.walletData = 'No';
                    this.TierData = 'No';
                    this.addedEmployeelist = this.employeeList

                    console.log(this.addedEmployeelist)
                    this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                      this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                        "message": "Corporates information has been updated. Please refresh screen."
                      }, {
                        headers: {
                          Authorization: 'Bearer ' + accessToken,
                          'Content-Type': 'application/json',
                        }
                      }).subscribe((res) => {
                        console.log({ res })
                      })
                    })
                    this.GetCorpDetails1(corporateId)
                    // this.getServiceWorkerDetails()
                    // if(bulkplans && bulkplans.length>0){

                    //   bulkplans.forEach(element => {

                    //     if(element.subGroupId=="20"){
                    //       this.basicInfo = false;
                    //       this.plansInfo = false;
                    //       this.wallettierInfo = false;
                    //       this.nowalletnotierInfo = false;
                    //       this.EmployeeInfo = true;
                    //       this.datagraphInfo = false;
                    //       this.walletData = 'No';
                    //       this.TierData = 'No';
                    //       this.GetCorpDetails1(corporateId)

                    //     }else{
                    //       this.basicInfo = false;
                    //       this.plansInfo = false;
                    //       this.wallettierInfo = false;
                    //       this.nowalletnotierInfo = false;
                    //       this.EmployeeInfo = false;
                    //       this.datagraphInfo = true;
                    //       this.walletData = 'No';
                    //       this.TierData = 'No';
                    //       this.GetCorpDetails1(corporateId)
                    //     }

                    //   });

                    // }
                    // else{
                    //   this.basicInfo = false;
                    //   this.plansInfo = false;
                    //   this.wallettierInfo = false;
                    //   this.nowalletnotierInfo = false;
                    //   this.EmployeeInfo = true;
                    //   this.walletData = 'No';
                    //   this.TierData = 'No';
                    //   this.GetCorpDetails1(corporateId)
                    // }

                  } else if (
                    formData.tierConfig == false &&
                    formData.walletConfig == true
                  ) {
                    this.basicInfo = false;
                    this.plansInfo = false;
                    this.wallettierInfo = false;
                    this.showTiersTable = false;
                    this.nowalletnotierInfo = false;
                    this.walletData = 'Selected';
                    this.TierData = 'No';
                    this.GetCorpDetails1(corporateId)
                    // this.getServiceWorkerDetails()
                  } else if (
                    formData.tierConfig == true &&
                    formData.walletConfig == true
                  ) {
                    this.basicInfo = false;
                    this.plansInfo = false;
                    this.wallettierInfo = false;
                    this.showTiersTable = false;
                    this.nowalletnotierInfo = false;
                    this.walletData = 'Selected';
                    this.TierData = 'Selected';
                    this.GetCorpDetails1(corporateId)
                    // this.getServiceWorkerDetails()
                  } else if (
                    formData.tierConfig == true &&
                    formData.walletConfig == false
                  ) {
                    this.basicInfo = false;
                    this.plansInfo = false;
                    this.wallettierInfo = false;
                    this.showTiersTable = false;
                    this.nowalletnotierInfo = false;
                    this.EmployeeInfo = false;
                    this.walletData = 'No';
                    this.TierData = 'Selected';
                    this.GetCorpDetails1(corporateId)
                    // this.getServiceWorkerDetails()
                  }

                  this.wallettierInfoandtier = false;
                }
              })
            }

            else {

              this.updateAllStatus();
              this.EmployeeAddData = response.data.employeeKeys;

              // this.employeeWorkingProviance=response.data.working_provinces;
              this.employeeWorkingProviance = response.data.working_provinces.sort(
                (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
              );
              // this.headerComponent.applicationStatus(7);

              if (
                formData.tierConfig == false &&
                formData.walletConfig == false
              ) {

                let bulkplans = JSON.parse(sessionStorage.getItem('summaryBlock1'));
                this.basicInfo = false;
                this.plansInfo = false;
                this.wallettierInfo = false;
                this.nowalletnotierInfo = false;
                this.EmployeeInfo = false;
                this.datagraphInfo = false;
                this.walletData = 'No';
                this.TierData = 'No';
                this.addedEmployeelist = this.employeeList

                console.log(this.addedEmployeelist)
                this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                  this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                    "message": "Corporates information has been updated. Please refresh screen."
                  }, {
                    headers: {
                      Authorization: 'Bearer ' + accessToken,
                      'Content-Type': 'application/json',
                    }
                  }).subscribe((res) => {
                    console.log({ res })
                  })
                })
                this.GetCorpDetails1(corporateId)
                // this.getServiceWorkerDetails()
                // if(bulkplans && bulkplans.length>0){

                //   bulkplans.forEach(element => {

                //     if(element.subGroupId=="20"){
                //       this.basicInfo = false;
                //       this.plansInfo = false;
                //       this.wallettierInfo = false;
                //       this.nowalletnotierInfo = false;
                //       this.EmployeeInfo = true;
                //       this.datagraphInfo = false;
                //       this.walletData = 'No';
                //       this.TierData = 'No';
                //       this.GetCorpDetails1(corporateId)

                //     }else{
                //       this.basicInfo = false;
                //       this.plansInfo = false;
                //       this.wallettierInfo = false;
                //       this.nowalletnotierInfo = false;
                //       this.EmployeeInfo = false;
                //       this.datagraphInfo = true;
                //       this.walletData = 'No';
                //       this.TierData = 'No';
                //       this.GetCorpDetails1(corporateId)
                //     }

                //   });

                // }
                // else{
                //   this.basicInfo = false;
                //   this.plansInfo = false;
                //   this.wallettierInfo = false;
                //   this.nowalletnotierInfo = false;
                //   this.EmployeeInfo = true;
                //   this.walletData = 'No';
                //   this.TierData = 'No';
                //   this.GetCorpDetails1(corporateId)
                // }

              } else if (
                formData.tierConfig == false &&
                formData.walletConfig == true
              ) {
                this.basicInfo = false;
                this.plansInfo = false;
                this.wallettierInfo = true;
                this.nowalletnotierInfo = false;
                this.walletData = 'Selected';
                this.TierData = 'No';
                this.GetCorpDetails1(corporateId)
                // this.getServiceWorkerDetails()
              } else if (
                formData.tierConfig == true &&
                formData.walletConfig == true
              ) {

                this.basicInfo = false;
                this.plansInfo = false;
                this.wallettierInfo = true;
                this.nowalletnotierInfo = false;
                this.walletData = 'Selected';
                this.TierData = 'Selected';
                this.GetCorpDetails1(corporateId)
                // this.getServiceWorkerDetails()
              } else if (
                formData.tierConfig == true &&
                formData.walletConfig == false
              ) {
                this.basicInfo = false;
                this.plansInfo = false;
                this.wallettierInfo = false;
                this.nowalletnotierInfo = false;
                this.EmployeeInfo = false;
                this.walletData = 'No';
                this.TierData = 'Selected';
                this.GetCorpDetails1(corporateId)
                // this.getServiceWorkerDetails()
              }

              this.wallettierInfoandtier = false;
            }








          }

          else {
            Swal.fire({ title: this.lang.Info ?? 'Info', text: response.message });

            // this.toastrService.error(this.lang.Error??'Error', response.message);
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            console.log(error)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
    // }
  }

  editTierSuccess(response){
    var accessToken = sessionStorage.getItem('accessToken');
    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint;
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');
    let summaryBluckplans = [];
    let summaryBlock1 = [];
    let summaryBlock2 = [];
    let summaryBlock3 = [];
    let paidByCompany: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let coveredByCompany: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let paidByEmployees: { planLevelId: any; tierId: number; parentPlanLevelId: number }[] = [];
    let bulkPlans: { planLevelId: any; quantity: any, tierId: number; parentPlanLevelId: number; subGrpname: any }[] = [];

    let summaryBlockBulkA = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    let summaryBlock1A = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
    let summaryBlock2A = JSON.parse(
      sessionStorage.getItem('summaryBlock2') || '[]'
    );

    let summaryBlock3A = JSON.parse(
      sessionStorage.getItem('summaryBlock3') || '[]'
    );

    console.log({ summaryBlock1A })

    summaryBluckplans = summaryBlockBulkA.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      )));
    summaryBlock1 = summaryBlock1A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      ))
    );
    summaryBlock2 = summaryBlock2A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.planLevelId === item.planLevelId
      ))
    );
    summaryBlock3A = summaryBlock3A.filter((item, index, self) =>
      index === self.findIndex((t) => (
        t.subGroupId === item.subGroupId
      ))
    );


    summaryBlockBulkA.forEach((element: any) => {
      let obj: any = {
        planLevelId: parseInt(element.subGroupId),//subGroupId
        tierId: this.tierDetails.id,
        quantity: element.subGroupId != 38 ? parseInt(this.showHeadCount[element.subGroupId]) : 0,
        coverage: element.coverage ? element.coverage : '',
        parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
        subGrpname: element.subGrpname,
        planLevelName: element.subGrpname
        // subscriptionId: subscriptionId
      };

      let subsId = this.bulkplans.filter((ele) => ele.planLevelId == element.subGroupId)
      console.log({ subsId })
      if (subsId && subsId.length > 0 && subsId[0].subscriptionId) {
        obj.subscriptionId = subsId[0].subscriptionId
      }
      else {
        obj.subscriptionId = 0
      }

      bulkPlans.push(obj);

    });
    summaryBlock1A.forEach((element: any) => {
      console.log("1212121212", element)
      let obj = {
        id: element.id,
        planLevelId: parseInt(element.subGroupId),//subGroupId
        tierId: this.tierDetails.id,
        coverage: element.coverage ? element.coverage : '',
        parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
        settings: element?.settingsAdditional || {},
        companyPaidCoverage: this.getPlanCoverage[element.subGroupId] || "DIRECT",
        planLevelName: element.subGrpname
      };
      paidByCompany.push(obj);
    });

    summaryBlock2A.forEach((element: any) => {

      let obj = {
        id: element.id,
        planLevelId: parseInt(element.subGroupId),
        tierId: this.tierDetails.id,
        coverage: element.coverage ? element.coverage : '',
        parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
        settings: element?.settingsAdditional || {},
        planLevelName: element.subGrpname

      };
      coveredByCompany.push(obj);
    });

    summaryBlock3A.forEach((element: any) => {
      let obj = {
        id: element.id,
        planLevelId: parseInt(element.subGroupId),
        tierId: this.tierDetails.id,
        coverage: element.coverage ? element.coverage : '',
        parentPlanLevelId: element.parentId ? parseInt(element.parentId) : 0,
        settings: element?.settingsAdditional || {},
        planLevelName: element.subGrpname

      };
      paidByEmployees.push(obj);
    });
    this.planRequestBody = {
      configuration: {
        tier: formData.tierConfig == true ? true : false,
        wallet: formData.walletConfig == true ? true : false,
      },
      paidByCompany: paidByCompany,
      bulkPlans: bulkPlans,
      bulkPlansIncluded: bulkPlans.length > 0 ? true : false,
      // "upgradedPlans": [{"planLevelId": 0, "tierId": 0}],
      // "employeePurchasePlans": [{"planLevelId": 0,"tierId": 0}],
      coveredByCompany: coveredByCompany?.length > 0 ? coveredByCompany : [],
      paidByEmployee: paidByEmployees?.length > 0 ? paidByEmployees : [],
      enableCoveredByCompany: this.upgradeplansselection
        ? true
        : false || this.upgradeplansselectiontiers
          ? true
          : false,
      enablePaidByEmployee: this.employeeplanpurchase
        ? true
        : false || this.employeeplanpurchasetiers
          ? true
          : false,
      corporateTieredPlanLevelIds: this.getcorporateTieredplanLevelIds(this.paidByCompanyDefault, this.coveredByCompanyDefault, this.paidByEmployeeDefault),
      defaultTier: 0,
      payRollDeduction: "YES",
      requireEmployeeName: JSON.parse(sessionStorage.getItem('requireEmployeeName')),
    };

    endPoint = `/api/ap/admin/corporate/${corporateId}/tier/${this.tierDetails.id}/plans`;

    $('#EditTierandWalletConfig-modal').modal('hide');
      this.showEditTier = false;
      this.ref.detectChanges();
      // show popup and if set ok then move next

      if (formData.tierConfig == true) {
        sessionStorage.setItem('summaryBlockBulk', '[]');
        sessionStorage.setItem('summaryBlock1', '[]');
        sessionStorage.setItem('summaryBlock2', '[]');
        sessionStorage.setItem('summaryBlock3', '[]');
      }


      if (response.data && Array.isArray(response.data.planSelections) && response.data.planSelections.length > 0) {
        let plansHtml: any = `<ul>`;
        if (response.data.planSelections.subscriptionUpdation && response.data.planSelections.subscriptionUpdation.plans.length > 0) {
          plansHtml += `<li style="color: ${response.data.planSelections.subscriptionUpdation.bgColor};">${this.getPlanNames(response.data.planSelections.subscriptionUpdation.plans) + ' ' + response.data.planSelections.subscriptionUpdation.note}</li>`;
        }

        if (response.data.planSelections.subscriptionConfirmation && response.data.planSelections.subscriptionConfirmation.plans.length > 0) {
          plansHtml += `<li style="color: ${response.data.planSelections.subscriptionConfirmation.bgColor};">${this.getPlanNames(response.data.planSelections.subscriptionConfirmation.plans) + ' ' + response.data.planSelections.subscriptionConfirmation.note}</li>`;
        }

        if (response.data.planSelections.subscriptionUpdationThroughCorporate && response.data.planSelections.subscriptionUpdationThroughCorporate.plans.length > 0) {
          plansHtml += `<li style="color: ${response.data.planSelections.subscriptionUpdationThroughCorporate.bgColor};">${this.getPlanNames(response.data.planSelections.subscriptionUpdationThroughCorporate.plans) + ' ' + response.data.planSelections.subscriptionUpdationThroughCorporate.note}</li>`;
        }

        plansHtml += `</ul>`;
        Swal.fire({
          title: 'Info',
          html: plansHtml,
        }).then((result) => {
          if (result.isConfirmed) {

            this.updateAllStatus();
            this.EmployeeAddData = response.data.employeeKeys;

            this.employeeWorkingProviance = response.data.working_provinces.sort(
              (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
            );
            if (
              formData.tierConfig == false &&
              formData.walletConfig == false
            ) {

              let bulkplans = JSON.parse(sessionStorage.getItem('summaryBlock1'));
              this.basicInfo = false;
              this.plansInfo = false;
              this.wallettierInfo = false;
              this.nowalletnotierInfo = false;
              this.EmployeeInfo = false;
              this.datagraphInfo = false;
              this.showTiersTable = false;
              this.walletData = 'No';
              this.TierData = 'No';
              this.addedEmployeelist = this.employeeList

              console.log(this.addedEmployeelist)
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                  "message": "Corporates information has been updated. Please refresh screen."
                }, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  }
                }).subscribe((res) => {
                  console.log({ res })
                })
              })
              this.GetCorpDetails1(corporateId)
              
            } else if (
              formData.tierConfig == false &&
              formData.walletConfig == true
            ) {
              this.basicInfo = false;
              this.plansInfo = false;
              this.wallettierInfo = false;
              this.showTiersTable = false;
              this.nowalletnotierInfo = false;
              this.walletData = 'Selected';
              this.TierData = 'No';
              this.GetCorpDetails1(corporateId)
              // this.getServiceWorkerDetails()
            } else if (
              formData.tierConfig == true &&
              formData.walletConfig == true
            ) {
              this.basicInfo = false;
              this.plansInfo = false;
              this.wallettierInfo = false;
              this.showTiersTable = false;
              this.nowalletnotierInfo = false;
              this.walletData = 'Selected';
              this.TierData = 'Selected';
              this.GetCorpDetails1(corporateId)
              // this.getServiceWorkerDetails()
            } else if (
              formData.tierConfig == true &&
              formData.walletConfig == false
            ) {
              this.basicInfo = false;
              this.plansInfo = false;
              this.wallettierInfo = false;
              this.showTiersTable = false;
              this.nowalletnotierInfo = false;
              this.EmployeeInfo = false;
              this.walletData = 'No';
              this.TierData = 'Selected';
              this.GetCorpDetails1(corporateId)
              // this.getServiceWorkerDetails()
            }

            this.wallettierInfoandtier = false;
          }
        })
      }

      else {

        this.updateAllStatus();
        this.EmployeeAddData = response.data.employeeKeys;

        // this.employeeWorkingProviance=response.data.working_provinces;
        this.employeeWorkingProviance = response.data.working_provinces.sort(
          (a: any, b: any) => (a.shortName > b.shortName ? 1 : -1)
        );

        if (
          formData.tierConfig == false &&
          formData.walletConfig == false
        ) {

          let bulkplans = JSON.parse(sessionStorage.getItem('summaryBlock1'));
          this.basicInfo = false;
          this.plansInfo = false;
          this.wallettierInfo = false;
          this.nowalletnotierInfo = false;
          this.EmployeeInfo = false;
          this.datagraphInfo = false;
          this.walletData = 'No';
          this.TierData = 'No';
          this.addedEmployeelist = this.employeeList

          console.log(this.addedEmployeelist)
          this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
            this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
              "message": "Corporates information has been updated. Please refresh screen."
            }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((res) => {
              console.log({ res })
            })
          })
          this.GetCorpDetails1(corporateId)
          
        } else if (
          formData.tierConfig == false &&
          formData.walletConfig == true
        ) {
          this.basicInfo = false;
          this.plansInfo = false;
          this.wallettierInfo = true;
          this.nowalletnotierInfo = false;
          this.walletData = 'Selected';
          this.TierData = 'No';
          this.GetCorpDetails1(corporateId)
          // this.getServiceWorkerDetails()
        } else if (
          formData.tierConfig == true &&
          formData.walletConfig == true
        ) {

          this.basicInfo = false;
          this.plansInfo = false;
          this.wallettierInfo = true;
          this.nowalletnotierInfo = false;
          this.walletData = 'Selected';
          this.TierData = 'Selected';
          this.GetCorpDetails1(corporateId)
          // this.getServiceWorkerDetails()
        } else if (
          formData.tierConfig == true &&
          formData.walletConfig == false
        ) {
          this.basicInfo = false;
          this.plansInfo = false;
          this.wallettierInfo = false;
          this.nowalletnotierInfo = false;
          this.EmployeeInfo = false;
          this.walletData = 'No';
          this.TierData = 'Selected';
          this.GetCorpDetails1(corporateId)
          // this.getServiceWorkerDetails()
        }

        this.wallettierInfoandtier = false;
      }
  }
  public submitTierInfo() {
    var corporateId = sessionStorage.getItem('corporateId');

    let annualIncome = [];

    for (let i = 0; i < this.dynamicArray.length; i++) {
      this.dynamicArray[i].tierName = this.capitalize(
        this.dynamicArray[i].tierName
      );

      if (this.dynamicArray[i].walletAmount.length > 2) {
        this.dynamicArray[i].walletAmount = parseInt(
          this.dynamicArray[i].walletAmount.replace(/\$/g, '')
        );
      } else {
        this.dynamicArray[i].walletAmount = 0;
      }
    }
    for (let i = 0; i < this.dynamicArrayService.length; i++) {
      if (this.dynamicArrayService[i].walletAmount.length > 2) {
        this.dynamicArrayService[i].walletAmount = parseInt(
          this.dynamicArrayService[i].walletAmount.replace(/\$/g, '') || ''
        );
      } else {
        this.dynamicArrayService[i].walletAmount = 0;
      }

      this.dynamicArrayService[i].from = parseInt(
        this.dynamicArrayService[i].from
      );
      this.dynamicArrayService[i].to = parseInt(this.dynamicArrayService[i].to);
    }

    for (let i = 0; i < this.dynamicArrayAnnualIncome.length; i++) {
      if (this.dynamicArrayAnnualIncome[i].walletAmount.length > 2) {
        this.dynamicArrayAnnualIncome[i].walletAmount = parseInt(
          this.dynamicArrayAnnualIncome[i].walletAmount.replace(/\$/g, '') || ''
        );
      } else {
        this.dynamicArrayAnnualIncome[i].walletAmount = 0;
      }

      this.dynamicArrayAnnualIncome[i].from = parseInt(
        this.dynamicArrayAnnualIncome[i].from
      );

      this.dynamicArrayAnnualIncome[i].to = parseInt(
        this.dynamicArrayAnnualIncome[i].to
      );

      this.dynamicArrayAnnualIncome[i].percentage = parseInt(
        this.dynamicArrayAnnualIncome[i].percentage
      );
    }

    console.log(this.dynamicArray);

    var ConfigureTiers =
      '/api/ap/admin/corporate/' + corporateId + '/configureTiers';
    var GetTiers = '/api/ap/admin/corporate/' + corporateId + '/tiers';
    var accessToken = sessionStorage.getItem('accessToken');
    let requestBody = {
      corporateId: corporateId,
      enableLengthOfService: this.lengthofServiceCheck,
      enableAnnualIncome: this.annualincomeCheck,
      default: this.dynamicArray,
      lengthOfService: this.lengthofServiceCheck
        ? this.dynamicArrayService
        : [],
      annualIncome: this.annualincomeCheck ? this.dynamicArrayAnnualIncome : [],
    };

    // this.dynamicArray.forEach((element: any) => {
    //   let obj = {
    //     id: element.sno,
    //     tierName: element.tierName,
    //   };
    //   this.tierinfonames.push(obj);
    // });
    // this.dynamicArrayService.forEach((element: any) => {
    //   let obj = {
    //     id: element.sno,
    //     tierName: element.tierName,
    //   };
    //   this.tierinfonames.push(obj);
    // });
    // this.dynamicArrayAnnualIncome.forEach((element: any) => {
    //   let obj = {
    //     id: element.sno,
    //     tierName: element.tierName,
    //   };
    //   this.tierinfonames.push(obj);
    // });
    // this.tierinfonames = [
    //   ...new Map(
    //     this.tierinfonames.map((item) => [item.tierName, item])
    //   ).values(),
    // ];

    //  console.log(this.tierinfonames)

    //  this.tierinfonames.filter((item, index) => this.tierinfonames.indexOf(item) === index);
    let el: HTMLElement = this.nextpage.nativeElement;
    el.click();

    this.http
      .post(environment.apiUrl + ConfigureTiers, requestBody, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe((response: any) => {
        if (this.annualincomeCheck == true) {
          for (let i = 0; i < this.dynamicArrayAnnualIncome.length; i++) {
            let obj = {
              Tier: this.capitalize(this.dynamicArrayAnnualIncome[i].tierName),
              walletAmount: this.dynamicArrayAnnualIncome[i].walletAmount,
            };

            this.finalTiersforGraph.push(obj);
          }
        } else if (this.lengthofServiceCheck == true) {
          for (let i = 0; i < this.dynamicArrayService.length; i++) {
            let obj = {
              Tier: this.capitalize(this.dynamicArrayService[i].tierName),
              walletAmount: this.dynamicArrayService[i].walletAmount,
            };

            this.finalTiersforGraph.push(obj);
          }
        } else {
          for (let i = 0; i < this.dynamicArray.length; i++) {
            let obj = {
              Tier: this.capitalize(this.dynamicArray[i].tierName),
              walletAmount: this.dynamicArray[i].walletAmount,
            };

            this.finalTiersforGraph.push(obj);
          }
        }

        this.http
          .get(environment.apiUrl + GetTiers, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200) {
                this.configureTierList = response.data;
              } else {
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
              }
            },
            (error) => {
              console.log(error);
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
          );
      }, (error) => {
        if (
          error.status == 400 ||
          error.status == 401 ||
          error.status == 402 ||
          error.status == 403
        ) {
          Swal.fire({
            title: this.lang.Error ?? 'Error',
            text: error.error.error.message,
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: this.lang.Proceed,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
            else {
              sessionStorage.clear();
              this.router.navigate(['/login']);
            }
          });
        } else {
          // Swal.fire(error.error.error.message)
          Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
        }
        // this.toastrService.error("Invalid Credentials", 'Error!');
      });
  }

  annualIncome(e: any) {
    // console.log(e.target.value)

    if (e.target.value == 'true') {
      this.annualincomeCheck = true;
      // this.addRowAnnual()
    } else {
      this.annualincomeCheck = false;
    }
  }

  lengthOfService(e: any) {
    // console.log(e.target.value)

    if (e.target.value == 'true') {
      this.lengthofServiceCheck = true;
      // this.addRowService()

      // let el: HTMLElement = this.myDiv.nativeElement;
      // el.click();
    } else {
      this.lengthofServiceCheck = false;
    }
  }
  tierslevel(e: any) {
    // console.log(e.target.value)

    if (e.target.value == 'true') {
      this.tiersLevelCheck = true;
    } else {
      this.tiersLevelCheck = false;
    }
  }


  checkSettings(data) {
    console.log(data)
    for (const pack of data) {
      for (const group of pack.groups) {
        for (const subGroup of group.subGroups) {
          if (subGroup?.settings?.upgrade) {
            return true;
          }
        }
      }
    }
    return false;
  }

  upgradeplans(e: any) {
    if (!this.checkSettings(this.plansBlock1)) {
      Swal.fire({ title: this.lang.Info, text: "No Plans to Upgrade" });
      let el: HTMLElement = this.upgradeplansfalse.nativeElement;
      el.click();
      return
    }

    setTimeout(() => {
      if (e.target.value == 'true') {
        // this.upgradeplansselection = true;
        let block1res = JSON.parse(
          sessionStorage.getItem('summaryBlock1') || '[]'
        );
        let block1Bulkres = JSON.parse(sessionStorage.getItem('summaryBlockBulk'))

        // console.log(block1res)
        // this.plansblock2()
        if (block1res.length > 0) {
          this.upgradeplansselection = true;
          this.plansblock2();
          // this.plansresblack3 = [];
        }
        else if (block1Bulkres.length > 0) {
          this.upgradeplansselection = true;
          this.plansblock2();
          // this.plansresblack3 = [];
        }
        else {
          Swal.fire({
            title: this.lang.Info,
            text: 'Please select one core plan from above',
          });

          this.upgradeplansselection = false;
          let el: HTMLElement = this.upgradeplansfalse.nativeElement;
          el.click();
        }
        if (this.employeeplanpurchase == true) {
          this.employeeplanpurchase = true
          // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
          // el.click();
          setTimeout(() => {
            let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
            el1.click();
          }, 100);
        }
      }
      else {

        this.upgradeplansselection = false;
        sessionStorage.setItem('summaryBlock2', '[]');
        if (this.employeeplanpurchase == true) {
          // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
          // el.click();
          setTimeout(() => {
            let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
            if (el1 != null) el1.click();
          }, 100);
        }
      }
    }, 1000);

  }

  upgradeplansTiers(e: any) {
    if (e.target.value == 'true') {
      let block1res = JSON.parse(
        sessionStorage.getItem('selectedTiersBlock1') || '[]'
      );
      let block2filter = block1res.filter(
        (item: any) => item.parentid == 1 || item.parentid == 6
      );

      console.log(block2filter);

      if (block1res.length > 0) {
        let el: HTMLElement = this.employeepurchaseTiersfalse.nativeElement;
        el.click();

        this.upgradeplansselectiontiers = true;
        this.plansblock2tiers();
      } else {
        Swal.fire({
          title: this.lang.Info,
          text: this.lang.Please_select_one_plan_from_above,
        });

        this.upgradeplansselectiontiers = false;
        let el: HTMLElement = this.upgradeplanstiersfalse.nativeElement;
        el.click();
      }
    } else {
      this.upgradeplansselectiontiers = false;
    }
  }

  public getpackageGroupId(packageId: any, Groupid: any) {
    // console.log("packageid"+packageId)

    this.planres2.forEach((element: any, index: any) => {
      if (element.id == packageId) {
        // console.log("packageidcheck"+element.id)
        // console.log("packageid"+packageId)
        this.packageIndex = index;
      }

      element.groups.forEach((element1: any, index1: any) => {
        if (element.id == packageId && element1.id == Groupid) {
          // console.log("groupidcheck"+element1.id)
          // console.log("groupid"+Groupid)
          this.groupIndex = index1;
        }
      });
    });
  }
  public getpackageGroupIdblock2(packageId: any, Groupid: any) {
    let results = JSON.parse(sessionStorage.getItem('block2result') || '[]');

    results.forEach((element: any, index: any) => {
      if (element.id == packageId) {
        // console.log("packageidcheck"+element.id)
        // console.log("packageid"+packageId)
        this.packageIndexblock2 = index;
      }

      element.groups.forEach((element1: any, index1: any) => {
        if (element.id == packageId && element1.id == Groupid) {
          // console.log("groupidcheck"+element1.id)
          // console.log("groupid"+Groupid)
          this.groupIndexblock2 = index1;
          // alert(this.groupIndex)
        }
      });
    });
  }

  public plansblock212() {

    this.plansNewBlock2 = [];

    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('mainresults') || '[]'
    );

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );




    setTimeout(() => {

      let block1res = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]');



      for (let i = 0; i < block1res.length; i++) {
        if (block1res[i].subGroupId == 17) {

          $('#executiveplanssingle17').prop('disabled', false);
          $('#executiveplanscouple17').prop('disabled', false);
          $('#executiveplansfamily17').prop('disabled', false);
        }
        else {

          // $('#executiveplanssingle17').prop('disabled', true);
          // $('#executiveplanscouple17').prop('disabled', true);
          // $('#executiveplansfamily17').prop('disabled', true);
        }
        if (block1res[i].subGroupId == 18) {
          $('#executiveplanssingle18').prop('disabled', false);
          $('#executiveplanscouple18').prop('disabled', false);
          $('#executiveplansfamily18').prop('disabled', false);
        }
        else {
          // $('#executiveplanssingle18').prop('disabled', true);
          // $('#executiveplanscouple18').prop('disabled', true);
          // $('#executiveplansfamily18').prop('disabled', true);
        }

        if (block1res[i].subGroupId == 28) {
          $('#executiveplanssingle28').prop('disabled', false);
          $('#executiveplanscouple28').prop('disabled', false);
          $('#executiveplansfamily28').prop('disabled', false);
        }
        else {
          // $('#executiveplanssingle28').prop('disabled', true);
          // $('#executiveplanscouple28').prop('disabled', true);
          // $('#executiveplansfamily28').prop('disabled', true);
        }

      }

    }, 100);
    let block1Bulk = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]')
    this.plansNewBlock2.forEach((packagelevel: any, index: any) => {
      if (!packagelevel) {
      }
      else {
        packagelevel.groups.forEach((groups: any, index1: any) => {
          // if (packagelevel.id == 2 && block1Bulk.length > 0) {
          //   this.selectedplansblock1 = JSON.parse(
          //     sessionStorage.getItem('summaryBlockBulk') || '[]')
          // } else {
          this.selectedplansblock1 = JSON.parse(
            sessionStorage.getItem('summaryBlock1') || '[]')
          groups?.subGroups.forEach((subGroups: any, index2: any) => {

            // }
            if (subGroups) {
              this.selectedplansblock1.forEach((selectplan: any) => {
                if (
                  packagelevel.id == selectplan.packageid &&
                  packagelevel.groups.id == selectplan.parentid
                ) {

                  if (subGroups.id == selectplan.subGroupId && subGroups.id != '17' && subGroups.id != '18' && subGroups.id != '28') {
                    this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index2, 1)

                    if (selectplan.disallowedPlanLevels) {
                      let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

                      console.log(disallowed_plans)

                      disallowed_plans.forEach((disallowed: any, index9) => {


                        this.plansNewBlock2[index]['groups'][index1]['subGroups'].forEach((plan: any, index10) => {

                          if (this.plansNewBlock2[index]['groups'][index1]['subGroups'][index10].id == disallowed) {
                            this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index10, 1)
                          }
                        })



                      })
                      console.log(this.plansNewBlock2)

                    }



                  }


                  if (
                    !this.plansNewBlock2[index] ||
                    !this.plansNewBlock2[index]['groups'] ||
                    !this.plansNewBlock2[index]['groups'][index1] ||
                    !this.plansNewBlock2[index]['groups'][index1]['subGroups']
                  ) {
                  }

                  else {
                    var allAvailble = this.plansNewBlock2[index]['groups'][index1]['subGroups']

                    console.log(allAvailble)


                    // console.log(console.log(this.plansNewBlock2[index]))
                    // console.log(selectplan)
                    // console.log(this.plansNewBlock2[index].id)
                    // console.log(selectplan.packageid)
                    // console.log(this.plansNewBlock2[index]['groups'][index1].id)
                    // console.log(selectplan.parentId)




                    // if (

                    //   this.plansNewBlock2[index].id == selectplan.packageid &&
                    //   this.plansNewBlock2[index]['groups'][index1].id !=
                    //   selectplan.parentId
                    // ) {
                    //   console.log("ignore")

                    //   this.plansNewBlock2[index]['groups'][index1] = null;
                    //   // this.plansNewBlock2[index] = null;

                    // }

                    // else {

                    console.log("oktoselect")
                    console.log(allAvailble);
                    allAvailble.forEach((element1: any, index2: any) => {
                      if (element1 != null) {
                        // if(element1.)
                        console.log(element1)

                        if (element1.id == '17' || element1.id == '18' || element1.id == '28') {
                          console.log(element1.id)
                          console.log(element1.ordering); //23  24   Default===single and Family
                          console.log(selectplan.orderId); //23  23
                          // if (element1.ordering > selectplan.orderId) {
                          //   console.log('ifstate');
                          // }
                          // else {
                          console.log('coverage' + selectplan.coverage);

                          this.upgradeplanscheck = this.getExecutiveCoveragesFromCode(selectplan.coverage)
                          // {single:true,couple:true,fam:false}

                          console.log(this.upgradeplanscheck)

                          if (this.upgradeplanscheck && this.upgradeplanscheck != null) {
                            if (this.upgradeplanscheck.single) {
                              console.log(element1.id)
                              console.log(selectplan.subGroupId)
                              if (element1.id >= selectplan.subGroupId) {
                                this.plansNewBlock2[index]['groups'][index1][
                                  'subGroups'
                                ][index2]['coverage'] = '001';
                              } else {
                                this.plansNewBlock2[index]['groups'][index1][
                                  'subGroups'
                                ][index2] = null;
                              }
                            }
                            if (this.upgradeplanscheck.couple) {
                              if (element1.id >= selectplan.subGroupId) {
                                this.plansNewBlock2[index]['groups'][index1][
                                  'subGroups'
                                ][index2]['coverage'] = '010';
                              } else {
                                this.plansNewBlock2[index]['groups'][index1][
                                  'subGroups'
                                ][index2] = null;
                              }
                            }
                            if (this.upgradeplanscheck.single && this.upgradeplanscheck.couple) {
                              if (element1.id >= selectplan.subGroupId) {
                                this.plansNewBlock2[index]['groups'][index1][
                                  'subGroups'
                                ][index2]['coverage'] = '011';
                              } else {
                                this.plansNewBlock2[index]['groups'][index1][
                                  'subGroups'
                                ][index2] = null;
                              }
                            }
                            if (this.upgradeplanscheck.family) {
                              this.plansNewBlock2[index]['groups'][index1][
                                'subGroups'
                              ][index2] = null;
                            }
                          }

                          this.plansNewBlock2.forEach(
                            (elementres: any, index5: any) => {
                              if (!elementres || !elementres.groups) {
                              } else {
                                elementres.groups.forEach(
                                  (group: any, index6: any) => {
                                    console.log(group);
                                    if (!this.plansNewBlock2[index5] ||
                                      !this.plansNewBlock2[index5]['groups'] ||
                                      !this.plansNewBlock2[index5]['groups'][
                                      index6
                                      ] ||
                                      !this.plansNewBlock2[index5]['groups'][
                                      index6
                                      ]['subGroups']
                                    ) {
                                    } else {
                                      group.subGroups.forEach(
                                        (subgroups: any, index7: any) => {
                                          let validSubgroups = group[
                                            'subGroups'
                                          ].filter((v: any) => v !== null);

                                          console.log(validSubgroups);
                                          if (validSubgroups.length > 0) {
                                          } else {
                                            // this.plansNewBlock2[index5][
                                            //   'groups'
                                            // ][index6] = null;

                                            this.plansNewBlock2[index5] = null;
                                            // this.plansNewBlock2.splice(index5,1)
                                          }
                                        }
                                      );
                                    }

                                    let validgroups = elementres.groups.filter(
                                      (v: any) => v !== null
                                    );

                                    console.log(validgroups);
                                    if (validgroups.length > 0) {
                                    } else {
                                      this.plansNewBlock2[index5] = null;
                                      ////////show subGroups here
                                    }
                                    //
                                  }
                                );
                              }
                            }
                          );
                          // }
                        }
                        else {
                          console.log(element1.id)
                          // if (element1.ordering > selectplan.orderId) {
                          // }
                          // else {
                          // console.log(this.plansNewBlock2?.[index]?.groups?.[index1]?.subGroups?.[index2])
                          this.plansNewBlock2[index]['groups'][index1][
                            'subGroups'
                          ][index2] = null;

                          this.plansNewBlock2.forEach(
                            (elementres: any, index5: any) => {
                              if (!elementres || !elementres.groups) {
                              } else {
                                elementres.groups.forEach(
                                  (group: any, index6: any) => {
                                    console.log(group);
                                    if (!this.plansNewBlock2[index5] ||
                                      !this.plansNewBlock2[index5]['groups'] ||
                                      !this.plansNewBlock2[index5]['groups'][
                                      index6
                                      ] ||
                                      !this.plansNewBlock2[index5]['groups'][
                                      index6
                                      ]['subGroups']
                                    ) {
                                    } else {
                                      group.subGroups.forEach(
                                        (subgroups: any, index7: any) => {
                                          let validSubgroups = group[
                                            'subGroups'
                                          ].filter((v: any) => v !== null);

                                          console.log(validSubgroups);
                                          if (validSubgroups.length > 0) {
                                          } else {
                                            // this.plansNewBlock2[index5][
                                            //   'groups'
                                            // ][index6] = null;

                                            this.plansNewBlock2[index5] = null;
                                            // this.plansNewBlock2.splice(index5,1)
                                          }
                                        }
                                      );
                                    }

                                    let validgroups = elementres.groups.filter(
                                      (v: any) => v !== null
                                    );

                                    console.log(validgroups);
                                    if (validgroups.length > 0) {
                                    } else {
                                      this.plansNewBlock2[index5] = null;
                                      ////////show subGroups here
                                    }
                                    //
                                  }
                                );
                              }
                            }
                          );
                          // }
                        }
                      }
                    });
                    // }
                  }
                }
              });
            }
          })
        });
      }
    });

    console.log(this.plansNewBlock2);
    this.plansNewBlock2.forEach((packagelevel: any, index: any) => {

      packagelevel.groups.forEach((groups: any, index1: any) => {
        groups.subGroups.forEach(
          (subgroups: any, index7: any) => {
            console.log(subgroups)
            let validSubgroups = groups[
              'subGroups'
            ].filter((v: any) => v !== null);


            console.log(validSubgroups)
          })

      })
    })

    this.plansresblack2 = this.plansNewBlock2;

    sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

    setTimeout(() => {
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        if (selectedplansblock2.length > 0) {
          for (let i = 0; i < selectedplansblock2.length; i++) {
            if (selectedplansblock2[i].subGroupId != 4) {
              // this.selectInBlock2()
            }
          }
        } else {
          // this.selectInBlock2()
        }
      }, 1000);
    }, 1000);

    // setTimeout(() => {
    //   $("#executiveplansblock2single17").prop("disabled", true);
    //   $("#executiveplansblock2couple17").prop("disabled", true);
    //   $("#executiveplansblock2family17").prop("disabled", true);
    //   $("#executiveplansblock2single18").prop("disabled", true);
    //   $("#executiveplansblock2couple18").prop("disabled", true);
    //   $("#executiveplansblock2family18").prop("disabled", true);

    // }, 1000);
  }
  public plansblock2() {

    this.plansNewBlock2 = [];

    this.plansNewBlock2 = JSON.parse(
      sessionStorage.getItem('mainresults') || '[]'
    );

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );

    setTimeout(() => {

      let block1res = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]');



      for (let i = 0; i < block1res.length; i++) {
        if (block1res[i].subGroupId == 17) {

          $('#executiveplanssingle17').prop('disabled', false);
          $('#executiveplanscouple17').prop('disabled', false);
          $('#executiveplansfamily17').prop('disabled', false);
        }
        else {

          // $('#executiveplanssingle17').prop('disabled', true);
          // $('#executiveplanscouple17').prop('disabled', true);
          // $('#executiveplansfamily17').prop('disabled', true);
        }
        if (block1res[i].subGroupId == 18) {
          $('#executiveplanssingle18').prop('disabled', false);
          $('#executiveplanscouple18').prop('disabled', false);
          $('#executiveplansfamily18').prop('disabled', false);
        }
        else {
          // $('#executiveplanssingle18').prop('disabled', true);
          // $('#executiveplanscouple18').prop('disabled', true);
          // $('#executiveplansfamily18').prop('disabled', true);
        }

        if (block1res[i].subGroupId == 28) {
          $('#executiveplanssingle28').prop('disabled', false);
          $('#executiveplanscouple28').prop('disabled', false);
          $('#executiveplansfamily28').prop('disabled', false);
        }
        else {
          // $('#executiveplanssingle28').prop('disabled', true);
          // $('#executiveplanscouple28').prop('disabled', true);
          // $('#executiveplansfamily28').prop('disabled', true);
        }

      }

    }, 100);

    this.plansNewBlock2.forEach((packagelevel: any, index: any) => {
      if (!packagelevel) {
      }
      else {
        packagelevel.groups.forEach((groups: any, index1: any) => {

          this.selectedplansblock1 = JSON.parse(
            sessionStorage.getItem('summaryBlock1') || '[]')
          groups?.subGroups.forEach((subGroups: any, index2: any) => {

            // }
            if (subGroups) {
              this.selectedplansblock1.forEach((selectplan: any) => {
                if (
                  packagelevel.id == selectplan.packageid &&
                  packagelevel.groups.id == selectplan.parentid
                ) {

                  // if (subGroups.id == selectplan.subGroupId && subGroups.id != '17' && subGroups.id != '18' && subGroups.id != '28') {
                  //   this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index2,1)

                  //   if(selectplan.disallowedPlanLevels){
                  //     let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

                  //     console.log(disallowed_plans)

                  //     disallowed_plans.forEach((disallowed: any,index9) => {


                  //       this.plansNewBlock2[index]['groups'][index1]['subGroups'].forEach((plan: any,index10) => {

                  //         if(this.plansNewBlock2[index]['groups'][index1]['subGroups'][index10].id==disallowed){
                  //           this.plansNewBlock2[index]['groups'][index1]['subGroups'].splice(index10,1)
                  //         }
                  //       })



                  //     })
                  //     console.log(this.plansNewBlock2)

                  //   }



                  // }


                  if (
                    !this.plansNewBlock2[index] ||
                    !this.plansNewBlock2[index]['groups'] ||
                    !this.plansNewBlock2[index]['groups'][index1] ||
                    !this.plansNewBlock2[index]['groups'][index1]['subGroups']
                  ) {
                  }

                  else {
                    var allAvailble = this.plansNewBlock2[index]['groups'][index1]['subGroups']

                    console.log(allAvailble)

                    allAvailble.forEach((element1: any, index2: any) => {
                      if (element1 != null) {
                        // if(element1.)
                        console.log(element1)

                        if (element1.id == '17' || element1.id == '18' || element1.id == '28') {
                          console.log(element1.id)
                          console.log(element1.ordering); //23  24   Default===single and Family
                          console.log(selectplan.orderId); //23  23
                          // if (element1.ordering > selectplan.orderId) {
                          //   console.log('ifstate');
                          // }
                          // else {

                          this.upgradeplanscheck = this.getExecutiveCoveragesFromCode(selectplan.coverage)
                          // {single:true,couple:true,fam:false}



                          if (element1.id == selectplan.subGroupId) {
                            if (this.upgradeplanscheck && this.upgradeplanscheck != null) {
                              if (this.upgradeplanscheck.single) {
                                console.log(element1.id)
                                console.log(selectplan.subGroupId)
                                if (element1.id >= selectplan.subGroupId) {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2]['coverage'] = '001';
                                } else {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2] = null;
                                }
                              }
                              if (this.upgradeplanscheck.couple) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2]['coverage'] = '010';
                                } else {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2] = null;
                                }
                              }
                              if (this.upgradeplanscheck.single && this.upgradeplanscheck.couple) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2]['coverage'] = '011';
                                } else {
                                  this.plansNewBlock2[index]['groups'][index1][
                                    'subGroups'
                                  ][index2] = null;
                                }
                              }
                              if (this.upgradeplanscheck.family) {
                                this.plansNewBlock2[index]['groups'][index1][
                                  'subGroups'
                                ][index2] = null;
                              }
                            }
                          }

                          // this.plansNewBlock2.forEach(
                          //   (elementres: any, index5: any) => {
                          //     if (!elementres || !elementres.groups) {
                          //     } else {
                          //       elementres.groups.forEach(
                          //         (group: any, index6: any) => {
                          //           console.log(group);
                          //           if (!this.plansNewBlock2[index5] ||
                          //             !this.plansNewBlock2[index5]['groups'] ||
                          //             !this.plansNewBlock2[index5]['groups'][
                          //             index6
                          //             ] ||
                          //             !this.plansNewBlock2[index5]['groups'][
                          //             index6
                          //             ]['subGroups']
                          //           ) {
                          //           } else {
                          //             group.subGroups.forEach(
                          //               (subgroups: any, index7: any) => {
                          //                 let validSubgroups = group[
                          //                   'subGroups'
                          //                 ].filter((v: any) => v !== null);

                          //                 console.log(validSubgroups);
                          //                 if (validSubgroups.length > 0) {
                          //                 } else {
                          //                   // this.plansNewBlock2[index5][
                          //                   //   'groups'
                          //                   // ][index6] = null;

                          //                   this.plansNewBlock2[index5] = null;
                          //                   // this.plansNewBlock2.splice(index5,1)
                          //                 }
                          //               }
                          //             );
                          //           }

                          //           let validgroups = elementres.groups.filter(
                          //             (v: any) => v !== null
                          //           );

                          //           console.log(validgroups);
                          //           if (validgroups.length > 0) {
                          //           } else {
                          //            this.plansNewBlock2[index5] = null;
                          //             ////////show subGroups here
                          //           }
                          //           //
                          //         }
                          //       );
                          //     }
                          //   }
                          // );
                          // }
                        }
                        else {
                          if (element1.id == selectplan.subGroupId) {
                            this.plansNewBlock2[index]['groups'][index1][
                              'subGroups'
                            ][index2] = null;
                          }
                          //   this.plansNewBlock2[index]['groups'][index1][
                          //     'subGroups'
                          //   ][index2] = null;
                          // if (element1.ordering > selectplan.orderId) {
                          // }
                          // else {
                          //   this.plansNewBlock2[index]['groups'][index1][
                          //     'subGroups'
                          //   ][index2] = null;
                          // }
                          // if(element1.id ==selectplan.subGroupId){


                          //      this.plansNewBlock2[index]['groups'][index1][
                          //     'subGroups'
                          //   ][index2] = null;
                          // }
                          // console.log(element1.id)


                          // this.plansNewBlock2[index]['groups'][index1][
                          //   'subGroups'
                          // ][index2] = null;

                          // this.plansNewBlock2.forEach(
                          //   (elementres: any, index5: any) => {
                          //     if (!elementres || !elementres.groups) {
                          //     } else {
                          //       elementres.groups.forEach(
                          //         (group: any, index6: any) => {
                          //           console.log(group);
                          //           if (!this.plansNewBlock2[index5] ||
                          //             !this.plansNewBlock2[index5]['groups'] ||
                          //             !this.plansNewBlock2[index5]['groups'][
                          //             index6
                          //             ] ||
                          //             !this.plansNewBlock2[index5]['groups'][
                          //             index6
                          //             ]['subGroups']
                          //           ) {
                          //           } else {
                          //             group.subGroups.forEach(
                          //               (subgroups: any, index7: any) => {
                          //                 let validSubgroups = group[
                          //                   'subGroups'
                          //                 ].filter((v: any) => v !== null);

                          //                 console.log(validSubgroups);
                          //                 if (validSubgroups.length > 0) {
                          //                 } else {
                          //                   // this.plansNewBlock2[index5][
                          //                   //   'groups'
                          //                   // ][index6] = null;
                          //                   // this.plansNewBlock2[index5] = null;
                          //                   // this.plansNewBlock2[index5] = null;
                          //                   // this.plansNewBlock2.splice(index5,1)
                          //                 }
                          //               }
                          //             );
                          //           }

                          //           let validgroups = elementres.groups.filter(
                          //             (v: any) => v !== null
                          //           );

                          //           console.log(validgroups);
                          //           if (validgroups.length > 0) {
                          //           } else {
                          //             // this.plansNewBlock2[index5] = null;
                          //             ////////show subGroups here
                          //           }
                          //           //
                          //         }
                          //       );
                          //     }
                          //   }
                          // );
                          // }
                        }
                      }
                    });
                    // }
                  }
                }
              });
            }
          })
        });
      }
    });

    console.log(this.plansNewBlock2);
    //     this.plansNewBlock2.forEach((packagelevel: any, index: any) => {

    //       packagelevel.groups.forEach((groups: any, index1: any) => {
    //         groups.subGroups.forEach(
    //           (subgroups: any, index7: any) => {
    //             console.log(subgroups)
    //             let validSubgroups = groups[
    //               'subGroups'
    //             ].filter((v: any) => v !== null);

    // if(validSubgroups==null){
    //   console.log("empty plans")
    // }
    //             console.log(validSubgroups)
    //           })

    //       })
    //     })
    this.plansresblack2 = this.plansNewBlock2;

    sessionStorage.setItem('block2result', JSON.stringify(this.plansresblack2));

    setTimeout(() => {
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        if (selectedplansblock2.length > 0) {
          for (let i = 0; i < selectedplansblock2.length; i++) {
            if (selectedplansblock2[i].subGroupId != 4) {
              // this.selectInBlock2()
            }
          }
        } else {
          // this.selectInBlock2()
        }
      }, 1000);
    }, 1000);

    // setTimeout(() => {
    //   $("#executiveplansblock2single17").prop("disabled", true);
    //   $("#executiveplansblock2couple17").prop("disabled", true);
    //   $("#executiveplansblock2family17").prop("disabled", true);
    //   $("#executiveplansblock2single18").prop("disabled", true);
    //   $("#executiveplansblock2couple18").prop("disabled", true);
    //   $("#executiveplansblock2family18").prop("disabled", true);

    // }, 1000);
  }
  public selectInBlock2() {
    const dom: HTMLElement = this.elementRef.nativeElement;
    const element: any = dom.querySelector('#plancheck2Upgrade' + 4);

    if (element) {
      element.click();
    }
  }

  public plansblock2tiers() {
    this.plansNewBlock2Tiers = [];

    // this.plansNewBlock2Tiers = this.plansBlock1Tiers
    this.plansNewBlock2Tiers = JSON.parse(
      sessionStorage.getItem('plansBlock1Tiers') || '[]'
    );
    // this.plansNewBlock2Tiers = this.plansBlock1Tiers

    // this.selectedplansblock1 = JSON.parse(
    //   sessionStorage.getItem('selectedTiersBlock1') || '[]'
    // );

    this.selectedplansblock1 = this.seelctedplanLevelTierMapping;

    console.log(this.selectedplansblock1);

    this.plansNewBlock2Tiers.forEach((packagelevel: any, index: any) => {
      if (!packagelevel) {
      } else {
        packagelevel.groups.forEach((groups: any, index1: any) => {
          this.selectedplansblock1.forEach((selectplan: any) => {
            if (
              packagelevel.id == selectplan.packageId &&
              packagelevel.groups.id == selectplan.parentId
            ) {
              if (
                !this.plansNewBlock2Tiers[index] ||
                !this.plansNewBlock2Tiers[index]['groups'] ||
                !this.plansNewBlock2Tiers[index]['groups'][index1] ||
                !this.plansNewBlock2Tiers[index]['groups'][index1]['subGroups']
              ) {
              } else {
                var allAvailble =
                  this.plansNewBlock2Tiers[index]['groups'][index1][
                  'subGroups'
                  ];

                if (
                  this.plansNewBlock2Tiers[index].id == selectplan.packageId &&
                  this.plansNewBlock2Tiers[index]['groups'][index1].id !=
                  selectplan.parentid
                ) {
                  // console.log("ignore")

                  this.plansNewBlock2Tiers[index]['groups'][index1] = null;
                } else {
                  //  console.log("oktoselect")
                  console.log(allAvailble);
                  allAvailble.forEach((element1: any, index2: any) => {
                    if (element1 != null) {
                      this.plansNewBlock2Tiers[index]['groups'][index1][
                        'subGroups'
                      ][index2].tiers = []; //here tiersmake empty Array
                      this.plansNewBlock2Tiers[index]['groups'][index1][
                        'subGroups'
                      ][index2].checked = false; //here tiersmake empty Array
                      // if(element1.)

                      if (element1.parentId != 15) {
                        if (element1.id == selectplan.subGroupid) {
                          // this.plansNewBlock2Tiers[index]['groups'][index1][
                          //   'subGroups'
                          // ][index2] = null;    ///Here Plan Selection

                          selectplan.tiers.forEach(
                            (tiers: any, index7: any) => {
                              if (tiers.name == 'All') {
                                this.plansNewBlock2Tiers[index]['groups'][
                                  index1
                                ]['subGroups'][index2] = null;
                              }
                              else {

                                // console.log(availbleTierBlock2)

                              }

                            }
                          );

                          this.plansNewBlock2Tiers.forEach(
                            (elementres: any, index5: any) => {
                              if (!elementres || !elementres.groups) {
                              } else {
                                elementres.groups.forEach(
                                  (group: any, index6: any) => {
                                    if (
                                      !this.plansNewBlock2Tiers[index5] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ][index6] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ][index6]['subGroups']
                                    ) {
                                    } else {
                                      console.log(group);
                                      group.subGroups.forEach(
                                        (subgroups: any, index7: any) => {
                                          let validSubgroups = group[
                                            'subGroups'
                                          ].filter((v: any) => v !== null);

                                          console.log(validSubgroups);
                                          if (validSubgroups.length > 0) {
                                          } else {
                                            this.plansNewBlock2Tiers[index5][
                                              'groups'
                                            ][index6] = null;
                                            // this.plansNewBlock2.splice(index5,1)
                                          }
                                        }
                                      );
                                    }

                                    let validgroups = elementres.groups.filter(
                                      (v: any) => v !== null
                                    );

                                    console.log(validgroups);
                                    if (validgroups.length > 0) {
                                    } else {
                                      this.plansNewBlock2Tiers[index5] = null;
                                      ////////show subGroups here
                                    }
                                    //
                                  }
                                );
                              }
                            }
                          );
                        } else {
                        }
                      } else {
                        if (element1.id == selectplan.subGroupid) {
                          if (selectplan.coverage == 'Single') {
                            // if (element1.id >= selectplan.subGroupId) {
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2]['coverage']="Couple"
                            // }
                            // else{
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2] = null;
                            // }
                          } else if (selectplan.coverage == 'Couple') {
                            // if (element1.id >= selectplan.subGroupId) {
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2]['coverage']="Family"
                            // }
                            // else{
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2] = null;
                            // }
                          } else {
                            this.plansNewBlock2Tiers[index]['groups'][index1][
                              'subGroups'
                            ][index2] = null;
                          }
                          this.plansNewBlock2Tiers.forEach(
                            (elementres: any, index5: any) => {
                              if (!elementres || !elementres.groups) {
                              } else {
                                elementres.groups.forEach(
                                  (group: any, index6: any) => {
                                    if (
                                      !this.plansNewBlock2Tiers[index5] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ][index6] ||
                                      !this.plansNewBlock2Tiers[index5][
                                      'groups'
                                      ][index6]['subGroups']
                                    ) {
                                    } else {
                                      console.log(group);
                                      group.subGroups.forEach(
                                        (subgroups: any, index7: any) => {
                                          let validSubgroups = group[
                                            'subGroups'
                                          ].filter((v: any) => v !== null);

                                          console.log(validSubgroups);
                                          if (validSubgroups.length > 0) {
                                          } else {
                                            this.plansNewBlock2Tiers[index5][
                                              'groups'
                                            ][index6] = null;
                                            // this.plansNewBlock2.splice(index5,1)
                                          }
                                        }
                                      );
                                    }

                                    let validgroups = elementres.groups.filter(
                                      (v: any) => v !== null
                                    );

                                    console.log(validgroups);
                                    if (validgroups.length > 0) {
                                    } else {
                                      this.plansNewBlock2Tiers[index5] = null;
                                      ////////show subGroups here
                                    }
                                    //
                                  }
                                );
                              }
                            }
                          );
                        } else {
                          // console.log("coverage"+selectplan.coverage)
                          // if(selectplan.coverage=="Single"){
                          //   if (element1.id >= selectplan.subGroupId) {
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2]['coverage']="Couple"
                          //   }
                          //   else{
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2] = null;
                          //   }
                          // }
                          // else if(selectplan.coverage=="Couple"){
                          //   if (element1.id >= selectplan.subGroupId) {
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2]['coverage']="Family"
                          //   }
                          //   else{
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2] = null;
                          //   }
                          // }
                          // else{
                          //   this.plansNewBlock2Tiers[index]['groups'][index1][
                          //     'subGroups'
                          //   ][index2] = null;
                          // }
                        }
                      }
                    }
                  });
                }
              }
            }
          });
        });
      }
    });

    console.log(this.plansNewBlock2Tiers);

    this.plansresblack2Tiers = this.plansNewBlock2Tiers;

    sessionStorage.setItem(
      'block2resultTiers',
      JSON.stringify(this.plansresblack2Tiers)
    );

    setTimeout(() => {
      sessionStorage.setItem('selectedTiersBlock2', '[]');
      const dom: HTMLElement = this.elementRef.nativeElement;

      this.plansresblack2Tiers.forEach((packagelevel: any, index: any) => {
        if (!packagelevel) {
        } else {
          packagelevel.groups.forEach((groups: any, index1: any) => {
            if (
              !this.plansresblack2Tiers[index] ||
              !this.plansresblack2Tiers[index]['groups']
            ) {
            } else {
              if (
                !this.plansresblack2Tiers[index]['groups'][index1] ||
                !this.plansresblack2Tiers[index]['groups'][index1]['subGroups']
              ) {
              } else {
                groups.subGroups.forEach((subGroups: any, index2: any) => {
                  if (
                    !this.plansresblack2Tiers[index]['groups'][index1] ||
                    !this.plansresblack2Tiers[index]['groups'][index1][
                    'subGroups'
                    ][index2]
                  ) {
                  } else {
                    // const element: any = dom.querySelector("#plancheck2Upgrade" +  this.plansresblack2Tiers[index]['groups'][index1]['subGroups'][index2].id);
                    // console.log(element)
                    //    element.click()    ///Here plans Selectedt Auto
                  }
                });
              }
            }
          });
        }
      });
    }, 1000);
  }

  planpurchase(e: any) {

    if (e.target.value == 'true') {
      let checkCoverage = true;

      this.employeeplanpurchase = true;

      if (this.upgradeplansselection == true) {
        let block1res = JSON.parse(
          sessionStorage.getItem('summaryBlock2') || '[]'
        );


        console.log(block1res)
        sessionStorage.setItem('summaryBlock2', JSON.stringify(block1res))
        this.plansblock3();
        // if (JSON.parse(sessionStorage.getItem('summaryBlock1'))) {

        //   this.employeeplanpurchase = true;

        //   this.plansblock3();
        // }
        // else {
        //   // Swal.fire(this.lang.Info,this.lang.Please_select_one_plan_from_above);
        //   Swal.fire({ title: this.lang.Info, text: this.lang.Please_select_one_plan_from_above });

        //   this.employeeplanpurchase = false;
        //   let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        //   el.click();
        // }
      }
      else {
        // this.plansblock3()
        let summaryBlock1 = JSON.parse(sessionStorage.getItem('summaryBlock1')) ?? [];
        this.plansblock3()
        // if (summaryBlock1 && summaryBlock1.length > 0) {

        //   this.employeeplanpurchase = true;

        //   this.plansblock3();
        // }
        // else {
        //   // Swal.fire(this.lang.Info,this.lang.Please_select_one_plan_from_above);
        //   Swal.fire({ title: this.lang.Info, text: this.lang.Please_select_one_plan_from_above });

        //   this.employeeplanpurchase = false;
        //   let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        //   el.click();
        // }

      }

      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );

      setTimeout(() => {
        for (let i = 0; i < selectedplansblock3.length; i++) {

          $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

          // element2.checked = true;
          // this.plancheck3Coverage = selectedplansblock3[i].coverage;
          this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)


          if (
            this.plancheck3Coverage
          ) {
            if (this.plancheck3Coverage.single) {

              $("#executiveplansblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            } if (this.plancheck3Coverage.couple) {

              $("#executiveplansblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            } if (this.plancheck3Coverage.family) {

              $("#executiveplansblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            }
          }
        }
      }, 3000);



    }
    else {


      this.employeeplanpurchase = false;
      sessionStorage.setItem('summaryBlock3', '[]');
    }
  }
  planpurchaseTiers(e: any) {
    if (e.target.value == 'true') {
      if (
        JSON.parse(sessionStorage.getItem('selectedTiersBlock1') || '[]')
          .length > 0
      ) {
        this.employeeplanpurchasetiers = true;
        this.plansblock3Tiers();
      } else {
        // Swal.fire(this.lang.Info,this.lang.Please_select_one_plan_from_above);
        Swal.fire({ title: this.lang.Info, text: this.lang.Please_select_one_plan_from_above });

        this.employeeplanpurchasetiers = false;
        let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        el.click();
      }
    } else {
      this.employeeplanpurchasetiers = false;
      sessionStorage.setItem('selectedTiersBlock3', '[]');
    }
  }
  public plansblock3() {

    this.Newplansresblack3 = [];

    if (this.upgradeplansselection == true) {
      this.Newplansresblack3 = JSON.parse(
        sessionStorage.getItem('block2result') || '[]'
      );

      // this.Newplansresblack3 = this.plansresblack2Tiers;
      this.selectedplansblock1 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
    } else {
      this.Newplansresblack3 = JSON.parse(
        sessionStorage.getItem('mainresults') || '[]'
      );
      // this.Newplansresblack3 = this.plansBlock1Tiers;
      this.selectedplansblock1 = JSON.parse(
        sessionStorage.getItem('summaryBlock1') || '[]'
      );
    }

    this.Newplansresblack3.forEach((packagelevel: any, index: any) => {
      var grpcount = 0;

      if (!packagelevel) {
      }

      else {
        packagelevel.groups.forEach((groups: any, index1: any) => {
          groups?.subGroups.forEach((subGroups: any, index2: any) => {
            if (subGroups) {
              this.selectedplansblock1.forEach((selectplan: any) => {

                if (
                  packagelevel.id == selectplan.packageid &&
                  packagelevel.groups.id == selectplan.parentid
                ) {
                  if (subGroups.id == selectplan.subGroupId && subGroups.id != '17' && subGroups.id != '18' && subGroups.id != '28') {
                    this.Newplansresblack3[index]['groups'][index1]['subGroups'].splice(index2, 1)

                    if (selectplan.disallowedPlanLevels) {
                      let disallowed_plans = selectplan.disallowedPlanLevels.split(',');

                      console.log(disallowed_plans)

                      disallowed_plans.forEach((disallowed: any, index9) => {


                        this.Newplansresblack3[index]['groups'][index1]['subGroups'].forEach((plan: any, index10) => {
                          // console.log(this.Newplansresblack3[index]['groups'][index1]['subGroups'][index10].id)
                          // console.log(this.Newplansresblack3[index]['groups'][index1]['subGroups'])
                          // console.log(disallowed)
                          if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index10] != null) {
                            if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index10].id == disallowed) {
                              this.Newplansresblack3[index]['groups'][index1]['subGroups'].splice(index10, 1)
                            }
                          }
                        })



                      })


                    }



                  }
                  if (
                    !this.Newplansresblack3[index] ||
                    !this.Newplansresblack3[index]['groups']
                  ) {

                  } else {
                    if (
                      !this.Newplansresblack3[index]['groups'][index1] ||
                      !this.Newplansresblack3[index]['groups'][index1]['subGroups']
                    ) {

                    } else {

                      var allAvailble =
                        this.Newplansresblack3[index]['groups'][index1][
                        'subGroups'
                        ];

                      var sgcount = 0;

                      // console.log(allAvailble)

                      allAvailble.forEach((element1: any, index2: any) => {
                        if (element1 != null) {
                          //removeif
                          // console.log("6")
                          if (element1.id != '17' && element1.id != '18' && element1.id != '28') {
                            // if (element1.ordering > selectplan.orderId) {
                            // }
                            // else {
                            //   this.Newplansresblack3[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2] = null;

                            //   this.Newplansresblack3.forEach(
                            //     (elementres: any, index5: any) => {
                            //       if (!elementres || !elementres.groups) {
                            //       } else {
                            //         elementres.groups.forEach(
                            //           (group: any, index6: any) => {
                            //             // console.log(group)
                            //             if (
                            //               !this.Newplansresblack3[index5] ||
                            //               !this.Newplansresblack3[index5][
                            //               'groups'
                            //               ] ||
                            //               !this.Newplansresblack3[index5]['groups'][
                            //               index6
                            //               ] ||
                            //               !this.Newplansresblack3[index5]['groups'][
                            //               index6
                            //               ]['subGroups']
                            //             ) {
                            //             } else {
                            //               group.subGroups.forEach(
                            //                 (subgroups: any, index7: any) => {
                            //                   let validSubgroups = group[
                            //                     'subGroups'
                            //                   ].filter((v: any) => v !== null);

                            //                   console.log(validSubgroups);
                            //                   if (validSubgroups.length > 0) {
                            //                   } else {
                            //                     this.Newplansresblack3[index5][
                            //                       'groups'
                            //                     ][index6] = null;
                            //                     // this.plansNewBlock2.splice(index5,1)
                            //                   }
                            //                 }
                            //               );
                            //             }

                            //             let validgroups = elementres.groups.filter(
                            //               (v: any) => v !== null
                            //             );

                            //             console.log(validgroups);
                            //             if (validgroups.length > 0) {
                            //             } else {
                            //               this.Newplansresblack3[index5] = null;
                            //               ////////show subGroups here
                            //             }
                            //             //
                            //           }
                            //         );
                            //       }
                            //     }
                            //   );
                            //   sgcount++;
                            // }
                          }

                          else {

                            if (selectplan.disallowedPlanLevels) {
                              let disallowed_plans = selectplan.disallowedPlanLevels.split(',');
                              disallowed_plans.forEach((disallowed: any, index9) => {
                                console.log(this.Newplansresblack3[index]['groups'][index1]['subGroups'])

                                this.Newplansresblack3[index]['groups'][index1]['subGroups'].forEach((plan: any, index11) => {
                                  if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11] != null) {
                                    console.log(this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11])
                                    if (this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11].id == disallowed) {
                                      this.Newplansresblack3[index]['groups'][index1]['subGroups'][index11] = null
                                    }
                                  }
                                })

                              })


                            }
                            console.log(element1.ordering); //23  24   Default===single and Family
                            console.log(selectplan.orderId); //23  23
                            if (element1.ordering > selectplan.orderId) {
                              console.log('ifstate');
                            }

                            else {
                              console.log('coverage' + selectplan.subGroupId);

                              this.employeeplancheck = this.getExecutiveCoveragesFromCode(selectplan.coverage)

                              console.log(this.employeeplancheck)
                              if (this.employeeplancheck && this.employeeplancheck.single) {
                                console.log(this.Newplansresblack3[index]['groups'][index1][
                                  'subGroups'
                                ][index2])
                                if (element1.id >= selectplan.subGroupId) {
                                  this.Newplansresblack3[index]['groups'][index1][
                                    'subGroups'
                                  ][index2]['coverage'] = '001';
                                } else {
                                  this.Newplansresblack3[index]['groups'][index1][
                                    'subGroups'
                                  ][index2] = null;
                                }
                              }
                              if (this.employeeplancheck && this.employeeplancheck.couple) {
                                if (element1.id >= selectplan.subGroupId) {
                                  this.Newplansresblack3[index]['groups'][index1][
                                    'subGroups'
                                  ][index2]['coverage'] = '010';
                                } else {
                                  this.Newplansresblack3[index]['groups'][index1][
                                    'subGroups'
                                  ][index2] = null;
                                }
                              }
                              if (this.employeeplancheck && this.employeeplancheck.family) {
                                this.Newplansresblack3[index]['groups'][index1][
                                  'subGroups'
                                ][index2] = null;
                              }

                              this.Newplansresblack3.forEach(
                                (elementres: any, index5: any) => {
                                  if (!elementres || !elementres.groups) {
                                  } else {
                                    elementres.groups.forEach(
                                      (group: any, index6: any) => {
                                        // console.log(group)
                                        if (
                                          !this.Newplansresblack3[index5] ||
                                          !this.Newplansresblack3[index5][
                                          'groups'
                                          ] ||
                                          !this.Newplansresblack3[index5]['groups'][
                                          index6
                                          ] ||
                                          !this.Newplansresblack3[index5]['groups'][
                                          index6
                                          ]['subGroups']
                                        ) {
                                        } else {
                                          group.subGroups.forEach(
                                            (subgroups: any, index7: any) => {
                                              let validSubgroups = group[
                                                'subGroups'
                                              ].filter((v: any) => v !== null);

                                              console.log(validSubgroups);
                                              if (validSubgroups.length > 0) {
                                              } else {
                                                this.Newplansresblack3[index5][
                                                  'groups'
                                                ][index6] = null;
                                                // this.plansNewBlock2.splice(index5,1)
                                              }
                                            }
                                          );
                                        }

                                        let validgroups = elementres.groups.filter(
                                          (v: any) => v !== null
                                        );

                                        console.log(validgroups);
                                        if (validgroups.length > 0) {
                                        } else {
                                          this.Newplansresblack3[index5] = null;
                                          ////////show subGroups here
                                        }
                                        //
                                      }
                                    );
                                  }
                                }
                              );
                            }
                          }
                        }
                      });
                    }
                  }
                }

              });
            }

          });

        });
      }
    });

    console.log(this.Newplansresblack3)
    const idToMove = 13;
    const index = this.Newplansresblack3.findIndex(item => item?.id === idToMove);

    // Check if the object with id exists and move it
    if (index !== -1) {
      const [objectToMove] = this.Newplansresblack3.splice(index, 1);  // Remove the object
      this.Newplansresblack3.unshift(objectToMove);  // Add it to the front
    }


    this.plansresblack3 = this.Newplansresblack3.filter((v: any) => v !== null);

    // console.log(this.plansresblack3)
    sessionStorage.setItem('block3result', JSON.stringify(this.plansresblack3));
  }
  public plansblock3Tiers() {
    this.plansNewBlock3Tiers = [];

    if (this.upgradeplansselectiontiers == true) {
      this.plansNewBlock3Tiers = JSON.parse(
        sessionStorage.getItem('block2resultTiers') || '[]'
      );

      // this.selectedplansblock1 = JSON.parse(
      //   sessionStorage.getItem('selectedTiersBlock2') || '[]'
      // );
      this.selectedplansblock1 = this.seelctedplanLevelTierMappingBlock2;
    } else {
      this.plansNewBlock3Tiers = JSON.parse(
        sessionStorage.getItem('plansBlock1Tiers') || '[]'
      );
      // this.selectedplansblock1 = JSON.parse(
      //   sessionStorage.getItem('selectedTiersBlock2') || '[]'
      // );
      this.selectedplansblock1 = this.seelctedplanLevelTierMappingBlock2;
    }

    console.log(this.selectedplansblock1);

    this.plansNewBlock3Tiers.forEach((packagelevel: any, index: any) => {
      if (!packagelevel) {
      } else {
        packagelevel.groups.forEach((groups: any, index1: any) => {
          this.selectedplansblock1.forEach((selectplan: any) => {
            if (
              packagelevel.id == selectplan.packageId &&
              packagelevel.groups.id == selectplan.parentId
            ) {
              if (
                !this.plansNewBlock3Tiers[index] ||
                !this.plansNewBlock3Tiers[index]['groups'] ||
                !this.plansNewBlock3Tiers[index]['groups'][index1] ||
                !this.plansNewBlock3Tiers[index]['groups'][index1]['subGroups']
              ) {
              } else {
                var allAvailble =
                  this.plansNewBlock3Tiers[index]['groups'][index1][
                  'subGroups'
                  ];

                if (
                  this.plansNewBlock3Tiers[index].id == selectplan.packageId &&
                  this.plansNewBlock3Tiers[index]['groups'][index1].id !=
                  selectplan.parentid
                ) {
                  // console.log("ignore")

                  this.plansNewBlock3Tiers[index]['groups'][index1] = null;
                } else {
                  //  console.log("oktoselect")
                  console.log(allAvailble);
                  allAvailble.forEach((element1: any, index2: any) => {
                    if (element1 != null) {
                      this.plansNewBlock3Tiers[index]['groups'][index1][
                        'subGroups'
                      ][index2].tiers = []; //here tiersmake empty Array
                      this.plansNewBlock3Tiers[index]['groups'][index1][
                        'subGroups'
                      ][index2].checked = false;
                      // if(element1.)

                      if (element1.parentId != 15) {
                        if (element1.id == selectplan.subGroupid) {
                          // this.plansNewBlock2Tiers[index]['groups'][index1][
                          //   'subGroups'
                          // ][index2] = null;    ///Here Plas Selection

                          selectplan.tiers.forEach(
                            (tiers: any, index7: any) => {
                              if (tiers.name == 'All') {
                                this.plansNewBlock3Tiers[index]['groups'][
                                  index1
                                ]['subGroups'][index2] = null;
                              }
                            }
                          );

                          this.plansNewBlock3Tiers.forEach(
                            (elementres: any, index5: any) => {
                              if (!elementres || !elementres.groups) {
                              } else {
                                elementres.groups.forEach(
                                  (group: any, index6: any) => {
                                    if (
                                      !this.plansNewBlock3Tiers[index5] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ][index6] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ][index6]['subGroups']
                                    ) {
                                    } else {
                                      console.log(group);
                                      group.subGroups.forEach(
                                        (subgroups: any, index7: any) => {
                                          let validSubgroups = group[
                                            'subGroups'
                                          ].filter((v: any) => v !== null);

                                          console.log(validSubgroups);
                                          if (validSubgroups.length > 0) {
                                          } else {
                                            this.plansNewBlock3Tiers[index5][
                                              'groups'
                                            ][index6] = null;
                                            // this.plansNewBlock2.splice(index5,1)
                                          }
                                        }
                                      );
                                    }

                                    let validgroups = elementres.groups.filter(
                                      (v: any) => v !== null
                                    );

                                    console.log(validgroups);
                                    if (validgroups.length > 0) {
                                    } else {
                                      this.plansNewBlock3Tiers[index5] = null;
                                      ////////show subGroups here
                                    }
                                    //
                                  }
                                );
                              }
                            }
                          );
                        } else {
                        }
                      } else {
                        if (element1.id == selectplan.subGroupid) {
                          if (selectplan.coverage == 'Single') {
                            // if (element1.id >= selectplan.subGroupId) {
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2]['coverage']="Couple"
                            // }
                            // else{
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2] = null;
                            // }
                          } else if (selectplan.coverage == 'Couple') {
                            // if (element1.id >= selectplan.subGroupId) {
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2]['coverage']="Family"
                            // }
                            // else{
                            //   this.plansNewBlock2Tiers[index]['groups'][index1][
                            //     'subGroups'
                            //   ][index2] = null;
                            // }
                          } else {
                            this.plansNewBlock3Tiers[index]['groups'][index1][
                              'subGroups'
                            ][index2] = null;
                          }
                          this.plansNewBlock3Tiers.forEach(
                            (elementres: any, index5: any) => {
                              if (!elementres || !elementres.groups) {
                              } else {
                                elementres.groups.forEach(
                                  (group: any, index6: any) => {
                                    if (
                                      !this.plansNewBlock3Tiers[index5] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ][index6] ||
                                      !this.plansNewBlock3Tiers[index5][
                                      'groups'
                                      ][index6]['subGroups']
                                    ) {
                                    } else {
                                      console.log(group);
                                      group.subGroups.forEach(
                                        (subgroups: any, index7: any) => {
                                          let validSubgroups = group[
                                            'subGroups'
                                          ].filter((v: any) => v !== null);

                                          console.log(validSubgroups);
                                          if (validSubgroups.length > 0) {
                                          } else {
                                            this.plansNewBlock3Tiers[index5][
                                              'groups'
                                            ][index6] = null;
                                            // this.plansNewBlock2.splice(index5,1)
                                          }
                                        }
                                      );
                                    }

                                    let validgroups = elementres.groups.filter(
                                      (v: any) => v !== null
                                    );

                                    console.log(validgroups);
                                    if (validgroups.length > 0) {
                                    } else {
                                      this.plansNewBlock3Tiers[index5] = null;
                                      ////////show subGroups here
                                    }
                                    //
                                  }
                                );
                              }
                            }
                          );
                        } else {
                          // console.log("coverage"+selectplan.coverage)
                          // if(selectplan.coverage=="Single"){
                          //   if (element1.id >= selectplan.subGroupId) {
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2]['coverage']="Couple"
                          //   }
                          //   else{
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2] = null;
                          //   }
                          // }
                          // else if(selectplan.coverage=="Couple"){
                          //   if (element1.id >= selectplan.subGroupId) {
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2]['coverage']="Family"
                          //   }
                          //   else{
                          //     this.plansNewBlock2Tiers[index]['groups'][index1][
                          //       'subGroups'
                          //     ][index2] = null;
                          //   }
                          // }
                          // else{
                          //   this.plansNewBlock2Tiers[index]['groups'][index1][
                          //     'subGroups'
                          //   ][index2] = null;
                          // }
                        }
                      }
                    }
                  });
                }
              }
            }
          });
        });
      }
    });

    console.log(this.plansNewBlock3Tiers);

    this.plansresblack3Tiers = this.plansNewBlock3Tiers;
    sessionStorage.setItem(
      'block3resultTiers',
      JSON.stringify(this.plansresblack3Tiers)
    );

    setTimeout(() => {
      const dom: HTMLElement = this.elementRef.nativeElement;

      this.plansresblack3Tiers.forEach((packagelevel: any, index: any) => {
        if (!packagelevel) {
        } else {
          packagelevel.groups.forEach((groups: any, index1: any) => {
            if (
              !this.plansresblack3Tiers[index] ||
              !this.plansresblack3Tiers[index]['groups']
            ) {
            } else {
              if (
                !this.plansresblack3Tiers[index]['groups'][index1] ||
                !this.plansresblack3Tiers[index]['groups'][index1]['subGroups']
              ) {
              } else {
                groups.subGroups.forEach((subGroups: any, index2: any) => {
                  if (
                    !this.plansresblack3Tiers[index]['groups'][index1] ||
                    !this.plansresblack3Tiers[index]['groups'][index1][
                    'subGroups'
                    ][index2]
                  ) {
                  } else {
                    // const element: any = dom.querySelector("#plancheck3Voluntry" +  this.plansresblack3Tiers[index]['groups'][index1]['subGroups'][index2].id);
                    // this block is for automatic Check
                    //  element.click()
                  }
                });
              }
            }
          });
        }
      });
    }, 1000);
  }

  gotonotiernwalletInfo() {
    this.nowalletnotierInfo = false;
    this.EmployeeInfo = false;
    this.plansInfo = true;
  }
  gotoEmployeeDetails() {
    // this.basicInfo =false;
    // this.plansInfo =false;
    // this.wallettierInfo =false;
    // this.wallettierInfoandtier =false;
    this.nowalletnotierInfo = false;
    this.EmployeeInfo = true;
  }

 public closeEditTierdModel(): void {
  // Reset form controls
  this.selectedGracePeriodKey = '';
  this.allowCarryOver1 = '';
  this.maxCarryOverLimit = null;
  this.maxCarryOverAmount = '';
  this.wsaReimbursementFreeze = '';
  this.freezeStartDate = '';
  this.reimbursementFreezeReason = '';
  this.validationMessage = '';

  // Reset category and subcategory selections
  this.categorySelection = {};
  this.subCategorySelection = {};
  this.selectedCategoryData = [];

  // Reset custom subcategory text
  if (this.categoriesWithSubcategories) {
    this.categoriesWithSubcategories.forEach(item => {
      item.customSubcategoryLabel = '';
    });
  }
}


  public getExistingTiers() {
    var corporateId = sessionStorage.getItem('corporateId');

    var GetTiers = '/api/ap/admin/corporate/' + corporateId + '/tiers';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(environment.apiUrl + GetTiers, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {

          this.corporateTiers = response.data

        }
      )
  }

  public configuretiers() {
    var corporateId = sessionStorage.getItem('corporateId');

    var GetTiers = '/api/ap/admin/corporate/' + corporateId + '/tiers';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .get(environment.apiUrl + GetTiers, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.dynamicArray = [];
            this.dynamicArrayService = [];
            this.dynamicArrayAnnualIncome = [];
            this.configureTierList = response.data;

            for (let i = 0; i < this.configureTierList.length; i++) {
              if (this.configureTierList[i].tierType == 'DEFAULT') {
                let obj = {
                  sno: i + 1,
                  tierName: this.configureTierList[i].name,
                  walletAmount: '$' + this.configureTierList[i].spendingLimit,
                  id: this.configureTierList[i].id,
                };

                this.dynamicArray.push(obj);

                console.log(this.dynamicArray);
              }
            }

            for (let j = 0; j < this.configureTierList.length; j++) {
              if (this.configureTierList[j].tierType == 'LENGTH_OF_SERVICE') {
                let el1: HTMLElement = this.lengthOfServicetrue.nativeElement;
                el1.click();
                let obj = {
                  sno: j + 1,
                  tierName: this.configureTierList[j].name,
                  from: this.configureTierList[j].fromLength,
                  to: this.configureTierList[j].toLength,
                  period: '',
                  walletAmount: '$' + this.configureTierList[j].spendingLimit,
                  id: this.configureTierList[j].id,
                };

                this.dynamicArrayService.push(obj);
              }
            }

            for (let k = 0; k < this.configureTierList.length; k++) {
              if (this.configureTierList[k].tierType == 'ANNUAL_INCOME') {
                let el1: HTMLElement = this.annualIncometrue.nativeElement;
                el1.click();
                let obj = {
                  sno: k + 1,
                  tierName: this.configureTierList[k].name,
                  percentage: this.configureTierList[k].incomePercentage,
                  from: this.configureTierList[k].fromLength,
                  to: this.configureTierList[k].toLength,
                  period: '',
                  walletAmount: '$' + this.configureTierList[k].spendingLimit,
                  id: this.configureTierList[k].id,
                };

                this.dynamicArrayAnnualIncome.push(obj);
              }
            }
          } else {
            // Swal.fire(this.lang.Info,response.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );

    this.selectedplansforTier = JSON.parse(
      sessionStorage.getItem('summaryBlock1') || '[]'
    );
  }
  public gotobasicInfo() {
    // sessionStorage.setItem("header","Home")
    this.customSelected = false
    this.showEditTier = false;
    this.showstatus = false;
    this.showsearchbox = true;
    this.headerComponent.headerDetails('Home');
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    // this.waitTime = formData.expectednoofEmployees;

    this.CorpName = formData.corporationName;
    this.policyStartDate =
      this.datePipe.transform(formData.PolicyStartDate, 'MM-dd-yyyy') || '';
    this.streetAddress = formData.streetAddress;
    this.streetAddress2 = formData.streetAddress2;
    this.country = formData.country;
    this.city = formData.city;
    this.province = formData.Province;
    this.postalCode = formData.postalCode;
    this.waitTime = formData.waitingPeriod;
    this.paymentInfo = formData.paymentInfo;
    this.setupWallet = formData.walletConfig;
    this.setUplevelofCoverage = formData.tierConfig;
    this.noOfEmployees = formData.expectednoofEmployees;
    // this.imagedisplay = this.uploadadminlogoimg
    const dom: HTMLElement = this.elementRef.nativeElement;

    if (this.setUplevelofCoverage == true) {
      this.basicInfo = true;
      this.plansInfo = false;
      this.showTiersTable = false;
    } else {
      this.basicInfo = true;
      this.plansInfo = false;
      this.showTiersTable = false;
      setTimeout(() => {

        if (this.waitTime == 0) {
          const element: any = dom.querySelector('#nowaitingPeriod');
          if (element != null && element != undefined)
            element.click();
        } else if (this.waitTime == 3) {
          const element: any = dom.querySelector('#threemonths');
          if (element != null && element != undefined)
            element.click();
        } else if (this.waitTime == 6) {
          const element: any = dom.querySelector('#sixmonths');
          if (element != null && element != undefined)
            element.click();
        } else {
          const element: any = dom.querySelector('#customselection');
          console.log(element);
          if (element != null || element != undefined)
            element.click();
        }

        var reader = new FileReader();
        reader.readAsDataURL(this.uploadadminlogoimg??'');

        reader.onload = (_event) => {
          this.showimagelogo = false;
          this.uploadlogoafter = true;
          this.imagedisplay = reader.result;
        };
      }, 1000);
    }





    let adminData;
    if (sessionStorage.getItem('adminData')) {
      adminData = JSON.parse(sessionStorage.getItem('adminData'));
      this.adminData = adminData;
      this.addadminform = false;
      this.showaddadmin = true;
    }

    // if (adminData) {

    // }
  }
  customSelectedfunction() {
    this.customSelected = true;
  }

  gotodashboard() {
    // history.back()
    let CorpId = this.route.snapshot.params['id']
    this.router.navigate([`/manageCorporates/${CorpId}/view`]);
  }
  waitingPeriodChange(e: any) {
    if (e.target.value == 'Custom') {
      this.customSelected = true;
      this.clientregform.get('waitingPeriodCustom').setValidators(Validators.required);
    } else {
      this.customSelected = false;
      this.clientregform.get('waitingPeriodCustom').reset();
      this.clientregform.get('waitingPeriodCustom').clearValidators();
    }
    this.clientregform.get('waitingPeriodCustom').updateValueAndValidity();
  }

  public gotoplansInfo() {
    this.basicInfo = false;
    this.plansInfo = true;
    this.wallettierInfo = false;
    this.wallettierInfoandtier = false;

    this.planssummary = JSON.parse(sessionStorage.getItem('planResults'));

    this.selectedplansblock1 = JSON.parse(
      sessionStorage.getItem('summaryBlock1')
    );

    if (this.planssummary) {
      // [{"packageid":"2","parentId":"14","subGroupId":"21","orderId":"18","packagename":"Mental Health & Wellness","groupname":"Wellness","subGrpname":"Mind & Body","tiers":[],"packageindex":1,"groupindex":0,"subgroupindex":2}]
      // this.planssummary.forEach((plandetails:any,index:number) => {
      //   plandetails.groups.forEach((groups:any,index1:number) => {
      //     this.selectedplansblock1.forEach((subgroup:any,index3:number) => {
      //       var allAvailble = this.planssummary[index]['groups'][index1]['subGroups'];
      //       allAvailble.forEach((element1: any, index2: any) => {
      //         if (element1 != null) {
      //           if (element1.id == subgroup.subGroupId) {
      //             setTimeout(() => {
      //               const dom: HTMLElement = this.elementRef.nativeElement;
      //               const element: any = dom.querySelector("#plancheck" + element1.id);
      //               console.log(element)
      //                 element.click()
      //             },100)
      //           }
      //         }
      //         });
      //   });
      //   });
      // });
    }
  }

  public submitwallettierInfo() {
    // this.basicInfo = false;
    // this.plansInfo = false;
    // this.wallettierInfo = false;
    // this.wallettierInfoandtier = false;
    // this.EmployeeInfo = true;
  }

  public gotoEmployeeInfo() {


    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    if (formData.tierConfig == true) {
      this.basicInfo = false;
      this.plansInfo = false;
      this.wallettierInfo = false;
      this.EmployeeInfo = false;
      this.datagraphInfo = false;
      this.nowalletnotierInfo = false;
      this.showTiersTable = true;
      this.isAddTier = false;
      this.showAddTier = false;

    }

    else {
      this.basicInfo = false;
      this.plansInfo = true;
      this.wallettierInfo = false;
      this.EmployeeInfo = false;
      this.datagraphInfo = false;
      this.nowalletnotierInfo = false;
      this.showAddTier = true;

      this.getExistingTiers()
      let selectedsummaryBlockBulk = JSON.parse(
        sessionStorage.getItem('summaryBlockBulk') || '[]'
      );
      let selectedplansblock1 = JSON.parse(
        sessionStorage.getItem('summaryBlock1') || '[]'
      );
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );


      this.uploadEmployeeExcelData = []
      this.executeBlocks1(selectedsummaryBlockBulk, selectedplansblock1, selectedplansblock2, selectedplansblock3)
        .then((message) => console.log(message))
        .catch((error) => console.error("An error occurred:", error));

    }
  }
  public submitdatagraphInfo() {
    this.basicInfo = true;
    this.plansInfo = false;
    this.wallettierInfo = false;
    this.EmployeeInfo = false;
    this.datagraphInfo = false;
  }

  isCorporate: boolean = false;
  message: string = "";
  checkboxesForMail: any

  // invitationCorporate(id: any) {
  //   this.isCorporate = true
  //   const name = sessionStorage.getItem('corporationName')
  //   this.message = `Send ${name} portal access link to:`
  //   console.log(this.adminData, "admindata")
  //   console.log(this.groupContactsData)
  //   this.checkboxesForMail = this.adminData.map((c: any, i: number) => {
  //     let displayName;
  //     for (let g of this.groupContactsData) {
  //       displayName = g.key === c.role && c.role != 'CORPORATE_OTHERS' ? g.display : c.roleName.toLowerCase()
  //     }
  //     console.log(displayName)
  //     return {
  //       label: `${displayName} ${c.firstName} ${c.lastName} {${c.email}}`,
  //       checked: false,
  //       id: c.groupAdminId
  //     }
  //   })
  //   console.log(this.adminData, "admin")
  //   console.log(this.checkboxesForMail, "grishma")
  //   this.inviteGroupContacts(id)
  // }

  invitationCorporate(id: any) {
    this.isCorporate = true
    const name = sessionStorage.getItem('corporationName')
    this.message = `Send ${name} portal access link to:`

    const accessToken = sessionStorage.getItem('accessToken');
    const getGroupContacts = `/api/ap/admin/corporate/${id}/groupAdmins`;
    this._LoaderService.ShowLoader()
    this.http.get(environment.apiUrl + getGroupContacts, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {
      this._LoaderService.HideLoader()
      if (response['status'] == 200 || response['statusCode'] == 200) {
        const checkboxes = response.data
        this.checkboxesForMail = checkboxes.map((c: any, i: number) => {
          const obj = {
            label: `${c.roleNameDisplay == "Others" ? c.roleName : c.roleNameDisplay} ${c.firstName} ${c.lastName} {${c.email}}`,
            checked: false,
            id: c.groupAdminId
          }
          return obj
        }
        )
        this.inviteGroupContacts(id)
      } else {
        Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
      }
    }), (error) => {
      this._LoaderService.HideLoader()
      Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
    }

    console.log("checboxes", this.checkboxesForMail)

  }


  inviteGroupContacts(id: number) {
    $('#confirmationModal').modal('show');
    if (!this.isSubscribed) {
      this.confirmationDialog.confirmed.subscribe(obj => {
        this.isSubscribed = true;
        if (obj.confirmed) {
          const brokerAdminIds = obj.selectedCheckboxes.map((o, i) => (o.id))
          if (obj.confirmed) {
            const accessToken = sessionStorage.getItem('accessToken');
            console.log("started", brokerAdminIds)
            const GetBrokers = `/api/ap/admin/corporate/${id}/invitation`;
            this.http.post(environment.apiUrl + GetBrokers, { brokerAdminIds }, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              }
            }).subscribe((response: any) => {

              if (response['status'] == 200 || response['statusCode'] == 200) {
                // window.location.reload()
                this.router.navigate(['/manageCorporates'])
                Swal.fire({ title: this.lang.Info, text: response.message })
              } else {
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
              }


            }), (error) => {
              Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
            }
          }
        }
        $('#confirmationModal').modal('hide');
      });
    }
  }

  invitationbroker(id: any) {
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var GetBrokers = `/api/ap/admin/corporate/${id}/invitation`;

    //https://testadminapi.groupbenefitz.aitestpro.com/api/ap/admin/corporate/1660/invitation
    this.http.get(environment.apiUrl + GetBrokers, {
      headers: {
        Authorization: 'Bearer ' + accessToken,
        'Content-Type': 'application/json',
      }
    }).subscribe((response: any) => {

      if (response['status'] == 200 || response['statusCode'] == 200) {
        //  Swal.fire({title:this.lang.Info,text:response.message})
        Swal.fire({ title: this.lang.Info, text: response.message }).then((result) => {
          if (result.isConfirmed) {
            let accessTokensession = sessionStorage.getItem('accessToken');
            var keyToPreserve = ['adminName', 'role', 'loginname', 'accessToken'];

            // Get all keys from sessionStorage
            var keys = Object.keys(sessionStorage);

            // Iterate through the keys and remove them from sessionStorage, except the one to preserve
            keys.forEach(function (key) {
              // if (key !== keyToPreserve) {
              if (!keyToPreserve?.includes(key)) {
                sessionStorage.removeItem(key);
              }
            });
            sessionStorage.setItem('accessToken', accessTokensession);
            // window.location.reload();
            this.basicInfo = true;
            this.plansInfo = false;
            this.wallettierInfo = false;
            this.EmployeeInfo = false;
            this.datagraphInfo = false;
            this.router.navigate(['/manageCorporates']);
          }
        });
      } else {
        Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message })
      }


    }), (error) => {
      Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
    }

  }

  submitformlink() {
    let GroupContacts = JSON.parse(sessionStorage.getItem('adminData') || '[]');
    var corporateId = sessionStorage.getItem('corporateId');
    this.store.dispatch(loadCorporateDataSuccess({ corporateDate: [] }));
    this.store.dispatch(loadCorporateData());

    if (this.domainExisting) {

      this.invitationCorporate(corporateId);
    }
    else {
      if (GroupContacts.length > 0) {
        $('#subdomains-modal').modal('show');
        var accessToken = sessionStorage.getItem('accessToken');
        var subdomains = '/api/ap/admin/corporate/' + corporateId + '/subDomains';

        this.http
          .get(environment.apiUrl + subdomains, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200) {
                this.SubDomains = response.data;
                this.SubDomains = this.SubDomains
              } else {
                // Swal.fire(this.lang.Error??'Error',response.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      } else {
        this.adminform.reset()
        $('#groupAmdins-modal').modal('show');
      }
    }
  }

  addGroupadmin() {
    this.emailAlreadyexist = false;
    $('#groupAmdins-modal').modal('hide');
    console.log(this.adminData);
    if (this.adminform.invalid) {
      console.log(this.adminform);
      return;
    }
    console.log(JSON.stringify(this.adminform.value, null, 2));

    let obj = {
      firstName: this.capitalize(this.adminform.value.adminfirstname),
      lastName: this.capitalize(this.adminform.value.adminlastname),
      phoneNum: this.adminform.value.adminphone,
      email: this.adminform.value.adminemail,
      role: this.adminform.value.role,
    };

    this.adminData.push(obj);

    // this.adminData = JSON.parse(sessionStorage.getItem('adminData') || '[]');
    // this.adminData = this.dummyAdminData;
    this.adminform.reset();
    this.showaddadmin = true;
    this.addadminform = false;
    sessionStorage.setItem('adminData', JSON.stringify(this.adminData));

    // this.adminData= JSON.parse(sessionStorage.getItem("adminData") || "[]")

    console.log(this.adminData);

    this.updateStatus(3);

    $('#subdomains-modal').modal('show');
    var corporateId = sessionStorage.getItem('corporateId');
    var accessToken = sessionStorage.getItem('accessToken');
    var subdomains = '/api/ap/admin/corporate/' + corporateId + '/subDomains';

    this.http
      .get(environment.apiUrl + subdomains, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.SubDomains = response.data;
          } else {
            // Swal.fire(this.lang.Error??'Error',response.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
              else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }

  subDomainConfirm() {


    if (this.subdomainName && this.subdomainName.length > 0) {
      var corporateId = sessionStorage.getItem('corporateId');
      var endPoint = '/api/ap/admin/corporate/' + corporateId + '/employee';
      var accessToken = sessionStorage.getItem('accessToken');
      var SubmitAdminInfo =
        '/api/ap/admin/corporate/' + corporateId + '/signupConfirmationDuplicate';

      let accessTokensession = sessionStorage.getItem('accessToken');

      let GroupContacts = JSON.parse(sessionStorage.getItem('adminData') || '[]');

      let obj = {
        groupadmins: GroupContacts,
        domainName: this.subdomainName,
      };

      if (GroupContacts.length > 0) {
        this.http
          .post(environment.apiUrl + SubmitAdminInfo, obj, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .subscribe(
            (response: any) => {
              if (response['status'] == 200) {
                $('#subdomains-modal').modal('hide');
                // Swal.fire('Success','successfully sent to admin');

                if (response.warning && response.warning.length > 0) {
                  Swal.fire({
                    title: 'Warning',
                    text: response.warning,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      var role = sessionStorage.getItem('role');

                      // sessionStorage.clear();
                      sessionStorage.setItem('accessToken', accessTokensession);
                      sessionStorage.setItem('role', role);
                      // window.location.reload();
                      this.basicInfo = true;
                      this.plansInfo = false;
                      this.wallettierInfo = false;
                      this.EmployeeInfo = false;
                      this.datagraphInfo = false;
                      // this.router.navigate(['/manageCorporates'])
                      this.router.navigate(['/manageCorporates/' + corporateId + '/view'])
                    }
                  });
                } else {
                  Swal.fire({
                    title: 'Success',
                    // text: 'Successfully sent to admin',
                    text: response.message,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      var keyToPreserve = ["adminName", "role", "loginname", "language"];


                      // Get all keys from sessionStorage
                      var keys = Object.keys(sessionStorage);

                      // Iterate through the keys and remove them from sessionStorage, except the one to preserve
                      keys.forEach(function (key) {
                        // if (key !== keyToPreserve) {
                        if (!keyToPreserve?.includes(key)) {
                          sessionStorage.removeItem(key);
                        }
                      });
                      sessionStorage.setItem('accessToken', accessTokensession);
                      // window.location.reload();
                      this.basicInfo = true;
                      this.plansInfo = false;
                      this.wallettierInfo = false;
                      this.EmployeeInfo = false;
                      this.datagraphInfo = false;
                      // this.router.navigate(['/manageCorporates']);
                      this.router.navigate(['/manageCorporates/' + corporateId + '/view'])
                    }
                  });
                }
              } else {
                //  this.submitformlink()
                // Swal.fire(this.lang.Error??'Error',response.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: response.message });
              }
            },
            (error) => {
              if (
                error.status == 400 ||
                error.status == 401 ||
                error.status == 402 ||
                error.status == 403
              ) {
                Swal.fire({
                  title: this.lang.Error ?? 'Error',
                  text: error.error.error.message,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: this.lang.Proceed,
                }).then((result) => {
                  /* Read more about isConfirmed, isDenied below */
                  if (result.isConfirmed) {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                  else {
                    sessionStorage.clear();
                    this.router.navigate(['/login']);
                  }
                });
              } else {
                // Swal.fire(error.error.error.message)
                Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
              }
              // this.toastrService.error("Invalid Credentials", 'Error!');
            }
          );
      } else {
        // Swal.fire('Please add one Group Contact');
      }
    }
    else {
      Swal.fire({ title: this.lang.Info, text: this.lang.Please_select_subdomain_for_your_portal });

    }

  }
  scrollTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  gotoPlansorWallet(employeeData: any) {


    console.log(employeeData)
    let selectedsummaryBlockBulk = JSON.parse(
      sessionStorage.getItem('summaryBlockBulk') || '[]'
    );
    this.employeeList = employeeData
    this._LoaderService.ShowLoader()

    this.showEmployeelist = employeeData

    console.log(this.showEmployeelist)
    let bulkcheckarray = []

    for (let i = 0; i < this.showEmployeelist.length; i++) {
      if (this.showEmployeelist[i].isBulk == true) {
        bulkcheckarray.push(this.showEmployeelist[i])
      }
    }
    console.log(bulkcheckarray)
    if (bulkcheckarray.length > 0) {


      this.showEmployeeValue = bulkcheckarray.length

      console.log(this.showEmployeeValue)
      // if(selectedsummaryBlockBulk.length>0){
      //   setTimeout(() => {
      //     for (let i = 0; i < selectedsummaryBlockBulk.length; i++) {

      //       $("#plancheckboxbulk" + selectedsummaryBlockBulk[i].subGroupId).click()


      //   }
      //   }, 1000);
      // }

    }
    else {
      this.showEmployeeValue = ''


      // setTimeout(() => {
      //   for (let i = 0; i < selectedsummaryBlockBulk.length; i++) {

      //     $("#plancheckboxbulk" + selectedsummaryBlockBulk[i].subGroupId).click()


      // }
      // }, 1000);

    }

    setTimeout(() => {
      this._LoaderService.HideLoader()

    }, 2000);

    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    if (formData.tierConfig == true) {
      this.basicInfo = false;
      this.plansInfo = false;
      this.wallettierInfo = false;
      this.EmployeeInfo = false;
      this.datagraphInfo = false;
      this.nowalletnotierInfo = false;
      this.showTiersTable = true




    }

    else {
      this.basicInfo = false;
      this.plansInfo = true;
      this.wallettierInfo = false;
      this.EmployeeInfo = false;
      this.datagraphInfo = false;
      this.nowalletnotierInfo = false;


      if (formData.tierConfig == false) {
        let selectedsummaryBlockBulk = JSON.parse(
          sessionStorage.getItem('summaryBlockBulk') || '[]'
        );
        let selectedplansblock1 = JSON.parse(
          sessionStorage.getItem('summaryBlock1') || '[]'
        );
        let selectedplansblock2 = JSON.parse(
          sessionStorage.getItem('summaryBlock2') || '[]'
        );
        let selectedplansblock3 = JSON.parse(
          sessionStorage.getItem('summaryBlock3') || '[]'
        );


        this.uploadEmployeeExcelData = []
        this.executeBlocks1(selectedsummaryBlockBulk, selectedplansblock1, selectedplansblock2, selectedplansblock3)
          .then((message) => console.log(message))
          .catch((error) => console.error("An error occurred:", error));

        // setTimeout(() => {
        //   const dom: HTMLElement = this.elementRef.nativeElement;
        //   if (selectedplansblock1.length > 0) {

        //     for (let i = 0; i < selectedplansblock1.length; i++) {
        //       const element: any = dom.querySelector(
        //         '#plancheck' + selectedplansblock1[i].subGroupId
        //       );
        //       $("#plancheck" + selectedplansblock1[i].subGroupId).prop("checked", true);


        //       // element.checked = true;
        //       // this.plancheckCoverage = selectedplansblock1[i].coverage;
        //       this.plancheckCoverage =  this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

        //       if (this.plancheckCoverage) {
        //         console.log(this.plancheckCoverage);
        //         if (this.plancheckCoverage.single) {
        //           const element2: any = dom.querySelector(
        //             '#executiveplanssingle' + selectedplansblock1[i].subGroupId
        //           );
        //           $("#executiveplanssingle" + selectedplansblock1[i].subGroupId).prop("checked", true);

        //           // element2.checked = true;
        //         } if (this.plancheckCoverage.couple) {
        //           const element2: any = dom.querySelector(
        //             '#executiveplanscouple' + selectedplansblock1[i].subGroupId
        //           );
        //           $("#executiveplanscouple" + selectedplansblock1[i].subGroupId).prop("checked", true);

        //           // element2.checked = true;
        //         } if (this.plancheckCoverage.family) {
        //           const element2: any = dom.querySelector(
        //             '#executiveplansfamily' + selectedplansblock1[i].subGroupId
        //           );
        //           $("#executiveplansfamily" + selectedplansblock1[i].subGroupId).prop("checked", true);

        //           // element2.checked = true;
        //         }
        //       }
        //     }
        //   }
        //   if (selectedplansblock2.length > 0) {


        //     let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
        //     el1.click();
        //     this.upgradeplansselection == true;

        //     setTimeout(() => {
        //       for (let i = 0; i < selectedplansblock2.length; i++) {
        //         const element1: any = dom.querySelector(
        //           '#plancheck2Upgrade' + selectedplansblock2[i].subGroupId
        //         );
        //         $("#plancheck2Upgrade" + selectedplansblock2[i].subGroupId).prop("checked", true);
        //         // element1.checked = true;
        //         this.plancheck2Coverage =  this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)

        //         if (
        //           this.plancheck2Coverage
        //         ) {
        //           console.log(this.plancheckCoverage);
        //           if (this.plancheck2Coverage.single) {
        //             const element2: any = dom.querySelector(
        //               '#executiveplansblock2single' +
        //                 selectedplansblock2[i].subGroupId
        //             );
        //             // element2.checked = true;
        //             $("#executiveplansblock2single" + selectedplansblock2[i].subGroupId).prop("checked", true);

        //           } if (this.plancheck2Coverage.couple) {
        //             const element2: any = dom.querySelector(
        //               '#executiveplansblock2couple' +
        //                 selectedplansblock2[i].subGroupId
        //             );
        //             // element2.checked = true;
        //             $("#executiveplansblock2couple" + selectedplansblock2[i].subGroupId).prop("checked", true);

        //           } if (this.plancheck2Coverage.family) {
        //             const element2: any = dom.querySelector(
        //               '#executiveplansblock2family' +
        //                 selectedplansblock2[i].subGroupId
        //             );
        //             // element2.checked = true;
        //             $("#executiveplansblock2family" + selectedplansblock2[i].subGroupId).prop("checked", true);

        //           }
        //         }
        //       }
        //     }, 2000);


        //                 }

        //   else{
        //     if (this.upgradeplansselection == true) {
        //       let el: HTMLElement = this.upgradeplansfalse.nativeElement;
        //       el.click();
        //       setTimeout(() => {
        //         let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
        //         el1.click();

        //       }, 10);
        //     }
        //   }


        //   setTimeout(() => {
        //     if (selectedplansblock3.length > 0) {
        //       let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
        //       el1.click();
        //       this.employeeplanpurchase == true;
        //        setTimeout(() => {

        //         for (let i = 0; i < selectedplansblock3.length; i++) {
        //           const element2: any = dom.querySelector(
        //             '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
        //           );
        //           $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

        //           this.plancheck3Coverage =  this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)


        //           if (
        //             this.plancheck3Coverage
        //           ) {
        //             if (this.plancheck3Coverage.single) {
        //               const element2: any = dom.querySelector(
        //                 '#executiveplansblock3single' +
        //                   selectedplansblock3[i].subGroupId
        //               );
        //               $("#executiveplansblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);

        //               // element2.checked = true;
        //             } if (this.plancheck3Coverage.couple) {
        //               const element2: any = dom.querySelector(
        //                 '#executiveplansblock3couple' +
        //                   selectedplansblock3[i].subGroupId
        //               );
        //               $("#executiveplansblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);

        //               // element2.checked = true;
        //             } if (this.plancheck3Coverage.family) {
        //               const element2: any = dom.querySelector(
        //                 '#executiveplansblock3family' +
        //                   selectedplansblock3[i].subGroupId
        //               );
        //               $("#executiveplansblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);

        //               // element2.checked = true;
        //             }
        //           }
        //         }
        //        }, 1500);
        //     }
        //     else{
        //       if (this.employeeplanpurchase == true) {
        //         let el: HTMLElement = this.employeepurchasefalse.nativeElement;
        //         el.click();
        //         setTimeout(() => {
        //           let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
        //           el1.click();
        //         }, 100);
        //       }
        //     }
        //   }, 3000);

        // }, 1000);
      }
      else {
        let selectedplansblock1 = this.seelctedplanLevelTierMapping || [];
        let selectedplansblock2 = this.seelctedplanLevelTierMappingBlock2 || [];
        let selectedplansblock3 = this.seelctedplanLevelTierMappingBlock3 || [];

        console.log(selectedplansblock1);
        console.log(selectedplansblock2);
        console.log(selectedplansblock3);

        setTimeout(() => {
          const dom: HTMLElement = this.elementRef.nativeElement;

          console.log(selectedplansblock1);
          if (selectedplansblock1.length > 0) {
            for (let i = 0; i < selectedplansblock1.length; i++) {
              const element: any = dom.querySelector(
                '#plancheck' + selectedplansblock1[i].subGroupid
              );
              element.checked = true;
              this.plancheckCoverage = this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

              // this.plancheckCoverage = selectedplansblock1[i].coverage;
              if (this.plancheckCoverage) {
                if (this.plancheckCoverage.single) {
                  const element2: any = dom.querySelector(
                    '#executiveplansTiersingle' +
                    selectedplansblock1[i].subGroupid
                  );
                  element2.checked = true;
                } if (this.plancheckCoverage.couple) {
                  const element2: any = dom.querySelector(
                    '#executiveplansTiercouple' +
                    selectedplansblock1[i].subGroupid
                  );
                  element2.checked = true;
                } if (this.plancheckCoverage.family) {
                  const element2: any = dom.querySelector(
                    '#executiveplansTierfamily' +
                    selectedplansblock1[i].subGroupid
                  );
                  element2.checked = true;
                }
              }
              this.plansBlock1Tiers[selectedplansblock1[i].packageindex][
                'groups'
              ][selectedplansblock1[i].groupindex]['subGroups'][
                selectedplansblock1[i].subgroupindex
              ].tiers = selectedplansblock1[i].tiers;
            }
          }
          if (selectedplansblock2.length > 0) {
            console.log(selectedplansblock2);
            let el1: HTMLElement = this.upgradeplanstierstrue.nativeElement;
            el1.click();
            this.upgradeplansselectiontiers == true;
            setTimeout(() => {
              for (let i = 0; i < selectedplansblock2.length; i++) {
                const element1: any = dom.querySelector(
                  '#plancheck2Upgrade' + selectedplansblock2[i].subGroupid
                );
                element1.checked = true;

                this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)

                if (
                  this.plancheck2Coverage
                ) {
                  console.log(this.plancheck2Coverage);
                  if (this.plancheck2Coverage.single) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock2Tiersingle' +
                      selectedplansblock2[i].subGroupid
                    );
                    element2.checked = true;
                  } else if (this.plancheck2Coverage.couple) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock2Tiercouple' +
                      selectedplansblock2[i].subGroupid
                    );
                    element2.checked = true;
                  } else if (this.plancheck2Coverage.family) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock2Tierfamily' +
                      selectedplansblock2[i].subGroupid
                    );
                    element2.checked = true;
                  }
                }
                this.plansresblack2Tiers[selectedplansblock2[i].packageindex][
                  'groups'
                ][selectedplansblock2[i].groupindex]['subGroups'][
                  selectedplansblock2[i].subgroupindex
                ].tiers = selectedplansblock2[i].tiers;
              }
            }, 1000);
          }
          if (selectedplansblock3.length > 0) {
            let el1: HTMLElement = this.employeepurchaseTierstrue.nativeElement;
            el1.click();
            this.employeeplanpurchasetiers == true;
            setTimeout(() => {
              for (let i = 0; i < selectedplansblock3.length; i++) {
                const element2: any = dom.querySelector(
                  '#plancheck3Voluntry' + selectedplansblock3[i].subGroupid
                );
                element2.checked = true;
                // this.plancheck3Coverage = selectedplansblock3[i].coverage;
                this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)

                if (
                  this.plancheck3Coverage
                ) {
                  if (this.plancheck3Coverage.single) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock3Tiersingle' +
                      selectedplansblock3[i].subGroupid
                    );
                    element2.checked = true;
                  } else if (this.plancheck3Coverage.couple) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock3Tiercouple' +
                      selectedplansblock3[i].subGroupid
                    );
                    element2.checked = true;
                  } else if (this.plancheck3Coverage.family) {
                    const element2: any = dom.querySelector(
                      '#executiveplansblock3Tierfamily' +
                      selectedplansblock3[i].subGroupid
                    );
                    element2.checked = true;
                  }
                }
                this.plansresblack3Tiers[selectedplansblock3[i].packageindex][
                  'groups'
                ][selectedplansblock3[i].groupindex]['subGroups'][
                  selectedplansblock3[i].subgroupindex
                ].tiers = selectedplansblock3[i].tiers;
              }
            }, 1500);
          }
        }, 1000);
      }

      setTimeout(() => {

        let block1res = JSON.parse(
          sessionStorage.getItem('summaryBlock1') || '[]');



        for (let i = 0; i < block1res.length; i++) {
          if (block1res[i].subGroupId == 17) {

            $('#executiveplanssingle17').prop('disabled', false);
            $('#executiveplanscouple17').prop('disabled', false);
            $('#executiveplansfamily17').prop('disabled', false);
          }
          else {

            // $('#executiveplanssingle17').prop('disabled', true);
            // $('#executiveplanscouple17').prop('disabled', true);
            // $('#executiveplansfamily17').prop('disabled', true);
          }
          if (block1res[i].subGroupId == 18) {
            $('#executiveplanssingle18').prop('disabled', false);
            $('#executiveplanscouple18').prop('disabled', false);
            $('#executiveplansfamily18').prop('disabled', false);
          }
          else {
            // $('#executiveplanssingle18').prop('disabled', true);
            // $('#executiveplanscouple18').prop('disabled', true);
            // $('#executiveplansfamily18').prop('disabled', true);
          }

          if (block1res[i].subGroupId == 28) {
            $('#executiveplanssingle28').prop('disabled', false);
            $('#executiveplanscouple28').prop('disabled', false);
            $('#executiveplansfamily28').prop('disabled', false);
          }
          else {
            // $('#executiveplanssingle28').prop('disabled', true);
            // $('#executiveplanscouple28').prop('disabled', true);
            // $('#executiveplansfamily28').prop('disabled', true);
          }
          // if(block1res[i].subGroupId == 17 && block1res[i].subGroupId == 18 ){

          // }
          // else{
          //   $('#executiveplanssingle17').prop('disabled', true);
          //   $('#executiveplanscouple17').prop('disabled', true);
          //   $('#executiveplansfamily17').prop('disabled', true);
          //   $('#executiveplanssingle18').prop('disabled', true);
          //   $('#executiveplanscouple18').prop('disabled', true);
          //   $('#executiveplansfamily18').prop('disabled', true);
          // }
        }

      }, 100);

      this.getExistingTiers()

    }

    // if (formData.walletConfig == true) {
    //   this.basicInfo = false;
    //   this.plansInfo = false;
    //   this.wallettierInfo = true;
    //   this.EmployeeInfo = false;
    //   this.datagraphInfo = false;
    //   this.nowalletnotierInfo = false;




    // }

    // else {
    //   this.basicInfo = false;
    //   this.plansInfo = true;
    //   this.wallettierInfo = false;
    //   this.EmployeeInfo = false;
    //   this.datagraphInfo = false;
    //   this.nowalletnotierInfo = false;


    //   if (formData.tierConfig == false) {
    //     let selectedsummaryBlockBulk = JSON.parse(
    //       sessionStorage.getItem('summaryBlockBulk') || '[]'
    //     );
    //     let selectedplansblock1 = JSON.parse(
    //       sessionStorage.getItem('summaryBlock1') || '[]'
    //     );
    //     let selectedplansblock2 = JSON.parse(
    //       sessionStorage.getItem('summaryBlock2') || '[]'
    //     );
    //     let selectedplansblock3 = JSON.parse(
    //       sessionStorage.getItem('summaryBlock3') || '[]'
    //     );


    //     this.uploadEmployeeExcelData = []
    //     this.executeBlocks1(selectedsummaryBlockBulk, selectedplansblock1, selectedplansblock2, selectedplansblock3)
    //       .then((message) => console.log(message))
    //       .catch((error) => console.error("An error occurred:", error));

    //     // setTimeout(() => {
    //     //   const dom: HTMLElement = this.elementRef.nativeElement;
    //     //   if (selectedplansblock1.length > 0) {

    //     //     for (let i = 0; i < selectedplansblock1.length; i++) {
    //     //       const element: any = dom.querySelector(
    //     //         '#plancheck' + selectedplansblock1[i].subGroupId
    //     //       );
    //     //       $("#plancheck" + selectedplansblock1[i].subGroupId).prop("checked", true);


    //     //       // element.checked = true;
    //     //       // this.plancheckCoverage = selectedplansblock1[i].coverage;
    //     //       this.plancheckCoverage =  this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

    //     //       if (this.plancheckCoverage) {
    //     //         console.log(this.plancheckCoverage);
    //     //         if (this.plancheckCoverage.single) {
    //     //           const element2: any = dom.querySelector(
    //     //             '#executiveplanssingle' + selectedplansblock1[i].subGroupId
    //     //           );
    //     //           $("#executiveplanssingle" + selectedplansblock1[i].subGroupId).prop("checked", true);

    //     //           // element2.checked = true;
    //     //         } if (this.plancheckCoverage.couple) {
    //     //           const element2: any = dom.querySelector(
    //     //             '#executiveplanscouple' + selectedplansblock1[i].subGroupId
    //     //           );
    //     //           $("#executiveplanscouple" + selectedplansblock1[i].subGroupId).prop("checked", true);

    //     //           // element2.checked = true;
    //     //         } if (this.plancheckCoverage.family) {
    //     //           const element2: any = dom.querySelector(
    //     //             '#executiveplansfamily' + selectedplansblock1[i].subGroupId
    //     //           );
    //     //           $("#executiveplansfamily" + selectedplansblock1[i].subGroupId).prop("checked", true);

    //     //           // element2.checked = true;
    //     //         }
    //     //       }
    //     //     }
    //     //   }
    //     //   if (selectedplansblock2.length > 0) {


    //     //     let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
    //     //     el1.click();
    //     //     this.upgradeplansselection == true;

    //     //     setTimeout(() => {
    //     //       for (let i = 0; i < selectedplansblock2.length; i++) {
    //     //         const element1: any = dom.querySelector(
    //     //           '#plancheck2Upgrade' + selectedplansblock2[i].subGroupId
    //     //         );
    //     //         $("#plancheck2Upgrade" + selectedplansblock2[i].subGroupId).prop("checked", true);
    //     //         // element1.checked = true;
    //     //         this.plancheck2Coverage =  this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)

    //     //         if (
    //     //           this.plancheck2Coverage
    //     //         ) {
    //     //           console.log(this.plancheckCoverage);
    //     //           if (this.plancheck2Coverage.single) {
    //     //             const element2: any = dom.querySelector(
    //     //               '#executiveplansblock2single' +
    //     //                 selectedplansblock2[i].subGroupId
    //     //             );
    //     //             // element2.checked = true;
    //     //             $("#executiveplansblock2single" + selectedplansblock2[i].subGroupId).prop("checked", true);

    //     //           } if (this.plancheck2Coverage.couple) {
    //     //             const element2: any = dom.querySelector(
    //     //               '#executiveplansblock2couple' +
    //     //                 selectedplansblock2[i].subGroupId
    //     //             );
    //     //             // element2.checked = true;
    //     //             $("#executiveplansblock2couple" + selectedplansblock2[i].subGroupId).prop("checked", true);

    //     //           } if (this.plancheck2Coverage.family) {
    //     //             const element2: any = dom.querySelector(
    //     //               '#executiveplansblock2family' +
    //     //                 selectedplansblock2[i].subGroupId
    //     //             );
    //     //             // element2.checked = true;
    //     //             $("#executiveplansblock2family" + selectedplansblock2[i].subGroupId).prop("checked", true);

    //     //           }
    //     //         }
    //     //       }
    //     //     }, 2000);


    //     //                 }

    //     //   else{
    //     //     if (this.upgradeplansselection == true) {
    //     //       let el: HTMLElement = this.upgradeplansfalse.nativeElement;
    //     //       el.click();
    //     //       setTimeout(() => {
    //     //         let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
    //     //         el1.click();

    //     //       }, 10);
    //     //     }
    //     //   }


    //     //   setTimeout(() => {
    //     //     if (selectedplansblock3.length > 0) {
    //     //       let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
    //     //       el1.click();
    //     //       this.employeeplanpurchase == true;
    //     //        setTimeout(() => {

    //     //         for (let i = 0; i < selectedplansblock3.length; i++) {
    //     //           const element2: any = dom.querySelector(
    //     //             '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
    //     //           );
    //     //           $("#plancheck3Voluntry" + selectedplansblock3[i].subGroupId).prop("checked", true);

    //     //           this.plancheck3Coverage =  this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)


    //     //           if (
    //     //             this.plancheck3Coverage
    //     //           ) {
    //     //             if (this.plancheck3Coverage.single) {
    //     //               const element2: any = dom.querySelector(
    //     //                 '#executiveplansblock3single' +
    //     //                   selectedplansblock3[i].subGroupId
    //     //               );
    //     //               $("#executiveplansblock3single" + selectedplansblock3[i].subGroupId).prop("checked", true);

    //     //               // element2.checked = true;
    //     //             } if (this.plancheck3Coverage.couple) {
    //     //               const element2: any = dom.querySelector(
    //     //                 '#executiveplansblock3couple' +
    //     //                   selectedplansblock3[i].subGroupId
    //     //               );
    //     //               $("#executiveplansblock3couple" + selectedplansblock3[i].subGroupId).prop("checked", true);

    //     //               // element2.checked = true;
    //     //             } if (this.plancheck3Coverage.family) {
    //     //               const element2: any = dom.querySelector(
    //     //                 '#executiveplansblock3family' +
    //     //                   selectedplansblock3[i].subGroupId
    //     //               );
    //     //               $("#executiveplansblock3family" + selectedplansblock3[i].subGroupId).prop("checked", true);

    //     //               // element2.checked = true;
    //     //             }
    //     //           }
    //     //         }
    //     //        }, 1500);
    //     //     }
    //     //     else{
    //     //       if (this.employeeplanpurchase == true) {
    //     //         let el: HTMLElement = this.employeepurchasefalse.nativeElement;
    //     //         el.click();
    //     //         setTimeout(() => {
    //     //           let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
    //     //           el1.click();
    //     //         }, 100);
    //     //       }
    //     //     }
    //     //   }, 3000);

    //     // }, 1000);
    //   }
    //   else {
    //     let selectedplansblock1 = this.seelctedplanLevelTierMapping || [];
    //     let selectedplansblock2 = this.seelctedplanLevelTierMappingBlock2 || [];
    //     let selectedplansblock3 = this.seelctedplanLevelTierMappingBlock3 || [];

    //     console.log(selectedplansblock1);
    //     console.log(selectedplansblock2);
    //     console.log(selectedplansblock3);

    //     setTimeout(() => {
    //       const dom: HTMLElement = this.elementRef.nativeElement;

    //       console.log(selectedplansblock1);
    //       if (selectedplansblock1.length > 0) {
    //         for (let i = 0; i < selectedplansblock1.length; i++) {
    //           const element: any = dom.querySelector(
    //             '#plancheck' + selectedplansblock1[i].subGroupid
    //           );
    //           element.checked = true;
    //           this.plancheckCoverage = this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

    //           // this.plancheckCoverage = selectedplansblock1[i].coverage;
    //           if (this.plancheckCoverage) {
    //             if (this.plancheckCoverage.single) {
    //               const element2: any = dom.querySelector(
    //                 '#executiveplansTiersingle' +
    //                 selectedplansblock1[i].subGroupid
    //               );
    //               element2.checked = true;
    //             } if (this.plancheckCoverage.couple) {
    //               const element2: any = dom.querySelector(
    //                 '#executiveplansTiercouple' +
    //                 selectedplansblock1[i].subGroupid
    //               );
    //               element2.checked = true;
    //             } if (this.plancheckCoverage.family) {
    //               const element2: any = dom.querySelector(
    //                 '#executiveplansTierfamily' +
    //                 selectedplansblock1[i].subGroupid
    //               );
    //               element2.checked = true;
    //             }
    //           }
    //           this.plansBlock1Tiers[selectedplansblock1[i].packageindex][
    //             'groups'
    //           ][selectedplansblock1[i].groupindex]['subGroups'][
    //             selectedplansblock1[i].subgroupindex
    //           ].tiers = selectedplansblock1[i].tiers;
    //         }
    //       }
    //       if (selectedplansblock2.length > 0) {
    //         console.log(selectedplansblock2);
    //         let el1: HTMLElement = this.upgradeplanstierstrue.nativeElement;
    //         el1.click();
    //         this.upgradeplansselectiontiers == true;
    //         setTimeout(() => {
    //           for (let i = 0; i < selectedplansblock2.length; i++) {
    //             const element1: any = dom.querySelector(
    //               '#plancheck2Upgrade' + selectedplansblock2[i].subGroupid
    //             );
    //             element1.checked = true;

    //             this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)

    //             if (
    //               this.plancheck2Coverage
    //             ) {
    //               console.log(this.plancheck2Coverage);
    //               if (this.plancheck2Coverage.single) {
    //                 const element2: any = dom.querySelector(
    //                   '#executiveplansblock2Tiersingle' +
    //                   selectedplansblock2[i].subGroupid
    //                 );
    //                 element2.checked = true;
    //               } else if (this.plancheck2Coverage.couple) {
    //                 const element2: any = dom.querySelector(
    //                   '#executiveplansblock2Tiercouple' +
    //                   selectedplansblock2[i].subGroupid
    //                 );
    //                 element2.checked = true;
    //               } else if (this.plancheck2Coverage.family) {
    //                 const element2: any = dom.querySelector(
    //                   '#executiveplansblock2Tierfamily' +
    //                   selectedplansblock2[i].subGroupid
    //                 );
    //                 element2.checked = true;
    //               }
    //             }
    //             this.plansresblack2Tiers[selectedplansblock2[i].packageindex][
    //               'groups'
    //             ][selectedplansblock2[i].groupindex]['subGroups'][
    //               selectedplansblock2[i].subgroupindex
    //             ].tiers = selectedplansblock2[i].tiers;
    //           }
    //         }, 1000);
    //       }
    //       if (selectedplansblock3.length > 0) {
    //         let el1: HTMLElement = this.employeepurchaseTierstrue.nativeElement;
    //         el1.click();
    //         this.employeeplanpurchasetiers == true;
    //         setTimeout(() => {
    //           for (let i = 0; i < selectedplansblock3.length; i++) {
    //             const element2: any = dom.querySelector(
    //               '#plancheck3Voluntry' + selectedplansblock3[i].subGroupid
    //             );
    //             element2.checked = true;
    //             // this.plancheck3Coverage = selectedplansblock3[i].coverage;
    //             this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)

    //             if (
    //               this.plancheck3Coverage
    //             ) {
    //               if (this.plancheck3Coverage.single) {
    //                 const element2: any = dom.querySelector(
    //                   '#executiveplansblock3Tiersingle' +
    //                   selectedplansblock3[i].subGroupid
    //                 );
    //                 element2.checked = true;
    //               } else if (this.plancheck3Coverage.couple) {
    //                 const element2: any = dom.querySelector(
    //                   '#executiveplansblock3Tiercouple' +
    //                   selectedplansblock3[i].subGroupid
    //                 );
    //                 element2.checked = true;
    //               } else if (this.plancheck3Coverage.family) {
    //                 const element2: any = dom.querySelector(
    //                   '#executiveplansblock3Tierfamily' +
    //                   selectedplansblock3[i].subGroupid
    //                 );
    //                 element2.checked = true;
    //               }
    //             }
    //             this.plansresblack3Tiers[selectedplansblock3[i].packageindex][
    //               'groups'
    //             ][selectedplansblock3[i].groupindex]['subGroups'][
    //               selectedplansblock3[i].subgroupindex
    //             ].tiers = selectedplansblock3[i].tiers;
    //           }
    //         }, 1500);
    //       }
    //     }, 1000);
    //   }

    //   setTimeout(() => {

    //     let block1res = JSON.parse(
    //       sessionStorage.getItem('summaryBlock1') || '[]');



    //     for (let i = 0; i < block1res.length; i++) {
    //       if (block1res[i].subGroupId == 17) {

    //         $('#executiveplanssingle17').prop('disabled', false);
    //         $('#executiveplanscouple17').prop('disabled', false);
    //         $('#executiveplansfamily17').prop('disabled', false);
    //       }
    //       else {

    //         // $('#executiveplanssingle17').prop('disabled', true);
    //         // $('#executiveplanscouple17').prop('disabled', true);
    //         // $('#executiveplansfamily17').prop('disabled', true);
    //       }
    //       if (block1res[i].subGroupId == 18) {
    //         $('#executiveplanssingle18').prop('disabled', false);
    //         $('#executiveplanscouple18').prop('disabled', false);
    //         $('#executiveplansfamily18').prop('disabled', false);
    //       }
    //       else {
    //         // $('#executiveplanssingle18').prop('disabled', true);
    //         // $('#executiveplanscouple18').prop('disabled', true);
    //         // $('#executiveplansfamily18').prop('disabled', true);
    //       }

    //       if (block1res[i].subGroupId == 28) {
    //         $('#executiveplanssingle28').prop('disabled', false);
    //         $('#executiveplanscouple28').prop('disabled', false);
    //         $('#executiveplansfamily28').prop('disabled', false);
    //       }
    //       else {
    //         // $('#executiveplanssingle28').prop('disabled', true);
    //         // $('#executiveplanscouple28').prop('disabled', true);
    //         // $('#executiveplansfamily28').prop('disabled', true);
    //       }
    //       // if(block1res[i].subGroupId == 17 && block1res[i].subGroupId == 18 ){

    //       // }
    //       // else{
    //       //   $('#executiveplanssingle17').prop('disabled', true);
    //       //   $('#executiveplanscouple17').prop('disabled', true);
    //       //   $('#executiveplansfamily17').prop('disabled', true);
    //       //   $('#executiveplanssingle18').prop('disabled', true);
    //       //   $('#executiveplanscouple18').prop('disabled', true);
    //       //   $('#executiveplansfamily18').prop('disabled', true);
    //       // }
    //     }

    //   }, 100);

    // }
  }

  executeBlocks1(selectedsummaryBlockBulk, selectedplansblock1, selectedplansblock2, selectedplansblock3) {
    // return ; // return statement added because - we are using common-plans component to select plans
    return new Promise((resolve, reject) => {
      // First block of code
      console.log("Executing block 1");

      for (let i = 0; i < selectedsummaryBlockBulk.length; i++) {
        setTimeout(() => {
          $("#plancheckboxbulk" + selectedsummaryBlockBulk[i].subGroupId).prop("checked", true);
          this.showEmployeeValue = selectedsummaryBlockBulk[i].quantity
        })
        if (selectedsummaryBlockBulk[i].disallowedPlanLevels != null) {
          let disallowed_plans = selectedsummaryBlockBulk[i].disallowedPlanLevels.split(',');
          const dom1: HTMLElement = this.elementRef.nativeElement;
          for (let i = 0; i < disallowed_plans.length; i++) {
            console.log(disallowed_plans[i]);
            console.log(disallowed_plans[i]);
            setTimeout(() => {
              let elem: any = dom1.querySelector(`#plancheckboxbulk${disallowed_plans[i]}`)

              if (elem != null) {
                if (!elem.disabled) {

                  elem.disabled = true
                }
              }
            }, 100);

          }
        }

      }

      for (let i = 0; i < selectedplansblock1.length; i++) {
        setTimeout(() => {
          $("#plancheck" + selectedplansblock1[i].subGroupId).prop("checked", true);
          this.plancheckCoverage = this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

          if (this.plancheckCoverage) {
            console.log("grishma,", this.plancheckCoverage);
            if (this.plancheckCoverage.single) {

              $("#executiveplanssingle" + selectedplansblock1[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            } if (this.plancheckCoverage.couple) {

              $("#executiveplanscouple" + selectedplansblock1[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            } if (this.plancheckCoverage.family) {

              $("#executiveplansfamily" + selectedplansblock1[i].subGroupId).prop("checked", true);

              // element2.checked = true;
            }
          }
          if (selectedplansblock1[i].disallowedPlanLevels != null) {
            console.log(selectedplansblock1[i].disallowedPlanLevels)
            let disallowed_plans = selectedplansblock1[i].disallowedPlanLevels.split(',');
            const dom1: HTMLElement = this.elementRef.nativeElement;
            for (let i = 0; i < disallowed_plans.length; i++) {
              setTimeout(() => {
                let elem: any = dom1.querySelector(`#plancheck${disallowed_plans[i]}`)

                if (elem != null) {
                  if (!elem.disabled) {

                    elem.disabled = true
                  }
                }



              }, 100);

            }
          }

          if (i === selectedplansblock1.length - 1) {
            // Second block of code

            console.log("Executing block 2");


            setTimeout(() => {
              if (selectedplansblock2.length > 0) {
                let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
                el1.click();
                this.upgradeplansselection == true;

                for (let j = 0; j < selectedplansblock2.length; j++) {
                  setTimeout(() => {
                    $("#plancheck2Upgrade" + selectedplansblock2[j].subGroupId).prop("checked", true);
                    // element1.checked = true;
                    this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock2[j].coverage)

                    if (
                      this.plancheck2Coverage
                    ) {
                      console.log(this.plancheckCoverage);
                      if (this.plancheck2Coverage.single) {
                        $("#executiveplansblock2single" + selectedplansblock2[j].subGroupId).prop("checked", true);

                      } if (this.plancheck2Coverage.couple) {
                        $("#executiveplansblock2couple" + selectedplansblock2[j].subGroupId).prop("checked", true);

                      } if (this.plancheck2Coverage.family) {
                        $("#executiveplansblock2family" + selectedplansblock2[j].subGroupId).prop("checked", true);

                      }
                    }
                    console.log(`Block 2 - Task ${j + 1} completed`);
                    if (j === selectedplansblock2.length - 1) {
                      // Third block of code
                      console.log("Executing block 3");

                      setTimeout(() => {
                        if (selectedplansblock3.length > 0) {
                          let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                          if (el1 != null) el1.click();
                          this.employeeplanpurchase == true
                          for (let k = 0; k < selectedplansblock3.length; k++) {
                            setTimeout(() => {
                              $("#plancheck3Voluntry" + selectedplansblock3[k].subGroupId).prop("checked", true);

                              this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[k].coverage)


                              if (
                                this.plancheck3Coverage
                              ) {
                                if (this.plancheck3Coverage.single) {

                                  $("#executiveplansblock3single" + selectedplansblock3[k].subGroupId).prop("checked", true);

                                  // element2.checked = true;
                                } if (this.plancheck3Coverage.couple) {

                                  $("#executiveplansblock3couple" + selectedplansblock3[k].subGroupId).prop("checked", true);

                                  // element2.checked = true;
                                } if (this.plancheck3Coverage.family) {

                                  $("#executiveplansblock3family" + selectedplansblock3[k].subGroupId).prop("checked", true);

                                  // element2.checked = true;
                                }
                              }
                              console.log(`Block 3 - Task ${k + 1} completed`);
                              if (k === selectedplansblock3.length - 1) {
                                resolve("All blocks executed successfully");
                              }
                            }, 1500);
                          }
                        }
                      }, 1000);

                    }
                  }, 1000);
                }
              }
              if (selectedplansblock2.length == 0 && selectedplansblock3.length > 0) {
                let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
                if (el1 != null) el1.click();
                this.employeeplanpurchase == true
                for (let k = 0; k < selectedplansblock3.length; k++) {
                  setTimeout(() => {
                    $("#plancheck3Voluntry" + selectedplansblock3[k].subGroupId).prop("checked", true);

                    this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[k].coverage)


                    if (
                      this.plancheck3Coverage
                    ) {
                      if (this.plancheck3Coverage.single) {

                        $("#executiveplansblock3single" + selectedplansblock3[k].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      } if (this.plancheck3Coverage.couple) {

                        $("#executiveplansblock3couple" + selectedplansblock3[k].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      } if (this.plancheck3Coverage.family) {

                        $("#executiveplansblock3family" + selectedplansblock3[k].subGroupId).prop("checked", true);

                        // element2.checked = true;
                      }
                    }
                    console.log(`Block 3 - Task ${k + 1} completed`);
                    if (k === selectedplansblock3.length - 1) {
                      resolve("All blocks executed successfully");
                    }
                  }, 1500);
                }
              }
            }, 1000);





          }
        }, 1000);
      }
    });
  }

  showdatagrpah(employeelist) {
    console.log(employeelist);

    // alert(this.applicationStatus)

    this.addedEmployeelist = employeelist;

    this.employeeList = employeelist;
    this.basicInfo = false;
    this.plansInfo = false;
    this.wallettierInfo = false;
    this.EmployeeInfo = false;
    this.datagraphInfo = true;
    this.nowalletnotierInfo = false;
    this.updateAllStatus();
  }

  updateStatus(id: number) {
    let i = this.adminStatuslist.findIndex((status) => status.id == id);

    if (id == 1) {
      //address -- province
      if (
        this.clientregform.value.streetAddress &&
        this.clientregform.value.country &&
        this.clientregform.value.city &&
        this.clientregform.value.Province &&
        this.clientregform.value.postalCode
      ) {
        if (this.adminStatuslist[i].id == 1) {
          this.adminStatuslist[i].checked = true;
          //statusChangeCounter++;
          //this.add()
        }
      } else {
        if (this.adminStatuslist[i].id == 1) {
          this.adminStatuslist[i].checked = false;
          //statusChangeCounter++;
          //this.add()
        }
      }
    }

    if (id == 2) {
      console.log('poclist date changed---update!?');
      //policy start date
      if (this.clientregform.value.PolicyStartDate) {
        if (this.adminStatuslist[i].id == 2) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 2) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    if (id == 3) {
      if (this.adminData.length > 0) {
        if (this.adminStatuslist[i].id == 3) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 3) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    if (id == 4) {
      if (this.clientregform.value.waitingPeriod) {
        if (this.adminStatuslist[i].id == 4) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 4) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }
    if (id == 5) {
      if (this.clientregform.value.paymentInfo) {
        if (this.adminStatuslist[i].id == 5) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 5) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    if (id == 6) {
      if (this.clientregform.value.corporatelogo) {
        if (this.adminStatuslist[i].id == 6) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 6) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    if (id == 7) {
      if (this.clientregform.value.walletConfig) {
        if (this.adminStatuslist[i].id == 7) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 7) {
          this.adminStatuslist[i].checked = true;
        }
      }
    }

    if (id == 8) {
      if (this.clientregform.value.tierConfig) {
        if (this.adminStatuslist[i].id == 8) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 8) {
          this.adminStatuslist[i].checked = true;
        }
      }
    }

    if (id == 9) {
      if (this.paidByCompany?.length > 0) {
        if (this.adminStatuslist[i].id == 9) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 9) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    if (id == 10) {
      if (this.employeeList.length > 0) {
        if (this.adminStatuslist[i].id == 10) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 10) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    //last after all status
    // this.add();
  }
  updateAllStatus() {
    console.log(this.adminData);
    for (let i = 0; i < this.adminStatuslist.length; i++) {
      if (
        this.clientregform.value.streetAddress &&
        this.clientregform.value.country &&
        this.clientregform.value.city &&
        this.clientregform.value.Province &&
        this.clientregform.value.postalCode
      ) {
        if (this.adminStatuslist[i].id == 1) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 1) {
          this.adminStatuslist[i].checked = false;
        }
      }
      if (this.clientregform.value.PolicyStartDate) {
        if (this.adminStatuslist[i].id == 2) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 2) {
          this.adminStatuslist[i].checked = false;
        }
      }

      if (this.adminData.length > 0) {
        if (this.adminStatuslist[i].id == 3) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 3) {
          this.adminStatuslist[i].checked = false;
        }
      }
      if (this.clientregform.value.waitingPeriod) {
        if (this.adminStatuslist[i].id == 4) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 4) {
          this.adminStatuslist[i].checked = false;
        }
      }

      if (this.clientregform.value.paymentInfo) {
        if (this.adminStatuslist[i].id == 5) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 5) {
          this.adminStatuslist[i].checked = false;
        }
      }
      if (this.clientregform.value.corporatelogo) {
        if (this.adminStatuslist[i].id == 6) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 6) {
          this.adminStatuslist[i].checked = false;
        }
      }

      if (this.clientregform.value.walletConfig) {
        if (this.adminStatuslist[i].id == 7) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 7) {
          this.adminStatuslist[i].checked = true;
        }
      }

      if (this.clientregform.value.tierConfig) {
        if (this.adminStatuslist[i].id == 8) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 8) {
          this.adminStatuslist[i].checked = true;
        }
      }

      console.log(this.paidByCompany);
      if (this.paidByCompany?.length > 0) {
        if (this.adminStatuslist[i].id == 9) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 9) {
          this.adminStatuslist[i].checked = false;
        }
      }
      if (this.employeeList.length > 0) {
        if (this.adminStatuslist[i].id == 10) {
          this.adminStatuslist[i].checked = true;
        }
      } else {
        if (this.adminStatuslist[i].id == 10) {
          this.adminStatuslist[i].checked = false;
        }
      }
    }

    this.add();

    //this.add()
  }

  public add() {
    //re-order them by color --- red // black
    let redStatus = this.adminStatuslist.filter(
      (status) => status.color == 'red'
    );
    let blackStatus = this.adminStatuslist.filter(
      (status) => status.color == 'black'
    );
    this.adminStatuslist = redStatus.concat(blackStatus);

    var t = this.adminStatuslist.filter((opt) => opt.checked).map((opt) => opt);
    console.log(t);
    this.lengthofstatus = t.length;
    this.applicationStatus = this.lengthofstatus;
    // this.headerComponent.applicationStatus(this.lengthofstatus);
  }
  showemployeepage(event) {
    console.log(event)
    this.selectedWalletConfig = event.payForService;
    this.basicInfo = false;
    this.plansInfo = false;
    this.wallettierInfo = false;
    this.EmployeeInfo = true;
    this.datagraphInfo = false;
    this.nowalletnotierInfo = false;
  }

  public getExecutiveCoveragesFromCode(code: string) {

    let coverage;

    if (code) {
      coverage = { single: false, couple: false, family: false }
      if (code[0] == '1') {
        coverage.family = true;
      }
      if (code[1] == '1') {
        coverage.couple = true;
      }
      if (code[2] == '1') {
        coverage.single = true;
      }
    } else {
      coverage = null
    }

    return coverage;

  }
  gotoplanspagefromwallet() {
    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    this.basicInfo = false;
    this.plansInfo = true;
    this.wallettierInfo = false;
    this.EmployeeInfo = false;
    this.datagraphInfo = false;
    this.nowalletnotierInfo = false;

    if (formData.tierConfig == false) {
      let selectedplansblock1 = JSON.parse(
        sessionStorage.getItem('summaryBlock1') || '[]'
      );
      let selectedplansblock2 = JSON.parse(
        sessionStorage.getItem('summaryBlock2') || '[]'
      );
      let selectedplansblock3 = JSON.parse(
        sessionStorage.getItem('summaryBlock3') || '[]'
      );

      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;
        if (selectedplansblock1.length > 0) {
          for (let i = 0; i < selectedplansblock1.length; i++) {
            const element: any = dom.querySelector(
              '#plancheck' + selectedplansblock1[i].subGroupId
            );
            // element.checked = true;
            element.click()

            setTimeout(() => {
              element.click()
            }, 10);
            // this.plancheckCoverage = selectedplansblock1[i].coverage;

            this.plancheckCoverage = this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

            // {single: true, couple: true, family: false}
            if (this.plancheckCoverage) {
              // console.log(this.plancheckCoverage['single']);

              console.log(this.plancheckCoverage.single)
              if (this.plancheckCoverage.single) {

                const element2: any = dom.querySelector(
                  '#executiveplanssingle' + selectedplansblock1[i].subGroupId
                );
                element2.checked = true;
              } if (this.plancheckCoverage.couple) {
                const element2: any = dom.querySelector(
                  '#executiveplanscouple' + selectedplansblock1[i].subGroupId
                );
                element2.checked = true;
              } if (this.plancheckCoverage.family) {
                const element2: any = dom.querySelector(
                  '#executiveplansfamily' + selectedplansblock1[i].subGroupId
                );
                element2.checked = true;
              }
            }
          }
        }
        if (selectedplansblock2.length > 0) {
          let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
          el1.click();
          this.upgradeplansselection == true;
          setTimeout(() => {
            for (let i = 0; i < selectedplansblock2.length; i++) {
              const element1: any = dom.querySelector(
                '#plancheck2Upgrade' + selectedplansblock2[i].subGroupId
              );
              element1.checked = true;
              // this.plancheck2Coverage = selectedplansblock2[i].coverage;
              this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)


              if (this.plancheck2Coverage) {
                if (this.plancheck2Coverage.single) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2single' +
                    selectedplansblock2[i].subGroupId
                  );
                  element2.checked = true;
                } if (this.plancheck2Coverage.couple) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2couple' +
                    selectedplansblock2[i].subGroupId
                  );
                  element2.checked = true;
                } else if (this.plancheck2Coverage.family) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2family' +
                    selectedplansblock2[i].subGroupId
                  );
                  element2.checked = true;
                }
              }
            }
          }, 1000);
        }
        else {
          if (this.upgradeplansselection == true) {
            let el: HTMLElement = this.upgradeplansfalse.nativeElement;
            el.click();
            setTimeout(() => {
              let el1: HTMLElement = this.upgradeplanstrue?.nativeElement;
              el1.click();

            }, 10);
          }

        }
        if (selectedplansblock3.length > 0) {
          let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
          el1.click();
          this.employeeplanpurchase == true;
          setTimeout(() => {
            for (let i = 0; i < selectedplansblock3.length; i++) {
              const element2: any = dom.querySelector(
                '#plancheck3Voluntry' + selectedplansblock3[i].subGroupId
              );
              element2.checked = true;
              this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)

              // this.plancheck3Coverage = selectedplansblock3[i].coverage;

              if (this.plancheck3Coverage) {
                if (this.plancheck3Coverage.single) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3single' +
                    selectedplansblock3[i].subGroupId
                  );
                  element2.checked = true;
                } if (this.plancheck3Coverage.couple) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3couple' +
                    selectedplansblock3[i].subGroupId
                  );
                  element2.checked = true;
                } if (this.plancheck3Coverage.family) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3family' +
                    selectedplansblock3[i].subGroupId
                  );
                  element2.checked = true;
                }
              }
            }
          }, 1500);
        }
        else {
          if (this.employeeplanpurchase == true) {
            // let el: HTMLElement = this.employeepurchasefalse.nativeElement;
            // el.click();
            setTimeout(() => {
              let el1: HTMLElement = this.employeepurchasetrue?.nativeElement;
              el1.click();
            }, 100);
          }
        }
      }, 1000);
    } else {
      let selectedplansblock1 = this.seelctedplanLevelTierMapping || [];
      let selectedplansblock2 = this.seelctedplanLevelTierMappingBlock2 || [];
      let selectedplansblock3 = this.seelctedplanLevelTierMappingBlock3 || [];

      setTimeout(() => {
        const dom: HTMLElement = this.elementRef.nativeElement;

        console.log(selectedplansblock1);
        if (selectedplansblock1.length > 0) {
          for (let i = 0; i < selectedplansblock1.length; i++) {
            const element: any = dom.querySelector(
              '#plancheck' + selectedplansblock1[i].subGroupid
            );
            element.checked = true;
            this.plancheckCoverage = this.getExecutiveCoveragesFromCode(selectedplansblock1[i].coverage)

            // this.plancheckCoverage = selectedplansblock1[i].coverage;
            if (this.plancheckCoverage) {
              if (this.plancheckCoverage.single) {
                const element2: any = dom.querySelector(
                  '#executiveplansTiersingle' +
                  selectedplansblock1[i].subGroupid
                );
                element2.checked = true;
              } if (this.plancheckCoverage.couple) {
                const element2: any = dom.querySelector(
                  '#executiveplansTiercouple' +
                  selectedplansblock1[i].subGroupid
                );
                element2.checked = true;
              } if (this.plancheckCoverage.family) {
                const element2: any = dom.querySelector(
                  '#executiveplansTierfamily' +
                  selectedplansblock1[i].subGroupid
                );
                element2.checked = true;
              }
            }
            this.plansBlock1Tiers[selectedplansblock1[i].packageindex][
              'groups'
            ][selectedplansblock1[i].groupindex]['subGroups'][
              selectedplansblock1[i].subgroupindex
            ].tiers = selectedplansblock1[i].tiers;
          }
        }
        if (selectedplansblock2.length > 0) {
          console.log(selectedplansblock2);
          let el1: HTMLElement = this.upgradeplanstierstrue.nativeElement;
          el1.click();
          this.upgradeplansselectiontiers == true;
          setTimeout(() => {
            for (let i = 0; i < selectedplansblock2.length; i++) {
              const element1: any = dom.querySelector(
                '#plancheck2Upgrade' + selectedplansblock2[i].subGroupid
              );
              element1.checked = true;

              this.plancheck2Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock2[i].coverage)

              if (
                this.plancheck2Coverage
              ) {
                console.log(this.plancheck2Coverage);
                if (this.plancheck2Coverage.single) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2Tiersingle' +
                    selectedplansblock2[i].subGroupid
                  );
                  element2.checked = true;
                } else if (this.plancheck2Coverage.couple) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2Tiercouple' +
                    selectedplansblock2[i].subGroupid
                  );
                  element2.checked = true;
                } else if (this.plancheck2Coverage.family) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock2Tierfamily' +
                    selectedplansblock2[i].subGroupid
                  );
                  element2.checked = true;
                }
              }
              this.plansresblack2Tiers[selectedplansblock2[i].packageindex][
                'groups'
              ][selectedplansblock2[i].groupindex]['subGroups'][
                selectedplansblock2[i].subgroupindex
              ].tiers = selectedplansblock2[i].tiers;
            }
          }, 1000);
        }
        if (selectedplansblock3.length > 0) {
          let el1: HTMLElement = this.employeepurchaseTierstrue.nativeElement;
          el1.click();
          this.employeeplanpurchasetiers == true;
          setTimeout(() => {
            for (let i = 0; i < selectedplansblock3.length; i++) {
              const element2: any = dom.querySelector(
                '#plancheck3Voluntry' + selectedplansblock3[i].subGroupid
              );
              element2.checked = true;
              // this.plancheck3Coverage = selectedplansblock3[i].coverage;
              this.plancheck3Coverage = this.getExecutiveCoveragesFromCode(selectedplansblock3[i].coverage)

              if (
                this.plancheck3Coverage
              ) {
                if (this.plancheck3Coverage.single) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3Tiersingle' +
                    selectedplansblock3[i].subGroupid
                  );
                  element2.checked = true;
                } else if (this.plancheck3Coverage.couple) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3Tiercouple' +
                    selectedplansblock3[i].subGroupid
                  );
                  element2.checked = true;
                } else if (this.plancheck3Coverage.family) {
                  const element2: any = dom.querySelector(
                    '#executiveplansblock3Tierfamily' +
                    selectedplansblock3[i].subGroupid
                  );
                  element2.checked = true;
                }
              }
              this.plansresblack3Tiers[selectedplansblock3[i].packageindex][
                'groups'
              ][selectedplansblock3[i].groupindex]['subGroups'][
                selectedplansblock3[i].subgroupindex
              ].tiers = selectedplansblock3[i].tiers;
            }
          }, 1500);
        }
      }, 1000);
    }
  }
  phonenumbercheck(event) {
    // console.log(event)
    this.formatPhoneNumber(event.target.value);
  }
  formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? '+1 ' : '';
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }

  phoneFormat(event: any) {
    const inputValue = this.adminform.get("adminphone").value;

    this.adminform
      .get("adminphone")
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }

  phoneFormat1(event: any) {
    const inputValue = this.addEmployeeformList.get("employeePhoneno").value;

    this.addEmployeeformList
      .get("employeePhoneno")
      .setValue(this.phoneNoFormat.transform(inputValue), { emitEvent: false });
  }
  alphabatesOnly(event: any) {
    return this.commonPatternsService.alphabatesOnly(event);
  }

  alphaNumarics(event: any) {
    return this.commonPatternsService.alphaNumarics(event);
  }
  textChangeToLowerCase(formGroup: any, formcontrolField: any) {
    formGroup[formcontrolField].setValue(formGroup[formcontrolField].value.toLowerCase());
  }
  textChangeToLowerCase1(formcontrolField: any) {
    // console.log(this.emp, this.emp['employeeEmail']?.errors, this.emp['employeeEmail']?.errors['required'], this.emp['employeeEmail']?.errors['pattern'])
    this.emp[formcontrolField].setValue(
      this.emp[formcontrolField].value.toLowerCase()
    );
  }

  othersField(event: any) {
    if (event.target.value == "CORPORATE_OTHERS") {
      this.showOtherField = true;
      this.adminform.get('roleName').setValidators(Validators.required);
      this.adminform.get('roleName').updateValueAndValidity();
    }
    else {
      this.showOtherField = false;
      this.adminform.get('roleName').clearValidators();
      this.adminform.get('roleName').updateValueAndValidity();
    }
  }


  exportAsXLSXWaddel(): void {

    console.log(this.multiSelectProviancenames)

    if (!this.showEmployeeValue1) {
      this.headCountmiss1 = true
    }
    else {
      this.headCountmiss1 = false

      this.employeedata = [
        {
          "label": "firstName",
          "key": "firstName",
          "value": "First Name",
          "mandatory": true
        },
        {
          "label": "lastName",
          "key": "lastName",
          "value": "Last Name",
          "mandatory": true
        },
        {
          "label": "email",
          "key": "email",
          "value": "Email",
          "mandatory": true
        },
        {
          "label": "phoneNum",
          "key": "phoneNum",
          "value": "Phone Number",
          "mandatory": true
        },
        {
          "label": "streetAddress",
          "key": "streetAddress",
          "value": "Street Address",
          "mandatory": true
        },
        {
          "label": "country",
          "key": "country",
          "value": "Country",
          "mandatory": true
        },
        {
          "label": "city",
          "key": "city",
          "value": "City",
          "mandatory": true
        },
        {
          "label": "province",
          "key": "province",
          "value": "Province",
          "mandatory": true
        },
        {
          "label": "postalCode",
          "key": "postalCode",
          "value": "PostalCode",
          "mandatory": true
        }
      ]

      this.employeedata2 = [
        {
          "label": "firstName",
          "key": "firstName",
          "value": "First Name",
          "mandatory": true,
          display: true
        },
        {
          "label": "lastName",
          "key": "lastName",
          "value": "Last Name",
          "mandatory": true,
          display: true
        },
        {
          "label": "email",
          "key": "email",
          "value": "Email",
          "mandatory": true,
          display: true
        },
        {
          "label": "phoneNum",
          "key": "phoneNum",
          "value": "Phone Number",
          "mandatory": true,
          display: true
        },
        {
          "label": "streetAddress",
          "key": "streetAddress",
          "value": "Street Address",
          "mandatory": true,
          display: true
        },
        {
          "label": "country",
          "key": "country",
          "value": "Country",
          "mandatory": true,
          display: true
        },
        {
          "label": "city",
          "key": "city",
          "value": "City",
          "mandatory": true,
          display: true
        },
        {
          "label": "province",
          "key": "province",
          "value": "Province",
          "mandatory": true,
          display: true
        },
        {
          "label": "postalCode",
          "key": "postalCode",
          "value": "PostalCode",
          "mandatory": true,
          display: true
        }]


      var obj: any = {};
      for (let i = 0; i < this.employeedata.length; i++) {
        obj[this.employeedata[i].value] = '';
        this.excelempdata.push(obj);
      }

      var finalres = Object.values(
        this.excelempdata.reduce((c, e) => {
          if (!c[e.Gender]) c[e.Gender] = e;
          return c;
        }, {})
      );

      console.log(finalres)
      this.finalemployeekeys = finalres;
      let multiProviance = [];
      this.configprovincereslist.map((proviance) => {
        multiProviance.push(proviance.shortName);
      });
      console.log(this.finalemployeekeys);
      let formData = JSON.parse(sessionStorage.getItem('formData') || '');
      this.excelService.exportAsExcelFileBulkwaddell(
        this.finalemployeekeys,
        this.employeedata2,
        'CorporateBulksPlansWaddell',
        formData.tierConfig,
        formData.walletConfig,
        this.showEmployeeValue1,
        this.multiSelectProviancenames
      );
    }


  }

  public countPhoneNumberDigits(phoneNumber) {
    // Remove non-digit characters using a regular expression
    let digitsOnly = phoneNumber.replace(/\D/g, '');
    // Return the length of the resulting string
    return digitsOnly.length;
  }

  editEmployees(subgrpId) {
    this.selectedSubGrpId = subgrpId
    $('#showBulkEmployeelist').modal('show')
    this.filteredEmployeeList = this.employeeList.filter(item => item.bulkPlanLevelId === subgrpId);
    // this.filteredEmployeeList = this.employeeList
  }

  onFileChangeExcelWaddel(ev: any) {
    console.log("calling1")
    console.log(this.showEmployeeValue1)
    if (!this.showEmployeeValue1) {
      this.headCountmiss1 = true
    }
    else {
      this.headCountmiss1 = false

      const file = ev.target.files[0];
      var fileExtension = '.' + ev.target.files[0].name.split('.').pop();
      const timestamp = new Date().getTime();


      var allowedMimes = [
        '.xlsx'
      ];

      let error = false;

      let message = '';

      const newFilename = `file_${timestamp}${fileExtension}`;
      console.log(newFilename)
      const newFile = new File([file], newFilename, { type: file.type });
      console.log(newFile)

      if (allowedMimes?.includes(fileExtension)) {
        let workBook: any = null;
        let jsonData = [];
        const reader = new FileReader();
        reader.readAsArrayBuffer(newFile)
        reader.onload = async (event) => {
          const data = reader.result;
          const wb = await this.excelService.readDataFromExcel(data);
          const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
          console.log(employeeSheet);
          if (employeeSheet) {
            let firstRow = employeeSheet.getRow(1);
            console.log(firstRow)
            if (!firstRow.cellCount) return;
            let keys = firstRow.values;
            console.log(keys)
            let seenEmployeeEmails = new Set();
            let ExceldataError = false
            let ExceldataErrorMessage = ''
            let ExceldataemailError = false
            let ExceldataPhonenumberError = false
            let ExceldataPhonenumberErrorMessage = ''
            let ExceldataEmailErrorMessage = ''
            let ExceldataFirstNameError = false
            let ExceldataFirstNameErrorMessage = ''
            let ExceldataLastNameError = false
            let ExceldataLastNameErrorMessage = ''
            let ExceldatapostalCodeError = false;
            let ExceldataPosatlCodeErrorMessage = ''
            let ExceldataProvinceError = false;
            let ExceldataProvinceErrorMessage = '';
            employeeSheet.eachRow((row, rowNumber) => {
              if (rowNumber == 1) return;
              let values = row.values;
              let obj = {};
              //@ts-ignore


              //@ts-ignore

              for (let i = 1; i < keys.length; i++) {
                if (ExceldataError) {
                  break;
                }
                if (keys[i]) {
                  let value = values[i]


                  // if(value==""){
                  //   this.myFileInput.nativeElement.value = '';

                  // }
                  switch (keys[i]) {
                    case "First Name":
                      if (value && value != '') {
                        console.log(value)
                        if (value.text && value.text.length) {
                          value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                        }
                        else {
                          value = value.charAt(0).toUpperCase() + value.slice(1)
                        }
                        if (value.length >= 1) {

                        }
                        else {
                          ExceldataFirstNameError = true
                          ExceldataFirstNameErrorMessage = "First Name must be minimum of 1 characters, please check"
                          break;
                        }
                      }
                      else {
                        console.log(value)
                        ExceldataError = true
                        ExceldataErrorMessage = "First Name can't be empty"
                        break;
                      }
                      break;
                    case "Last Name":
                      if (value && value != '') {
                        // console.log(value.length)
                        if (value.text && value.text.length) {
                          value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                        }
                        else {
                          value = value.charAt(0).toUpperCase() + value.slice(1)
                        }
                        if (value.length >= 1) {

                        }
                        else {
                          ExceldataLastNameError = true
                          ExceldataLastNameErrorMessage = "Last Name must be minimum of 1 characters, please check"
                          break;
                        }
                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = "Last Name can't be empty"
                        break;
                      }
                      break;
                    case "Email":
                      if (value && value != '') {
                        // value=value.text
                        if (seenEmployeeEmails.has(value)) {
                          ExceldataemailError = true;
                          ExceldataEmailErrorMessage = "Duplicate Employee ID exists, please check";
                          ExceldataError = true;
                          break;
                        } else {
                          seenEmployeeEmails.add(value);
                        }
                        if (value.text && value.text.length) {
                          value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
                        }
                        else {
                          value = value.charAt(0).toLowerCase() + value.slice(1)
                        }
                        var filter = this.commonPatternsService.emailTestPattern;
                        // if (!filter.test(value)) {
                        //     // alert('Please /provide a valid email address');

                        //     ExceldataemailError =true
                        // ExceldataEmailErrorMessage = "Some fields have invalid email, please check"
                        // break;
                        // }

                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = "Email can't be empty"
                        break;
                      }


                      break;
                    // case "Plan Enrollment Date":
                    //     if (value && value != '') {


                    //     }
                    //     else {
                    //       ExceldataError = true
                    //       ExceldataErrorMessage = "Plan Enrollment Date can't be empty"
                    //       break;
                    //     }
                    //     break;

                    case "Phone Number":
                      if (value && value != '') {
                        // console.log(value)
                        // console.log(value.length)
                        // if (value.length == 10) {

                        // }
                        // else {
                        //   ExceldataPhonenumberError = true
                        //   ExceldataPhonenumberErrorMessage = "Phone Number not equal to 10 digits, please check"
                        //   break;
                        // }

                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = "Phone Number can't be empty"
                        break;
                      }
                      break;
                    case "Street Address":
                      if (value && value != '') {


                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = "Street Address can't be empty"
                        break;
                      }
                      break;
                    case "Country":
                      if (value && value != '') {


                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = "Country can't be empty"
                        break;
                      }
                      break;
                    case "City":
                      if (value && value != '') {


                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = "City can't be empty"
                        break;
                      }
                      break;
                    case "PostalCode":


                      if (value && value != '') {
                        value = value.toUpperCase();

                        this.ExcelProvinceCode = this.postalvalue

                        console.log
                        var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;

                        if (this.provincialZipcodes.indexOf(value[0]) == -1 || !postalRegexp.test(value)) {

                          ExceldatapostalCodeError = true
                          ExceldataPosatlCodeErrorMessage = "Some fields have invalid postal code, please check"
                          break;

                        }

                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = "PostalCode can't be empty"
                        break;
                      }
                      break;

                    case "Province":
                      if (value && value != '') {

                        this.configprovinceres.forEach((element: any) => {
                          if (element.shortName == this.postalvalue) {
                            this.provincialZipcodes = element.zipcodes.split(',');
                            this.provincelistid = element.id;
                            this.state_id = parseInt(element.fusebillId);
                            this.statename = element.name;
                          }
                        });


                        console.log(this.ExcelProvinceCode)
                        //   if (this.provincialZipcodes.indexOf(this.ExcelProvinceCode[0]) == -1) {
                        // ExceldataProvinceError =true
                        // ExceldataProvinceErrorMessage = "Some fields have invalid postal code, please check"
                        // break;

                        //   }

                      }
                      else {
                        ExceldataError = true
                        ExceldataErrorMessage = "Province can't be empty"
                        break;
                      }
                      break;

                  }

                  obj[keys[i]] = value;


                }

              }
              jsonData.push(obj);
            });
            if (ExceldataError) {

              Swal.fire({
                title: this.lang.Error
                , text: ExceldataErrorMessage
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }


              });
              jsonData = []
            }
            if (ExceldataFirstNameError) {

              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: ExceldataFirstNameErrorMessage
              }).then((result) => {
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }


              });
              jsonData = []
            }
            if (ExceldataLastNameError) {

              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: ExceldataLastNameErrorMessage
              }).then((result) => {
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }
              })
              jsonData = []
            }
            if (ExceldataemailError) {

              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: ExceldataEmailErrorMessage
              }).then((result) => {
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }

              });
              jsonData = []
            }
            if (ExceldataPhonenumberError) {

              Swal.fire({
                title: this.lang.Error ?? 'Error',
                text: ExceldataPhonenumberErrorMessage
              }).then((result) => {
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }

              });
              jsonData = []
            }
            if (ExceldatapostalCodeError) {

              Swal.fire({
                title: this.lang.Error
                , text: ExceldataPosatlCodeErrorMessage
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }


              });
              jsonData = []
            }
            if (ExceldataProvinceError) {

              Swal.fire({
                title: this.lang.Error
                , text: ExceldataProvinceErrorMessage
              }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                  this.myFileInputwaddel.nativeElement.value = '';
                }


              });
              jsonData = []
            }

            keys = []



            let uploadEmployeeData = jsonData;


            // this.showEmployeeValue = array.length+uploadEmployeeData.length
            // if (array.length+uploadEmployeeData.length != this.showEmployeeValue) {

            //   Swal.fire({ title: this.lang.Info, text: "Head count and upload Employee/Entity List not match." });
            //   this.myFileInput.nativeElement.value = '';

            // }
            // else {



            this.multiSelectProviancenames.sort(function (a, b) {
              return (a.id - b.id);
            })

            let province = ""
            let provincearray = []

            this.multiSelectProviancenames.forEach(element => {
              provincearray.push(element.shortName)
            });


            if (this.multiSelectProviancenames.length == 1) {
              // for(let i=0;i<this.multiSelectProviancenames.length;i++){
              province = this.multiSelectProviancenames[0].shortName
              // }
            }
            else if (this.multiSelectProviancenames.length > 1) {
              if (provincearray?.includes(this.province)) {
                province = this.province

              }
              else {
                if (provincearray?.includes("ON")) {
                  province = "ON"
                }
                else {
                  province = this.multiSelectProviancenames[0].shortName
                }
              }

            }


            console.log(uploadEmployeeData)
            uploadEmployeeData = uploadEmployeeData.map(function (obj: any) {
              // obj['planEnrollmentDate'] = obj['Plan Enrollment Date'];
              obj['employeeId'] = obj['Employee ID']?.toString() || "";

              obj['firstName'] = obj['First Name'];
              obj['lastName'] = obj['Last Name'];
              obj['email'] = obj['Email'];
              // obj['residentIn'] = obj['Resident in'];
              obj['country'] = "Canada";
              // obj['province'] = obj['Province of Employment'];
              obj['province'] = obj['Province'];
              obj['phoneNum'] = obj['Phone Number'];
              obj['streetAddress'] = obj['Street Address'];
              obj['postalCode'] = obj['PostalCode'];
              obj['city'] = obj['City'];


              obj['uId'] = 0;
              obj['bulkPlanLevelId'] = 34
              obj['isBulk'] = true

              if (typeof obj.phoneNum == 'number') {
                obj.phoneNum = obj.phoneNum.toString();
              }

              if (typeof obj.planEnrollmentDate == 'number') {
                obj.planEnrollmentDate = obj.planEnrollmentDate.toString();
              }
              if (typeof obj.streetAddress == 'number') {
                obj.streetAddress = obj.streetAddress.toString();
              }


              console.log(obj)

              // obj.dateofBirth =  new Date((obj.dateofBirth - (25567 + 1))*86400*1000);
              delete obj['Employee ID'];

              delete obj['First Name'];
              delete obj['Last Name'];
              delete obj['Email'];

              // delete obj['Plan Enrollment Date'];
              delete obj['Province'];
              //delete obj['Resident in'];
              delete obj['Country'];
              delete obj['City'];

              delete obj['Phone Number'];
              // delete obj['uId'];
              delete obj['Street Address'];
              delete obj['PostalCode'];
              // delete obj['Provience Id'];
              // Assign new key
              return obj;

            });

            // assign province-id
            //asign tier-id
            console.log(uploadEmployeeData);
            this.uploadEmployeeExcelData = uploadEmployeeData



            let array = []
            let array1 = []
            if (jsonData.length > 0) {
              console.log(this.employeeList)
              if (this.employeeList.length > 0) {
                for (let i = 0; i < this.employeeList.length; i++) {
                  if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                    array.push(this.employeeList[i]);
                  } else {
                    array1.push(this.employeeList[i]);
                  }


                }
                console.log(array1, array, this.employeeList)

                if (array.length > 0) {
                  Swal.fire({
                    title: this.lang.Info,
                    html: '<div style="text-align: left;">' + this.lang.Do_you_want_to_replace_or_append_the_employee_list + ' <br> <div style="font-size: 10px;">Replace - Existing replaced with new file.<br>Append - File will be appended to the existing list.</div></div>', showCancelButton: true,
                    showDenyButton: true,
                    confirmButtonColor: '#10104d',
                    cancelButtonColor: '#10104d',
                    confirmButtonText: this.lang.Append,
                    denyButtonText: this.lang.Replace

                  }).then((result) => {
                    if (result.isConfirmed) {

                      console.log(this.employeeList) //old

                      console.log(uploadEmployeeData) //new

                      let temparray = []
                      let uploadEmployeeDataIndex = []
                      let existingRemoveEmployeeDataIndex = []
                      temparray = this.employeeList
                      let existingEmails = this.employeeList.map(a => a.email);


                      for (let j = 0; j < uploadEmployeeData.length; j++) {
                        if (existingEmails?.includes(uploadEmployeeData[j].email)) {
                          console.log(existingEmails.indexOf(uploadEmployeeData[j].email))
                          console.log(this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)])
                          if (this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId && this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId > 0) {
                            existingRemoveEmployeeDataIndex.push(existingEmails.indexOf(uploadEmployeeData[j].email))
                          }
                          else {
                            temparray[existingEmails.indexOf(uploadEmployeeData[j].email)] = uploadEmployeeData[j]
                          }

                        }
                        else {
                          temparray.push(uploadEmployeeData[j]);
                        }
                      }



                      console.log(temparray)

                      let EmailError = []
                      if (existingRemoveEmployeeDataIndex.length > 0) {
                        for (let i = 0; i < existingRemoveEmployeeDataIndex.length; i++) {
                          EmailError.push(temparray[existingRemoveEmployeeDataIndex[i]].email)
                        }
                      }

                      console.log(EmailError)
                      console.log(temparray)

                      console.log(this.employeeList)

                      this.employeeList = temparray
                      console.log(this.employeeList)

                      let mergeArray = []
                      // let initialLength = this.employeeList.length;
                      for (let i = 0; i < this.employeeList.length; i++) {
                        console.log(this.employeeList[i].isBulk, this.employeeList.length, this.employeeList[i].isBulk == true)
                        if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                          console.log(this.employeeList[i].isBulk == true)
                          mergeArray.push(this.employeeList[i]);
                          // this.bulkemployeeList.push(this.employeeList[i]);
                        }
                        // }
                      }
                      this.bulkemployeeList = [...this.bulkemployeeList, ...this.employeeList]

                      this.showEmployeeValue1 = mergeArray.length
                      console.log(this.showEmployeeValue1, this.bulkemployeeList)

                      for (let i = 0; i < this.employeeList.length; i++) {

                        if (this.employeeList[i] && this.employeeList[i]['uId']) {

                        }
                        else {
                          this.employeeList[i]['uId'] = 0
                        }
                        if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

                        }
                        else {
                          this.employeeList[i]['phoneNum'] = ""
                        }
                      }

                      this.lengthofemployee = this.employeeList.length;

                      if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

                      }
                      else {
                        // this.maxEmployeeCount = this.employeeList.length;
                        let formData = JSON.parse(sessionStorage.getItem('formData') || '');

                        this.maxEmployeeCount = formData.expectednoofEmployees;
                      }
                      this.addedEmployeelist = this.employeeList
                      // this.addedEmployeelist.forEach((element: any) => {
                      //   element["isBulk"] = true
                      // })

                      console.log(this.employeeList);
                      this.toastrService.success(this.showEmployeeValue1 + " " + this.lang.Employees_Added);
                      setTimeout(() => {
                        setTimeout(() => {
                          if (EmailError.length > 0) {
                            this.toastrService.warning(EmailError.toString() + " " + this.lang.Employees_Exists);
                          }
                        }, 1000);
                      }, 1000);


                    }
                    else if (result.isDenied) {
                      this.deletedId = []
                      for (let i = 0; i < uploadEmployeeData.length; i++) {
                        array1.push(uploadEmployeeData[i]);
                      }
                      console.log(uploadEmployeeData)

                      for (let i = 0; i < this.employeeList.length; i++) {
                        if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                          if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
                            this.deletedId.push(this.employeeList[i].uId);
                          }
                        }
                      }
                      console.log(this.deletedId)
                      setTimeout(() => {
                        this.deleteEmployee(array1);
                      }, 2000);
                      this.employeeList = array1

                      console.log(this.employeeList)
                      let mergeArray = []
                      for (let i = 0; i < array1.length; i++) {
                        if (array1[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                          mergeArray.push(array1[i]);
                          this.bulkemployeeList.push(array1[i]);

                        }
                      }
                      console.log()
                      this.showEmployeeValue1 = mergeArray.length
                      this.toastrService.success(this.showEmployeeValue1 + " " + this.lang.Employees_Added);


                    }
                  });
                }
                else {
                  for (let i = 0; i < uploadEmployeeData.length; i++) {
                    this.employeeList.push(uploadEmployeeData[i]);
                  }

                  let mergeArray = []
                  for (let i = 0; i < this.employeeList.length; i++) {
                    if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                      mergeArray.push(this.employeeList[i]);
                    }
                  }

                  // this.showEmployeeValue = mergeArray.length



                  this.lengthofemployee = this.employeeList.length;

                  if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

                  }
                  else {
                    // this.maxEmployeeCount = this.employeeList.length;
                    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

                    this.maxEmployeeCount = formData.expectednoofEmployees;
                  }
                  this.addedEmployeelist = this.employeeList
                  // this.addedEmployeelist.forEach((element: any) => {
                  //   element["isBulk"] = true
                  // })

                  console.log(uploadEmployeeData)
                  this.showEmployeeValue = uploadEmployeeData.length

                  this.bulkemployeeList = uploadEmployeeData

                  console.log(this.employeeList);
                  this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);

                }
              }
              else {
                this.employeeList = uploadEmployeeData;


                this.lengthofemployee = this.employeeList.length;

                if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

                }
                else {
                  // this.maxEmployeeCount = this.employeeList.length;
                  let formData = JSON.parse(sessionStorage.getItem('formData') || '');

                  this.maxEmployeeCount = formData.expectednoofEmployees;
                }
                this.addedEmployeelist = this.employeeList
                // this.addedEmployeelist.forEach((element: any) => {
                //   element["isBulk"] = true
                // })
                console.log(this.employeeList);
                this.showEmployeeValue1 = uploadEmployeeData.length
                this.bulkemployeeList = uploadEmployeeData

                this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);

              }
            }

            //original-employee-list

            //already-emp-cust-id?


            if (this.employeeList.length > 0) {
              this.myFileInputwaddel.nativeElement.value = '';
            }
          }
          else {
            //tampered excel error
          }




          // }
        };

      }
      else {
        error = true;

        message = 'Invalid file type. Only xlsx files are allowed.';
        // alert(message);
        Swal.fire({ title: this.lang.Info, text: message });
      }
    }

    // reader.readAsBinaryString(file);
  }

  toCamelCase(str) {
    // console.log(str)
    const s = str
      .toLowerCase()
      .split(' ')
      .map((word, index) => {
        if (index === 0) {
          return word;
        } else {
          return word.charAt(0).toUpperCase() + word.slice(1);
        }
      })
      .join('');
    return s
  }
  async onFileChangeExcel(ev: any, subgrpId: any, headers: any) {


    if (!this.showHeadCount[subgrpId] || this.showHeadCount[subgrpId] <= 0) {
      return
    }

    const file = ev.target.files[0];
    var fileExtension = '.' + ev.target.files[0].name.split('.').pop();


    var allowedMimes = [
      '.xlsx'
    ];

    let error = false;

    let message = '';

    if (allowedMimes?.includes(fileExtension)) {
      let workBook: any = null;
      let jsonData = [];
      const reader = new FileReader();
      reader.readAsArrayBuffer(file)
      reader.onload = async (event) => {
        const data = reader.result;
        const wb = await this.excelService.readDataFromExcel(data);
        const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
        console.log(employeeSheet);
        if (employeeSheet) {
          let firstRow = employeeSheet.getRow(1);
          console.log(firstRow)
          if (!firstRow.cellCount) return;
          let keys = firstRow.values;
          console.log(keys)
          let seenEmployeeEmails = new Set();
          let ExceldataError = false
          let ExceldataErrorMessage = ''
          let ExceldataemailError = false
          let ExceldataEmailErrorMessage = ''
          let ExceldataFirstNameError = false
          let ExceldataFirstNameErrorMessage = ''
          let ExceldataLastNameError = false
          let ExceldataLastNameErrorMessage = ''
          employeeSheet.eachRow((row, rowNumber) => {
            if (rowNumber == 1) return;
            let values = row.values;
            let obj = {};
            //@ts-ignore


            //@ts-ignore
            for (let i = 1; i < keys.length; i++) {
              if (ExceldataError) {
                break;
              }
              if (keys[i]) {
                let value = values[i]
                // if(value==""){
                //   this.myFileInput.nativeElement.value = '';

                // }
                switch (keys[i]) {
                  case "First Name":
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                      if (value.length >= 1) {

                      }
                      else {
                        ExceldataFirstNameError = true
                        ExceldataFirstNameErrorMessage = "First Name must be minimum of 1 characters, please check"
                        break;
                      }
                    }
                    else {
                      console.log(value)
                      ExceldataError = true
                      ExceldataErrorMessage = "First Name can't be empty"
                      break;
                    }
                    break;
                  case "Last Name":
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                      if (value.length >= 1) {

                      }
                      else {
                        ExceldataLastNameError = true
                        ExceldataLastNameErrorMessage = "Last Name must be minimum of 1 characters, please check"
                        break;
                      }
                    }
                    else {
                      ExceldataError = true
                      ExceldataErrorMessage = "Last Name can't be empty"
                      break;
                    }
                    break;

                  case "Email":
                    if (value && value != '') {
                      // value=value.text
                      if (seenEmployeeEmails.has(value)) {
                        ExceldataemailError = true;
                        ExceldataEmailErrorMessage = "Duplicate Employee ID exists, please check";
                        ExceldataError = true;
                        break;
                      } else {
                        seenEmployeeEmails.add(value);
                      }
                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toLowerCase() + value.slice(1)
                      }
                      var filter = this.commonPatternsService.emailTestPattern;
                      // if (!filter.test(value)) {
                      //     // alert('Please /provide a valid email address');

                      //     ExceldataemailError =true
                      // ExceldataEmailErrorMessage = "Some fields have invalid email, please check"
                      // break;
                      // }

                    }
                    else {
                      ExceldataError = true
                      ExceldataErrorMessage = "Email can't be empty"
                      break;
                    }


                    break;
                  case "Date of Hire":
                    if (value && value != '') {
                      value = moments(value).format(this.dateFormat)
                    }
                    break;
                  case "Date of Birth":
                    if (value && value != '') {
                      value = moments(value).format(this.dateFormat);
                      let today = moment(new Date());
                      let maxDAte = moment(today.subtract('16', 'years').calendar()).format(this.dateFormat);

                      if (moment(value).isAfter(maxDAte)) {
                        ExceldataError = true;
                        ExceldataErrorMessage = "Age must be greater than or equal to 16";
                      }
                    }
                    break;

                  case "Country":


                    // if (value && value != '') {


                    // }
                    // else {
                    //   ExceldataError = true
                    //   ExceldataErrorMessage = "Country can't be empty"
                    //   break;
                    // }


                    break;
                  case "Province of Employment":

                    // if(value && value !=''){


                    //   }
                    //   else{
                    //     ExceldataError =true
                    //     ExceldataErrorMessage = "Province can't be empty"
                    //     break;
                    //   }
                    break;
                  case "Classification Tier":
                    // obj["classificationTier"] = this.gettierId(value)
                    break;
                  case "Job Title":
                    if (value && value != '') {

                      if (value.text && value.text.length) {
                        value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
                      }
                      else {
                        value = value.charAt(0).toUpperCase() + value.slice(1)
                      }
                    }
                    break;
                }

                obj[keys[i]] = value;


              }

            }

            jsonData.push(obj);
          });
          if (ExceldataError) {

            Swal.fire({
              title: this.lang.Error
              , text: ExceldataErrorMessage
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }


            });
            jsonData = []
          }
          if (ExceldataemailError) {

            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: ExceldataEmailErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }

            });
            jsonData = []
          }
          if (ExceldataFirstNameError) {

            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: ExceldataFirstNameErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }


            });
            jsonData = []
          }
          if (ExceldataLastNameError) {

            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: ExceldataLastNameErrorMessage
            }).then((result) => {
              if (result.isConfirmed) {
                this.myFileInput.nativeElement.value = '';
              }
            })
            jsonData = []
          }
        } else {
          //tampered excel error
        }

        console.log(jsonData);

        // jsonData.forEach((element: any) => {
        //   element["isBulk"]=true
        // })



        // this.showEmployeeValue = array.length+uploadEmployeeData.length
        // if (array.length+uploadEmployeeData.length != this.showEmployeeValue) {

        //   Swal.fire({ title: this.lang.Info, text: "Head count and upload Employee/Entity List not match." });
        //   this.myFileInput.nativeElement.value = '';

        // }
        // else {



        this.multiSelectProviancenames.sort(function (a, b) {
          return (a.id - b.id);
        })

        let province = ""
        let provincearray = []

        this.multiSelectProviancenames.forEach(element => {
          provincearray.push(element.shortName)
        });


        if (this.multiSelectProviancenames.length == 1) {
          // for(let i=0;i<this.multiSelectProviancenames.length;i++){
          province = this.multiSelectProviancenames[0].shortName
          // }
        }
        else if (this.multiSelectProviancenames.length > 1) {
          if (provincearray?.includes(this.province)) {
            province = this.province

          }
          else {
            if (provincearray?.includes("ON")) {
              province = "ON"
            }
            else {
              province = this.multiSelectProviancenames[0].shortName
            }
          }

        }


        console.log(jsonData)

        let uploadEmployeeData = [];
        for (let i = 0; i < jsonData.length; i++) {
          let data: any = {};

          headers.map((h) => {
            // console.log(h)

            let key = this.toCamelCase(h.value)

            data[key] = jsonData[i][h.value] ? jsonData[i][h.value] : ""
          })
          data['isBulk'] = true;
          data['uId'] = 0;
          data['bulkPlanLevelId'] = subgrpId
          if (typeof data?.employeeId == 'number') {
            data.employeeId = data.employeeId.toString();
          }
          if (typeof data?.phoneNumber == 'number') {
            data.phoneNumber = data.phoneNumber.toString();
          }
          if (data?.phoneNumber == '') {
            data.phoneNumber = '';
          }
          if (data?.annualIncome == '') {
            data.annualIncome = 0;
          }
          if (data?.classificationTier == '' || data?.classificationTier == undefined || data?.classificationTier == "All") {
            data.classificationTier = 0; //assign default tier id
          }
          uploadEmployeeData.push(data)
        }

        console.log(uploadEmployeeData)


        this.uploadEmployeeExcelData = [...uploadEmployeeData]

        console.log(this.uploadEmployeeExcelData)
        console.log(this.employeeList)

        // console.log(this.employeeList, subgrpId)
        let array = []
        let array1 = []
        if (this.employeeList.length > 0) {
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
              array.push(this.employeeList[i]);
            } else {
              array1.push(this.employeeList[i]);
            }


          }
          console.log(array1, array, this.employeeList)

          if (array.length > 0) {
            Swal.fire({
              title: this.lang.Info,
              html: '<div style="text-align: left;">' + this.lang.Do_you_want_to_replace_or_append_the_employee_list + ' <br> <div style="font-size: 10px;">Replace - Existing replaced with new file.<br>Append - File will be appended to the existing list.</div></div>', showCancelButton: true,
              showDenyButton: true,
              confirmButtonColor: '#10104d',
              cancelButtonColor: '#10104d',
              confirmButtonText: this.lang.Append,
              denyButtonText: this.lang.Replace

            }).then(async (result) => {
              if (result.isConfirmed) {

                console.log(this.employeeList) //old
                console.log(uploadEmployeeData) //new

                let temparray = []
                let existingRemoveEmployeeDataIndex = []
                temparray = this.employeeList
                let existingEmails = this.employeeList.map(a => a.email);


                for (let j = 0; j < uploadEmployeeData.length; j++) {
                  if (existingEmails?.includes(uploadEmployeeData[j].email)) {
                    console.log(existingEmails.indexOf(uploadEmployeeData[j].email))
                    console.log(this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)])
                    if (this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId && this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId > 0) {

                      existingRemoveEmployeeDataIndex.push(existingEmails.indexOf(uploadEmployeeData[j].email))

                    }
                    else {

                      temparray[existingEmails.indexOf(uploadEmployeeData[j].email)] = uploadEmployeeData[j]
                    }

                  }
                  else {
                    temparray.push(uploadEmployeeData[j]);
                  }
                }



                console.log(temparray)

                let EmailError = []
                if (existingRemoveEmployeeDataIndex.length > 0) {
                  for (let i = 0; i < existingRemoveEmployeeDataIndex.length; i++) {
                    EmailError.push(temparray[existingRemoveEmployeeDataIndex[i]].email)
                  }
                }

                console.log(EmailError)
                console.log(temparray)
                console.log(this.employeeList)
                this.employeeList = temparray
                console.log(this.employeeList)

                let mergeArray = []

                for (let i = 0; i < this.employeeList.length; i++) {
                  console.log(this.employeeList[i].isBulk, this.employeeList.length, this.employeeList[i].isBulk == true)
                  if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
                    console.log(this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId)
                    mergeArray.push(this.employeeList[i]);
                  }
                }

                this.bulkemployeeList = [...this.bulkemployeeList, ...this.employeeList]

                this.showEmployeeValue = mergeArray.length
                console.log(this.showEmployeeValue, this.bulkemployeeList)

                this.lengthofemployee = this.employeeList.length;

                if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

                }
                else {
                  // this.maxEmployeeCount = this.employeeList.length;
                  let formData = JSON.parse(sessionStorage.getItem('formData') || '');

                  this.maxEmployeeCount = formData.expectednoofEmployees;
                }
                this.addedEmployeelist = this.employeeList


                console.log(this.employeeList);
                this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);
                setTimeout(() => {
                  setTimeout(() => {
                    if (EmailError.length > 0) {
                      this.toastrService.warning(EmailError.toString() + " " + this.lang.Employees_Exists);
                    }
                  }, 1000);
                }, 1000);


              }
              else if (result.isDenied) {
                this.deletedId = []
                for (let i = 0; i < uploadEmployeeData.length; i++) {
                  array1.push(uploadEmployeeData[i]);
                }
                console.log(uploadEmployeeData)

                for (let i = 0; i < this.employeeList.length; i++) {
                  if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
                    if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
                      this.deletedId.push(this.employeeList[i].uId);
                    }
                  }
                }
                console.log(this.deletedId)
                setTimeout(() => {
                  this.deleteEmployee(array1);
                }, 2000);
                this.employeeList = array1

                console.log(this.employeeList)
                let mergeArray = []
                for (let i = 0; i < array1.length; i++) {
                  if (array1[i].isBulk == true) {
                    mergeArray.push(array1[i]);
                    this.bulkemployeeList.push(array1[i]);

                  }
                }
                console.log()
                this.showEmployeeValue = mergeArray.length
                this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);


              }
              await this.updateHeadCount(subgrpId)

            });
          }
          else {
            for (let i = 0; i < uploadEmployeeData.length; i++) {
              this.employeeList.push(uploadEmployeeData[i]);
            }

            let mergeArray = []
            for (let i = 0; i < this.employeeList.length; i++) {
              if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == subgrpId) {
                mergeArray.push(this.employeeList[i]);
              }
            }


            console.log(this.employeeList)
            this.lengthofemployee = this.employeeList.length;

            if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

            }
            else {
              // this.maxEmployeeCount = this.employeeList.length;
              let formData = JSON.parse(sessionStorage.getItem('formData') || '');

              this.maxEmployeeCount = formData.expectednoofEmployees;
            }
            this.addedEmployeelist = this.employeeList

            console.log(this.addedEmployeelist)
            console.log(uploadEmployeeData)
            this.showEmployeeValue = uploadEmployeeData.length

            this.bulkemployeeList = uploadEmployeeData

            console.log(this.employeeList);
            this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);

          }
        }
        else {
          this.employeeList = uploadEmployeeData;

          console.log(this.employeeList);
          this.lengthofemployee = this.employeeList.length;

          if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

          }
          else {
            let formData = JSON.parse(sessionStorage.getItem('formData') || '');

            this.maxEmployeeCount = formData.expectednoofEmployees;
          }
          this.addedEmployeelist = this.employeeList

          console.log(this.employeeList);
          this.showEmployeeValue = uploadEmployeeData.length
          this.bulkemployeeList = uploadEmployeeData

          this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);
        }

        if (this.employeeList.length > 0) {
          this.myFileInput.nativeElement.value = '';
        }
        await this.updateHeadCount(subgrpId)

      };
    }
    else {
      error = true;

      message = 'Invalid file type. Only xlsx files are allowed.';
      // alert(message);
      Swal.fire({ title: this.lang.Info, text: message });
    }


    // reader.readAsBinaryString(file);
  }

  async updateHeadCount(subgrpId) {

    if (this.employeeList.length <= 0) return false
    console.log(this.showHeadCount[subgrpId], this.employeeList)
    this.showHeadCount[subgrpId] = 0
    this.employeeList.forEach((emp) => {
      if (emp.isBulk && emp.bulkPlanLevelId > 0 && emp.bulkPlanLevelId == subgrpId) {
        if (this.showHeadCount[emp.bulkPlanLevelId]) {
          console.log(this.showHeadCount[subgrpId], this.employeeList)
          this.showHeadCount[emp.bulkPlanLevelId]++;
        } else {
          this.showHeadCount[emp.bulkPlanLevelId] = 1;
        }
      }
    });
    console.log(this.showHeadCount[subgrpId], this.employeeList)
    this.addedEmployeelist = this.employeeList

  }


  exportAsXLSX(subgroupId, keys): void {

    // console.log(keys, this.showHeadCount[subgroupId])
    this.excelempdata = []

    if (!this.showHeadCount[subgroupId] || this.showHeadCount[subgroupId] <= 0) {
      return
    }


    this.employeedata = keys

    this.employeedata2 = keys
    var obj: any = {};


    console.log(this.employeedata)
    for (let i = 0; i < this.employeedata.length; i++) {
      obj[this.employeedata[i].value] = '';
      this.excelempdata.push(obj);
      console.log({ "exp": this.excelempdata })
    }

    var finalres = Object.values(
      this.excelempdata.reduce((c, e) => {
        if (!c[e.Gender]) c[e.Gender] = e;
        return c;
      }, {})
    );
    console.log(this.excelempdata)

    this.finalemployeekeys = finalres;

    console.log(this.finalemployeekeys);
    let multiProviance = [];

    this.configprovincereslist.map((proviance) => {
      multiProviance.push(proviance.shortName);
    });

    let formData = JSON.parse(sessionStorage.getItem('formData') || '');

    this.excelService.exportAsExcelFileBulk(
      this.finalemployeekeys,
      this.employeedata2,
      'CorporateBulksPlans',
      formData.tierConfig,
      formData.walletConfig,
      this.showHeadCount[subgroupId],
      this.multiSelectProviancenames
    );

  }



  // onFileChangeExcel(ev: any, subgrpId) {
  //   // if (subgrpId == 34) {
  //   //   this.onFileChangeExcelWaddel(ev)
  //   //   return;
  //   // }
  //   console.log("calling")
  //   console.log(this.showEmployeeValue)
  //   if (!this.showHeadCount[subgrpId] || this.showHeadCount[subgrpId] <= 0) {
  //     return
  //   }

  //   this.headCountmiss = false
  //   const file = ev.target.files[0];
  //   var fileExtension = '.' + ev.target.files[0].name.split('.').pop();


  //   var allowedMimes = [
  //     '.xlsx'
  //   ];

  //   let error = false;

  //   let message = '';

  //   if (allowedMimes?.includes(fileExtension)) {
  //     let workBook: any = null;
  //     let jsonData = [];
  //     const reader = new FileReader();
  //     reader.readAsArrayBuffer(file)
  //     reader.onload = async (event) => {
  //       const data = reader.result;
  //       const wb = await this.excelService.readDataFromExcel(data);
  //       const employeeSheet = wb.getWorksheet(this.excelService.EXCEL_SHEETNAME);
  //       console.log(employeeSheet);
  //       if (employeeSheet) {
  //         let firstRow = employeeSheet.getRow(1);
  //         console.log(firstRow)
  //         if (!firstRow.cellCount) return;
  //         let keys = firstRow.values;
  //         console.log(keys)
  //         let seenEmployeeEmails = new Set();
  //         let ExceldataError = false
  //         let ExceldataErrorMessage = ''
  //         let ExceldataemailError = false
  //         let ExceldataEmailErrorMessage = ''
  //         let ExceldataFirstNameError = false
  //         let ExceldataFirstNameErrorMessage = ''
  //         let ExceldataLastNameError = false
  //         let ExceldataLastNameErrorMessage = ''
  //         employeeSheet.eachRow((row, rowNumber) => {
  //           if (rowNumber == 1) return;
  //           let values = row.values;
  //           let obj = {};
  //           //@ts-ignore


  //           //@ts-ignore
  //           for (let i = 1; i < keys.length; i++) {
  //             if (ExceldataError) {
  //               break;
  //             }
  //             if (keys[i]) {
  //               let value = values[i]
  //               // if(value==""){
  //               //   this.myFileInput.nativeElement.value = '';

  //               // }
  //               switch (keys[i]) {
  //                 case "First Name":
  //                   if (value && value != '') {

  //                     if (value.text && value.text.length) {
  //                       value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                     }
  //                     else {
  //                       value = value.charAt(0).toUpperCase() + value.slice(1)
  //                     }
  //                     if (value.length >= 3) {

  //                     }
  //                     else {
  //                       ExceldataFirstNameError = true
  //                       ExceldataFirstNameErrorMessage = "First Name must be minimum of 3 characters, please check"
  //                       break;
  //                     }
  //                   }
  //                   else {
  //                     console.log(value)
  //                     ExceldataError = true
  //                     ExceldataErrorMessage = "First Name can't be empty"
  //                     break;
  //                   }
  //                   break;
  //                 case "Last Name":
  //                   if (value && value != '') {

  //                     if (value.text && value.text.length) {
  //                       value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                     }
  //                     else {
  //                       value = value.charAt(0).toUpperCase() + value.slice(1)
  //                     }
  //                     if (value.length >= 3) {

  //                     }
  //                     else {
  //                       ExceldataLastNameError = true
  //                       ExceldataLastNameErrorMessage = "Last Name must be minimum of 3 characters, please check"
  //                       break;
  //                     }
  //                   }
  //                   else {
  //                     ExceldataError = true
  //                     ExceldataErrorMessage = "Last Name can't be empty"
  //                     break;
  //                   }
  //                   break;

  //                 case "Email":
  //                   if (value && value != '') {
  //                     // value=value.text
  //                     if (seenEmployeeEmails.has(value)) {
  //                       ExceldataemailError = true;
  //                       ExceldataEmailErrorMessage = "Duplicate Employee ID exists, please check";
  //                       ExceldataError = true;
  //                       break;
  //                     } else {
  //                       seenEmployeeEmails.add(value);
  //                     }
  //                     if (value.text && value.text.length) {
  //                       value = value.text.charAt(0).toLowerCase() + value.text.slice(1)
  //                     }
  //                     else {
  //                       value = value.charAt(0).toLowerCase() + value.slice(1)
  //                     }
  //                     var filter = this.commonPatternsService.emailTestPattern;
  //                     // if (!filter.test(value)) {
  //                     //     // alert('Please /provide a valid email address');

  //                     //     ExceldataemailError =true
  //                     // ExceldataEmailErrorMessage = "Some fields have invalid email, please check"
  //                     // break;
  //                     // }

  //                   }
  //                   else {
  //                     ExceldataError = true
  //                     ExceldataErrorMessage = "Email can't be empty"
  //                     break;
  //                   }


  //                   break;
  //                 case "Date of Hire":
  //                   if (value && value != '') {
  //                     value = moments(value).format(this.dateFormat)
  //                   }
  //                   break;
  //                 case "Date of Birth":
  //                   if (value && value != '') {
  //                     value = moments(value).format(this.dateFormat);
  //                     let today = moment(new Date());
  //                     let maxDAte = moment(today.subtract('16', 'years').calendar()).format(this.dateFormat);

  //                     if (moment(value).isAfter(maxDAte)) {
  //                       ExceldataError = true;
  //                       ExceldataErrorMessage = "Age should not exceed 16 years";
  //                     }
  //                   }
  //                   break;

  //                 case "Country":


  //                   // if (value && value != '') {


  //                   // }
  //                   // else {
  //                   //   ExceldataError = true
  //                   //   ExceldataErrorMessage = "Country can't be empty"
  //                   //   break;
  //                   // }


  //                   break;
  //                 case "Province of Employment":

  //                   // if(value && value !=''){


  //                   //   }
  //                   //   else{
  //                   //     ExceldataError =true
  //                   //     ExceldataErrorMessage = "Province can't be empty"
  //                   //     break;
  //                   //   }
  //                   break;
  //                 case "Classification Tier":
  //                   // obj["classificationTier"] = this.gettierId(value)
  //                   break;
  //                 case "Job Title":
  //                   if (value && value != '') {

  //                     if (value.text && value.text.length) {
  //                       value = value.text.charAt(0).toUpperCase() + value.text.slice(1)
  //                     }
  //                     else {
  //                       value = value.charAt(0).toUpperCase() + value.slice(1)
  //                     }
  //                   }
  //                   break;
  //               }

  //               obj[keys[i]] = value;


  //             }

  //           }

  //           jsonData.push(obj);
  //         });
  //         if (ExceldataError) {

  //           Swal.fire({
  //             title: this.lang.Error
  //             , text: ExceldataErrorMessage
  //           }).then((result) => {
  //             /* Read more about isConfirmed, isDenied below */
  //             if (result.isConfirmed) {
  //               this.myFileInput.nativeElement.value = '';
  //             }


  //           });
  //           jsonData = []
  //         }
  //         if (ExceldataemailError) {

  //           Swal.fire({
  //             title: this.lang.Error??'Error',
  //             text: ExceldataEmailErrorMessage
  //           }).then((result) => {
  //             if (result.isConfirmed) {
  //               this.myFileInput.nativeElement.value = '';
  //             }

  //           });
  //           jsonData = []
  //         }
  //         if (ExceldataFirstNameError) {

  //           Swal.fire({
  //             title: this.lang.Error??'Error',
  //             text: ExceldataFirstNameErrorMessage
  //           }).then((result) => {
  //             if (result.isConfirmed) {
  //               this.myFileInput.nativeElement.value = '';
  //             }


  //           });
  //           jsonData = []
  //         }
  //         if (ExceldataLastNameError) {

  //           Swal.fire({
  //             title: this.lang.Error??'Error',
  //             text: ExceldataLastNameErrorMessage
  //           }).then((result) => {
  //             if (result.isConfirmed) {
  //               this.myFileInput.nativeElement.value = '';
  //             }
  //           })
  //           jsonData = []
  //         }
  //       } else {
  //         //tampered excel error
  //       }

  //       console.log(jsonData);

  //       // jsonData.forEach((element: any) => {
  //       //   element["isBulk"]=true
  //       // })

  //       let uploadEmployeeData = jsonData;


  //       // this.showEmployeeValue = array.length+uploadEmployeeData.length
  //       // if (array.length+uploadEmployeeData.length != this.showEmployeeValue) {

  //       //   Swal.fire({ title: this.lang.Info, text: "Head count and upload Employee/Entity List not match." });
  //       //   this.myFileInput.nativeElement.value = '';

  //       // }
  //       // else {



  //       this.multiSelectProviancenames.sort(function (a, b) {
  //         return (a.id - b.id);
  //       })

  //       let province = ""
  //       let provincearray = []

  //       this.multiSelectProviancenames.forEach(element => {
  //         provincearray.push(element.shortName)
  //       });


  //       if (this.multiSelectProviancenames.length == 1) {
  //         // for(let i=0;i<this.multiSelectProviancenames.length;i++){
  //         province = this.multiSelectProviancenames[0].shortName
  //         // }
  //       }
  //       else if (this.multiSelectProviancenames.length > 1) {
  //         if (provincearray?.includes(this.province)) {
  //           province = this.province

  //         }
  //         else {
  //           if (provincearray?.includes("ON")) {
  //             province = "ON"
  //           }
  //           else {
  //             province = this.multiSelectProviancenames[0].shortName
  //           }
  //         }

  //       }



  //       uploadEmployeeData = uploadEmployeeData.map(function (obj: any) {
  //         obj['employeeId'] = obj['Employee ID']?.toString() || "";
  //         obj['firstName'] = obj['First Name'];
  //         obj['lastName'] = obj['Last Name'];
  //         obj['email'] = obj['Email'];
  //         obj['jobTitle'] = obj['Job Title'];
  //         obj['dateOfBirth'] = obj['Date of Birth'];
  //         obj['dateOfHire'] = obj['Date of Hire'];
  //         obj['gender'] = obj['Gender'];
  //         // obj['residentIn'] = obj['Resident in'];
  //         obj['country'] = "Canada";
  //         // obj['province'] = obj['Province of Employment'];
  //         obj['province'] = province;
  //         obj['maritalStatus'] = obj['Marital Status'];
  //         obj['phoneNum'] = obj['Phone'];
  //         obj['annualIncome'] = obj['Annual Income'];
  //         // obj['annualIncome'] = obj['Annaul Income'];
  //         // obj['provienceName'] = obj['Provience Name'];
  //         obj['classificationTier'] = obj['Classification Tier'];
  //         obj['isBulk'] = true;
  //         obj['uId'] = 0;
  //         obj['bulkPlanLevelId'] = 20



  //         if (typeof obj.employeeId == 'number') {
  //           obj.employeeId = obj.employeeId.toString();
  //         }
  //         if (typeof obj.phoneNum == 'number') {
  //           obj.phoneNum = obj.phoneNum.toString();
  //         }
  //         if (obj.phoneNum == '') {
  //           obj.phoneNum = '';
  //         }
  //         if (obj.annualIncome == '') {
  //           obj.annualIncome = 0;
  //         }
  //         if (obj.classificationTier == '' || obj.classificationTier == undefined || obj.classificationTier == "All") {
  //           obj.classificationTier = 0; //assign default tier id
  //         }

  //         // obj.dateofBirth =  new Date((obj.dateofBirth - (25567 + 1))*86400*1000);
  //         delete obj['Employee ID'];
  //         delete obj['First Name'];
  //         delete obj['Last Name'];
  //         delete obj['Email'];
  //         delete obj['Job Title'];
  //         delete obj['Date of Birth'];
  //         delete obj['Date of Hire'];
  //         delete obj['Gender'];
  //         //delete obj['Resident in'];
  //         delete obj['Country'];
  //         delete obj['Province of Employment'];
  //         delete obj['Marital Status'];
  //         delete obj['Phone'];
  //         delete obj['Annual Income'];
  //         delete obj['Provience Name'];
  //         delete obj['Classification Tier'];
  //         delete obj['Provience Id'];
  //         // Assign new key
  //         return obj;

  //       });

  //       // assign province-id
  //       //asign tier-id
  //       console.log(uploadEmployeeData);
  //       this.uploadEmployeeExcelData = uploadEmployeeData



  //       let array = []
  //       let array1 = []
  //       if (this.employeeList.length > 0) {
  //         for (let i = 0; i < this.employeeList.length; i++) {
  //           if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 20) {
  //             array.push(this.employeeList[i]);
  //           } else {
  //             array1.push(this.employeeList[i]);
  //           }


  //         }
  //         console.log(array1, array, this.employeeList)

  //         if (array.length > 0) {
  //           Swal.fire({
  //             title: this.lang.Info,
  //             html: '<div style="text-align: left;">'+this.lang.Do_you_want_to_replace_or_append_the_employee_list+' <br> <div style="font-size: 10px;">Replace - Existing replaced with new file.<br>Append - File will be appended to the existing list.</div></div>', showCancelButton: true,
  //             showDenyButton: true,
  //             confirmButtonColor: '#10104d',
  //             cancelButtonColor: '#10104d',
  //             confirmButtonText: this.lang.Append,
  //             denyButtonText: this.lang.Replace

  //           }).then((result) => {
  //             if (result.isConfirmed) {

  //               console.log(this.employeeList) //old

  //               console.log(uploadEmployeeData) //new

  //               let temparray = []
  //               let uploadEmployeeDataIndex = []
  //               let existingRemoveEmployeeDataIndex = []
  //               temparray = this.employeeList
  //               let existingEmails = this.employeeList.map(a => a.email);


  //               for (let j = 0; j < uploadEmployeeData.length; j++) {
  //                 if (existingEmails?.includes(uploadEmployeeData[j].email)) {
  //                   console.log(existingEmails.indexOf(uploadEmployeeData[j].email))
  //                   console.log(this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)])
  //                   if (this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId && this.employeeList[existingEmails.indexOf(uploadEmployeeData[j].email)].uId > 0) {


  //                     existingRemoveEmployeeDataIndex.push(existingEmails.indexOf(uploadEmployeeData[j].email))

  //                   }
  //                   else {

  //                     temparray[existingEmails.indexOf(uploadEmployeeData[j].email)] = uploadEmployeeData[j]
  //                   }

  //                 }
  //                 else {
  //                   temparray.push(uploadEmployeeData[j]);
  //                 }
  //               }



  //               console.log(temparray)

  //               let EmailError = []
  //               if (existingRemoveEmployeeDataIndex.length > 0) {
  //                 for (let i = 0; i < existingRemoveEmployeeDataIndex.length; i++) {
  //                   EmailError.push(temparray[existingRemoveEmployeeDataIndex[i]].email)
  //                 }
  //               }

  //               console.log(EmailError)
  //               console.log(temparray)

  //               console.log(this.employeeList)

  //               this.employeeList = temparray
  //               console.log(this.employeeList)

  //               let mergeArray = []
  //               // let initialLength = this.employeeList.length;
  //               for (let i = 0; i < this.employeeList.length; i++) {
  //                 console.log(this.employeeList[i].isBulk, this.employeeList.length, this.employeeList[i].isBulk == true)
  //                 if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 20) {
  //                   console.log(this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 20)
  //                   mergeArray.push(this.employeeList[i]);
  //                   // this.bulkemployeeList.push(this.employeeList[i]);
  //                 }
  //                 // }
  //               }
  //               this.bulkemployeeList = [...this.bulkemployeeList, ...this.employeeList]

  //               this.showEmployeeValue = mergeArray.length
  //               console.log(this.showEmployeeValue, this.bulkemployeeList)

  //               for (let i = 0; i < this.employeeList.length; i++) {

  //                 if (this.employeeList[i] && this.employeeList[i]['uId']) {

  //                 }
  //                 else {
  //                   this.employeeList[i]['uId'] = 0
  //                 }
  //                 if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

  //                 }
  //                 else {
  //                   this.employeeList[i]['phoneNum'] = ""
  //                 }
  //               }

  //               this.lengthofemployee = this.employeeList.length;

  //               if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

  //               }
  //               else {
  //                 // this.maxEmployeeCount = this.employeeList.length;
  //                 let formData = JSON.parse(sessionStorage.getItem('formData') || '');

  //                 this.maxEmployeeCount = formData.expectednoofEmployees;
  //               }
  //               this.addedEmployeelist = this.employeeList
  //               // this.addedEmployeelist.forEach((element: any) => {
  //               //   element["isBulk"] = true
  //               // })

  //               console.log(this.employeeList);
  //               this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);
  //               setTimeout(() => {
  //                 setTimeout(() => {
  //                   if (EmailError.length > 0) {
  //                     this.toastrService.warning(EmailError.toString() + " " + this.lang.Employees_Exists);
  //                   }
  //                 }, 1000);
  //               }, 1000);


  //             }
  //             else if (result.isDenied) {
  //               this.deletedId = []
  //               for (let i = 0; i < uploadEmployeeData.length; i++) {
  //                 array1.push(uploadEmployeeData[i]);
  //               }
  //               console.log(uploadEmployeeData)

  //               for (let i = 0; i < this.employeeList.length; i++) {
  //                 if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 20) {
  //                   if (this.employeeList[i].uId && this.employeeList[i].uId > 0) {
  //                     this.deletedId.push(this.employeeList[i].uId);
  //                   }
  //                 }
  //               }
  //               console.log(this.deletedId)
  //               setTimeout(() => {
  //                 this.deleteEmployee(array1);
  //               }, 2000);
  //               this.employeeList = array1

  //               console.log(this.employeeList)
  //               let mergeArray = []
  //               for (let i = 0; i < array1.length; i++) {
  //                 if (array1[i].isBulk == true) {
  //                   mergeArray.push(array1[i]);
  //                   this.bulkemployeeList.push(array1[i]);

  //                 }
  //               }
  //               console.log()
  //               this.showEmployeeValue = mergeArray.length
  //               this.toastrService.success(this.showEmployeeValue + " " + this.lang.Employees_Added);


  //             }
  //           });
  //         }
  //         else {
  //           for (let i = 0; i < uploadEmployeeData.length; i++) {
  //             this.employeeList.push(uploadEmployeeData[i]);
  //           }

  //           let mergeArray = []
  //           for (let i = 0; i < this.employeeList.length; i++) {
  //             if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 20) {
  //               mergeArray.push(this.employeeList[i]);
  //             }
  //           }

  //           // this.showEmployeeValue = mergeArray.length

  //           for (let i = 0; i < this.employeeList.length; i++) {
  //             if (this.employeeList[i] && this.employeeList[i]['uId']) {

  //             }
  //             else {
  //               this.employeeList[i]['uId'] = 0
  //             }
  //             if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

  //             }
  //             else {
  //               this.employeeList[i]['phoneNum'] = ""
  //             }
  //           }

  //           this.lengthofemployee = this.employeeList.length;

  //           if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

  //           }
  //           else {
  //             // this.maxEmployeeCount = this.employeeList.length;
  //             let formData = JSON.parse(sessionStorage.getItem('formData') || '');

  //             this.maxEmployeeCount = formData.expectednoofEmployees;
  //           }
  //           this.addedEmployeelist = this.employeeList
  //           // this.addedEmployeelist.forEach((element: any) => {
  //           //   element["isBulk"] = true
  //           // })

  //           console.log(uploadEmployeeData)
  //           this.showEmployeeValue = uploadEmployeeData.length

  //           this.bulkemployeeList = uploadEmployeeData

  //           console.log(this.employeeList);
  //           this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);

  //         }
  //       }
  //       else {
  //         this.employeeList = uploadEmployeeData;
  //         for (let i = 0; i < this.employeeList.length; i++) {
  //           if (this.employeeList[i] && this.employeeList[i]['uId']) {

  //           }
  //           else {
  //             this.employeeList[i]['uId'] = 0
  //           }
  //           if (this.employeeList[i] && this.employeeList[i]['phoneNum']) {

  //           }
  //           else {
  //             this.employeeList[i]['phoneNum'] = ""
  //           }
  //         }

  //         this.lengthofemployee = this.employeeList.length;

  //         if (this.maxEmployeeCount && this.maxEmployeeCount > 0) {

  //         }
  //         else {
  //           // this.maxEmployeeCount = this.employeeList.length;
  //           let formData = JSON.parse(sessionStorage.getItem('formData') || '');

  //           this.maxEmployeeCount = formData.expectednoofEmployees;
  //         }
  //         this.addedEmployeelist = this.employeeList
  //         // this.addedEmployeelist.forEach((element: any) => {
  //         //   element["isBulk"] = true
  //         // })
  //         console.log(this.employeeList);
  //         this.showEmployeeValue = uploadEmployeeData.length
  //         this.bulkemployeeList = uploadEmployeeData

  //         this.toastrService.success(uploadEmployeeData.length + " " + this.lang.Employees_Added);

  //       }

  //       //original-employee-list

  //       //already-emp-cust-id?


  //       if (this.employeeList.length > 0) {
  //         this.myFileInput.nativeElement.value = '';
  //       }


  //       // }
  //     };
  //   }
  //   else {
  //     error = true;

  //     message = 'Invalid file type. Only xlsx files are allowed.';
  //     // alert(message);
  //     Swal.fire({ title: this.lang.Info, text: message });
  //   }


  //   // reader.readAsBinaryString(file);
  // }
  // exportAsXLSX(keys): void {


  //   if (!this.showEmployeeValue) {
  //     this.headCountmiss = true
  //   }
  //   else {
  //     this.headCountmiss = false
  //     this.employeedata = [
  //       {
  //         label: 'Employee ID',
  //         key: 'employeeId',
  //         mandatory: true,
  //         display: true,
  //       },
  //       {
  //         label: 'First Name',
  //         key: 'firstName',
  //         mandatory: true,
  //         display: true,
  //       },
  //       {
  //         label: 'Last Name',
  //         key: 'lastName',
  //         mandatory: true,
  //         display: true,
  //       },
  //       {
  //         label: 'Email',
  //         key: 'email',
  //         mandatory: true,
  //         display: true,
  //       },
  //     ];

  //     this.employeedata2 = [
  //       {
  //         label: 'Employee ID',
  //         header: 'Employee ID',
  //         key: 'employeeId',
  //         mandatory: true,
  //         display: true,

  //       },
  //       {
  //         label: 'First Name',
  //         header: 'First Name',
  //         key: 'firstName',
  //         mandatory: true,
  //         display: true,
  //       },
  //       {
  //         label: 'Last Name',
  //         header: 'Last Name',
  //         key: 'lastName',
  //         mandatory: true,
  //         display: true,
  //       },
  //       {
  //         label: 'Email',
  //         header: 'Email',
  //         key: 'email',
  //         mandatory: true,
  //         display: true,
  //       },
  //     ];

  //     var obj: any = {};
  //     for (let i = 0; i < this.employeedata.length; i++) {
  //       obj[this.employeedata[i].label] = '';
  //       this.excelempdata.push(obj);
  //     }

  //     var finalres = Object.values(
  //       this.excelempdata.reduce((c, e) => {
  //         if (!c[e.Gender]) c[e.Gender] = e;
  //         return c;
  //       }, {})
  //     );

  //     this.finalemployeekeys = finalres;
  //     let multiProviance = [];
  //     this.configprovincereslist.map((proviance) => {
  //       multiProviance.push(proviance.shortName);
  //     });
  //     console.log(this.finalemployeekeys);
  //     let formData = JSON.parse(sessionStorage.getItem('formData') || '');
  //     this.excelService.exportAsExcelFileBulk(
  //       this.finalemployeekeys,
  //       this.employeedata2,
  //       'CorporateBulksPlans',
  //       formData.tierConfig,
  //       formData.walletConfig,
  //       this.showEmployeeValue,
  //       this.multiSelectProviancenames
  //     );
  //   }


  // }

  // dateFormat(dateFormat: any): any {
  //   throw new Error('Method not implemented.');
  // }

  async deleteemployeeexcel(admin, index, selectedSubGrpId) {
    if (admin.uId && admin.uId > 0) {
      Swal.fire({
        title: this.lang.Alert,
        text: this.lang.Do_you_want_to_delete_this_employee_and_update_head_count,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {



          const Data = this.employeeList;

          const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items
          this.showHeadCount[selectedSubGrpId] = this.showHeadCount[selectedSubGrpId] - 1
          this.employeeList = Data;

          let employeeBulkCheck = []

          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == selectedSubGrpId) {
              employeeBulkCheck.push(this.employeeList[i])
            }
          }

          this.deletedId.push(admin.uId);

          let Obj = {
            employees: this.employeeList,
            deletedIds: this.deletedId || [],
          };

          var corporateId = sessionStorage.getItem('corporateId');
          var endPoint =
            '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
          var accessToken = sessionStorage.getItem('accessToken');
          this.http
            .post(environment.apiUrl + endPoint, Obj, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  let employeeBulkCheckfinal = []

                  for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == selectedSubGrpId) {
                      employeeBulkCheckfinal.push(response.data[i])
                    }
                  }

                  this.showEmployeeValue = employeeBulkCheckfinal.length
                  if (this.showEmployeeValue == 0) {
                    $("#showBulkEmployeelist").modal('hide');
                  }

                } else {
                  Swal.fire({
                    title: 'Error#' + response.errorCode,
                    text: response.message,
                  });
                }
              },
              (error) => {
                if (
                  error.status == 400 ||
                  error.status == 401 ||
                  error.status == 402 ||
                  error.status == 403
                ) {
                  Swal.fire({
                    title: this.lang.Error ?? 'Error',
                    text: error.error.error.message,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang.Proceed,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    } else {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    }
                  });
                } else {
                  // Swal.fire(error.error.error.message)
                  Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
                }
                // this.toastrService.error("Invalid Credentials", 'Error!');
              }
            );

        }
      });
    }
    else {
      Swal.fire({
        title: this.lang.Alert,
        text: this.lang.Do_you_want_to_delete_this_employee_and_update_head_count,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

          const Data = this.employeeList;
          const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items
          this.showHeadCount[selectedSubGrpId] = this.showHeadCount[selectedSubGrpId] - 1

          this.employeeList = Data;
          // console.log(this.bulkplans)

          let employeeBulkCheck = []
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true) {
              employeeBulkCheck.push(this.employeeList[i])
            }
          }
          this.showEmployeeValue = employeeBulkCheck.length

          if (this.showEmployeeValue == 0) {
            $("#showBulkEmployeelist").modal('hide');
          }



        }
      });
    }



  }
  deleteemployeeexcelwaddell(admin, index) {
    if (admin.uId && admin.uId > 0) {
      Swal.fire({
        title: this.lang.Alert,
        text: this.lang.Do_you_want_to_delete_this_employee_and_update_head_count,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {



          const Data = this.employeeList;

          const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

          this.employeeList = Data;
          let employeeBulkCheck = []

          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
              employeeBulkCheck.push(this.employeeList[i])
            }
          }

          this.deletedId.push(admin.uId);

          let Obj = {
            employees: this.employeeList,
            deletedIds: this.deletedId || [],
          };

          var corporateId = sessionStorage.getItem('corporateId');
          var endPoint =
            '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
          var accessToken = sessionStorage.getItem('accessToken');
          this.http
            .post(environment.apiUrl + endPoint, Obj, {
              headers: {
                Authorization: 'Bearer ' + accessToken,
                'Content-Type': 'application/json',
              },
            })
            .subscribe(
              (response: any) => {
                if (response['status'] == 200) {
                  let employeeBulkCheckfinal = []

                  for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].isBulk == true && this.employeeList[i].bulkPlanLevelId == 34) {
                      employeeBulkCheckfinal.push(response.data[i])
                    }
                  }

                  this.showEmployeeValue1 = employeeBulkCheckfinal.length
                  if (this.showEmployeeValue1 == 0) {
                    $("#showBulkEmployeelistwaddell").modal('hide');
                  }
                  this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                    this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                      "message": "Corporates information has been updated. Please refresh screen."
                    }, {
                      headers: {
                        Authorization: 'Bearer ' + accessToken,
                        'Content-Type': 'application/json',
                      }
                    }).subscribe((res) => {
                      console.log({ res })
                    })
                  })
                } else {
                  Swal.fire({
                    title: 'Error#' + response.errorCode,
                    text: response.message,
                  });
                }
              },
              (error) => {
                if (
                  error.status == 400 ||
                  error.status == 401 ||
                  error.status == 402 ||
                  error.status == 403
                ) {
                  Swal.fire({
                    title: this.lang.Error ?? 'Error',
                    text: error.error.error.message,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang.Proceed,
                  }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (result.isConfirmed) {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    } else {
                      sessionStorage.clear();
                      this.router.navigate(['/login']);
                    }
                  });
                } else {
                  // Swal.fire(error.error.error.message)
                  Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
                }
                // this.toastrService.error("Invalid Credentials", 'Error!');
              }
            );

        }
      });
    }
    else {
      Swal.fire({
        title: this.lang.Alert,
        text: this.lang.Do_you_want_to_delete_this_employee_and_update_head_count,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: this.lang.Proceed,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {

          const Data = this.employeeList;
          const removed = Data.splice(index, 1); // Mutates fruits and returns array of removed items

          this.employeeList = Data;
          // console.log(this.bulkplans)

          let employeeBulkCheck = []
          for (let i = 0; i < this.employeeList.length; i++) {
            if (this.employeeList[i].isBulk == true) {
              employeeBulkCheck.push(this.employeeList[i])
            }
          }
          this.showEmployeeValue = employeeBulkCheck.length

          if (this.showEmployeeValue == 0) {
            $("#showBulkEmployeelist").modal('hide');
          }



        }
      });
    }


  }
  deleteEmployee(data) {

    console.log(data)

    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.employeeList[i].maritalStatus == 'Single') {
        this.employeeList[i].maritalStatus = 'Single';
      }
      if (this.employeeList[i].maritalStatus == 'Couple') {
        this.employeeList[i].maritalStatus = 'Couple';
      }
      if (this.employeeList[i].maritalStatus == 'Family') {
        this.employeeList[i].maritalStatus = 'Family';
      }
    }

    let Obj = {
      employees: data || [],
      deletedIds: this.deletedId || [],
    };

    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, Obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.deletedId = []
            this.employeeList = response.data
            if (
              response.failedEmployeesList &&
              response.failedEmployeesList.length > 0
            ) {

              this.failedEmployeesList = response.failedEmployeesList

              for (let i = 0; i < this.employeeList.length; i++) {
                for (let j = 0; j < response.data.length; j++) {
                  if (this.employeeList[i].email == response.data[j].email) {
                    this.employeeList[i] = response.data[j]
                  }

                }
              }
              this.employeeList = this.employeeList

              console.log(this.employeeList)

              let array = [];

              for (
                let i = 0;
                i < response.failedEmployeesList.length;
                i++
              ) {
                let obj = {
                  mail: response.failedEmployeesList[i].mailId,
                };
                array.push(response.failedEmployeesList[i].mailId);
                this.message = response.failedEmployeesList[i].message;
              }

              $('#existmail-modal').modal('show');
              this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
                this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                  "message": "Corporates information has been updated. Please refresh screen."
                }, {
                  headers: {
                    Authorization: 'Bearer ' + accessToken,
                    'Content-Type': 'application/json',
                  }
                }).subscribe((res) => {
                  console.log({ res })
                })
              })
              console.log(array);
              // var hh = "<br>"+array+"</br>";
              // Swal.fire({
              //   title: this.lang.Info,
              //   html: '' + this.message + ' :<br>' + array + '</br>',
              // });

            }
          } else {
            Swal.fire({
              title: 'Error#' + response.errorCode,
              text: response.message,
            });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }
  deleteEmployee1(deletedId) {

    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.employeeList[i].maritalStatus == 'Single') {
        this.employeeList[i].maritalStatus = 'Single';
      }
      if (this.employeeList[i].maritalStatus == 'Couple') {
        this.employeeList[i].maritalStatus = 'Couple';
      }
      if (this.employeeList[i].maritalStatus == 'Family') {
        this.employeeList[i].maritalStatus = 'Family';
      }
    }

    let Obj = {
      employees: [],
      deletedIds: deletedId || [],
    };

    var corporateId = sessionStorage.getItem('corporateId');
    var endPoint = '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
    var accessToken = sessionStorage.getItem('accessToken');
    this.http
      .post(environment.apiUrl + endPoint, Obj, {
        headers: {
          Authorization: 'Bearer ' + accessToken,
          'Content-Type': 'application/json',
        },
      })
      .subscribe(
        (response: any) => {
          if (response['status'] == 200) {
            this.http.get(environment.apiUrl + '/api/ap/global/set-adminCorporates').subscribe((newResponse) => {
              this.http.post(environment.reportApiUrl + '/websocket/corporate/notification-to-others', {
                "message": "Corporates information has been updated. Please refresh screen."
              }, {
                headers: {
                  Authorization: 'Bearer ' + accessToken,
                  'Content-Type': 'application/json',
                }
              }).subscribe((res) => {
                console.log({ res })
              })
            })
          } else {
            Swal.fire({
              title: 'Error#' + response.errorCode,
              text: response.message,
            });
          }
        },
        (error) => {
          if (
            error.status == 400 ||
            error.status == 401 ||
            error.status == 402 ||
            error.status == 403
          ) {
            Swal.fire({
              title: this.lang.Error ?? 'Error',
              text: error.error.error.message,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.lang.Proceed,
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              } else {
                sessionStorage.clear();
                this.router.navigate(['/login']);
              }
            });
          } else {
            // Swal.fire(error.error.error.message)
            Swal.fire({ title: this.lang.Error ?? 'Error', text: error.error.error.message });
          }
          // this.toastrService.error("Invalid Credentials", 'Error!');
        }
      );
  }
  public selectedBulkPlanId = ""
  clearEmployeeData() {
    this.selectedBulkPlanId = "";
    this.presentMail = "";
    this.addemployeefrom = false;
    this.editemployeefrom = false;

    this.editEmployeeindex = null;

    this.editEmployeeId = "";
    this.editEmployeefirstname = "";
    this.editEmployeelastname = "";
    this.editEmployeeemail = "";
    this.editEmployeephone = "";
    this.editEmployeeStreeAddress = "";
    this.editEmployeeCity = "";
    this.editEmployeeProvicne = "";
    this.editEmployeeposatlCode = "";
    this.editemployeeCountry = null;
    this.editEmployeeResidenetIn = "";

    this.editEmployeeDateofbirth = "";
    this.editEmployeeDateofhire = "";
    this.editEmployeeOccupation = "";
    this.editEmployeesex = null;

    this.editEmployeefamilyStatus = null;

    this.editEmployeeeAnnualIncome = "";
    this.editEmployeeId = "";
    this.UId = "";
    this.isBulk = false;
  }

  editemployeeexcel(admin: any, index: any) {
    $('#editEmployee-modal').modal('show');
    this.clearEmployeeData()

    console.log(admin);

    console.log(this.addedEmployeelist)
    this.selectedBulkPlanId = admin?.bulkPlanLevelId || ""
    this.presentMail = admin.email;
    this.addemployeefrom = false;
    this.editemployeefrom = true;

    this.editEmployeeindex = index;

    this.editEmployeeId = admin.employeeId;
    this.editEmployeefirstname = admin.firstName;
    this.editEmployeelastname = admin.lastName;
    this.editEmployeeemail = admin.email;
    this.editEmployeephone = admin.phoneNumber;
    this.editEmployeeemail = admin.email;
    this.editEmployeeStreeAddress = admin.streetAddress;
    this.editEmployeeCity = admin.city
    this.editEmployeeProvicne = admin.province;
    this.editEmployeeposatlCode = admin.postalcode;
    this.editemployeeCountry = admin.country ?? '' != '' ? admin.country : null;
    this.editEmployeeResidenetIn = admin.province;

    this.editEmployeeDateofbirth =
      admin.dateOfBirth == '' || admin.dateOfBirth == undefined
        ? ''
        : moment(admin.dateOfBirth).format('MM-DD-YYYY');
    this.editEmployeeDateofbirth =
      admin.dateOfHire == '' || admin.dateOfHire == undefined
        ? ''
        : moment(admin.dateOfHire).format('MM-DD-YYYY');
    this.editEmployeeDateofhire =
      admin.dateOfHire == '' || admin.dateOfHire == undefined
        ? ''
        : moment(admin.dateOfHire).format('MM-DD-YYYY');
    this.editEmployeeOccupation = admin.jobTitle;
    this.editEmployeesex = admin.gender ?? '' != '' ? admin.gender : null;

    this.editEmployeefamilyStatus =
      admin.maritalStatus ?? '' != ''
        ? this.commonPatternsService.textCaptalize(admin.maritalStatus)
        : null;

    this.editEmployeeeAnnualIncome = admin.annualIncome;
    this.editEmployeeId = admin.classificationTier;
    this.UId = admin.uId;
    this.isBulk = admin.isBulk ? true : false;

    this.getprovincelist1(admin.country);
  }
  editemployeetolist() {

    console.log(this.addEmployeeformList.controls)
    if (this.addEmployeeformList.invalid) {
      this.addEmployeeformList.markAllAsTouched();
      return;
    }
    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.addEmployeeformList.value.employeeEmail == this.employeeList[i].email && i !== this.editEmployeeindex) {
        Swal.fire({
          title: this.lang.Error ?? 'Error',
          text: `Duplicate Email Id's Exist`,
          showCancelButton: false,
          showDenyButton: false,
          confirmButtonText: 'ok'
        })
        return
      }
    }

    let editEmailObj = {
      firstName: this.capitalize(
        this.addEmployeeformList.value.employeeFirstName
      ),
      customerId: this.UId,
      employeeId: parseInt(
        this.addEmployeeformList.value.employeeId
          ? this.addEmployeeformList.value.employeeId.toString()
          : ''
      ),
      newEmail: this.addEmployeeformList.value.employeeEmail,
      email: this.presentMail,
    };
    console.log('eddddddEmail', editEmailObj);


    let input = {
      employeeId: this.addEmployeeformList.value.employeeId
        ? this.addEmployeeformList.value.employeeId.toString()
        : '',
      firstName: this.capitalize(
        this.addEmployeeformList.value.employeeFirstName
      ),
      lastName: this.capitalize(
        this.addEmployeeformList.value.employeeLastName
      ),
      email: this.addEmployeeformList.value.employeeEmail,
      jobTitle:
        this.capitalize(this.addEmployeeformList.value.employeeOccupation) ||
        '',
      dateOfHire: this.addEmployeeformList.value.employeeDateofhire || '',
      dateOfBirth: this.addEmployeeformList.value.employeeDateofbirth || '',
      gender: this.addEmployeeformList.value.employeeGender || '',
      workingProvince: this.addEmployeeformList.value.employeeResidence || '',
      maritalStatus: this.addEmployeeformList.value.employeefamilyStatus || '',
      phoneNumber: this.addEmployeeformList.value.employeePhoneno || '',
      provinceId: this.provincelistid || 0,
      workingProvienceId: this.provincelistid || 0,
      country: this.addEmployeeformList.value.employeeCountry || '',
      province: this.addEmployeeformList.value.employeeProvince || '',
      postalCode: this.addEmployeeformList.value.employeePostalCode || '',
      streetAddress: this.addEmployeeformList.value.employeeStreetAddress || '',
      city: this.addEmployeeformList.value.employeeCity || '',
      provinceName: this.addEmployeeformList.value.province || '',
      annualIncome:
        parseInt(this.addEmployeeformList.value.empployeeAnnualIncome) || 0,
      classificationTier:
        parseInt(this.addEmployeeformList.value.employeeTier) || 0,
      uId: this.UId,
      isBulk: this.isBulk,
      bulkPlanLevelId: this.selectedBulkPlanId
      // fuseBillCustomerCreation: true,
    };


    console.log(this.employeeList);
    this.employeeList[this.editEmployeeindex] = input;
    this.addemployeefrom = false;
    this.editemployeefrom = false;
    this.addEmployeeformList.reset();
    console.log(this.addEmployeeformList.controls)
    this.lengthofemployee = this.employeeList.length;
    $('#editEmployee-modal').modal('hide');


  }
  editemployeeexcelwaddell(admin: any, index: any) {
    $('#editEmployeewaddel-modal').modal('show');

    console.log(admin);
    this.addemployeefrom = false;
    this.editemployeefrom = true;
    this.editEmployeeindex = index;
    this.editEmployeeId = admin.employeeId;
    this.editEmployeefirstname = admin.firstName;
    this.editEmployeelastname = admin.lastName;
    this.editEmployeephone = admin.phoneNum;
    this.editEmployeeemail = admin.email;
    this.presentMail = admin.email;
    this.editEmployeeStreeAddress = admin.streetAddress;
    this.editEmployeeCity = admin.city
    this.editEmployeeProvicne = admin.province;
    this.editEmployeeposatlCode = admin.postalCode;


    this.editemployeeCountry = admin.country ?? '' != '' ? admin.country : null;
    this.editEmployeeResidenetIn = admin.province;


    this.editEmployeeId = admin.classificationTier;
    this.UId = admin.uId;
    this.isBulk = admin.isBulk ? true : false;

    // this.getprovincelist1(admin.country);
  }

  editemployeetolistwaddell() {

    if (this.addEmployeeformListwaddell.invalid) {
      this.addEmployeeformListwaddell.markAllAsTouched();
      console.log(this.addEmployeeformListwaddell.controls)
      return;
    }
    for (let i = 0; i < this.employeeList.length; i++) {
      if (this.addEmployeeformListwaddell.value.employeeEmail == this.employeeList[i].email && i !== this.editEmployeeindex) {
        Swal.fire({
          title: this.lang.Error ?? 'Error',
          text: `Duplicate Email Id's Exist`,
          showCancelButton: false,
          showDenyButton: false,
          confirmButtonText: 'ok'
        })
        return
      }
    }

    let editEmailObj = {
      firstName: this.capitalize(
        this.addEmployeeformListwaddell.value.employeeFirstName
      ),
      customerId: this.UId,
      employeeId: parseInt(
        this.addEmployeeformListwaddell.value.employeeId
          ? this.addEmployeeformListwaddell.value.employeeId.toString()
          : ''
      ),
      newEmail: this.addEmployeeformListwaddell.value.employeeEmail,
      email: this.presentMail,
    };
    console.log('eddddddEmail', editEmailObj);


    let input = {
      employeeId: this.addEmployeeformListwaddell.value.employeeId
        ? this.addEmployeeformListwaddell.value.employeeId.toString()
        : '',
      firstName: this.capitalize(
        this.addEmployeeformListwaddell.value.employeeFirstName
      ),
      lastName: this.capitalize(
        this.addEmployeeformListwaddell.value.employeeLastName
      ),
      email: this.addEmployeeformListwaddell.value.employeeEmail,


      //residentIn: this.addEmployeeformList.value.employeeResidence || '',
      country: this.addEmployeeformListwaddell.value.employeeCountry || '',
      province: this.addEmployeeformListwaddell.value.employeeProvince || '',
      postalCode: this.addEmployeeformListwaddell.value.employeePostalCode || '',
      phoneNum: this.addEmployeeformListwaddell.value.employeePhoneno || '',
      streetAddress: this.addEmployeeformListwaddell.value.employeeStreetAddress || '',
      city: this.addEmployeeformListwaddell.value.employeeCity || '',
      uId: this.UId,
      isBulk: this.isBulk,
      // bulkPlanLevelId: 34
      // fuseBillCustomerCreation: true,
    };


    console.log(this.employeeList);
    this.employeeList[this.editEmployeeindex] = input;
    this.addemployeefrom = false;
    this.editemployeefrom = false;
    this.addEmployeeformList.reset();
    this.lengthofemployee = this.employeeList.length;
    $('#editEmployeewaddel-modal').modal('hide');


  }
  updateTotal(index: any, event: any, subgrp: any, count: number) {
    if (count) {
      if (event.target.value < count) {
        Swal.fire({ title: this.lang.Error ?? 'Error', text: `${subgrp.name}-required head-count ${count}` })
        this.showHeadCount[subgrp.id] = ""
      }
    }
    this.uploadEmployeeExcelData = []

  }

  updateTotal1(index: any, event: any) {
    if (!this.showEmployeeValue1) {
      this.headCountmiss1 = true
    }
    else {
      this.headCountmiss1 = false
    }
    this.uploadEmployeeExcelData = []
    //    let val=event.target.value;
    //    let unnitPrice;
    //    if(index==0)
    //    unnitPrice=5
    //   else if(index==1)
    //   unnitPrice=10;
    // else if(index==2)
    // unnitPrice=15;

    //   let subTotal=val*unnitPrice;
    //   let tax=subTotal*0.13;
    //   let total=subTotal+tax;
    //   document.getElementById('tax_'+index).innerHTML="$"+tax.toFixed(2);
    //   document.getElementById('total_'+index).innerHTML="$"+total.toFixed(2);
    //   document.getElementById('subtotal_'+index).innerHTML="$"+subTotal.toFixed(2);
  }
  titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you       // Assign it back to the array       splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);        }   // Directly return the joined string
      return splitStr.join(' ');
    }
  }

  //  Get ProvinceID
  getprovinceId(value) { }




  alphaNumaricssWithHipen(event: any) {
    const charCode = event.which ? event.which : event.keyCode;

    if (event.currentTarget.value.length == 0) {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        charCode === 45
      )
        return true;
      else return false;
    } else {
      if (
        (charCode >= 65 && charCode <= 90) ||
        (charCode >= 97 && charCode <= 122) ||
        (charCode >= 48 && charCode <= 57) ||
        charCode === 32 ||
        charCode === 45
      )
        return true;
      else return false;
    }
  }

  // This method checks if the subgroup.id exists in bulkplans
  isPlanInBulkplans(subgroupId: number): boolean {
    // Check if subgroupId matches any planLevelId in bulkplans
    return this.bulkplans.some(plan => plan.planLevelId === subgroupId);
  }

  // This method returns the headcount as a string (or some text) based on the plan data in bulkplans
  getHeadCountText(subgroupId: number): string {
    const plan = this.bulkplans.find(plan => plan.planLevelId == subgroupId);
    if (plan) {
      // Assuming `quantity` holds the headcount number, you can return it as a string
      return `${plan.quantity}`;
    }
    return "Headcount not available";  // Default text if not found
  }

  // Sort the bulkplans by activation date
  get sortedBulkplans() {
    return this.bulkplans.sort((a, b) => {
      const dateA = new Date(a.activationDate);
      const dateB = new Date(b.activationDate);
      return dateA.getTime() - dateB.getTime(); // Ascending order
    });
  }

  // This method returns all plans that match a given planLevel
  getPlansByPlanLevel(subgroupId: string) {
    // Filter the bulkplans based on planLevel and sort by activationDate
    return this.bulkplans
      .filter(plan => plan.planLevelId == subgroupId)  // Filter plans by planLevel
      .sort((a, b) => {
        const dateA = new Date(a.activationDate);
        const dateB = new Date(b.activationDate);
        return dateA.getTime() - dateB.getTime();  // Ascending order by activationDate
      });
  }

  // Function to format the date to 'MMM-dd-yyyy' format
  formatDate(date: Date): string {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[date.getMonth()];
    const day = ('0' + date.getDate()).slice(-2);  // Ensure day is always 2 digits
    const year = date.getFullYear();

    return `${month}-${day}-${year}`;
  }

  // Function to get the next 3 months dynamically
  generateDateOptions() {
    const currentDate = new Date();
    for (let i = 1; i <= 3; i++) {
      // Increment the current month by i
      const newDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));

      // Set the date to the first of the month
      newDate.setDate(1);

      // Format the new date
      const formattedDate = this.formatDate(newDate);

      // Add the option with the formatted date and value as YYYY-MM-DD
      this.dateOptions.push({
        value: newDate.toISOString().split('T')[0], // Store value in YYYY-MM-DD format
        text: formattedDate
      });
    }
  }

  updateBulkHeadCount(plan) {
    this.editPlanHeadCount = plan;
    this.currentHeadCount = plan.quantity;
    this.newHeadCount = plan.quantity;

    const currentDate = new Date();
    const newDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
    // Set the date to the first of the month
    newDate.setDate(1);
    // this.effectiveDate = newDate.toISOString().split('T')[0]
    this.effectiveDate = null

    this.editBulkPlanModal = true;
    console.log('showHeadCount', this.showHeadCount);

    this.nonEditingBulkPlan = this.bulkplans.find(pla => pla.planLevelId == plan.planLevelId && pla.status != plan.status)
    console.log(this.nonEditingBulkPlan)

    this.expandActivePlanExpiry = false;
    this.toggleExpandActivePlanExpiry()
  }

  terminateBulkPlan(plan) {
    this.editPlanHeadCount = plan;
    this.nonEditingBulkPlan = this.bulkplans.find(pla => pla.planLevelId == plan.planLevelId && pla.status != plan.status)
    console.log(this.nonEditingBulkPlan)

    const currentDate = new Date();
    const newDate = new Date(currentDate.setMonth(currentDate.getMonth() + 1));
    // Set the date to the first of the month
    newDate.setDate(1);
    // this.effectiveDate = newDate.toISOString().split('T')[0]
    this.effectiveDate = null
  }

  async submitEmployees() {
    let newEmployeesUIds = [];
    if (this.employeeList && this.employeeList.length > 0) {
      let Obj = {
        employees: this.employeeList,
        deletedIds: this.deletedId || [],
      };

      const corporateId = sessionStorage.getItem('corporateId');
      const endPoint = '/api/ap/admin/corporate/' + corporateId + '/employeeNew';
      const accessToken: any = sessionStorage.getItem('accessToken');

      try {
        const response: any = await this.http
          .post(environment.apiUrl + endPoint, Obj, {
            headers: {
              Authorization: 'Bearer ' + accessToken,
              'Content-Type': 'application/json',
            },
          })
          .toPromise();

        // Process the response
        // console.log(response)
        for (let i = 0; i < this.employeeList.length; i++) {
          if (this.employeeList[i].uId == 0) {
            console.log(this.employeeList[i].email)
            const matchingResponse = response?.data?.find((res: any) => res.email == this.employeeList[i].email);

            if (matchingResponse) {
              newEmployeesUIds.push(matchingResponse?.uId);
            }
          }
        }
      } catch (error) {
        console.error('Error during employee submission:', error);
      }
    }

    return newEmployeesUIds;
  }


  async saveHeadCount() {
    // // Assuming updatedEmployees is the list received from the API response
    // const updatedEmployees = [];

    // // Flag to check if any new employee has been added
    // let newEmployeesAdded = false;

    // // Loop through the updated employees and check if there are any new employees
    // this.employeeList.forEach((updatedEmployee) => {
    //     // Check if the employee is already in the existing employeeList
    //     const employeeExists = this.employeeList.some(existingEmployee => existingEmployee.employeeId === updatedEmployee.employeeId);

    //     // If employee doesn't exist in the current list, mark as new and update the flag
    //     if (!employeeExists) {
    //         newEmployeesAdded = true;
    //         updatedEmployees.push(updatedEmployee)
    //     }
    // });

    // let updateEmployeeList:any= false;
    // // If new employees were added, update the employee list and set the flag
    // if (newEmployeesAdded) {
    //   console.log('updatedEmployees',updatedEmployees)
    // } else {
    //   console.log('updatedEmployees',updatedEmployees)
    // }

    let newEmployeesUIds = await this.submitEmployees()

    const obj = {
      "bulkPlan": this.editPlanHeadCount,
      "newHeadCount": this.newHeadCount,
      "effectiveDate": this.effectiveDate,
      "fuseBillCustomerId": this.corporateClientId.toString(),
      "expandActivePlanExpiry": this.expandActivePlanExpiry,
      employees: newEmployeesUIds || []
    }
    console.log(obj)
    let accessToken = sessionStorage.getItem('accessToken');
    // this.http.put(`http://[::1]:3002/api/ap/admin/corporate/${this.corporateId}/bulkPlan/${this.editPlanHeadCount.id}/updateHeadCount`, obj, {
    this.http.put(environment.apiUrl + `/api/ap/admin/corporate/${this.corporateId}/bulkPlan/${this.editPlanHeadCount.id}/updateHeadCount`, obj, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    })
      .subscribe((response: any) => {
        console.log(response)
        if (response.status == 200) {
          Swal.fire({ title: 'Info', text: response.message })
          this.GetCorpDetails();
        } else {
          Swal.fire({ title: 'Error', text: response.message ?? response.error.message })
        }
      })
  }

  toggleExpandActivePlanExpiry(date?: any) {
    const activationDate = new Date(this.nonEditingBulkPlan.activationDate);
    const effectiveDate = new Date(this.effectiveDate);
    const terminationDate = new Date(this.nonEditingBulkPlan.terminationDate);

    $('#expandActivePlanExpiry').prop('checked', false)
    if (this.editPlanHeadCount.status == 'Active' && effectiveDate.getTime() > activationDate.getTime()) {
      this.expandActivePlanExpiry = true;
    } else if (this.editPlanHeadCount.status == 'Provisioning' && effectiveDate.getTime() < terminationDate.getTime()) {
      this.expandActivePlanExpiry = true;
    } else {
      date == 'date' ? this.expandActivePlanExpiry = false
        : this.expandActivePlanExpiry = !this.expandActivePlanExpiry;
    }
    if (this.expandActivePlanExpiry) {
      $('#expandActivePlanExpiry').prop('checked', true)
    }
  }

  toggleTerminationExpiryDate() {
    const activationDate = new Date(this.editPlanHeadCount.activationDate);
    const effectiveDate = new Date(this.effectiveDate);

    if (this.editPlanHeadCount.status == 'Provisioning' && activationDate.getTime() == effectiveDate.getTime()) {
      this.showActivateOldPlan = true;
      this.activateOldPlan = true;
    } else {
      this.showActivateOldPlan = false;
      this.activateOldPlan = false;
    }
  }

  submitExpiration() {
    const obj = {
      bulkPlan: this.editPlanHeadCount,
      effectiveDate: this.effectiveDate,
      fuseBillCustomerId: this.corporateClientId.toString(),
      activateOldPlan: this.activateOldPlan,
      updateProvisioningDate: this.updateProvisioningDate,
      // employees: this.employeeList,
      deletedIds: this.deletedId || [],
    }
    let accessToken = sessionStorage.getItem('accessToken');
    // this.http.put(`http://[::1]:3002/api/ap/admin/corporate/${this.corporateId}/bulkPlan/${this.editPlanHeadCount.id}/terminateBulkPlan`, obj, {
    this.http.put(environment.apiUrl + `/api/ap/admin/corporate/${this.corporateId}/bulkPlan/${this.editPlanHeadCount.id}/terminateBulkPlan`, obj, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    })
      .subscribe((response: any) => {
        if (response.status == 200) {
          Swal.fire({ title: 'Info', text: response.message })
          this.GetCorpDetails();
        } else {
          Swal.fire({ title: 'Error', text: response.message ?? response.error.message })
        }
      })
  }

  toggleActivateOldPlan() {
    this.activateOldPlan = !this.activateOldPlan
  }

  toggleUpdateProvisioningDate() {
    this.updateProvisioningDate = !this.updateProvisioningDate
  }

  toggleEffectiveDate() {
    const activationDate = new Date(this.editPlanHeadCount.activationDate);
    const effectiveDate = new Date(this.effectiveDate);

    if (this.editPlanHeadCount.status == 'Provisioning' && activationDate < effectiveDate) {
      this.showActivateOldPlan = true;
      this.activateOldPlan = true;
    } else {
      this.showActivateOldPlan = false;
      this.activateOldPlan = false;
    }
  }
}

export function moments(date: string | undefined): moment.Moment {




  if (date)

    return moment((new Date(date)).toJSON())

  else

    return moment();

}
export function postalcodeValidator(control: AbstractControl) {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCode: true };
  }
  return null;
}
export function postalcodeValidatorwaddell(control: AbstractControl) {
  var postalRegexp = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/gm;
  if (control.value && !postalRegexp.test(control.value)) {
    return { invalidPostalCodewaddell: true };
  }
  return null;
}


// export function postalcodeValidator1(value) {

//   if(value==true){
//     return { invalidpostalcodeprivince: true };
//   }else{
//     return { invalidpostalcodeprivince: false };
//   }

// }